
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2Fl4v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $i35rc = parcelRequire("i35rc");


var $iXCQx = parcelRequire("iXCQx");


const $65f5939ddad688eb$var$AKModalDialog = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eGvdC")));

const $65f5939ddad688eb$var$AKModalTransition = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eGvdC")).then((module)=>({
            default: module.ModalTransition
        })));

const $65f5939ddad688eb$var$AKModalHeader = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("9ot3w"))));

const $65f5939ddad688eb$var$AKModalTitle = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("d8eRd"))));

const $65f5939ddad688eb$var$AKModalBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("1DHa6"))));

const $65f5939ddad688eb$var$AKModalFooter = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8o1lj"))));

const $65f5939ddad688eb$var$AKButton = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1cCuI")));

const $65f5939ddad688eb$var$SectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hcdJZ")));
const $65f5939ddad688eb$var$ModalThreeLOPrompt = ({ onClose: onClose = ()=>{}, isBlanketHidden: isBlanketHidden, ...props })=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl } = props;
    const isAuthUrlEmpty = !authUrl || authUrl === '';
    const intl = (0, $aXWIB.useIntl)();
    const { modalTitle: modalTitle, modalBody: modalBody } = isAuthUrlEmpty ? {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalErrorTitle),
        modalBody: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$SectionMessage, {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $65f5939ddad688eb$var$messages.noAuthURLErrorMessage)))
    } : {
        modalTitle: intl.formatMessage($65f5939ddad688eb$var$messages.modalAccessRequiredTitle),
        modalBody: promptMessage
    };
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTransition, null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalDialog, {
        onClose: ()=>{
            setIsModalOpen(false);
            onClose();
        },
        isBlanketHidden: isBlanketHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalTitle, null, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalBody, null, modalBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKModalFooter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
        appearance: "subtle",
        onClick: ()=>{
            setIsModalOpen(false);
            onClose();
        }
    }, intl.formatMessage($65f5939ddad688eb$var$messages.cancelButtonLabel)), !isAuthUrlEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$AKButton, {
        appearance: "primary",
        autoFocus: true,
        isLoading: loading,
        onClick: startAuth
    }, buttonText))));
};
var $65f5939ddad688eb$export$2e2bcd8739ae039 = $65f5939ddad688eb$var$ModalThreeLOPrompt;
const $65f5939ddad688eb$export$ee02671eeeecd75 = ({ onClose: onClose, appName: appName })=>{
    return function modalThreeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            onSuccess: ()=>dispatch({
                    type: 'render',
                    extensionData: {}
                }),
            appName: appName,
            onClose: onClose
        });
    };
};
const $65f5939ddad688eb$export$85a504818a81117d = ({ onClose: onClose, appName: appName, isBlanketHidden: isBlanketHidden = false })=>{
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($65f5939ddad688eb$var$ModalThreeLOPrompt, {
            ...props,
            appName: appName,
            onClose: onClose,
            isBlanketHidden: isBlanketHidden
        });
    };
};
const $65f5939ddad688eb$var$messages = (0, $aXWIB.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.modal.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    },
    modalErrorTitle: {
        id: "confluence.threeLOPrompt.modal.error.title",
        defaultMessage: "Error"
    },
    modalAccessRequiredTitle: {
        id: "confluence.threeLOPrompt.modal.access.required.title",
        defaultMessage: "Access required"
    },
    cancelButtonLabel: {
        id: "forge-ui.threeLOPrompt.modal.cancel.button.label",
        defaultMessage: "Cancel"
    }
});
module.exports["makeModalThreeLOPrompt"] = $65f5939ddad688eb$export$ee02671eeeecd75;
module.exports["makeModalThreeLOPromptForCustomUI"] = $65f5939ddad688eb$export$85a504818a81117d;

});

parcelRegister("jLYRk", function(module, exports) {
/**
 * UI Kit 1 markup components — not removed as still in use in the following:
 *
 * EmFn, StrikeFn, StringFn, StrongFn:
 *   - Used by platform/packages/forge/forge-ui/src/renderer/defaultComponents.tsx
 *     as part of the RendererNext component set.
 *
 */ 
var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");


var $gGmck = parcelRequire("gGmck");


var $1nSBE = parcelRequire("1nSBE");

const $a08eb7c3df84467c$var$useDeprecationWarning = (componentName)=>{
    const { forgeEnvironment: forgeEnvironment } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $gGmck.RendererContext));
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (forgeEnvironment !== 'PRODUCTION') (0, $1nSBE.default)(`[@forge/react: ${componentName}] Warning: The "${componentName}" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.`);
    }, [
        forgeEnvironment,
        componentName
    ]);
};
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST = [
    'http:',
    'https:',
    'ftp:',
    'ftps:',
    'mailto:',
    'skype:',
    'callto:',
    'facetime:',
    'git:',
    'irc:',
    'irc6:',
    'news:',
    'nntp:',
    'feed:',
    'cvs:',
    'svn:',
    'mvn:',
    'ssh:',
    'scp:',
    'sftp:',
    'itms:',
    'notes:',
    'hipchat:',
    'sourcetree:',
    'urn:',
    'tel:',
    'xmpp:',
    'telnet:',
    'vnc:',
    'rdp:',
    'whatsapp:',
    'slack:',
    'sip:',
    'sips:',
    'magnet:',
    'tds:'
];
const $a08eb7c3df84467c$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    if ($a08eb7c3df84467c$var$PROTOCOL_ALLOWLIST.includes(url.protocol)) return url.toString();
    else return 'about:blank';
};
function $a08eb7c3df84467c$export$e7bdca014c19fc5c({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Em');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "em"
    }, children);
}
function $a08eb7c3df84467c$export$97176b8d51d2058f({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strike');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("s", null, children);
}
function $a08eb7c3df84467c$export$89b8e0fa65f6a914({ text: text }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, text);
}
function $a08eb7c3df84467c$export$f301627d437cff88({ children: children }) {
    $a08eb7c3df84467c$var$useDeprecationWarning('Strong');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, children);
}
function $a08eb7c3df84467c$var$wrap(Component) {
    return function WrappedComponent({ Components: Components, children: children, props: propsAny, render: render, renderChildren: renderChildren, dispatch: dispatch }) {
        const props = propsAny;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props, renderChildren({
            Components: Components,
            children: children,
            render: render,
            dispatch: dispatch
        }));
    };
}
const $a08eb7c3df84467c$export$fec26b2d751c6d95 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$e7bdca014c19fc5c);
const $a08eb7c3df84467c$export$e9e7c187aef6a83a = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$97176b8d51d2058f);
const $a08eb7c3df84467c$export$11a9c970dcafffc0 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$89b8e0fa65f6a914);
const $a08eb7c3df84467c$export$566c617eb72a5976 = $a08eb7c3df84467c$var$wrap($a08eb7c3df84467c$export$f301627d437cff88);
module.exports["sanitizeUrl"] = $a08eb7c3df84467c$export$300bd6d67c49dbfc;
module.exports["EmFn"] = $a08eb7c3df84467c$export$fec26b2d751c6d95;
module.exports["StrikeFn"] = $a08eb7c3df84467c$export$e9e7c187aef6a83a;
module.exports["StringFn"] = $a08eb7c3df84467c$export$11a9c970dcafffc0;
module.exports["StrongFn"] = $a08eb7c3df84467c$export$566c617eb72a5976;

});

parcelRegister("gGmck", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["RendererContext"] = $4a7ba83bf95919d5$export$1e9ea4edb6d1bfe6;

});

parcelRegister("1nSBE", function(module, exports) {
$parcel$export(module.exports, "default", () => $da27ee5222cf5f14$export$2e2bcd8739ae039);
// Displays a warning message only once per message to avoid spamming the console with the same message multiple times.
const $da27ee5222cf5f14$var$messages = new Set();
function $da27ee5222cf5f14$export$2e2bcd8739ae039(message) {
    if ($da27ee5222cf5f14$var$messages.has(message)) return;
    $da27ee5222cf5f14$var$messages.add(message);
    if (typeof window !== 'undefined') // eslint-disable-next-line no-console
    console.warn(message);
}

});

parcelRegister("eGvdC", function(module, exports) {

let $ab0d344adaa80ec0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ab0d344adaa80ec0$var$load("bf0yj").then(()=>parcelRequire('3yfJl'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("1cCuI", function(module, exports) {

let $0e04c59be6084a94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0e04c59be6084a94$var$load("hhss7"),
    $0e04c59be6084a94$var$load("eMbal")
]).then(()=>parcelRequire('eAAnv'));

});

parcelRegister("hcdJZ", function(module, exports) {

let $c84e374759cab121$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c84e374759cab121$var$load("Wowvf"),
    $c84e374759cab121$var$load("cjJTJ")
]).then(()=>parcelRequire('iV9t7'));

});

parcelRegister("HEA67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $45DA9 = parcelRequire("45DA9");


var $7oKJR = parcelRequire("7oKJR");

const $5a707b7422677cdc$export$5c431bb5ef7d7900 = ({ extensionId: extensionId, localId: localId, children: children })=>{
    (0, $7oKJR.setupContextKeysFromSessionStorage)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            forgeUIAttributes: {
                localId: localId,
                ...(0, $45DA9.extensionIdToAnalyticsAttributes)(extensionId)
            }
        }
    }, children);
};
module.exports["ForgeUIExtensionAnalyticsContext"] = $5a707b7422677cdc$export$5c431bb5ef7d7900;

});

parcelRegister("45DA9", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

function $4b306a2ad8292411$export$d4650cd03b563908(extensionId) {
    if (!extensionId) return {};
    try {
        const ari = (0, $7MEO5.parse)(extensionId);
        if (!ari.resourceId) return {};
        const [appId, environmentId, groupId, extensionKey] = ari.resourceId.split('/');
        return {
            appId: appId,
            environmentId: environmentId,
            groupId: groupId,
            extensionKey: extensionKey
        };
    } catch  {
        return {};
    }
}
module.exports["extensionIdToAnalyticsAttributes"] = $4b306a2ad8292411$export$d4650cd03b563908;

});

parcelRegister("fgm2d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $iRRvH = parcelRequire("iRRvH");


var $gWF6I = parcelRequire("gWF6I");

/* CustomUIRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $3b6c709f803268e6$var$ModalSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
    MAX: 'max',
    FULLSCREEN: 'fullscreen'
};
const $3b6c709f803268e6$var$modalDimensions = {
    [$3b6c709f803268e6$var$ModalSizes.SMALL]: {
        height: '20vh',
        minHeight: '320px'
    },
    [$3b6c709f803268e6$var$ModalSizes.MEDIUM]: {
        height: '40vh',
        minHeight: '520px'
    },
    [$3b6c709f803268e6$var$ModalSizes.LARGE]: {
        height: '70vh',
        minHeight: '720px'
    },
    [$3b6c709f803268e6$var$ModalSizes.XLARGE]: {
        height: '90vh'
    },
    [$3b6c709f803268e6$var$ModalSizes.MAX]: {
        height: '100%'
    },
    [$3b6c709f803268e6$var$ModalSizes.FULLSCREEN]: {
        height: '100%'
    }
};
const $3b6c709f803268e6$export$b3b34c460afe006f = (size)=>{
    if ((0, $dh538.fg)('destructure-getmodaldimensions-with-failsafe')) {
        const safeSize = $3b6c709f803268e6$var$modalDimensions[size] ? size : 'medium';
        return $3b6c709f803268e6$var$modalDimensions[safeSize];
    }
    return $3b6c709f803268e6$var$modalDimensions[size];
};

/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/relay/unused-fields */ 



var $gdv5Z = parcelRequire("gdv5Z");


var $a9dFP = parcelRequire("a9dFP");

var $cOrQJ = parcelRequire("cOrQJ");


var $jIiuI = parcelRequire("jIiuI");


var $ijfiP = parcelRequire("ijfiP");




var $a4TK8 = parcelRequire("a4TK8");

const $fbfcc51dc5b115ca$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))))=>{
    const [memoizedData, setMemoizedData] = (0, $42omo.useState)(data);
    (0, $42omo.useEffect)(()=>{
        if (!equalityCheck(data, memoizedData)) setMemoizedData(data);
    }, [
        data,
        memoizedData,
        equalityCheck
    ]);
    return memoizedData;
};



var $2uzbP = parcelRequire("2uzbP");


var $kaOT1 = parcelRequire("kaOT1");


var $5oEbs = parcelRequire("5oEbs");

var $LiNdD = parcelRequire("LiNdD");




var $4jZsH = parcelRequire("4jZsH");


var $6hkBe = parcelRequire("6hkBe");





var $ge8sG = parcelRequire("ge8sG");


var $UZU5S = parcelRequire("UZU5S");



var $6baEI = parcelRequire("6baEI");

const $130ab70bfb5bcaa7$export$9b96caef38763092 = ()=>{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};












/* InnerIframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $cUcZ5 = parcelRequire("cUcZ5");

var $39e5966e46da3777$exports = {};
!function(e) {
    var t;
    $39e5966e46da3777$exports = e();
}(function() {
    return (function r(o, i, u) {
        function s(n, e) {
            if (!i[n]) {
                if (!o[n]) {
                    var t = undefined;
                    if (!e && t) return t(n, !0);
                    if (a) return a(n, !0);
                    throw new Error("Cannot find module '" + n + "'");
                }
                e = i[n] = {
                    exports: {}
                };
                o[n][0].call(e.exports, function(e) {
                    var t = o[n][1][e];
                    return s(t || e);
                }, e, e.exports, r, o, i, u);
            }
            return i[n].exports;
        }
        for(var a = undefined, e = 0; e < u.length; e++)s(u[e]);
        return s;
    })({
        1: [
            function(w, b, m) {
                (function(e, n, s, c, d, h, p, g, y) {
                    "use strict";
                    var r = w("crypto");
                    function t(e, t) {
                        t = u(e, t);
                        var n;
                        return void 0 === (n = "passthrough" !== t.algorithm ? r.createHash(t.algorithm) : new l).write && (n.write = n.update, n.end = n.update), f(t, n).dispatch(e), n.update || n.end(""), n.digest ? n.digest("buffer" === t.encoding ? void 0 : t.encoding) : (e = n.read(), "buffer" !== t.encoding ? e.toString(t.encoding) : e);
                    }
                    (m = b.exports = t).sha1 = function(e) {
                        return t(e);
                    }, m.keys = function(e) {
                        return t(e, {
                            excludeValues: !0,
                            algorithm: "sha1",
                            encoding: "hex"
                        });
                    }, m.MD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex"
                        });
                    }, m.keysMD5 = function(e) {
                        return t(e, {
                            algorithm: "md5",
                            encoding: "hex",
                            excludeValues: !0
                        });
                    };
                    var o = r.getHashes ? r.getHashes().slice() : [
                        "sha1",
                        "md5"
                    ], i = (o.push("passthrough"), [
                        "buffer",
                        "hex",
                        "binary",
                        "base64"
                    ]);
                    function u(e, t) {
                        var n = {};
                        if (n.algorithm = (t = t || {}).algorithm || "sha1", n.encoding = t.encoding || "hex", n.excludeValues = !!t.excludeValues, n.algorithm = n.algorithm.toLowerCase(), n.encoding = n.encoding.toLowerCase(), n.ignoreUnknown = !0 === t.ignoreUnknown, n.respectType = !1 !== t.respectType, n.respectFunctionNames = !1 !== t.respectFunctionNames, n.respectFunctionProperties = !1 !== t.respectFunctionProperties, n.unorderedArrays = !0 === t.unorderedArrays, n.unorderedSets = !1 !== t.unorderedSets, n.unorderedObjects = !1 !== t.unorderedObjects, n.replacer = t.replacer || void 0, n.excludeKeys = t.excludeKeys || void 0, void 0 === e) throw new Error("Object argument required.");
                        for(var r = 0; r < o.length; ++r)o[r].toLowerCase() === n.algorithm.toLowerCase() && (n.algorithm = o[r]);
                        if (-1 === o.indexOf(n.algorithm)) throw new Error('Algorithm "' + n.algorithm + '"  not supported. supported values: ' + o.join(", "));
                        if (-1 === i.indexOf(n.encoding) && "passthrough" !== n.algorithm) throw new Error('Encoding "' + n.encoding + '"  not supported. supported values: ' + i.join(", "));
                        return n;
                    }
                    function a(e) {
                        if ("function" == typeof e) return null != /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e));
                    }
                    function f(o, t, i) {
                        i = i || [];
                        function u(e) {
                            return t.update ? t.update(e, "utf8") : t.write(e, "utf8");
                        }
                        return {
                            dispatch: function(e) {
                                return this["_" + (null === (e = o.replacer ? o.replacer(e) : e) ? "null" : typeof e)](e);
                            },
                            _object: function(t) {
                                var n, e = Object.prototype.toString.call(t), r = /\[object (.*)\]/i.exec(e);
                                r = (r = r ? r[1] : "unknown:[" + e + "]").toLowerCase();
                                if (0 <= (e = i.indexOf(t))) return this.dispatch("[CIRCULAR:" + e + "]");
                                if (i.push(t), void 0 !== s && s.isBuffer && s.isBuffer(t)) return u("buffer:"), u(t);
                                if ("object" === r || "function" === r || "asyncfunction" === r) return e = Object.keys(t), o.unorderedObjects && (e = e.sort()), !1 === o.respectType || a(t) || e.splice(0, 0, "prototype", "__proto__", "constructor"), o.excludeKeys && (e = e.filter(function(e) {
                                    return !o.excludeKeys(e);
                                })), u("object:" + e.length + ":"), n = this, e.forEach(function(e) {
                                    n.dispatch(e), u(":"), o.excludeValues || n.dispatch(t[e]), u(",");
                                });
                                if (!this["_" + r]) {
                                    if (o.ignoreUnknown) return u("[" + r + "]");
                                    throw new Error('Unknown object type "' + r + '"');
                                }
                                this["_" + r](t);
                            },
                            _array: function(e, t) {
                                t = void 0 !== t ? t : !1 !== o.unorderedArrays;
                                var n = this;
                                if (u("array:" + e.length + ":"), !t || e.length <= 1) return e.forEach(function(e) {
                                    return n.dispatch(e);
                                });
                                var r = [], t = e.map(function(e) {
                                    var t = new l, n = i.slice();
                                    return f(o, t, n).dispatch(e), r = r.concat(n.slice(i.length)), t.read().toString();
                                });
                                return i = i.concat(r), t.sort(), this._array(t, !1);
                            },
                            _date: function(e) {
                                return u("date:" + e.toJSON());
                            },
                            _symbol: function(e) {
                                return u("symbol:" + e.toString());
                            },
                            _error: function(e) {
                                return u("error:" + e.toString());
                            },
                            _boolean: function(e) {
                                return u("bool:" + e.toString());
                            },
                            _string: function(e) {
                                u("string:" + e.length + ":"), u(e.toString());
                            },
                            _function: function(e) {
                                u("fn:"), a(e) ? this.dispatch("[native]") : this.dispatch(e.toString()), !1 !== o.respectFunctionNames && this.dispatch("function-name:" + String(e.name)), o.respectFunctionProperties && this._object(e);
                            },
                            _number: function(e) {
                                return u("number:" + e.toString());
                            },
                            _xml: function(e) {
                                return u("xml:" + e.toString());
                            },
                            _null: function() {
                                return u("Null");
                            },
                            _undefined: function() {
                                return u("Undefined");
                            },
                            _regexp: function(e) {
                                return u("regex:" + e.toString());
                            },
                            _uint8array: function(e) {
                                return u("uint8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint8clampedarray: function(e) {
                                return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int8array: function(e) {
                                return u("int8array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint16array: function(e) {
                                return u("uint16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int16array: function(e) {
                                return u("int16array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _uint32array: function(e) {
                                return u("uint32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _int32array: function(e) {
                                return u("int32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float32array: function(e) {
                                return u("float32array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _float64array: function(e) {
                                return u("float64array:"), this.dispatch(Array.prototype.slice.call(e));
                            },
                            _arraybuffer: function(e) {
                                return u("arraybuffer:"), this.dispatch(new Uint8Array(e));
                            },
                            _url: function(e) {
                                return u("url:" + e.toString());
                            },
                            _map: function(e) {
                                u("map:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _set: function(e) {
                                u("set:");
                                e = Array.from(e);
                                return this._array(e, !1 !== o.unorderedSets);
                            },
                            _file: function(e) {
                                return u("file:"), this.dispatch([
                                    e.name,
                                    e.size,
                                    e.type,
                                    e.lastModfied
                                ]);
                            },
                            _blob: function() {
                                if (o.ignoreUnknown) return u("[blob]");
                                throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
                            },
                            _domwindow: function() {
                                return u("domwindow");
                            },
                            _bigint: function(e) {
                                return u("bigint:" + e.toString());
                            },
                            _process: function() {
                                return u("process");
                            },
                            _timer: function() {
                                return u("timer");
                            },
                            _pipe: function() {
                                return u("pipe");
                            },
                            _tcp: function() {
                                return u("tcp");
                            },
                            _udp: function() {
                                return u("udp");
                            },
                            _tty: function() {
                                return u("tty");
                            },
                            _statwatcher: function() {
                                return u("statwatcher");
                            },
                            _securecontext: function() {
                                return u("securecontext");
                            },
                            _connection: function() {
                                return u("connection");
                            },
                            _zlib: function() {
                                return u("zlib");
                            },
                            _context: function() {
                                return u("context");
                            },
                            _nodescript: function() {
                                return u("nodescript");
                            },
                            _httpparser: function() {
                                return u("httpparser");
                            },
                            _dataview: function() {
                                return u("dataview");
                            },
                            _signal: function() {
                                return u("signal");
                            },
                            _fsevent: function() {
                                return u("fsevent");
                            },
                            _tlswrap: function() {
                                return u("tlswrap");
                            }
                        };
                    }
                    function l() {
                        return {
                            buf: "",
                            write: function(e) {
                                this.buf += e;
                            },
                            end: function(e) {
                                this.buf += e;
                            },
                            read: function() {
                                return this.buf;
                            }
                        };
                    }
                    m.writeToStream = function(e, t, n) {
                        return void 0 === n && (n = t, t = {}), f(t = u(e, t), n).dispatch(e);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
            },
            {
                buffer: 3,
                crypto: 5,
                lYpoI2: 11
            }
        ],
        2: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    !function(e) {
                        "use strict";
                        var a = "undefined" != typeof Uint8Array ? Uint8Array : Array, t = "+".charCodeAt(0), n = "/".charCodeAt(0), r = "0".charCodeAt(0), o = "a".charCodeAt(0), i = "A".charCodeAt(0), u = "-".charCodeAt(0), s = "_".charCodeAt(0);
                        function f(e) {
                            e = e.charCodeAt(0);
                            return e === t || e === u ? 62 : e === n || e === s ? 63 : e < r ? -1 : e < r + 10 ? e - r + 26 + 26 : e < i + 26 ? e - i : e < o + 26 ? e - o + 26 : void 0;
                        }
                        e.toByteArray = function(e) {
                            var t, n;
                            if (0 < e.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                            var r = e.length, r = "=" === e.charAt(r - 2) ? 2 : "=" === e.charAt(r - 1) ? 1 : 0, o = new a(3 * e.length / 4 - r), i = 0 < r ? e.length - 4 : e.length, u = 0;
                            function s(e) {
                                o[u++] = e;
                            }
                            for(t = 0; t < i; t += 4)s((16711680 & (n = f(e.charAt(t)) << 18 | f(e.charAt(t + 1)) << 12 | f(e.charAt(t + 2)) << 6 | f(e.charAt(t + 3)))) >> 16), s((65280 & n) >> 8), s(255 & n);
                            return 2 == r ? s(255 & (n = f(e.charAt(t)) << 2 | f(e.charAt(t + 1)) >> 4)) : 1 == r && (s((n = f(e.charAt(t)) << 10 | f(e.charAt(t + 1)) << 4 | f(e.charAt(t + 2)) >> 2) >> 8 & 255), s(255 & n)), o;
                        }, e.fromByteArray = function(e) {
                            var t, n, r, o, i = e.length % 3, u = "";
                            function s(e) {
                                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e);
                            }
                            for(t = 0, r = e.length - i; t < r; t += 3)n = (e[t] << 16) + (e[t + 1] << 8) + e[t + 2], u += s((o = n) >> 18 & 63) + s(o >> 12 & 63) + s(o >> 6 & 63) + s(63 & o);
                            switch(i){
                                case 1:
                                    u = (u += s((n = e[e.length - 1]) >> 2)) + s(n << 4 & 63) + "==";
                                    break;
                                case 2:
                                    u = (u = (u += s((n = (e[e.length - 2] << 8) + e[e.length - 1]) >> 10)) + s(n >> 4 & 63)) + s(n << 2 & 63) + "=";
                            }
                            return u;
                        };
                    }(void 0 === f ? this.base64js = {} : f);
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        3: [
            function(O, e, H) {
                (function(e, n, f, r, h, p, g, y, w) {
                    var a = O("base64-js"), i = O("ieee754");
                    function f(e, t, n) {
                        if (!(this instanceof f)) return new f(e, t, n);
                        var r, o, i, u, s = typeof e;
                        if ("base64" === t && "string" == s) for(e = (u = e).trim ? u.trim() : u.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0;)e += "=";
                        if ("number" == s) r = j(e);
                        else if ("string" == s) r = f.byteLength(e, t);
                        else {
                            if ("object" != s) throw new Error("First argument needs to be a number, array or string.");
                            r = j(e.length);
                        }
                        if (f._useTypedArrays ? o = f._augment(new Uint8Array(r)) : ((o = this).length = r, o._isBuffer = !0), f._useTypedArrays && "number" == typeof e.byteLength) o._set(e);
                        else if (C(u = e) || f.isBuffer(u) || u && "object" == typeof u && "number" == typeof u.length) for(i = 0; i < r; i++)f.isBuffer(e) ? o[i] = e.readUInt8(i) : o[i] = e[i];
                        else if ("string" == s) o.write(e, 0, t);
                        else if ("number" == s && !f._useTypedArrays && !n) for(i = 0; i < r; i++)o[i] = 0;
                        return o;
                    }
                    function b(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t = [], n = 0; n < e.length; n++)t.push(255 & e.charCodeAt(n));
                            return t;
                        }(t), e, n, r);
                    }
                    function m(e, t, n, r) {
                        return f._charsWritten = c(function(e) {
                            for(var t, n, r = [], o = 0; o < e.length; o++)n = e.charCodeAt(o), t = n >> 8, n = n % 256, r.push(n), r.push(t);
                            return r;
                        }(t), e, n, r);
                    }
                    function v(e, t, n) {
                        var r = "";
                        n = Math.min(e.length, n);
                        for(var o = t; o < n; o++)r += String.fromCharCode(e[o]);
                        return r;
                    }
                    function o(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (o = e[t], t + 1 < r && (o |= e[t + 1] << 8)) : (o = e[t] << 8, t + 1 < r && (o |= e[t + 1])), o;
                    }
                    function u(e, t, n, r) {
                        r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length"));
                        var o, r = e.length;
                        if (!(r <= t)) return n ? (t + 2 < r && (o = e[t + 2] << 16), t + 1 < r && (o |= e[t + 1] << 8), o |= e[t], t + 3 < r && (o += e[t + 3] << 24 >>> 0)) : (t + 1 < r && (o = e[t + 1] << 16), t + 2 < r && (o |= e[t + 2] << 8), t + 3 < r && (o |= e[t + 3]), o += e[t] << 24 >>> 0), o;
                    }
                    function _(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = o(e, t, n, !0), 32768 & r ? -1 * (65535 - r + 1) : r;
                    }
                    function E(e, t, n, r) {
                        if (r || (d("boolean" == typeof n, "missing or invalid endian"), d(null != t, "missing offset"), d(t + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= t)) return r = u(e, t, n, !0), 2147483648 & r ? -1 * (4294967295 - r + 1) : r;
                    }
                    function I(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 3 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 23, 4);
                    }
                    function A(e, t, n, r) {
                        return r || (d("boolean" == typeof n, "missing or invalid endian"), d(t + 7 < e.length, "Trying to read beyond buffer length")), i.read(e, t, n, 52, 8);
                    }
                    function s(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "trying to write beyond buffer length"), Y(t, 65535));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 2); i < u; i++)e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
                    }
                    function l(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "trying to write beyond buffer length"), Y(t, 4294967295));
                        o = e.length;
                        if (!(o <= n)) for(var i = 0, u = Math.min(o - n, 4); i < u; i++)e[n + i] = t >>> 8 * (r ? i : 3 - i) & 255;
                    }
                    function B(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 1 < e.length, "Trying to write beyond buffer length"), F(t, 32767, -32768)), e.length <= n || s(e, 0 <= t ? t : 65535 + t + 1, n, r, o);
                    }
                    function L(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), F(t, 2147483647, -2147483648)), e.length <= n || l(e, 0 <= t ? t : 4294967295 + t + 1, n, r, o);
                    }
                    function U(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 3 < e.length, "Trying to write beyond buffer length"), D(t, 34028234663852886e22, -3.4028234663852886e+38)), e.length <= n || i.write(e, t, n, r, 23, 4);
                    }
                    function x(e, t, n, r, o) {
                        o || (d(null != t, "missing value"), d("boolean" == typeof r, "missing or invalid endian"), d(null != n, "missing offset"), d(n + 7 < e.length, "Trying to write beyond buffer length"), D(t, 17976931348623157e292, -1.7976931348623157e+308)), e.length <= n || i.write(e, t, n, r, 52, 8);
                    }
                    H.Buffer = f, H.SlowBuffer = f, H.INSPECT_MAX_BYTES = 50, f.poolSize = 8192, f._useTypedArrays = function() {
                        try {
                            var e = new ArrayBuffer(0), t = new Uint8Array(e);
                            return t.foo = function() {
                                return 42;
                            }, 42 === t.foo() && "function" == typeof t.subarray;
                        } catch (e) {
                            return !1;
                        }
                    }(), f.isEncoding = function(e) {
                        switch(String(e).toLowerCase()){
                            case "hex":
                            case "utf8":
                            case "utf-8":
                            case "ascii":
                            case "binary":
                            case "base64":
                            case "raw":
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                return !0;
                            default:
                                return !1;
                        }
                    }, f.isBuffer = function(e) {
                        return !(null == e || !e._isBuffer);
                    }, f.byteLength = function(e, t) {
                        var n;
                        switch(e += "", t || "utf8"){
                            case "hex":
                                n = e.length / 2;
                                break;
                            case "utf8":
                            case "utf-8":
                                n = T(e).length;
                                break;
                            case "ascii":
                            case "binary":
                            case "raw":
                                n = e.length;
                                break;
                            case "base64":
                                n = M(e).length;
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                n = 2 * e.length;
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return n;
                    }, f.concat = function(e, t) {
                        if (d(C(e), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), 0 === e.length) return new f(0);
                        if (1 === e.length) return e[0];
                        if ("number" != typeof t) for(o = t = 0; o < e.length; o++)t += e[o].length;
                        for(var n = new f(t), r = 0, o = 0; o < e.length; o++){
                            var i = e[o];
                            i.copy(n, r), r += i.length;
                        }
                        return n;
                    }, f.prototype.write = function(e, t, n, r) {
                        isFinite(t) ? isFinite(n) || (r = n, n = void 0) : (a = r, r = t, t = n, n = a), t = Number(t) || 0;
                        var o, i, u, s, a = this.length - t;
                        switch((!n || a < (n = Number(n))) && (n = a), r = String(r || "utf8").toLowerCase()){
                            case "hex":
                                o = function(e, t, n, r) {
                                    n = Number(n) || 0;
                                    var o = e.length - n;
                                    (!r || o < (r = Number(r))) && (r = o), d((o = t.length) % 2 == 0, "Invalid hex string"), o / 2 < r && (r = o / 2);
                                    for(var i = 0; i < r; i++){
                                        var u = parseInt(t.substr(2 * i, 2), 16);
                                        d(!isNaN(u), "Invalid hex string"), e[n + i] = u;
                                    }
                                    return f._charsWritten = 2 * i, i;
                                }(this, e, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                i = this, u = t, s = n, o = f._charsWritten = c(T(e), i, u, s);
                                break;
                            case "ascii":
                            case "binary":
                                o = b(this, e, t, n);
                                break;
                            case "base64":
                                i = this, u = t, s = n, o = f._charsWritten = c(M(e), i, u, s);
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                o = m(this, e, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return o;
                    }, f.prototype.toString = function(e, t, n) {
                        var r, o, i, u, s = this;
                        if (e = String(e || "utf8").toLowerCase(), t = Number(t) || 0, (n = void 0 !== n ? Number(n) : s.length) === t) return "";
                        switch(e){
                            case "hex":
                                r = function(e, t, n) {
                                    var r = e.length;
                                    (!t || t < 0) && (t = 0);
                                    (!n || n < 0 || r < n) && (n = r);
                                    for(var o = "", i = t; i < n; i++)o += k(e[i]);
                                    return o;
                                }(s, t, n);
                                break;
                            case "utf8":
                            case "utf-8":
                                r = function(e, t, n) {
                                    var r = "", o = "";
                                    n = Math.min(e.length, n);
                                    for(var i = t; i < n; i++)e[i] <= 127 ? (r += N(o) + String.fromCharCode(e[i]), o = "") : o += "%" + e[i].toString(16);
                                    return r + N(o);
                                }(s, t, n);
                                break;
                            case "ascii":
                            case "binary":
                                r = v(s, t, n);
                                break;
                            case "base64":
                                o = s, u = n, r = 0 === (i = t) && u === o.length ? a.fromByteArray(o) : a.fromByteArray(o.slice(i, u));
                                break;
                            case "ucs2":
                            case "ucs-2":
                            case "utf16le":
                            case "utf-16le":
                                r = function(e, t, n) {
                                    for(var r = e.slice(t, n), o = "", i = 0; i < r.length; i += 2)o += String.fromCharCode(r[i] + 256 * r[i + 1]);
                                    return o;
                                }(s, t, n);
                                break;
                            default:
                                throw new Error("Unknown encoding");
                        }
                        return r;
                    }, f.prototype.toJSON = function() {
                        return {
                            type: "Buffer",
                            data: Array.prototype.slice.call(this._arr || this, 0)
                        };
                    }, f.prototype.copy = function(e, t, n, r) {
                        if (t = t || 0, (r = r || 0 === r ? r : this.length) !== (n = n || 0) && 0 !== e.length && 0 !== this.length) {
                            d(n <= r, "sourceEnd < sourceStart"), d(0 <= t && t < e.length, "targetStart out of bounds"), d(0 <= n && n < this.length, "sourceStart out of bounds"), d(0 <= r && r <= this.length, "sourceEnd out of bounds"), r > this.length && (r = this.length);
                            var o = (r = e.length - t < r - n ? e.length - t + n : r) - n;
                            if (o < 100 || !f._useTypedArrays) for(var i = 0; i < o; i++)e[i + t] = this[i + n];
                            else e._set(this.subarray(n, n + o), t);
                        }
                    }, f.prototype.slice = function(e, t) {
                        var n = this.length;
                        if (e = S(e, n, 0), t = S(t, n, n), f._useTypedArrays) return f._augment(this.subarray(e, t));
                        for(var r = t - e, o = new f(r, void 0, !0), i = 0; i < r; i++)o[i] = this[i + e];
                        return o;
                    }, f.prototype.get = function(e) {
                        return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
                    }, f.prototype.set = function(e, t) {
                        return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, t);
                    }, f.prototype.readUInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return this[e];
                    }, f.prototype.readUInt16LE = function(e, t) {
                        return o(this, e, !0, t);
                    }, f.prototype.readUInt16BE = function(e, t) {
                        return o(this, e, !1, t);
                    }, f.prototype.readUInt32LE = function(e, t) {
                        return u(this, e, !0, t);
                    }, f.prototype.readUInt32BE = function(e, t) {
                        return u(this, e, !1, t);
                    }, f.prototype.readInt8 = function(e, t) {
                        if (t || (d(null != e, "missing offset"), d(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length)) return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                    }, f.prototype.readInt16LE = function(e, t) {
                        return _(this, e, !0, t);
                    }, f.prototype.readInt16BE = function(e, t) {
                        return _(this, e, !1, t);
                    }, f.prototype.readInt32LE = function(e, t) {
                        return E(this, e, !0, t);
                    }, f.prototype.readInt32BE = function(e, t) {
                        return E(this, e, !1, t);
                    }, f.prototype.readFloatLE = function(e, t) {
                        return I(this, e, !0, t);
                    }, f.prototype.readFloatBE = function(e, t) {
                        return I(this, e, !1, t);
                    }, f.prototype.readDoubleLE = function(e, t) {
                        return A(this, e, !0, t);
                    }, f.prototype.readDoubleBE = function(e, t) {
                        return A(this, e, !1, t);
                    }, f.prototype.writeUInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "trying to write beyond buffer length"), Y(e, 255)), t >= this.length || (this[t] = e);
                    }, f.prototype.writeUInt16LE = function(e, t, n) {
                        s(this, e, t, !0, n);
                    }, f.prototype.writeUInt16BE = function(e, t, n) {
                        s(this, e, t, !1, n);
                    }, f.prototype.writeUInt32LE = function(e, t, n) {
                        l(this, e, t, !0, n);
                    }, f.prototype.writeUInt32BE = function(e, t, n) {
                        l(this, e, t, !1, n);
                    }, f.prototype.writeInt8 = function(e, t, n) {
                        n || (d(null != e, "missing value"), d(null != t, "missing offset"), d(t < this.length, "Trying to write beyond buffer length"), F(e, 127, -128)), t >= this.length || (0 <= e ? this.writeUInt8(e, t, n) : this.writeUInt8(255 + e + 1, t, n));
                    }, f.prototype.writeInt16LE = function(e, t, n) {
                        B(this, e, t, !0, n);
                    }, f.prototype.writeInt16BE = function(e, t, n) {
                        B(this, e, t, !1, n);
                    }, f.prototype.writeInt32LE = function(e, t, n) {
                        L(this, e, t, !0, n);
                    }, f.prototype.writeInt32BE = function(e, t, n) {
                        L(this, e, t, !1, n);
                    }, f.prototype.writeFloatLE = function(e, t, n) {
                        U(this, e, t, !0, n);
                    }, f.prototype.writeFloatBE = function(e, t, n) {
                        U(this, e, t, !1, n);
                    }, f.prototype.writeDoubleLE = function(e, t, n) {
                        x(this, e, t, !0, n);
                    }, f.prototype.writeDoubleBE = function(e, t, n) {
                        x(this, e, t, !1, n);
                    }, f.prototype.fill = function(e, t, n) {
                        if (t = t || 0, n = n || this.length, d("number" == typeof (e = "string" == typeof (e = e || 0) ? e.charCodeAt(0) : e) && !isNaN(e), "value is not a number"), d(t <= n, "end < start"), n !== t && 0 !== this.length) {
                            d(0 <= t && t < this.length, "start out of bounds"), d(0 <= n && n <= this.length, "end out of bounds");
                            for(var r = t; r < n; r++)this[r] = e;
                        }
                    }, f.prototype.inspect = function() {
                        for(var e = [], t = this.length, n = 0; n < t; n++)if (e[n] = k(this[n]), n === H.INSPECT_MAX_BYTES) {
                            e[n + 1] = "...";
                            break;
                        }
                        return "<Buffer " + e.join(" ") + ">";
                    }, f.prototype.toArrayBuffer = function() {
                        if ("undefined" == typeof Uint8Array) throw new Error("Buffer.toArrayBuffer not supported in this browser");
                        if (f._useTypedArrays) return new f(this).buffer;
                        for(var e = new Uint8Array(this.length), t = 0, n = e.length; t < n; t += 1)e[t] = this[t];
                        return e.buffer;
                    };
                    var t = f.prototype;
                    function S(e, t, n) {
                        return "number" != typeof e ? n : t <= (e = ~~e) ? t : 0 <= e || 0 <= (e += t) ? e : 0;
                    }
                    function j(e) {
                        return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
                    }
                    function C(e) {
                        return (Array.isArray || function(e) {
                            return "[object Array]" === Object.prototype.toString.call(e);
                        })(e);
                    }
                    function k(e) {
                        return e < 16 ? "0" + e.toString(16) : e.toString(16);
                    }
                    function T(e) {
                        for(var t = [], n = 0; n < e.length; n++){
                            var r = e.charCodeAt(n);
                            if (r <= 127) t.push(e.charCodeAt(n));
                            else for(var o = n, i = (55296 <= r && r <= 57343 && n++, encodeURIComponent(e.slice(o, n + 1)).substr(1).split("%")), u = 0; u < i.length; u++)t.push(parseInt(i[u], 16));
                        }
                        return t;
                    }
                    function M(e) {
                        return a.toByteArray(e);
                    }
                    function c(e, t, n, r) {
                        for(var o = 0; o < r && !(o + n >= t.length || o >= e.length); o++)t[o + n] = e[o];
                        return o;
                    }
                    function N(e) {
                        try {
                            return decodeURIComponent(e);
                        } catch (e) {
                            return String.fromCharCode(65533);
                        }
                    }
                    function Y(e, t) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(0 <= e, "specified a negative value for writing an unsigned value"), d(e <= t, "value is larger than maximum value for type"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function F(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value"), d(Math.floor(e) === e, "value has a fractional component");
                    }
                    function D(e, t, n) {
                        d("number" == typeof e, "cannot write a non-number as a number"), d(e <= t, "value larger than maximum allowed value"), d(n <= e, "value smaller than minimum allowed value");
                    }
                    function d(e, t) {
                        if (!e) throw new Error(t || "Failed assertion");
                    }
                    f._augment = function(e) {
                        return e._isBuffer = !0, e._get = e.get, e._set = e.set, e.get = t.get, e.set = t.set, e.write = t.write, e.toString = t.toString, e.toLocaleString = t.toString, e.toJSON = t.toJSON, e.copy = t.copy, e.slice = t.slice, e.readUInt8 = t.readUInt8, e.readUInt16LE = t.readUInt16LE, e.readUInt16BE = t.readUInt16BE, e.readUInt32LE = t.readUInt32LE, e.readUInt32BE = t.readUInt32BE, e.readInt8 = t.readInt8, e.readInt16LE = t.readInt16LE, e.readInt16BE = t.readInt16BE, e.readInt32LE = t.readInt32LE, e.readInt32BE = t.readInt32BE, e.readFloatLE = t.readFloatLE, e.readFloatBE = t.readFloatBE, e.readDoubleLE = t.readDoubleLE, e.readDoubleBE = t.readDoubleBE, e.writeUInt8 = t.writeUInt8, e.writeUInt16LE = t.writeUInt16LE, e.writeUInt16BE = t.writeUInt16BE, e.writeUInt32LE = t.writeUInt32LE, e.writeUInt32BE = t.writeUInt32BE, e.writeInt8 = t.writeInt8, e.writeInt16LE = t.writeInt16LE, e.writeInt16BE = t.writeInt16BE, e.writeInt32LE = t.writeInt32LE, e.writeInt32BE = t.writeInt32BE, e.writeFloatLE = t.writeFloatLE, e.writeFloatBE = t.writeFloatBE, e.writeDoubleLE = t.writeDoubleLE, e.writeDoubleBE = t.writeDoubleBE, e.fill = t.fill, e.inspect = t.inspect, e.toArrayBuffer = t.toArrayBuffer, e;
                    };
                }).call(this, O("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
            },
            {
                "base64-js": 2,
                buffer: 3,
                ieee754: 10,
                lYpoI2: 11
            }
        ],
        4: [
            function(c, d, e) {
                (function(e, t, a, n, r, o, i, u, s) {
                    var a = c("buffer").Buffer, f = 4, l = new a(f);
                    l.fill(0);
                    d.exports = {
                        hash: function(e, t, n, r) {
                            for(var o = t(function(e, t) {
                                e.length % f != 0 && (n = e.length + (f - e.length % f), e = a.concat([
                                    e,
                                    l
                                ], n));
                                for(var n, r = [], o = t ? e.readInt32BE : e.readInt32LE, i = 0; i < e.length; i += f)r.push(o.call(e, i));
                                return r;
                            }(e = a.isBuffer(e) ? e : new a(e), r), 8 * e.length), t = r, i = new a(n), u = t ? i.writeInt32BE : i.writeInt32LE, s = 0; s < o.length; s++)u.call(i, o[s], 4 * s, !0);
                            return i;
                        }
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        5: [
            function(v, e, _) {
                (function(l, c, u, d, h, p, g, y, w) {
                    var u = v("buffer").Buffer, e = v("./sha"), t = v("./sha256"), n = v("./rng"), b = {
                        sha1: e,
                        sha256: t,
                        md5: v("./md5")
                    }, s = 64, a = new u(s);
                    function r(e, n) {
                        var r = b[e = e || "sha1"], o = [];
                        return r || i("algorithm:", e, "is not yet supported"), {
                            update: function(e) {
                                return u.isBuffer(e) || (e = new u(e)), o.push(e), e.length, this;
                            },
                            digest: function(e) {
                                var t = u.concat(o), t = n ? function(e, t, n) {
                                    u.isBuffer(t) || (t = new u(t)), u.isBuffer(n) || (n = new u(n)), t.length > s ? t = e(t) : t.length < s && (t = u.concat([
                                        t,
                                        a
                                    ], s));
                                    for(var r = new u(s), o = new u(s), i = 0; i < s; i++)r[i] = 54 ^ t[i], o[i] = 92 ^ t[i];
                                    return n = e(u.concat([
                                        r,
                                        n
                                    ])), e(u.concat([
                                        o,
                                        n
                                    ]));
                                }(r, n, t) : r(t);
                                return o = null, e ? t.toString(e) : t;
                            }
                        };
                    }
                    function i() {
                        var e = [].slice.call(arguments).join(" ");
                        throw new Error([
                            e,
                            "we accept pull requests",
                            "http://github.com/dominictarr/crypto-browserify"
                        ].join("\n"));
                    }
                    a.fill(0), _.createHash = function(e) {
                        return r(e);
                    }, _.createHmac = r, _.randomBytes = function(e, t) {
                        if (!t || !t.call) return new u(n(e));
                        try {
                            t.call(this, void 0, new u(n(e)));
                        } catch (e) {
                            t(e);
                        }
                    };
                    var o, f = [
                        "createCredentials",
                        "createCipher",
                        "createCipheriv",
                        "createDecipher",
                        "createDecipheriv",
                        "createSign",
                        "createVerify",
                        "createDiffieHellman",
                        "pbkdf2"
                    ], m = function(e) {
                        _[e] = function() {
                            i("sorry,", e, "is not implemented yet");
                        };
                    };
                    for(o in f)m(f[o], o);
                }).call(this, v("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./md5": 6,
                "./rng": 7,
                "./sha": 8,
                "./sha256": 9,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        6: [
            function(w, b, e) {
                (function(e, r, o, i, u, a, f, l, y) {
                    var t = w("./helpers");
                    function n(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
                        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, u = 0; u < e.length; u += 16){
                            var s = n, a = r, f = o, l = i, n = c(n, r, o, i, e[u + 0], 7, -680876936), i = c(i, n, r, o, e[u + 1], 12, -389564586), o = c(o, i, n, r, e[u + 2], 17, 606105819), r = c(r, o, i, n, e[u + 3], 22, -1044525330);
                            n = c(n, r, o, i, e[u + 4], 7, -176418897), i = c(i, n, r, o, e[u + 5], 12, 1200080426), o = c(o, i, n, r, e[u + 6], 17, -1473231341), r = c(r, o, i, n, e[u + 7], 22, -45705983), n = c(n, r, o, i, e[u + 8], 7, 1770035416), i = c(i, n, r, o, e[u + 9], 12, -1958414417), o = c(o, i, n, r, e[u + 10], 17, -42063), r = c(r, o, i, n, e[u + 11], 22, -1990404162), n = c(n, r, o, i, e[u + 12], 7, 1804603682), i = c(i, n, r, o, e[u + 13], 12, -40341101), o = c(o, i, n, r, e[u + 14], 17, -1502002290), n = d(n, r = c(r, o, i, n, e[u + 15], 22, 1236535329), o, i, e[u + 1], 5, -165796510), i = d(i, n, r, o, e[u + 6], 9, -1069501632), o = d(o, i, n, r, e[u + 11], 14, 643717713), r = d(r, o, i, n, e[u + 0], 20, -373897302), n = d(n, r, o, i, e[u + 5], 5, -701558691), i = d(i, n, r, o, e[u + 10], 9, 38016083), o = d(o, i, n, r, e[u + 15], 14, -660478335), r = d(r, o, i, n, e[u + 4], 20, -405537848), n = d(n, r, o, i, e[u + 9], 5, 568446438), i = d(i, n, r, o, e[u + 14], 9, -1019803690), o = d(o, i, n, r, e[u + 3], 14, -187363961), r = d(r, o, i, n, e[u + 8], 20, 1163531501), n = d(n, r, o, i, e[u + 13], 5, -1444681467), i = d(i, n, r, o, e[u + 2], 9, -51403784), o = d(o, i, n, r, e[u + 7], 14, 1735328473), n = h(n, r = d(r, o, i, n, e[u + 12], 20, -1926607734), o, i, e[u + 5], 4, -378558), i = h(i, n, r, o, e[u + 8], 11, -2022574463), o = h(o, i, n, r, e[u + 11], 16, 1839030562), r = h(r, o, i, n, e[u + 14], 23, -35309556), n = h(n, r, o, i, e[u + 1], 4, -1530992060), i = h(i, n, r, o, e[u + 4], 11, 1272893353), o = h(o, i, n, r, e[u + 7], 16, -155497632), r = h(r, o, i, n, e[u + 10], 23, -1094730640), n = h(n, r, o, i, e[u + 13], 4, 681279174), i = h(i, n, r, o, e[u + 0], 11, -358537222), o = h(o, i, n, r, e[u + 3], 16, -722521979), r = h(r, o, i, n, e[u + 6], 23, 76029189), n = h(n, r, o, i, e[u + 9], 4, -640364487), i = h(i, n, r, o, e[u + 12], 11, -421815835), o = h(o, i, n, r, e[u + 15], 16, 530742520), n = p(n, r = h(r, o, i, n, e[u + 2], 23, -995338651), o, i, e[u + 0], 6, -198630844), i = p(i, n, r, o, e[u + 7], 10, 1126891415), o = p(o, i, n, r, e[u + 14], 15, -1416354905), r = p(r, o, i, n, e[u + 5], 21, -57434055), n = p(n, r, o, i, e[u + 12], 6, 1700485571), i = p(i, n, r, o, e[u + 3], 10, -1894986606), o = p(o, i, n, r, e[u + 10], 15, -1051523), r = p(r, o, i, n, e[u + 1], 21, -2054922799), n = p(n, r, o, i, e[u + 8], 6, 1873313359), i = p(i, n, r, o, e[u + 15], 10, -30611744), o = p(o, i, n, r, e[u + 6], 15, -1560198380), r = p(r, o, i, n, e[u + 13], 21, 1309151649), n = p(n, r, o, i, e[u + 4], 6, -145523070), i = p(i, n, r, o, e[u + 11], 10, -1120210379), o = p(o, i, n, r, e[u + 2], 15, 718787259), r = p(r, o, i, n, e[u + 9], 21, -343485551), n = g(n, s), r = g(r, a), o = g(o, f), i = g(i, l);
                        }
                        return Array(n, r, o, i);
                    }
                    function s(e, t, n, r, o, i) {
                        return g((t = g(g(t, e), g(r, i))) << o | t >>> 32 - o, n);
                    }
                    function c(e, t, n, r, o, i, u) {
                        return s(t & n | ~t & r, e, t, o, i, u);
                    }
                    function d(e, t, n, r, o, i, u) {
                        return s(t & r | n & ~r, e, t, o, i, u);
                    }
                    function h(e, t, n, r, o, i, u) {
                        return s(t ^ n ^ r, e, t, o, i, u);
                    }
                    function p(e, t, n, r, o, i, u) {
                        return s(n ^ (t | ~r), e, t, o, i, u);
                    }
                    function g(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    b.exports = function(e) {
                        return t.hash(e, n, 16);
                    };
                }).call(this, w("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        7: [
            function(e, l, t) {
                (function(e, t, n, r, o, i, u, s, f) {
                    var a;
                    l.exports = a || function(e) {
                        for(var t, n = new Array(e), r = 0; r < e; r++)0 == (3 & r) && (t = 4294967296 * Math.random()), n[r] = t >>> ((3 & r) << 3) & 255;
                        return n;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        8: [
            function(c, d, e) {
                (function(e, t, n, r, o, s, a, f, l) {
                    var i = c("./helpers");
                    function u(l, c) {
                        l[c >> 5] |= 128 << 24 - c % 32, l[15 + (c + 64 >> 9 << 4)] = c;
                        for(var e, t, n, r = Array(80), o = 1732584193, i = -271733879, u = -1732584194, s = 271733878, d = -1009589776, h = 0; h < l.length; h += 16){
                            for(var p = o, g = i, y = u, w = s, b = d, a = 0; a < 80; a++){
                                r[a] = a < 16 ? l[h + a] : v(r[a - 3] ^ r[a - 8] ^ r[a - 14] ^ r[a - 16], 1);
                                var f = m(m(v(o, 5), (f = i, t = u, n = s, (e = a) < 20 ? f & t | ~f & n : !(e < 40) && e < 60 ? f & t | f & n | t & n : f ^ t ^ n)), m(m(d, r[a]), (e = a) < 20 ? 1518500249 : e < 40 ? 1859775393 : e < 60 ? -1894007588 : -899497514)), d = s, s = u, u = v(i, 30), i = o, o = f;
                            }
                            o = m(o, p), i = m(i, g), u = m(u, y), s = m(s, w), d = m(d, b);
                        }
                        return Array(o, i, u, s, d);
                    }
                    function m(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function v(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    d.exports = function(e) {
                        return i.hash(e, u, 20, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        9: [
            function(c, d, e) {
                (function(e, t, n, r, u, s, a, f, l) {
                    function b(e, t) {
                        var n = (65535 & e) + (65535 & t);
                        return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
                    }
                    function o(e, l) {
                        var c, d = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n = new Array(64);
                        e[l >> 5] |= 128 << 24 - l % 32, e[15 + (l + 64 >> 9 << 4)] = l;
                        for(var r, o, h = 0; h < e.length; h += 16){
                            for(var i = t[0], u = t[1], s = t[2], p = t[3], a = t[4], g = t[5], y = t[6], w = t[7], f = 0; f < 64; f++)n[f] = f < 16 ? e[f + h] : b(b(b((o = n[f - 2], m(o, 17) ^ m(o, 19) ^ v(o, 10)), n[f - 7]), (o = n[f - 15], m(o, 7) ^ m(o, 18) ^ v(o, 3))), n[f - 16]), c = b(b(b(b(w, m(o = a, 6) ^ m(o, 11) ^ m(o, 25)), a & g ^ ~a & y), d[f]), n[f]), r = b(m(r = i, 2) ^ m(r, 13) ^ m(r, 22), i & u ^ i & s ^ u & s), w = y, y = g, g = a, a = b(p, c), p = s, s = u, u = i, i = b(c, r);
                            t[0] = b(i, t[0]), t[1] = b(u, t[1]), t[2] = b(s, t[2]), t[3] = b(p, t[3]), t[4] = b(a, t[4]), t[5] = b(g, t[5]), t[6] = b(y, t[6]), t[7] = b(w, t[7]);
                        }
                        return t;
                    }
                    var i = c("./helpers"), m = function(e, t) {
                        return e >>> t | e << 32 - t;
                    }, v = function(e, t) {
                        return e >>> t;
                    };
                    d.exports = function(e) {
                        return i.hash(e, o, 32, !0);
                    };
                }).call(this, c("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
            },
            {
                "./helpers": 4,
                buffer: 3,
                lYpoI2: 11
            }
        ],
        10: [
            function(e, t, f) {
                (function(e, t, n, r, o, i, u, s, a) {
                    f.read = function(e, t, n, r, o) {
                        var i, u, l = 8 * o - r - 1, c = (1 << l) - 1, d = c >> 1, s = -7, a = n ? o - 1 : 0, f = n ? -1 : 1, o = e[t + a];
                        for(a += f, i = o & (1 << -s) - 1, o >>= -s, s += l; 0 < s; i = 256 * i + e[t + a], a += f, s -= 8);
                        for(u = i & (1 << -s) - 1, i >>= -s, s += r; 0 < s; u = 256 * u + e[t + a], a += f, s -= 8);
                        if (0 === i) i = 1 - d;
                        else {
                            if (i === c) return u ? NaN : 1 / 0 * (o ? -1 : 1);
                            u += Math.pow(2, r), i -= d;
                        }
                        return (o ? -1 : 1) * u * Math.pow(2, i - r);
                    }, f.write = function(e, t, l, n, r, c) {
                        var o, i, u = 8 * c - r - 1, s = (1 << u) - 1, a = s >> 1, d = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = n ? 0 : c - 1, h = n ? 1 : -1, c = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                        for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (i = isNaN(t) ? 1 : 0, o = s) : (o = Math.floor(Math.log(t) / Math.LN2), t * (n = Math.pow(2, -o)) < 1 && (o--, n *= 2), 2 <= (t += 1 <= o + a ? d / n : d * Math.pow(2, 1 - a)) * n && (o++, n /= 2), s <= o + a ? (i = 0, o = s) : 1 <= o + a ? (i = (t * n - 1) * Math.pow(2, r), o += a) : (i = t * Math.pow(2, a - 1) * Math.pow(2, r), o = 0)); 8 <= r; e[l + f] = 255 & i, f += h, i /= 256, r -= 8);
                        for(o = o << r | i, u += r; 0 < u; e[l + f] = 255 & o, f += h, o /= 256, u -= 8);
                        e[l + f - h] |= 128 * c;
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ],
        11: [
            function(e, h, t) {
                (function(e, t, n, r, o, f, l, c, d) {
                    var i, u, s;
                    function a() {}
                    (e = h.exports = {}).nextTick = (u = "undefined" != typeof window && window.setImmediate, s = "undefined" != typeof window && window.postMessage && window.addEventListener, u ? function(e) {
                        return window.setImmediate(e);
                    } : s ? (i = [], window.addEventListener("message", function(e) {
                        var t = e.source;
                        t !== window && null !== t || "process-tick" !== e.data || (e.stopPropagation(), 0 < i.length && i.shift()());
                    }, !0), function(e) {
                        i.push(e), window.postMessage("process-tick", "*");
                    }) : function(e) {
                        setTimeout(e, 0);
                    }), e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.on = a, e.addListener = a, e.once = a, e.off = a, e.removeListener = a, e.removeAllListeners = a, e.emit = a, e.binding = function(e) {
                        throw new Error("process.binding is not supported");
                    }, e.cwd = function() {
                        return "/";
                    }, e.chdir = function(e) {
                        throw new Error("process.chdir is not supported");
                    };
                }).call(this, e("lYpoI2"), "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
            },
            {
                buffer: 3,
                lYpoI2: 11
            }
        ]
    }, {}, [
        1
    ])(1);
});






var $iP9n7 = parcelRequire("iP9n7");







/**
 * @generated SignedSource<<a741b48463b70d862063d61fb73fa8b6>>
 * @relayHash 27a2ffb4f10a1c89ef127341679ca34d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd
const $fe98b83090a9da46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "30715749324f4ce2692f3d99003222db57884cb021e35c4efc344badee2c59dd",
            "metadata": {},
            "name": "useEmitPublicEvent_getExtensionListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fe98b83090a9da46$var$node.hash = "d64f8ab7fa1f6f87512e638d0dec22de";
var $fe98b83090a9da46$export$2e2bcd8739ae039 = $fe98b83090a9da46$var$node;



var $grQpA = parcelRequire("grQpA");





var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");




const $e3bb6e17ec90ff99$var$CORE_EVENT = 'core:event';
const $e3bb6e17ec90ff99$var$CLIENT_EVENTS = 'client-events';
const $e3bb6e17ec90ff99$var$CLIENT_EVENT = 'client-event';
const $e3bb6e17ec90ff99$var$EVENT_PREFIX = 'forge.bridge.';
const $e3bb6e17ec90ff99$var$filterAllowedRecipients = (allExtensions, extension)=>{
    const matchingExtension = allExtensions.find((ext)=>{
        if (ext && ext?.appId && ext?.key) return ext.appId === extension.appId && (ext.key === $e3bb6e17ec90ff99$var$CLIENT_EVENTS || ext.key === $e3bb6e17ec90ff99$var$CLIENT_EVENT);
    });
    const allowedRecipients = matchingExtension?.properties?.allowedRecipients ?? [];
    const filteredAllowedRecipients = allowedRecipients.filter((recipient)=>recipient !== '*').map((recipient)=>recipient.split('/').pop());
    if (!filteredAllowedRecipients.includes(extension.appId)) filteredAllowedRecipients.push(extension.appId);
    return filteredAllowedRecipients;
};
const $e3bb6e17ec90ff99$export$444d4d38f9da2a78 = (contextId, extension)=>{
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    const allowedRecipientsRef = (0, $42omo.useRef)(null);
    if (!extension?.appId || !(0, $dh538.fg)('forge-ui-add-public-event-methods')) return async ()=>{};
    const getAllowedRecipients = async ()=>{
        if (allowedRecipientsRef.current !== null) return allowedRecipientsRef.current;
        if (relayEnvironment) {
            const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $fe98b83090a9da46$export$2e2bcd8739ae039), {
                contextIds: [
                    contextId
                ],
                filter: [
                    {
                        type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                        value: [
                            $e3bb6e17ec90ff99$var$CORE_EVENT
                        ]
                    }
                ]
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                        }
                    }
                }
            });
            return new Promise((resolve)=>{
                observable.subscribe({
                    next: (result)=>{
                        const allExtensions = result?.extensionContexts?.[0]?.extensions || [];
                        const filteredAllowedRecipients = $e3bb6e17ec90ff99$var$filterAllowedRecipients(Array.from(allExtensions), extension);
                        resolve(filteredAllowedRecipients);
                    },
                    error: ()=>{
                        resolve([
                            extension.appId ?? ''
                        ]);
                    }
                });
            });
        }
        return [
            extension.appId
        ];
    };
    return async (eventData)=>{
        const { event: event, payload: payload } = eventData;
        if (allowedRecipientsRef.current === null) {
            const allowedRecipients = await getAllowedRecipients();
            allowedRecipientsRef.current = allowedRecipients;
        }
        const newEvent = new CustomEvent(`${$e3bb6e17ec90ff99$var$EVENT_PREFIX}${event}`, {
            detail: {
                extension: extension,
                payload: payload,
                allowedRecipients: allowedRecipientsRef.current ?? [
                    extension.appId
                ]
            }
        });
        window.document.dispatchEvent(newEvent);
    };
};


var $dj2Gr = parcelRequire("dj2Gr");
/**
 * @generated SignedSource<<baab784a150ef1ae055f04111e544716>>
 * @relayHash 146848d898d4f1b4f17c6ffe7e519e02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849
const $3fd7314b2ab5e588$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "installationId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGlobal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "payload"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v6 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "installationId",
                            "variableName": "installationId"
                        },
                        {
                            "kind": "Variable",
                            "name": "isGlobal",
                            "variableName": "isGlobal"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "payload",
                            "variableName": "payload"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ],
                    "concreteType": "EcosystemRealtimePublishBody",
                    "kind": "LinkedField",
                    "name": "publishRealtimeChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "eventId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventTimestamp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublishRealtimeChannelMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublishRealtimeChannelMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "81e1bc983c19feae9a62b87e16c21b378ccf00340edc9840ae4d1e14b946f849",
            "metadata": {},
            "name": "usePublishRealtimeChannelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3fd7314b2ab5e588$var$node.hash = "e82f2888e170470f31e8c75c07be4439";
var $3fd7314b2ab5e588$export$2e2bcd8739ae039 = $3fd7314b2ab5e588$var$node;








const $e9c93549781f9d57$export$df7d62be1d7f5fc9 = (installationId, context)=>{
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    return async (payload, contextToken)=>{
        const { channelName: channelName, isGlobal: isGlobal, options: options } = payload.data;
        const { token: token, contextOverrides: contextOverrides } = options || {};
        const eventPayload = JSON.stringify(payload.data.eventPayload);
        const channelContext = contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: contextOverrides
        }) : context;
        return new Promise((resolve, reject)=>{
            (0, $irOoi.commitMutation)(relayEnvironment, {
                mutation: (0, $3fd7314b2ab5e588$export$2e2bcd8739ae039),
                variables: {
                    installationId: installationId,
                    name: channelName,
                    payload: eventPayload,
                    context: channelContext,
                    isGlobal: isGlobal ?? false,
                    token: token
                },
                cacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
                            ...contextToken ? {
                                'x-forge-context-token': contextToken
                            } : {}
                        }
                    }
                },
                onCompleted: (data, errors)=>{
                    if (errors) {
                        reject(errors);
                        return;
                    }
                    if (data?.ecosystem?.publishRealtimeChannel) {
                        const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                        if (eventId && eventTimestamp) resolve({
                            eventId: eventId,
                            eventTimestamp: eventTimestamp
                        });
                        else resolve(undefined);
                    } else resolve(undefined);
                },
                onError: reject
            });
        });
    };
};





var $lrJXD = parcelRequire("lrJXD");

const $b7f5501d28b11a4d$var$getAGGWebsocketURI = ()=>{
    return `wss://${window.location.host}/gateway/api/graphql/subscriptions`;
};
const $b7f5501d28b11a4d$var$createAGGSubscriptionClient = ()=>{
    return (0, $lrJXD.createClient)({
        url: $b7f5501d28b11a4d$var$getAGGWebsocketURI(),
        retryAttempts: 2,
        lazy: true
    });
};
const $b7f5501d28b11a4d$var$getAGGSubscriptionClient = ()=>{
    let client = window.__FORGE_AGG_SUBSCRIPTION_CLIENT__;
    if (!client) {
        client = $b7f5501d28b11a4d$var$createAGGSubscriptionClient();
        window.__FORGE_AGG_SUBSCRIPTION_CLIENT__ = client;
    }
    return client;
};
class $b7f5501d28b11a4d$var$BasicSubscription {
    get subscriptionCallbacks() {
        return this._subscriptionCallbacks;
    }
    set subscriptionCallbacks(callbacks) {
        this._subscriptionCallbacks = callbacks;
    }
    unsubscribe() {
        if (!this.closed) {
            this.baseUnsubscribe();
            this.closed = true;
            this._subscriptionCallbacks = [];
        }
    }
    addCallback(callback) {
        this._subscriptionCallbacks.push(callback);
    }
    removeCallback(callback) {
        const index = this._subscriptionCallbacks.indexOf(callback);
        if (index !== -1) this._subscriptionCallbacks.splice(index, 1);
    }
    onNext(event) {
        const payload = this.parsePayload(event);
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(payload);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback: ', error);
            }
        });
    }
    onError(error) {
        this._subscriptionCallbacks.forEach((callback)=>{
            try {
                callback(null, error);
            } catch (callbackError) {
                // eslint-disable-next-line no-console
                console.error('[forge-realtime] Error in subscription callback:', callbackError);
            }
        });
    }
    parsePayload(payload) {
        try {
            return JSON.parse(payload);
        // eslint-disable-next-line no-unused-vars
        } catch (err) {
            return payload;
        }
    }
    constructor(baseUnsubscribe, callback){
        this.closed = void 0;
        this.baseUnsubscribe = void 0;
        this._subscriptionCallbacks = void 0;
        this.closed = false;
        this.baseUnsubscribe = baseUnsubscribe;
        this._subscriptionCallbacks = [
            callback
        ];
    }
}
const $b7f5501d28b11a4d$export$ec068583843480e7 = (payload, sink, subscriptionCallback, client)=>{
    if (!client) client = $b7f5501d28b11a4d$var$getAGGSubscriptionClient();
    const unsubscribe = client.subscribe(payload, sink);
    return new $b7f5501d28b11a4d$var$BasicSubscription(unsubscribe, subscriptionCallback);
};


const $364771c9cefa2143$var$realtimeChannel = `
	subscription realtimeChannel(
		$installationId: ID!
		$name: String!
		$context: String
		$isGlobal: Boolean
		$token: String
	) {
		ecosystem {
			realtimeChannel(
				installationId: $installationId
				name: $name
				context: $context
				isGlobal: $isGlobal
				token: $token
			) {
				payload
			}
		}
	}
`;
const $364771c9cefa2143$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
const $364771c9cefa2143$export$905d34fe81a9cf60 = ({ payload: payload, context: context, installationId: installationId, contextToken: contextToken })=>{
    const query = {
        operationName: 'realtimeChannel',
        query: $364771c9cefa2143$var$realtimeChannel
    };
    return {
        ...query,
        variables: {
            installationId: installationId,
            name: payload.data.channelName,
            context: context,
            isGlobal: payload.data.isGlobal ?? false,
            token: payload.data.options?.token
        },
        extensions: {
            'x-forge-context-token': contextToken,
            ...payload.data.options?.replaySeconds && {
                command: {
                    type: 'replay',
                    data: {
                        // Timestamp in seconds of when to replay messages from. Valid for up to 7 days in the past.
                        sequenceNumber: Date.now() / 1000 - payload.data.options.replaySeconds
                    }
                }
            }
        }
    };
};
const $364771c9cefa2143$var$unsubscribeAllSubscriptions = (activeSubscriptions)=>{
    activeSubscriptions.forEach((subscription)=>{
        if (!subscription.closed) subscription.unsubscribe();
    });
    activeSubscriptions.clear();
};
const $364771c9cefa2143$export$21407f03011cb801 = (installationId, context, getContextToken, getContextTokenOptions)=>{
    const activeSubscriptions = (0, $42omo.useRef)(new Map());
    (0, $42omo.useEffect)(()=>{
        const currentSubscriptions = activeSubscriptions.current;
        return ()=>{
            $364771c9cefa2143$var$unsubscribeAllSubscriptions(currentSubscriptions);
        };
    }, []);
    // this is the bridge method that will be called from the extension
    return async (payload)=>{
        const { onEvent: onEvent } = payload.data;
        const channelContext = payload.data.options?.contextOverrides ? JSON.stringify({
            context: context,
            contextOverrides: payload.data.options?.contextOverrides
        }) : context;
        const channelKey = $364771c9cefa2143$var$getChannelKey({
            channelName: payload.data.channelName,
            isGlobal: payload.data.isGlobal,
            channelContext: channelContext
        });
        const existingSubscription = activeSubscriptions.current.get(channelKey);
        if (existingSubscription) {
            // if subscription already exists
            existingSubscription.addCallback(onEvent);
            onEvent('SUBSCRIPTION_STARTED');
        } else {
            // helper to create a subscription and handle token refresh
            const createSubscription = async ()=>{
                const subscriptionPayload = $364771c9cefa2143$export$905d34fe81a9cf60({
                    payload: payload,
                    context: channelContext,
                    installationId: installationId,
                    contextToken: await getContextToken?.(getContextTokenOptions)
                });
                const subscription = (0, $b7f5501d28b11a4d$export$ec068583843480e7)(subscriptionPayload, {
                    next: (result)=>{
                        subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                    },
                    error: async (err)=>{
                        const error = Array.isArray(err) ? err[0] : err;
                        if (getContextToken && error?.message === 'Unauthorized request') try {
                            const newSubscription = await createSubscription();
                            newSubscription.subscriptionCallbacks = [
                                ...subscription.subscriptionCallbacks
                            ];
                            activeSubscriptions.current.set(channelKey, newSubscription);
                            subscription.unsubscribe();
                            return;
                        } catch (err) {
                            subscription.onError(err);
                            activeSubscriptions.current.delete(channelKey);
                            return;
                        }
                        subscription.onError(err);
                        activeSubscriptions.current.delete(channelKey);
                    },
                    complete: ()=>{
                        activeSubscriptions.current.delete(channelKey);
                    }
                }, onEvent);
                activeSubscriptions.current.set(channelKey, subscription);
                return subscription;
            };
            createSubscription();
        }
        return {
            unsubscribe: ()=>{
                const subscription = activeSubscriptions.current.get(channelKey);
                if (subscription) {
                    // remove one subscription
                    subscription.removeCallback(onEvent);
                    // if no more subscriptions remove the channelKey and unsubscribe
                    if (subscription.subscriptionCallbacks.length === 0) {
                        activeSubscriptions.current.delete(channelKey);
                        if (!subscription.closed) subscription.unsubscribe();
                    }
                }
            }
        };
    };
};



var $4ZTaE = parcelRequire("4ZTaE");


var $4LgCj = parcelRequire("4LgCj");

var $6fRDv = parcelRequire("6fRDv");

var $9XihO = parcelRequire("9XihO");

var $kxKUs = parcelRequire("kxKUs");

var $kZjf5 = parcelRequire("kZjf5");

var $buzAL = parcelRequire("buzAL");

var $i25hX = parcelRequire("i25hX");

const $87edcca4ef2d73a1$export$eb5f18ff99769aac = (extensionType)=>{
    const [product, moduleName] = extensionType.split(':');
    const SUPPORTED_PRODUCTS = [
        'jira',
        'confluence'
    ];
    // For xen:macro
    if (product === 'xen') return 'confluence';
    // Resolve non-portal JSM modules to Jira
    if (product === 'jiraServiceManagement') {
        if (moduleName && !moduleName.includes('portal')) return 'jira';
    }
    if (!SUPPORTED_PRODUCTS.includes(product)) return null;
    return product;
};


/**
 * @generated SignedSource<<379b0b68c383e481df3f2a60f643c6c4>>
 * @relayHash 6baab84fb33d5b03a95e7fc260932ffd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a
const $98784d239f8db17c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                },
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                }
            ],
            "concreteType": "AgentStudioAgentsConnection",
            "kind": "LinkedField",
            "name": "agentStudio_getAgents",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AgentStudioAgentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAssistant",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "externalConfigReference"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getRovoAgentIdRelayQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getRovoAgentIdRelayQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a",
            "metadata": {},
            "name": "getRovoAgentIdRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$98784d239f8db17c$var$node.hash = "2d164c49d934dbe7dee2500c2971c832";
var $98784d239f8db17c$export$2e2bcd8739ae039 = $98784d239f8db17c$var$node;





const $8b4a60e16bea70d5$export$6e6c2af98f57fa9d = 'ai_mate_agent';
// From https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/06c1faa9feb39485f12c6528f9baf9bb1c653451/platform/packages/ai-mate/conversation-assistant-agent/src/services/paginated-agents/utils.tsx
const $8b4a60e16bea70d5$var$getAgentIdFromAri = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $8b4a60e16bea70d5$var$getIdFromAgent = (agent)=>{
    const id = agent?.node?.id;
    if (!id) return null;
    return $8b4a60e16bea70d5$var$getAgentIdFromAri(agent?.node?.id);
};
const $8b4a60e16bea70d5$export$73f5d5418567eaae = (agentsList, agentKey, agentAppId)=>{
    // No agents found from given name so fallback to default agent
    if (agentsList.length === 0) return null;
    // OOTB agents can't have the same name,
    // but it can have the same name as a custom agent or a forge agent
    if (!agentKey || !agentAppId) {
        // Custom agents don't have externalConfigReference
        const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference != null && !agent?.node?.externalConfigReference.includes('ari:cloud:ecosystem::extension'));
        return $8b4a60e16bea70d5$var$getIdFromAgent(agent);
    }
    // Forge agents can have the same name so we have to filter further by key and appId
    // Their external config reference follows the pattern:
    // `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${moduleKey}`;
    const forgeAgentRegex = new RegExp(`${agentAppId}/[^/]+/static/${agentKey}`);
    const agent = agentsList.find((agent)=>agent?.node?.externalConfigReference && forgeAgentRegex.test(agent?.node?.externalConfigReference));
    return $8b4a60e16bea70d5$var$getIdFromAgent(agent);
};
const $8b4a60e16bea70d5$export$de10b7621d6ba909 = async ({ cloudId: cloudId, product: product, input: input, agentKey: agentKey, agentAppId: agentAppId, relayEnvironment: relayEnvironment })=>{
    if (!relayEnvironment) return $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
    try {
        const observable = (0, $irOoi.fetchQuery)(relayEnvironment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $98784d239f8db17c$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            input: input,
            product: product
        });
        return new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    const agentsList = data?.agentStudio_getAgents?.edges ?? [];
                    const agentId = $8b4a60e16bea70d5$export$73f5d5418567eaae(agentsList, agentKey, agentAppId) ?? $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
                    resolve(agentId);
                },
                error: ()=>{
                    resolve($8b4a60e16bea70d5$export$6e6c2af98f57fa9d);
                }
            });
        });
    } catch  {
        return $8b4a60e16bea70d5$export$6e6c2af98f57fa9d;
    }
};








const $a6f437d394af1fd4$var$ROVO_TOPIC = 'ai-mate';
const $a6f437d394af1fd4$var$FORGE_SOURCE = 'forge-bridge-open-rovo';
const $a6f437d394af1fd4$var$ROVO_EVENT_TYPE = 'chat-new';
const $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference = (appId, installationId, environmentId, agentKey)=>{
    return `${installationId}_ari:cloud:ecosystem::extension/${appId}/${environmentId}/static/${agentKey}`;
};
function $a6f437d394af1fd4$export$1b9e058b7e689de(extensionType, appId, cloudId, installationId, environmentId) {
    const publish = (0, $i25hX.usePublish)($a6f437d394af1fd4$var$ROVO_TOPIC);
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    return {
        openRovo: async ({ agentKey: agentKey, agentName: agentName, prompt: prompt, sourceAppId: sourceAppId, sourceInstallationId: sourceInstallationId, sourceEnvironmentId: sourceEnvironmentId })=>{
            const product = (0, $87edcca4ef2d73a1$export$eb5f18ff99769aac)(extensionType);
            if (!cloudId || !product) return false;
            // Use sourceAppId if provided (from embedded macro forwarding), otherwise use the captured appId
            const effectiveAppId = sourceAppId || appId;
            const effectiveInstallationId = sourceInstallationId || installationId;
            const effectiveEnvironmentId = sourceEnvironmentId || environmentId;
            const isForgeAgent = agentName && agentKey;
            const publishEventDetails = {
                type: $a6f437d394af1fd4$var$ROVO_EVENT_TYPE,
                product: product,
                source: $a6f437d394af1fd4$var$FORGE_SOURCE
            };
            let agentIdConfig;
            if (isForgeAgent) agentIdConfig = {
                agentExternalConfigReference: $a6f437d394af1fd4$var$makeForgeAgentExternalConfigReference(effectiveAppId, effectiveInstallationId, effectiveEnvironmentId, agentKey)
            };
            else {
                // If agent name is not provided use default rovo chat agent
                const agentId = agentName && !agentKey ? await (0, $8b4a60e16bea70d5$export$de10b7621d6ba909)({
                    agentAppId: effectiveAppId,
                    cloudId: cloudId,
                    input: {
                        name: agentName
                    },
                    product: product,
                    agentKey: agentKey,
                    relayEnvironment: relayEnvironment
                }) : (0, $8b4a60e16bea70d5$export$6e6c2af98f57fa9d);
                agentIdConfig = {
                    agentId: agentId
                };
            }
            publish({
                ...publishEventDetails,
                data: {
                    dialogues: [],
                    ...agentIdConfig,
                    ...prompt ? {
                        prompt: prompt
                    } : {}
                }
            });
        }
    };
}












const $dd25f80afb746bb3$export$c58c2ef6cd7b14a1 = (appId, accountId)=>!!window['__consentedApps']?.[`${appId}:${accountId}`];
const $dd25f80afb746bb3$export$8d4e05c53de89926 = (appId, accountId)=>{
    window.__consentedApps = window.__consentedApps || {};
    window.__consentedApps[`${appId}:${accountId}`] = true;
};






var $CMcde = parcelRequire("CMcde");

const $13104cd2bb06c6a7$export$aee5524fcec014ce = (loadingComponent)=>{
    if (loadingComponent) return typeof loadingComponent === 'function' ? loadingComponent() : loadingComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};



var $eahkE = parcelRequire("eahkE");





var $1uzCd = parcelRequire("1uzCd");




const $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS = 15;
const $5ba58c31384319a3$export$9de303ca9515c607 = ()=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [height, setHeight] = (0, $42omo.useState)(null);
    const [observationInvalidatedReason, setObservationInvalidatedReason] = (0, $42omo.useState)(null);
    const uniqueSizeObservationsRef = (0, $42omo.useRef)(0);
    // Memoize the observer callback to handle height changes
    const handleHeightChange = (0, $42omo.useCallback)((newHeight)=>{
        setHeight((prevHeight)=>{
            if (prevHeight !== newHeight) uniqueSizeObservationsRef.current++;
            return newHeight;
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!containerRef.current) return;
        // Reset observation counter for this instance
        uniqueSizeObservationsRef.current = 0;
        const observer = new ResizeObserver(([entry])=>{
            const newHeight = Math.trunc(entry.contentRect.height);
            handleHeightChange(newHeight);
            // Break after too many unique changes to prevent excessive tracking
            if (uniqueSizeObservationsRef.current >= $5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS) {
                observer.disconnect();
                setObservationInvalidatedReason(`Stopped counting after ${$5ba58c31384319a3$var$LIMIT_UNIQUE_RESIZE_OBSERVATIONS} unique resize events`);
            }
        });
        observer.observe(containerRef.current);
        // Cleanup observer on unmount
        return ()=>observer.disconnect();
    }, [
        handleHeightChange
    ]);
    return {
        containerRef: containerRef,
        height: height,
        observationInvalidatedReason: observationInvalidatedReason
    };
};



var $iUjrf = parcelRequire("iUjrf");


var $eI4ye = parcelRequire("eI4ye");

const $4db8dff54302fa45$export$1b708c663f12db29 = ({ isEnabled: isEnabled, viewportDimensions: viewportDimensions })=>{
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const { containerRef: containerRef, height: height } = (0, $5ba58c31384319a3$export$9de303ca9515c607)();
    const isTrackingRef = (0, $42omo.useRef)(true);
    // Initialize tracking timeout on mount, clear on unmount
    (0, $42omo.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            isTrackingRef.current = false;
        }, (0, $eI4ye.PERFORMANCE_ANALYTICS_INTERVAL));
        return ()=>clearTimeout(timeoutId);
    }, []);
    // Capture resize events when height changes and tracking is active
    (0, $42omo.useEffect)(()=>{
        // Only capture if height is valid, feature is enabled, and we're still tracking
        if (height !== null && isEnabled && isTrackingRef.current) captureEvent({
            type: 'resized',
            height: height,
            measuredHeight: viewportDimensions?.measuredHeight,
            viewportHeight: viewportDimensions?.viewportHeight,
            elapsed: (0, $1uzCd.getPerformanceMark)()
        });
    }, [
        height,
        isEnabled,
        captureEvent,
        viewportDimensions
    ]);
    return {
        containerRef: containerRef
    };
};



var $iqcSr = parcelRequire("iqcSr");


var $lMJg3 = parcelRequire("lMJg3");




var $b7qxC = parcelRequire("b7qxC");

const $9c850cca6011a656$var$globalEdgeUrlMap = {
    dev: 'dev.services.atlassian.com',
    stg: 'stg.services.atlassian.com',
    prod: 'services.atlassian.com'
};
const $9c850cca6011a656$var$getBaseUrl = (environment)=>{
    const baseUrl = $9c850cca6011a656$var$globalEdgeUrlMap[environment];
    if (!baseUrl) throw new Error(`Invalid environment: ${environment}`);
    const service = 'forge-outbound-proxy';
    const url = `https://${service}.${baseUrl}`;
    return url;
};
const $9c850cca6011a656$export$e02fc95a45760598 = async (appId, user, config, environment, contextToken)=>{
    const init = {
        method: 'POST',
        headers: {
            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
            'Content-Type': 'application/json',
            Authentication: `Bearer ${contextToken}`
        },
        body: JSON.stringify({
            user: user,
            config: config,
            appId: appId
        })
    };
    const url = $9c850cca6011a656$var$getBaseUrl((0, $b7qxC.getCDNEnvironment)(environment)) + '/client/feature-flags';
    const response = await fetch(url, init);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
};


/**
 * @generated SignedSource<<6718298d055bb8118877bc2d930a4b0a>>
 * @relayHash 054ff1d044a88d72c8190c4e95486551
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03
const $97ad737b2742538f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "concreteType": "ForgeInvocationToken",
        "kind": "LinkedField",
        "name": "forgeInvocationToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jwt"
            }
        ]
    }, v7 = {
        "concreteType": "InvocationTokenForUIMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "baseUrl"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SignInvocationTokenForUIResponse",
                    "kind": "LinkedField",
                    "name": "signInvocationTokenForUI",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "SignInvocationTokenForUIResponse",
                    "kind": "LinkedField",
                    "name": "signInvocationTokenForUI",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d76d2d503320e36d09076652b2b41d61cb81839e0eedd2aa0b959bf242a17b03",
            "metadata": {},
            "name": "useRemoteFetchClient_signInvocationTokenForUIMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$97ad737b2742538f$var$node.hash = "fe7d32870ddf9b8f5524abb29f382040";
var $97ad737b2742538f$export$2e2bcd8739ae039 = $97ad737b2742538f$var$node;









var $JsJ4Y = parcelRequire("JsJ4Y");

// FIT tokens are valid for 1 hour, but to include some buffer, we'll use 30 minutes.
const $f0e8edd6ba016f56$var$FIT_TOKEN_EXPIRY_MS = 1800000;
const $f0e8edd6ba016f56$export$a30e8bad2b49cec5 = ()=>{
    const [signInvocationTokenForUIMutation] = (0, $irOoi.useMutation)((0, $97ad737b2742538f$export$2e2bcd8739ae039));
    // Cache the FIT tokens against remoteKey to avoid excessively minting new FIT tokens.
    const cachedFitTokenMapRef = (0, $42omo.useRef)(new Map());
    return async (remoteKey, init, isMultipartFormData, restPath, contextToken)=>{
        if (!contextToken) throw new Error('Context token is required');
        const { fitToken: fitToken, remoteBaseUrl: remoteBaseUrl } = await $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation);
        // Call the remote with the FIT token as the authorization header
        const targetUrl = restPath ? new URL(restPath, remoteBaseUrl) : remoteBaseUrl;
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${fitToken}`);
        // handle multipart form data
        const body = isMultipartFormData ? $f0e8edd6ba016f56$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const response = await fetch(targetUrl, {
            ...init,
            headers: headers,
            body: body
        });
        // Handle binary response types
        const isAttachment = $f0e8edd6ba016f56$var$isBinaryContentType(response.headers.get('content-type'));
        if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
            const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
            return new Response(b64Content, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return response;
    };
};
async function $f0e8edd6ba016f56$var$getCachedFitToken(remoteKey, contextToken, cachedFitTokenMapRef, signInvocationTokenForUIMutation) {
    let fitToken;
    let remoteBaseUrl;
    const cachedFitToken = cachedFitTokenMapRef.current.get(remoteKey);
    // Attempt to use the cached FIT token if it is in the map and is valid
    if (cachedFitToken && $f0e8edd6ba016f56$var$isFitValid(cachedFitToken)) {
        fitToken = cachedFitToken.fitToken;
        remoteBaseUrl = cachedFitToken.remoteBaseUrl;
    } else {
        const fitExchangeResponse = await $f0e8edd6ba016f56$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation);
        const { fitToken: newFitToken, remoteBaseUrl: newRemoteBaseUrl } = fitExchangeResponse;
        cachedFitTokenMapRef.current.set(remoteKey, {
            fitToken: newFitToken,
            remoteBaseUrl: newRemoteBaseUrl,
            fitTokenExpiresAt: Date.now() + $f0e8edd6ba016f56$var$FIT_TOKEN_EXPIRY_MS
        });
        fitToken = newFitToken;
        remoteBaseUrl = newRemoteBaseUrl;
    }
    if (!remoteBaseUrl) throw new Error('Remote base URL is not available for the given remote key');
    if (!fitToken) throw new Error('FIT token is not available for the given remote key');
    return {
        fitToken: fitToken,
        remoteBaseUrl: remoteBaseUrl
    };
}
async function $f0e8edd6ba016f56$var$exchangeFCTForFIT(contextToken, remoteKey, signInvocationTokenForUIMutation) {
    return new Promise((resolve, reject)=>{
        signInvocationTokenForUIMutation({
            variables: {
                input: {
                    forgeContextToken: contextToken,
                    remoteKey: remoteKey
                }
            },
            onCompleted: (data, errors)=>{
                if (errors || !data?.signInvocationTokenForUI || data.signInvocationTokenForUI.errors) reject(new Error(`Failed to generate FIT token`));
                const response = {
                    fitToken: data.signInvocationTokenForUI?.forgeInvocationToken?.jwt ?? '',
                    remoteBaseUrl: data.signInvocationTokenForUI?.metadata?.baseUrl ?? ''
                };
                resolve(response);
            }
        });
    });
}
function $f0e8edd6ba016f56$var$isFitValid(cachedFitToken) {
    return cachedFitToken.fitTokenExpiresAt > Date.now();
}
function $f0e8edd6ba016f56$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key.startsWith('file')) {
        const encodedFileNameKey = `__${key}Name`;
        const encodedMimeTypeKey = `__${key}Type`;
        const fileName = formLike[encodedFileNameKey];
        const mimeType = formLike[encodedMimeTypeKey];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append(key, file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
function $f0e8edd6ba016f56$var$isBinaryContentType(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}





let $ab5a832ac7acfeff$var$postRobotOn = null;

if (typeof window !== 'undefined') $ab5a832ac7acfeff$var$postRobotOn = (parcelRequire("eLUTa")).postRobotOn;
const $ab5a832ac7acfeff$var$styles = {
    threeLOInfo: "_1bsb1osq _4t3i1osq",
    box: "_kqswh2mm"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $ab5a832ac7acfeff$var$modalIframeStyles = null;
const $ab5a832ac7acfeff$var$iframeStyles = null;
const $ab5a832ac7acfeff$var$hiddenIframeStyles = null;
const $ab5a832ac7acfeff$var$nonResizeableIframeStyles = null;
const $ab5a832ac7acfeff$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), props)
}; /**
    * Hook for determining default IFrame React ref, using parent ref when provided
    *
    * @param parentIframeRef parent IFrame React ref
    * @returns default IFrame React ref
    */ 
function $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef) {
    const localIframeRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    return mergedRef;
}
const $ab5a832ac7acfeff$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', src: src, bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable, getContextToken: getContextToken, timezone: timezone, locale: locale, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extensionPayload: extensionPayload, isHidden: isHidden, theme: theme, surfaceColor: surfaceColor, appId: appId, isInModal: isInModal, setIsLoading: setIsLoading, onError: onError, entryPoint: entryPoint, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId }, parentIframeRef)=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($ab5a832ac7acfeff$var$defaultComponents) : $ab5a832ac7acfeff$var$defaultComponents;
    const appIsAuthenticated = (0, $dd25f80afb746bb3$export$c58c2ef6cd7b14a1)(appId, accountId);
    const { appVersion: appVersion, consentUrl: consentUrl, currentUserConsent: currentUserConsent, requiresUserConsent: requiresUserConsent, properties: { frameId: frameId, layout: layout } } = extension;
    const [userConsentRequired, setUserConsentRequired] = (0, $42omo.useState)(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated);
    const productContext = (0, $42omo.useMemo)(()=>{
        const resolverContext = (0, $ge8sG.getResolverContext)({
            ...coreData,
            appVersion: appVersion
        }, extensionData);
        const viewContext = (0, $UZU5S.getViewContext)({
            resolverContext: resolverContext,
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
            locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionPayload: extensionPayload,
            extensionViewData: extensionViewData,
            theme: theme,
            surfaceColor: surfaceColor,
            location: window.location.toString()
        });
        return {
            resolverContext: resolverContext,
            viewContext: viewContext
        };
    }, [
        appVersion,
        coreData,
        extensionData,
        extensionViewData,
        accountId,
        extension,
        timezone,
        locale,
        extensionPayload,
        theme,
        surfaceColor
    ]); // For embedded macros, create context token options to pass to getContextToken
    // This ensures the token is generated for the embedded macro's context, not the parent's
    const embeddedMacroContextTokenOptions = isEmbeddedMacro ? {
        extensionOverride: {
            extension: extension,
            localId: coreData.localId
        }
    } : undefined; /**
                  * Wrapper for getContextToken that handles both embedded macro and regular cases.
                  * For embedded macros, includes the extension override to generate a token scoped to the embedded macro.
                  * Falls back to cached token when getContextToken is not available.
                  */ 
    const getContextTokenWrapper = async (contextIdsOverride)=>{
        if (!getContextToken) return contextTokenRef.current?.jwt;
        if (isEmbeddedMacro) return getContextToken({
            extensionOverride: {
                extension: extension,
                localId: coreData.localId
            },
            ...contextIdsOverride && {
                contextIdsOverride: contextIdsOverride
            }
        });
        return contextIdsOverride ? getContextToken({
            contextIdsOverride: contextIdsOverride
        }) : getContextToken();
    };
    const tracing = (0, $kaOT1.useTracingContext)();
    const contextTokenRef = (0, $42omo.useRef)(undefined);
    const [threeLOInfo, setThreeLOInfo] = (0, $42omo.useState)(null);
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    const iframeRef = $ab5a832ac7acfeff$var$useDefaultIframeRef(parentIframeRef);
    (0, $42omo.useEffect)(()=>{
        const clearThreeLOInfo = async ()=>setThreeLOInfo(null);
        if (userConsentRequired) {
            tracing?.recordConsentFlow('consent flow - start');
            setThreeLOInfo({
                authUrl: consentUrl,
                onSuccess: async ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'success');
                    setUserConsentRequired(false);
                    setIsThreeLOPromptVisible(false);
                    (0, $dd25f80afb746bb3$export$8d4e05c53de89926)(appId, accountId);
                    return clearThreeLOInfo();
                },
                onReject: ()=>{
                    tracing?.recordConsentFlow('consent flow - end', 'rejected');
                    return clearThreeLOInfo();
                }
            });
            setIsThreeLOPromptVisible(true);
            setShouldShowRenderer?.(false);
            if (onLoad) onLoad();
        }
    }, [
        onLoad,
        setIsThreeLOPromptVisible,
        setShouldShowRenderer,
        tracing,
        appId,
        accountId,
        consentUrl,
        userConsentRequired
    ]);
    const navigation = (0, $kZjf5.useNavigation)({
        extension: extension,
        push: bridge?.spaPush
    });
    const navigationRef = (0, $42omo.useRef)(navigation);
    navigationRef.current = navigation; // Skip FAUS navigate listener setup when this is the UI Kit macro custom config view (current resource is the config resource).
    const isMacroConfigView = Boolean(extension.properties?.config?.resource && extension.properties?.resource === extension.properties?.config?.resource); // Listen for navigate events from FAUS (e.g. link clicks in forge-adf-renderer). Skip when in modal or UI Kit macro custom config so only the macro body registers.
    (0, $42omo.useEffect)(()=>{
        if (layout === 'bodied' && coreData.localId && $ab5a832ac7acfeff$var$postRobotOn && !isInModal && !isMacroConfigView && (0, $dh538.fg)('platform_faus_navigate_to_product')) {
            const allowedDomain = (0, $6fRDv.getProductDomain)();
            try {
                const listener = $ab5a832ac7acfeff$var$postRobotOn(`navigateFromEmbeddedFAUS_${coreData.localId}`, {
                    domain: allowedDomain
                }, async ({ data: data })=>{
                    if (!data?.url) return;
                    navigationRef.current.onNavigate({
                        type: 'new-tab',
                        url: data.url
                    }).catch(()=>{});
                });
                return ()=>{
                    listener.cancel();
                }; // eslint-disable-next-line no-unused-vars
            } catch (_) {
                // eslint-disable-next-line no-console
                console.log('Failed to set up navigation listener');
            }
        }
    }, [
        layout,
        coreData.localId,
        isInModal,
        isMacroConfigView
    ]);
    const invoker = (0, $dj2Gr.useInvokeExtension)(contextIds, extension.id); // The hash generated here should match the one created in the Realtime service when it hashes extension.context
    // in the FCT.
    // If this is flaky because of differences between extensionData and the FCT's extension.context, then
    // use the decoded FCT context directly here as well.
    const extensionContext = (()=>{
        try {
            const { modal: // eslint-disable-next-line no-unused-vars
            modal, ...productExtensionData } = extensionData;
            return (0, (/*@__PURE__*/$parcel$interopDefault($39e5966e46da3777$exports)))(productExtensionData || {}); // eslint-disable-next-line no-unused-vars
        } catch (_) {
            // eslint-disable-next-line no-console
            console.error('Product context is not a serializable object.');
            return '';
        }
    })(); // the realtime hooks below have no side effect (i.e. does not actively trigger any network calls or actively makes any subscription).
    // It is because everything inside this hook is lazily initialized.
    // Importantly:
    // - SubscribeRealtimeChannel is called by the client (i.e. @forge/bridge)
    const subscribeRealtimeChannel = (0, $364771c9cefa2143$export$21407f03011cb801)(extension.installationId, extensionContext, getContextToken, embeddedMacroContextTokenOptions);
    const publishRealtimeChannel = (0, $e9c93549781f9d57$export$df7d62be1d7f5fc9)(extension.installationId, extensionContext);
    const renderThreeLOPrompt = (retry)=>{
        return new Promise((resolve, reject)=>{
            const authUrl = threeLOInfo?.authUrl || consentUrl;
            if (authUrl) {
                invokeRetriesRef.current.push(retry);
                tracing?.recordConsentFlow('consent flow - start');
                setThreeLOInfo({
                    authUrl: authUrl,
                    onSuccess: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'success');
                        resolve();
                        setThreeLOInfo(null);
                        setIsThreeLOPromptVisible(false);
                        setShouldShowRenderer?.(true);
                        return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                            invokeRetriesRef.current = [];
                        });
                    },
                    onReject: ()=>{
                        tracing?.recordConsentFlow('consent flow - end', 'rejected');
                        return reject();
                    }
                });
                setIsThreeLOPromptVisible(true);
                setShouldShowRenderer?.(false);
            }
        });
    };
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const rovoChat = (0, $a6f437d394af1fd4$export$1b9e058b7e689de)(extension.type, appId, cloudId, extension.installationId, extension.environmentId);
    const isAnonymousAccessSupportedByApp = extension.properties?.unlicensedAccess?.includes('anonymous') ?? false;
    const productFetchClient = (0, $9XihO.useProductFetchClient)({
        appId: appId,
        environment: environment,
        contextIds: contextIds,
        cloudId: cloudId,
        workspaceId: workspaceId,
        extensionId: extension.id,
        renderThreeLOPrompt: renderThreeLOPrompt,
        isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp
    });
    const permissions = (0, $buzAL.usePermission)({
        appId: appId,
        installationId: extension.installationId,
        contextIds: contextIds,
        extensionId: extension.id,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const emitPublicEvent = (0, $e3bb6e17ec90ff99$export$444d4d38f9da2a78)(contextIds[0], {
        appId: extension.appId,
        id: extension.id.split('/').slice(0, 3).join('/'),
        installationId: extension.installationId
    });
    const fetchRemoteClient = (0, $f0e8edd6ba016f56$export$a30e8bad2b49cec5)();
    const permissionFunctions = Object.fromEntries((0, $buzAL.permissionMethods).map((method)=>[
            `${(0, $buzAL.PERMISSION_METHOD_PREFIX)}${method}`,
            permissions[method]
        ]));
    const { loading: loading, iframeProps: { onLoad: onLoadIframeFromProps } } = (0, $kxKUs.useBridge)({
        cloudId: cloudId,
        theme: theme,
        surfaceColor: surfaceColor,
        origin: new URL(src).origin,
        api: {
            ...(0, $4LgCj.createBridgeApi)(bridge, {
                userConsentRequired: !!userConsentRequired
            }),
            ...(0, $dh538.fg)('platform_forge_ui_open_rovo_bridge') ? {
                openRovo: rovoChat.openRovo
            } : {},
            onInvoke: async (payload)=>{
                const contextToken = await getContextTokenWrapper(contextIds);
                tracing?.recordGqlCall('invokeExtension - start');
                const { data: data } = await invoker({
                    call: payload,
                    context: {
                        ...productContext.resolverContext
                    },
                    extensionPayload: extensionPayload,
                    contextToken: contextToken
                }); // Default to using the regular invocation response
                var resp = data?.invokeExtension;
                if (!resp?.success) {
                    const error = resp?.errors?.[0];
                    if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') return {
                        type: '3lo',
                        authUrl: error?.extensions.fields?.authInfoUrl
                    };
                    if (error?.extensions.errorType === (0, $eahkE.SANDBOX_DEPRECATION_ERROR) && onError && (0, $dh538.fg)('platform_render_sandbox_runtime_error_panel')) onError(error?.extensions.errorType);
                    return {
                        type: 'err',
                        message: error?.message ?? 'An error occurred while trying to invoke.'
                    };
                }
                tracing?.recordGqlCall('invokeExtension - end');
                contextTokenRef.current = resp?.contextToken;
                return {
                    type: 'ok',
                    response: resp?.response?.body
                };
            },
            onInitFeatureFlags: async (data)=>{
                const contextToken = await getContextTokenWrapper();
                tracing?.recordBridgeCall('getFeatureFlags - start');
                try {
                    const resp = await (0, $9c850cca6011a656$export$e02fc95a45760598)(appId, data.user, data.config, environment, contextToken);
                    tracing?.recordBridgeCall('getFeatureFlags - end');
                    return {
                        type: 'ok',
                        response: resp
                    };
                } catch (err) {
                    tracing?.recordBridgeCall('getFeatureFlags - end'); // eslint-disable-next-line no-console
                    console.error('There were errors while initialising feature flags client ', err);
                    return {
                        type: 'err',
                        message: 'An error occurred while trying to initialise feature flags client.'
                    };
                }
            },
            onNavigate: navigation.onNavigate,
            onThreeLO: async (authUrl, retry)=>{
                return new Promise((resolve, reject)=>{
                    invokeRetriesRef.current.push(retry);
                    tracing?.recordConsentFlow('consent flow - start');
                    setThreeLOInfo({
                        authUrl: authUrl,
                        onSuccess: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'success');
                            resolve();
                            setThreeLOInfo(null);
                            setIsThreeLOPromptVisible(false);
                            setShouldShowRenderer?.(true);
                            return Promise.all(invokeRetriesRef.current.map((retry)=>retry())).then(()=>{
                                invokeRetriesRef.current = [];
                            });
                        },
                        onReject: ()=>{
                            tracing?.recordConsentFlow('consent flow - end', 'rejected');
                            return reject();
                        }
                    });
                    setIsThreeLOPromptVisible(true);
                    setShouldShowRenderer?.(false);
                });
            },
            getContext: async ()=>({
                    ...productContext.viewContext
                }),
            fetchProduct: async ({ restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            fetchRemote: async ({ remoteKey: remoteKey, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
                const { path: path, ...init } = fetchRequestInit;
                const contextToken = await getContextTokenWrapper();
                const response = await fetchRemoteClient(remoteKey, init, isMultipartFormData, path, contextToken);
                const { status: status, statusText: statusText } = response;
                const headers = Object.fromEntries(response.headers.entries());
                const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
                const body = response.body ? await response.text() : undefined;
                return {
                    headers: headers,
                    status: status,
                    statusText: statusText,
                    body: body,
                    isAttachment: isAttachment
                };
            },
            getFrameId: ()=>frameId ?? null,
            subscribeRealtimeChannel: async (payload)=>{
                return subscribeRealtimeChannel(payload);
            },
            publishRealtimeChannel: async (payload)=>{
                const contextToken = await getContextTokenWrapper();
                return publishRealtimeChannel(payload, contextToken);
            },
            ...(0, $dh538.fg)('forge-ui-add-public-event-methods') ? {
                emitPublic: emitPublicEvent
            } : {},
            ...permissionFunctions
        },
        customBridgeMethods: customBridgeMethods,
        onLoad: onLoad,
        isResizable: isResizable,
        height: height,
        environment: environment,
        extension: extension,
        iframeRef: iframeRef,
        contextIds: contextIds,
        isInModal: isInModal,
        localId: coreData.localId,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId,
        extensionPayload: extensionPayload,
        extensionData: extensionData
    });
    (0, $42omo.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const { containerRef: containerRef } = (0, $4db8dff54302fa45$export$1b708c663f12db29)({
        // need to check if the extension is custom UI as well since this component is used in WebRuntime for UI Kit
        isEnabled: (0, $iqcSr.isCustomUI)(extension, entryPoint) && (0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')
    });
    const sandboxAttributeRules = [
        'allow-downloads',
        'allow-forms',
        'allow-modals',
        'allow-pointer-lock',
        'allow-same-origin',
        'allow-scripts'
    ];
    try {
        const egressService = (0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
        const containsWildCardEgress = egressService.containsWildCardEgress();
        if (containsWildCardEgress) sandboxAttributeRules.push('allow-popups', 'allow-popups-to-escape-sandbox');
         // eslint-disable-next-line no-unused-vars
    } catch (_) {}
    let framePermissionsPolicy = 'camera; clipboard-write; display-capture; fullscreen; microphone';
    if ((0, $dh538.fg)('platform_forge-ui_frame-allow-local-network-access')) framePermissionsPolicy += '; local-network-access';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $ab5a832ac7acfeff$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || threeLOInfo ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, navigation.getModalJsx(), permissions.getModalJsx(), (loading || threeLOInfo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ab5a832ac7acfeff$var$styles.threeLOInfo
    }, loading && !threeLOInfo && !isHidden && (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent), threeLOInfo && ThreeLOPrompt({
        authUrl: threeLOInfo.authUrl,
        onSuccess: threeLOInfo.onSuccess,
        metadata: {
            moduleType: extension.type
        }
    })), !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandboxAttributeRules.join(' '),
        allow: framePermissionsPolicy,
        src: src,
        ref: iframeRef,
        onLoad: onLoadIframeFromProps,
        title: `Iframe ${frameId ?? (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()} from ${appId}`,
        className: (0, $gMc0m.default)([
            "_19itglyw _1e0c1ule _1bsb1osq",
            (loading || threeLOInfo || isHidden) && "_1e0cglyw",
            isInModal && "_2rkofajl _4t3i1osq",
            !isResizable && "_4t3i1osq"
        ])
    })));
});









/**
 * @generated SignedSource<<ea0400c4387d6459c4e9e7dc2e97842b>>
 * @relayHash f504b87a4e0ed24c5467ba12a605952a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa
const $bae2b5f9b6a29d48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "environmentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "appId",
                    "variableName": "appId"
                },
                {
                    "kind": "Variable",
                    "name": "environmentId",
                    "variableName": "environmentId"
                }
            ],
            "concreteType": "AppTunnelDefinitions",
            "kind": "LinkedField",
            "name": "appActiveTunnels",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CustomUITunnelDefinition",
                    "kind": "LinkedField",
                    "name": "customUI",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "resourceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tunnelUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "9123000e799c8af26e2146bcbeaf5a5445b2e622a89605e7d2dedac44d1c74aa",
            "metadata": {},
            "name": "useCustomUITunnelsListRelay_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bae2b5f9b6a29d48$var$node.hash = "f05d61452951b17f46031ee0cc173398";
var $bae2b5f9b6a29d48$export$2e2bcd8739ae039 = $bae2b5f9b6a29d48$var$node;








const $783b254f80b9fbef$export$f31e7455041d7e13 = ({ loading: loading, data: data })=>{
    if (!loading) return data?.appActiveTunnels?.customUI;
    return undefined;
};
const $783b254f80b9fbef$export$fe132995f21ca9ac = (options)=>{
    const { appId: appId, environmentId: environmentId } = options;
    const contextIds = options.contextIds ?? [];
    /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */ const data = (0, $irOoi.useLazyLoadQuery)((0, $bae2b5f9b6a29d48$export$2e2bcd8739ae039), {
        appId: appId,
        environmentId: environmentId
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                }
            }
        }
    });
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/no-wrapping-hooks */ const tunnels = data?.appActiveTunnels?.customUI ?? [];
    return {
        tunnels: tunnels,
        loading: false
    };
};



var $dClXj = parcelRequire("dClXj");

const $8ec10056009983e2$var$TunnelsLoader = ({ appId: appId, contextIds: contextIds, environmentId: environmentId, children: children })=>{
    const { tunnels: tunnels } = (0, $783b254f80b9fbef$export$fe132995f21ca9ac)({
        appId: appId,
        environmentId: environmentId,
        contextIds: contextIds
    });
    return children({
        loading: false,
        tunnels: tunnels
    });
};
const $8ec10056009983e2$export$ac05e5a66b1a4559 = ({ environmentType: environmentType, appId: appId, contextIds: contextIds, environmentId: environmentId, children: children })=>{
    const fallbackResult = {
        tunnels: [],
        loading: true
    };
    if ((0, $dh538.fg)('forge-ui-refactor-iframe')) {
        if (environmentType === 'DEVELOPMENT') /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
            fallback: children({
                tunnels: [],
                loading: false
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: children(fallbackResult)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ec10056009983e2$var$TunnelsLoader, {
            appId: appId,
            contextIds: contextIds,
            environmentId: environmentId,
            children: children
        })));
        else return children({
            loading: false,
            tunnels: []
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
        fallback: children({
            tunnels: [],
            loading: false
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: children(fallbackResult)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ec10056009983e2$var$TunnelsLoader, {
        appId: appId,
        contextIds: contextIds,
        environmentId: environmentId,
        children: children
    })));
};



var $6oQb1 = parcelRequire("6oQb1");


var $jc2GP = parcelRequire("jc2GP");





var $luNHV = parcelRequire("luNHV");





var $hQK66 = parcelRequire("hQK66");




const $81f81791d185e0cc$export$5585193a0b9bb43d = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    const initialConfigKey = (0, $42omo.useRef)(null);
    const { config: config, ...extensionWithoutConfig } = context.extension ?? {};
    const currentConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(config);
    const baseContextKey = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))({
        ...context,
        extension: extensionWithoutConfig
    });
    const trackWrappedComponentMounted = $81f81791d185e0cc$var$useWrappedComponentMountTracker();
    (0, $42omo.useEffect)(()=>{
        (0, $luNHV.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
            config: config
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentConfigKey
    ]);
    if (forgeReactMajorVersion.current === null) forgeReactMajorVersion.current = getCurrentForgeReactMajorVersion();
    if (initialConfigKey.current === null) initialConfigKey.current = currentConfigKey;
    // for existing apps we need to ensure backwards compatibility
    const shouldContextKeyChangeOnConfigChange = forgeReactMajorVersion.current === null || forgeReactMajorVersion.current < 11;
    // if the app is using the new version of Forge react, we always uses the initial config key
    const key = baseContextKey + (shouldContextKeyChangeOnConfigChange ? currentConfigKey : initialConfigKey.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($81f81791d185e0cc$var$WrappedComponent, {
        key: key,
        onMounted: trackWrappedComponentMounted
    }, children);
};
const $81f81791d185e0cc$var$useWrappedComponentMountTracker = ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    const trackWrappedComponentMounted = (0, $hQK66.useCallbackOne)(()=>{
        mountedCount.current += 1;
        if (mountedCount.current > 1) trackExtensionRemounted({
            mountCount: mountedCount.current
        });
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackWrappedComponentMounted;
};
const $81f81791d185e0cc$var$WrappedComponent = ({ children: children, onMounted: onMounted })=>{
    (0, $42omo.useEffect)(()=>{
        onMounted();
    }, [
        onMounted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $cqiXo = parcelRequire("cqiXo");







/* InnerIframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $36a3b759c0c89f29$exports = {};
(()=>{
    "use strict";
    var e = {
        167 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.deserializeError = t.deserialize = void 0;
            const n = r(438), o = (e)=>"proxyCache" in e && "functionRegistry" in e;
            t.deserialize = (e, r, n = new WeakSet())=>{
                if (null == e) return e;
                if ("object" != typeof e) return e;
                if (a(e)) switch(e.__type__){
                    case "port_rpc_function":
                        return i(e, r);
                    case "port_rpc_error":
                        return (0, t.deserializeError)(e);
                    case "port_rpc_regex":
                        return c(e);
                }
                return e instanceof Date || e instanceof ArrayBuffer || ArrayBuffer.isView(e) ? e : n.has(e) ? void 0 : (n.add(e), s(e, r, n));
            };
            const s = (e, r, n)=>{
                if (Array.isArray(e)) return e.map((e)=>(0, t.deserialize)(e, r, n));
                if (e instanceof Map) {
                    const o = new Map();
                    for (const [s, i] of e)o.set(s, (0, t.deserialize)(i, r, n));
                    return o;
                }
                if (e instanceof Set) {
                    const o = new Set();
                    for (const s of e)o.add((0, t.deserialize)(s, r, n));
                    return o;
                }
                const o = {};
                for (const s of Object.keys(e))o[s] = (0, t.deserialize)(e[s], r, n);
                return o;
            }, i = (e, t)=>{
                const r = e[n.PROXY_ID_FIELD], { __name__: s } = e;
                if (o(t)) {
                    const e = t.functionStore.get(r);
                    if (e) return e;
                }
                if (o(t)) {
                    const e = t.proxyCache.get(r)?.deref();
                    if (e) return e;
                }
                const i = async (...e)=>t.send(`${n.FUNCTION_CALL_PREFIX}:${r}`, {
                        args: e
                    });
                return i[n.PROXY_ID_SYMBOL] = r, i[n.PROXY_ID_FIELD] = r, Object.defineProperty(i, "name", {
                    value: `proxy<${s}>`,
                    configurable: !0
                }), o(t) && (t.proxyCache.set(r, new WeakRef(i)), t.functionRegistry.register(i, r, i)), i;
            };
            t.deserializeError = (e)=>{
                const t = new Error(e.message);
                return e.stack && (t.stack = e.stack), e.name && (t.name = e.name), e.code && (t.code = e.code), t;
            };
            const c = (e)=>new RegExp(e.source, e.flags), a = (e)=>"object" == typeof e && null !== e && "__type__" in e && "string" == typeof e.__type__;
        },
        227 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.establish = void 0;
            const n = r(438), o = r(402), s = r(441), i = r(690), c = (e)=>{
                e.settled = !0;
                try {
                    e.port1.postMessage({
                        type: "DISCONNECT",
                        id: (0, n.uniqueID)()
                    });
                } catch  {}
                try {
                    e.port1.close();
                } catch  {}
            };
            t.establish = (e, t)=>{
                const { timeout: r, origin: a = "*", context: d, verify: u } = t ?? {}, l = r ?? (d ? n.ROUTED_HANDSHAKE_TIMEOUT : n.HANDSHAKE_TIMEOUT), f = (0, i.resolveTarget)(e, a, "establish");
                return new Promise((e, t)=>{
                    const { port1: r, port2: i } = new MessageChannel(), a = {
                        port1: r,
                        timer: void 0,
                        settled: !1,
                        verify: u,
                        resolve: e,
                        reject: t
                    };
                    a.timer = setTimeout(()=>{
                        a.settled || (c(a), t(new s.TimeoutError(`Handshake timeout: no response within ${l}ms`)));
                    }, l), r.onmessage = ((e)=>async (t)=>{
                            if (e.settled) return;
                            const r = t.data;
                            r?.type !== n.ROUTE_REJECT_TYPE ? r?.type === n.HANDSHAKE_ACK_TYPE && await (async (e, t)=>{
                                if (clearTimeout(e.timer), e.verify) try {
                                    if (!await e.verify(t.verificationData)) return c(e), void e.reject(new s.VerificationError());
                                } catch (t) {
                                    return c(e), void e.reject(new s.VerificationError(t instanceof Error ? t.message : "Verification failed"));
                                }
                                e.settled = !0, e.port1.onmessage = null, e.resolve(new o.ConnectionImpl(e.port1));
                            })(e, r) : ((e, t)=>{
                                clearTimeout(e.timer), c(e), e.reject(new s.RoutingError(t.error || "Route rejected"));
                            })(e, r);
                        })(a);
                    const _ = {
                        type: n.HANDSHAKE_MSG_TYPE,
                        ...d ? {
                            context: d
                        } : {}
                    };
                    try {
                        f.post(_, [
                            i
                        ]);
                    } catch (e) {
                        clearTimeout(a.timer), c(a), t(new s.RoutingError(`Failed to send handshake: ${e instanceof Error ? e.message : String(e)}`));
                    }
                });
            };
        },
        304 (e, t, r) {
            t.GJ = t._4 = void 0;
            var n = r(227);
            Object.defineProperty(t, "_4", {
                enumerable: !0,
                get: function() {
                    return n.establish;
                }
            });
            var o = r(930);
            Object.defineProperty(t, "GJ", {
                enumerable: !0,
                get: function() {
                    return o.onConnect;
                }
            });
            r(629), r(441);
        },
        402 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ConnectionImpl = void 0;
            const n = r(438), o = r(906), s = r(167), i = r(441);
            t.ConnectionImpl = class {
                on(e, t) {
                    if (this.requestListeners.has(e)) throw new i.DuplicateListenerError(e);
                    return this.requestListeners.set(e, {
                        handler: t,
                        once: !1
                    }), {
                        cancel: ()=>{
                            this.requestListeners.delete(e);
                        }
                    };
                }
                once(e, t) {
                    if (this.requestListeners.has(e)) throw new i.DuplicateListenerError(e);
                    return this.requestListeners.set(e, {
                        handler: t,
                        once: !0
                    }), {
                        cancel: ()=>{
                            this.requestListeners.delete(e);
                        }
                    };
                }
                send(e, t, r) {
                    if (this.destroyed) return Promise.reject(new i.ConnectionClosedError("Cannot send on a destroyed connection"));
                    const s = r?.fireAndForget ?? !1, c = r?.ackTimeout ?? n.DEFAULT_ACK_TIMEOUT, a = r?.timeout ?? n.RESPONSE_TIMEOUT, d = `${e}_${(0, n.uniqueID)()}`, u = {
                        type: "REQUEST",
                        id: d,
                        name: e,
                        data: (0, o.serialize)(t, this.functionStore, this.fnToId),
                        ...s ? {
                            fireAndForget: !0
                        } : {}
                    };
                    try {
                        this.port.postMessage(u);
                    } catch (e) {
                        return Promise.reject(e);
                    }
                    return s ? Promise.resolve(void 0) : this.awaitResponse(d, e, c, a);
                }
                awaitResponse(e, t, r, n) {
                    return new Promise((o, s)=>{
                        const c = {
                            resolve: o,
                            reject: s,
                            ackTimer: null,
                            responseTimer: null,
                            acked: !1
                        };
                        !1 !== r && r > 0 && (c.ackTimer = setTimeout(()=>{
                            c.acked || (this.pendingRequests.delete(e), this.clearPendingTimers(c), s(new i.TimeoutError(`ACK timeout: no ACK received for "${t}" within ${r}ms`)));
                        }, r)), n > 0 && (c.responseTimer = setTimeout(()=>{
                            this.pendingRequests.delete(e), this.clearPendingTimers(c), s(new i.TimeoutError(`Response timeout: no response for "${t}" within ${n}ms`));
                        }, n)), this.pendingRequests.set(e, c);
                    });
                }
                async ping(e) {
                    if (this.destroyed) return !1;
                    const t = e ?? n.PING_TIMEOUT;
                    try {
                        return await this.send(n.PING_NAME, void 0, {
                            timeout: t,
                            ackTimeout: t
                        }), !0;
                    } catch  {
                        return !1;
                    }
                }
                onDisconnect(e) {
                    return this.disconnectHandlers.add(e), {
                        cancel: ()=>{
                            this.disconnectHandlers.delete(e);
                        }
                    };
                }
                destroy() {
                    if (!this.destroyed) {
                        this.destroyed = !0;
                        try {
                            this.port.postMessage({
                                type: "DISCONNECT",
                                id: (0, n.uniqueID)()
                            });
                        } catch  {}
                        this.teardown();
                    }
                }
                handleMessage(e) {
                    switch(e.type){
                        case "REQUEST":
                            this.handleRequest(e);
                            break;
                        case "RESPONSE":
                            this.handleResponse(e);
                            break;
                        case "ACK":
                            this.handleAck(e);
                            break;
                        case "DISCONNECT":
                            this.handleDisconnect();
                            break;
                        case "FUNCTION_RELEASE":
                            this.handleFunctionRelease(e);
                    }
                }
                handleRequest(e) {
                    const { id: t, name: r, data: o, fireAndForget: c } = e;
                    if (c) return void this.handleFireAndForget(r, o);
                    if (this.sendAck(t), r === n.PING_NAME) return void this.sendResponse(t, void 0);
                    if (r.startsWith(`${n.FUNCTION_CALL_PREFIX}:`)) {
                        const e = r.slice(n.FUNCTION_CALL_PREFIX.length + 1), c = this.functionStore.get(e);
                        if (!c) return void this.sendErrorResponse(t, new i.HandlerNotFoundError(`function:${e}`));
                        const a = (0, s.deserialize)(o, this);
                        return void this.invokeHandlerAndRespond(t, ()=>c(...a?.args ?? []));
                    }
                    const a = this.requestListeners.get(r);
                    if (!a) return void this.sendErrorResponse(t, new i.HandlerNotFoundError(r));
                    a.once && this.requestListeners.delete(r);
                    const d = {
                        data: (0, s.deserialize)(o, this)
                    };
                    this.invokeHandlerAndRespond(t, ()=>a.handler(d));
                }
                handleResponse(e) {
                    const t = this.pendingRequests.get(e.id);
                    t && (this.pendingRequests.delete(e.id), this.clearPendingTimers(t), e.error ? t.reject((0, s.deserializeError)(e.error)) : t.resolve((0, s.deserialize)(e.data, this)));
                }
                handleAck(e) {
                    const t = this.pendingRequests.get(e.id);
                    t && (t.acked = !0, null !== t.ackTimer && (clearTimeout(t.ackTimer), t.ackTimer = null));
                }
                handleDisconnect() {
                    this.destroyed || (this.destroyed = !0, this.teardown());
                }
                handleFunctionRelease(e) {
                    const { functionId: t } = e, r = this.functionStore.get(t);
                    r && (this.fnToId.delete(r), this.functionStore.delete(t));
                }
                sendAck(e) {
                    try {
                        this.port.postMessage({
                            type: "ACK",
                            id: e
                        });
                    } catch  {}
                }
                sendFunctionRelease(e) {
                    if (!this.destroyed) try {
                        this.port.postMessage({
                            type: "FUNCTION_RELEASE",
                            functionId: e
                        });
                    } catch  {}
                }
                sendResponse(e, t) {
                    try {
                        const r = (0, o.serialize)(t, this.functionStore, this.fnToId);
                        this.port.postMessage({
                            type: "RESPONSE",
                            id: e,
                            data: r
                        });
                    } catch (t) {
                        try {
                            this.sendErrorResponse(e, t instanceof Error ? t : new Error(String(t)));
                        } catch  {}
                    }
                }
                sendErrorResponse(e, t) {
                    const r = t instanceof Error ? t : new Error(String(t)), n = {
                        message: r.message,
                        stack: r.stack,
                        name: r.name,
                        code: r.code
                    };
                    try {
                        this.port.postMessage({
                            type: "RESPONSE",
                            id: e,
                            error: n
                        });
                    } catch  {}
                }
                handleFireAndForget(e, t) {
                    if (e === n.PING_NAME) return;
                    if (e.startsWith(`${n.FUNCTION_CALL_PREFIX}:`)) {
                        const r = e.slice(n.FUNCTION_CALL_PREFIX.length + 1), o = this.functionStore.get(r);
                        if (!o) return;
                        const i = (0, s.deserialize)(t, this);
                        return void this.invokeAndForget(o, i?.args ?? []);
                    }
                    const r = this.requestListeners.get(e);
                    if (!r) return;
                    r.once && this.requestListeners.delete(e);
                    const o = {
                        data: (0, s.deserialize)(t, this)
                    };
                    try {
                        const e = r.handler(o);
                        e instanceof Promise && e.catch(()=>{});
                    } catch  {}
                }
                invokeAndForget(e, t) {
                    try {
                        const r = e(...t);
                        r instanceof Promise && r.catch(()=>{});
                    } catch  {}
                }
                invokeHandlerAndRespond(e, t) {
                    try {
                        const r = t();
                        r instanceof Promise ? r.then((t)=>this.sendResponse(e, t), (t)=>this.sendErrorResponse(e, t)) : this.sendResponse(e, r);
                    } catch (t) {
                        this.sendErrorResponse(e, t);
                    }
                }
                teardown() {
                    const e = new i.ConnectionClosedError();
                    for (const [, t] of this.pendingRequests)this.clearPendingTimers(t), t.reject(e);
                    for (const e of this.disconnectHandlers)try {
                        e();
                    } catch  {}
                    this.requestListeners.clear(), this.pendingRequests.clear(), this.functionStore.clear(), this.fnToId.clear();
                    for (const e of this.proxyCache.values()){
                        const t = e.deref();
                        t && this.functionRegistry.unregister(t);
                    }
                    this.proxyCache.clear(), this.disconnectHandlers.clear();
                    try {
                        this.port.close();
                    } catch  {}
                }
                clearPendingTimers(e) {
                    null !== e.ackTimer && (clearTimeout(e.ackTimer), e.ackTimer = null), null !== e.responseTimer && (clearTimeout(e.responseTimer), e.responseTimer = null);
                }
                constructor(e){
                    this.requestListeners = new Map(), this.pendingRequests = new Map(), this.functionStore = new Map(), this.fnToId = new Map(), this.proxyCache = new Map(), this.functionRegistry = new FinalizationRegistry((e)=>{
                        this.proxyCache.delete(e), this.sendFunctionRelease(e);
                    }), this.disconnectHandlers = new Set(), this.destroyed = !1, this.port = e, this.port.onmessage = (e)=>{
                        this.handleMessage(e.data);
                    };
                }
            };
        },
        438 (e, t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.uniqueID = t.PING_TIMEOUT = t.PROXY_ID_FIELD = t.PROXY_ID_SYMBOL = t.PING_NAME = t.ROUTE_REJECT_TYPE = t.FUNCTION_RELEASE_TYPE = t.FUNCTION_CALL_PREFIX = t.HANDSHAKE_ACK_TYPE = t.HANDSHAKE_MSG_TYPE = t.ROUTED_HANDSHAKE_TIMEOUT = t.HANDSHAKE_TIMEOUT = t.RESPONSE_TIMEOUT = t.DEFAULT_ACK_TIMEOUT = void 0, t.DEFAULT_ACK_TIMEOUT = 2e3, t.RESPONSE_TIMEOUT = -1, t.HANDSHAKE_TIMEOUT = 5e3, t.ROUTED_HANDSHAKE_TIMEOUT = 1e4, t.HANDSHAKE_MSG_TYPE = "__port_rpc_handshake__", t.HANDSHAKE_ACK_TYPE = "__port_rpc_handshake_ack__", t.FUNCTION_CALL_PREFIX = "__port_rpc_fn__", t.FUNCTION_RELEASE_TYPE = "__port_rpc_fn_release__", t.ROUTE_REJECT_TYPE = "__port_rpc_route_reject__", t.PING_NAME = "__port_rpc_ping__", t.PROXY_ID_SYMBOL = Symbol.for("port_rpc_proxy_id"), t.PROXY_ID_FIELD = "__id__", t.PING_TIMEOUT = 2e3;
            let r = 0;
            t.uniqueID = ()=>`uid_${Math.random().toString(36).substring(2)}_${++r}`;
        },
        441 (e, t) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.RoutingError = t.VerificationError = t.DuplicateListenerError = t.HandlerNotFoundError = t.ConnectionClosedError = t.TimeoutError = t.PortRpcError = void 0;
            class r extends Error {
                constructor(e, t = "PORT_RPC_ERROR"){
                    super(e), this.code = t, this.name = "PortRpcError";
                }
            }
            t.PortRpcError = r, t.TimeoutError = class extends r {
                constructor(e = "Operation timed out"){
                    super(e, "TIMEOUT"), this.name = "TimeoutError";
                }
            }, t.ConnectionClosedError = class extends r {
                constructor(e = "Connection is closed"){
                    super(e, "CONNECTION_CLOSED"), this.name = "ConnectionClosedError";
                }
            }, t.HandlerNotFoundError = class extends r {
                constructor(e){
                    super(`No handler registered for "${e}"`, "HANDLER_NOT_FOUND"), this.name = "HandlerNotFoundError";
                }
            }, t.DuplicateListenerError = class extends r {
                constructor(e){
                    super(`A listener is already registered for "${e}"`, "DUPLICATE_LISTENER"), this.name = "DuplicateListenerError";
                }
            }, t.VerificationError = class extends r {
                constructor(e = "Verification failed"){
                    super(e, "VERIFICATION_FAILED"), this.name = "VerificationError";
                }
            }, t.RoutingError = class extends r {
                constructor(e = "Routing failed"){
                    super(e, "ROUTING_FAILED"), this.name = "RoutingError";
                }
            };
        },
        629 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.forward = void 0;
            const n = r(930);
            t.forward = (e, t)=>(0, n.registerForwardResolver)(e, t);
        },
        690 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.resolveTarget = t.isWindow = void 0;
            const n = r(441);
            t.isWindow = (e)=>{
                if (!e) return !1;
                try {
                    const t = e;
                    return "function" == typeof t.postMessage && "object" == typeof t.self && null !== t.self;
                } catch (e) {
                    return e instanceof DOMException && "SecurityError" === e.name;
                }
            }, t.resolveTarget = (e, r, o = "connect")=>{
                if ("undefined" != typeof HTMLIFrameElement && e instanceof HTMLIFrameElement) {
                    const t = e.contentWindow;
                    if (!t) throw new n.PortRpcError(`Cannot ${o}: iframe has no contentWindow (not yet loaded?)`);
                    return {
                        post (e, n) {
                            t.postMessage(e, r, n);
                        }
                    };
                }
                if ("undefined" != typeof Worker && e instanceof Worker) return {
                    post (t, r) {
                        e.postMessage(t, r);
                    }
                };
                if ((0, t.isWindow)(e)) return {
                    post (t, n) {
                        e.postMessage(t, r, n);
                    }
                };
                throw new n.PortRpcError(`Unsupported ${o} target`);
            };
        },
        906 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.serialize = void 0;
            const n = r(438);
            t.serialize = (e, t, r, n = new WeakSet())=>{
                if (null == e) return e;
                if ("function" == typeof e) return s(e, t, r);
                if (e instanceof Error) return i(e);
                if (e instanceof RegExp) return c(e);
                if (e instanceof Date || e instanceof ArrayBuffer || ArrayBuffer.isView(e)) return e;
                if ("object" == typeof e) {
                    if (n.has(e)) return;
                    return n.add(e), o(e, t, r, n);
                }
                return "symbol" != typeof e ? e : void 0;
            };
            const o = (e, r, n, o)=>{
                if (Array.isArray(e)) return e.map((e)=>(0, t.serialize)(e, r, n, o));
                if (e instanceof Map) {
                    const s = new Map();
                    for (const [i, c] of e)s.set(i, (0, t.serialize)(c, r, n, o));
                    return s;
                }
                if (e instanceof Set) {
                    const s = new Set();
                    for (const i of e)s.add((0, t.serialize)(i, r, n, o));
                    return s;
                }
                const s = {};
                for (const i of Object.keys(e))s[i] = (0, t.serialize)(e[i], r, n, o);
                return s;
            }, s = (e, t, r)=>{
                const o = e[n.PROXY_ID_SYMBOL];
                if (o && "string" == typeof o) return {
                    __type__: "port_rpc_function",
                    __id__: o,
                    __name__: e.name || "anonymous"
                };
                const s = r.get(e);
                if (s) return {
                    __type__: "port_rpc_function",
                    __id__: s,
                    __name__: e.name || "anonymous"
                };
                const i = e[n.PROXY_ID_FIELD] || (0, n.uniqueID)();
                return r.set(e, i), t.set(i, e), {
                    __type__: "port_rpc_function",
                    __id__: i,
                    __name__: e.name || "anonymous"
                };
            }, i = (e)=>({
                    __type__: "port_rpc_error",
                    message: e.message,
                    stack: e.stack,
                    code: e.code,
                    name: e.name
                }), c = (e)=>({
                    __type__: "port_rpc_regex",
                    source: e.source,
                    flags: e.flags
                });
        },
        930 (e, t, r) {
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t._resetDispatcher = t.registerForwardResolver = t.onConnect = t.accept = void 0;
            const n = r(438), o = r(402), s = r(441), i = r(690), c = [], a = [];
            let d = null, u = null;
            const l = ()=>"undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope, f = ()=>{
                if (d) return;
                const e = (()=>{
                    if (l()) return self;
                    if ("undefined" != typeof window) return window;
                    throw new s.PortRpcError("Cannot detect accept/forward context");
                })(), t = (e)=>{
                    m(e);
                };
                u = e, d = t, e.addEventListener("message", t);
            }, _ = ()=>{
                u && d && u.removeEventListener("message", d), u = null, d = null;
            }, h = (e, t)=>{
                const r = e.indexOf(t);
                return -1 !== r && (e.splice(r, 1), 0 === c.length && 0 === a.length && _(), !0);
            }, p = async (e, t, r, n)=>e.consumed ? "next" : !e.allowedOrigins || l() || e.allowedOrigins.includes(n) ? e.matcher ? E(e, t, r) : (e.resolve && (e.consumed = !0), y(t, !0), g(e, new o.ConnectionImpl(t), r), "consumed") : "next", E = async (e, t, r)=>{
                let n;
                try {
                    n = await e.matcher(r);
                } catch  {
                    return "next";
                }
                return !1 === n ? "next" : e.consumed ? "restart" : (e.resolve && (e.consumed = !0), y(t, "object" != typeof n || n), g(e, new o.ConnectionImpl(t), r), "consumed");
            }, m = async (e)=>{
                const t = e.data;
                if (!t || t.type !== n.HANDSHAKE_MSG_TYPE) return;
                const r = e.ports?.[0];
                if (!r) return;
                const o = "context" in t && null != t.context ? t.context : void 0, s = l() ? "worker" : e.origin ?? "unknown";
                if (o && await (async (e, t, r)=>{
                    for (const n of [
                        ...c
                    ]){
                        if (n.options?.allowedOrigins && !l() && !n.options.allowedOrigins.includes(r)) continue;
                        let o;
                        try {
                            o = await n.resolver(t);
                        } catch (t) {
                            return T(e, t instanceof Error ? t.message : String(t)), !0;
                        }
                        if (null != o) return w(e, t, o, r), !0;
                    }
                    return !1;
                })(r, o, s)) return;
                const i = o ? {
                    ...o,
                    origin: s
                } : {
                    origin: s
                };
                if (!await (async (e, t, r)=>{
                    let n = !1;
                    do {
                        n = !1;
                        for (const o of a){
                            const s = await p(o, e, t, r);
                            if ("consumed" === s) return !0;
                            if ("restart" === s) {
                                n = !0;
                                break;
                            }
                        }
                    }while (n);
                    return !1;
                })(r, i, s)) try {
                    r.close();
                } catch  {}
            }, g = (e, t, r)=>{
                e.resolve ? (h(a, e), e.resolve(t, r)) : e.handler && e.handler(t, r);
            }, y = (e, t)=>{
                const r = {
                    type: n.HANDSHAKE_ACK_TYPE,
                    verificationData: t
                };
                try {
                    e.postMessage(r);
                } catch  {}
            }, T = (e, t)=>{
                const r = {
                    type: n.ROUTE_REJECT_TYPE,
                    error: t
                };
                try {
                    e.postMessage(r);
                } catch  {}
            }, w = (e, t, r, o)=>{
                const s = {
                    ...t,
                    origin: o
                }, c = r.origin ?? "*", a = {
                    type: n.HANDSHAKE_MSG_TYPE,
                    context: s
                };
                try {
                    (0, i.resolveTarget)(r.target, c, "forward").post(a, [
                        e
                    ]);
                } catch (t) {
                    T(e, `Forward failed: ${t instanceof Error ? t.message : String(t)}`);
                }
            };
            t.accept = (e)=>{
                f();
                const t = e?.timeout ?? n.HANDSHAKE_TIMEOUT;
                return new Promise((r, n)=>{
                    const o = {
                        matcher: e?.matcher,
                        allowedOrigins: e?.allowedOrigins,
                        resolve: (e)=>{
                            clearTimeout(i), r(e);
                        },
                        reject: n
                    };
                    a.push(o);
                    const i = setTimeout(()=>{
                        o.consumed || (h(a, o), n(new s.TimeoutError(`Accept timeout: no connection received within ${t}ms`)));
                    }, t);
                });
            }, t.onConnect = (e, t)=>{
                f();
                const r = new Set(), n = {
                    matcher: t?.matcher,
                    allowedOrigins: t?.allowedOrigins,
                    handler: (t, n)=>{
                        r.add(t), t.onDisconnect(()=>{
                            r.delete(t);
                        }), e(t, n);
                    }
                };
                a.push(n);
                const o = {
                    connections: r,
                    cancel () {
                        h(a, n);
                    },
                    destroyAll () {
                        o.cancel();
                        for (const e of [
                            ...r
                        ])e.destroy();
                        r.clear();
                    }
                };
                return o;
            }, t.registerForwardResolver = (e, t)=>{
                f();
                const r = {
                    resolver: e,
                    options: t
                };
                return c.push(r), {
                    cancel () {
                        h(c, r);
                    }
                };
            }, t._resetDispatcher = ()=>{
                for (const e of a)e.consumed = !0;
                c.length = 0, a.length = 0, _();
            };
        }
    }, t = {};
    function r(n) {
        var o = t[n];
        if (void 0 !== o) return o.exports;
        var s = t[n] = {
            exports: {}
        };
        return e[n](s, s.exports, r), s.exports;
    }
    r.d = (e, t)=>{
        for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        });
    }, r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var n = {};
    r.r(n), r.d(n, {
        createEmbeddedMacroBridgeListener: ()=>f,
        createEmbeddedMacroListener: ()=>_,
        createIframeBridge: ()=>l,
        createWorkerBridge: ()=>p,
        establishConnectionWithProduct: ()=>h,
        setupSandboxController: ()=>E
    });
    var o = r(304), s = function(e) {
        return (null == e ? void 0 : e.message.startsWith("No handler found for post message:")) || (null == e ? void 0 : e.message.startsWith("No handler registered for")) ? Promise.resolve() : Promise.reject("Error while sending bridge message: ".concat(null == e ? void 0 : e.message));
    }, i = "__ready", c = 2e4, a = function(e, t) {
        return Object.entries(t).map(function(t) {
            var r = t[0], n = t[1];
            return e.on(r, function(e) {
                return n ? n(e) : Promise.resolve();
            });
        });
    }, d = function(e, t, r, n) {
        e.send(i, t, {
            timeout: c
        }).then(function() {
            r(!0);
        }).catch(function(e) {
            return r(!1, e), s(e);
        }).catch(function(e) {
            console.error(n, e);
        });
    }, u = function() {
        return u = Object.assign || function(e) {
            for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
        }, u.apply(this, arguments);
    }, l = function(e) {
        if (!e.withWindow) throw new Error("Target window to setup the bridge with is not defined");
        return {
            open: function() {
                var t = e.withWindow, r = e.withDomain, n = e.features, l = e.theme, f = e.surfaceColor, _ = e.sendHandshakeMetric, h = e.metadata;
                return (0, o._4)(t, {
                    origin: r,
                    timeout: c,
                    context: {
                        type: "iframe-bridge",
                        metadata: h
                    }
                }).then(function(e) {
                    var t = a(e, n), r = e.on(i, function() {
                        return null;
                    });
                    return d(e, u({
                        theme: l,
                        surfaceColor: f
                    }, h || {}), _, "Iframe bridge: unexpected error in READY_EVENT handler:"), {
                        enableTheming: function() {
                            e.send("__theme_enable", null).catch(s);
                        },
                        setTheme: function(t, r, n) {
                            e.send("__theme_change", {
                                theme: t,
                                surfaceColor: r,
                                env: n,
                                isFedRamp: null == h ? void 0 : h.isFedRamp
                            }).catch(s);
                        },
                        close: function() {
                            r.cancel(), t.forEach(function(e) {
                                return (0, e.cancel)();
                            }), e.destroy();
                        }
                    };
                });
            }
        };
    }, f = function(e) {
        var t = window.location.origin;
        return (0, o.GJ)(function(t) {
            a(t, e);
        }, {
            matcher: function(e) {
                return "embeddedMacro" === e.type && e.origin === t && {
                    origin: t
                };
            }
        });
    }, _ = function(e) {
        var t = f(e);
        return {
            close: function() {
                return t.destroyAll();
            }
        };
    }, h = function() {
        var e = window.parent.parent, t = window.location.origin;
        return (0, o._4)(e, {
            context: {
                type: "embeddedMacro",
                origin: t
            },
            verify: function(e) {
                return e.origin === t;
            }
        });
    }, p = function(e) {
        if (!e.withWindow) throw new Error("Target window to setup the bridge with is not defined");
        return {
            open: function() {
                var t = e.withWindow, r = e.withDomain, n = e.features, s = e.sendHandshakeMetric, i = e.metadata, u = e.workerId;
                return (0, o._4)(t, {
                    origin: r,
                    timeout: c,
                    context: {
                        type: "worker-bridge",
                        workerId: u,
                        metadata: i
                    }
                }).then(function(e) {
                    var t = a(e, n);
                    return d(e, null, s, "Worker bridge: unexpected error in READY_EVENT handler:"), {
                        enableTheming: function() {},
                        setTheme: function() {},
                        close: function() {
                            t.forEach(function(e) {
                                return (0, e.cancel)();
                            }), e.destroy();
                        }
                    };
                });
            }
        };
    }, E = function(e, t) {
        return (0, o._4)(e, {
            origin: t,
            timeout: 5e3
        }).then(function(e) {
            return e.send("__sandbox_controller_request", null, {
                timeout: 5e3
            }).then(function(t) {
                return {
                    controller: t,
                    destroy: function() {
                        return e.destroy();
                    }
                };
            }).catch(function(r) {
                throw e.destroy(), new Error("Sandbox did not provide a controller (origin: ".concat(t, "): ").concat(r.message));
            });
        }, function(e) {
            throw new Error("Sandbox handshake failed (origin: ".concat(t, "): ").concat(e.message));
        });
    };
    $36a3b759c0c89f29$exports = n;
})();



var $9zb43 = parcelRequire("9zb43");




var $5U2YR = parcelRequire("5U2YR");











const $9d587b1ca74180de$var$defaultComponents = {
    ThreeLOPrompt: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), props)
};
const $9d587b1ca74180de$export$3be8e8bcb6b54c3e = ({ extension: extension, appId: appId, accountId: accountId, components: components, onLoad: onLoad, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, overlayController: overlayController })=>{
    const { ThreeLOPrompt: ThreeLOPrompt } = components ? components($9d587b1ca74180de$var$defaultComponents) : $9d587b1ca74180de$var$defaultComponents;
    const { consentUrl: consentUrl, requiresUserConsent: requiresUserConsent, currentUserConsent: currentUserConsent } = extension;
    const appIsAuthenticated = (0, $dd25f80afb746bb3$export$c58c2ef6cd7b14a1)(appId, accountId);
    const [userConsentRequired, setUserConsentRequired] = (0, $42omo.useState)(!!(consentUrl && !currentUserConsent && requiresUserConsent && !appIsAuthenticated));
    // Queue of pending retries across concurrent runtime 3LO prompts.
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    // Always-current values so callbacks created inside effects and renderThreeLOPrompt
    // always reference the latest props without stale closure issues.
    const latestRef = (0, $42omo.useRef)({
        ThreeLOPrompt: ThreeLOPrompt,
        overlayController: overlayController,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extension: extension,
        appId: appId,
        accountId: accountId,
        consentUrl: consentUrl,
        onLoad: onLoad
    });
    latestRef.current = {
        ThreeLOPrompt: ThreeLOPrompt,
        overlayController: overlayController,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extension: extension,
        appId: appId,
        accountId: accountId,
        consentUrl: consentUrl,
        onLoad: onLoad
    };
    // Shared presenter — shows <ThreeLOPrompt> via overlayController and handles
    // the common teardown (hide overlay, restore visibility + renderer) before
    // delegating to the caller-specific `onConsented` callback.
    const showThreeLOPrompt = (0, $hQK66.useCallbackOne)((authUrl, onConsented)=>{
        const { ThreeLOPrompt: ThreeLOPrompt, overlayController: overlayController, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, extension: extension } = latestRef.current;
        overlayController.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ThreeLOPrompt, {
            authUrl: authUrl,
            onSuccess: async ()=>{
                overlayController.hide();
                setIsThreeLOPromptVisible(false);
                setShouldShowRenderer?.(true);
                await onConsented();
            },
            metadata: {
                moduleType: extension.type
            }
        }), true);
        setIsThreeLOPromptVisible(true);
        setShouldShowRenderer?.(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!userConsentRequired) return;
        const { appId: appId, accountId: accountId, consentUrl: consentUrl, onLoad: onLoad } = latestRef.current;
        showThreeLOPrompt(consentUrl, async ()=>{
            setUserConsentRequired(false);
            (0, $dd25f80afb746bb3$export$8d4e05c53de89926)(appId, accountId);
        });
        onLoad?.();
    }, [
        userConsentRequired,
        showThreeLOPrompt
    ]);
    // Stable handler — created once, reads all values via latestRef at call time.
    const renderThreeLOPrompt = (0, $hQK66.useCallbackOne)((authUrl, retry)=>new Promise((resolve)=>{
            invokeRetriesRef.current.push(retry);
            showThreeLOPrompt(authUrl, async ()=>{
                resolve();
                try {
                    await Promise.all(invokeRetriesRef.current.map((r)=>r()));
                } finally{
                    invokeRetriesRef.current = [];
                }
            });
        }), [
        showThreeLOPrompt
    ]);
    return {
        userConsentRequired: userConsentRequired,
        renderThreeLOPrompt: renderThreeLOPrompt
    };
};





const $b44b52f09e1be159$export$38896ac4f3cfe88b = ()=>{
    const [overlayContent, setOverlayContent] = (0, $42omo.useState)(null);
    const [isOverlayOpen, setIsOverlayOpen] = (0, $42omo.useState)(false);
    const [affectsLayout, setAffectsLayout] = (0, $42omo.useState)(false);
    // Stable object — never recreated, always points at the current setter.
    const overlayControllerRef = (0, $42omo.useRef)({
        show: (content, willAffectsLayout = false)=>{
            setOverlayContent(content);
            setAffectsLayout(willAffectsLayout);
            setIsOverlayOpen(true);
        },
        hide: ()=>setIsOverlayOpen(false)
    });
    const overlay = isOverlayOpen ? overlayContent : null;
    return {
        overlay: overlay,
        overlayController: overlayControllerRef.current,
        isInlineActive: affectsLayout && isOverlayOpen
    };
};









var $inPa6 = parcelRequire("inPa6");




















var $20GoR = parcelRequire("20GoR");


const $b22670f2947f2693$export$74964fd55d087734 = (props, overlayController, renderThreeLOPrompt)=>{
    // renderThreeLOPrompt is read from props at service-assembly time (see servicesRef below).
    const invoker = (0, $dj2Gr.useInvokeExtension)(props.contextIds, props.extension.id);
    const tracing = (0, $kaOT1.useTracingContext)();
    const environment = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $jIiuI.EnvironmentContext));
    const relayContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $irOoi.ReactRelayContext));
    const isAnonymousAccessSupportedByApp = props.extension.properties?.unlicensedAccess?.includes('anonymous') ?? false;
    // Adapts the two-argument renderThreeLOPrompt into the single-argument shape
    // expected by useProductFetchClient. Falls back to a no-op when the extension
    // has no consentUrl (e.g. sandbox/test environments).
    const productRenderThreeLOPrompt = (retry)=>{
        const consentUrl = props.extension.consentUrl;
        if (!consentUrl) return Promise.resolve();
        return renderThreeLOPrompt(consentUrl, retry);
    };
    const remoteFetchClient = (0, $f0e8edd6ba016f56$export$a30e8bad2b49cec5)();
    const permissionFetchClient = (0, $20GoR.usePermissionFetchClient)({
        appId: props.appId,
        installationId: props.extension.installationId,
        contextIds: props.contextIds,
        extensionId: props.extension.id,
        renderThreeLOPrompt: productRenderThreeLOPrompt
    });
    const productFetchClient = (0, $9XihO.useProductFetchClient)({
        appId: props.appId,
        environment: environment,
        contextIds: props.contextIds,
        cloudId: props.coreData.cloudId,
        workspaceId: props.coreData.workspaceId,
        extensionId: props.extension.id,
        isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp,
        renderThreeLOPrompt: productRenderThreeLOPrompt,
        options: {
            client: props.apolloClient
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const analyticsTracker = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const { captureUntrustedEvent: captureUntrustedEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    // All hook calls must precede the tracing guard below.
    // servicesRef holds the latest assembled BridgeServices snapshot and is updated
    // synchronously every render. The stable getter reads from it at bridge-call time,
    // so every service (invoker, getContextToken, productFetchClient, etc.) is always
    // current — regardless of which dep changed — without per-service ref boilerplate.
    const servicesRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const getServices = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>servicesRef.current).current;
    if (!tracing) throw new Error('WorkerWebRuntime: TracingProvider not found in the component tree. ');
    if (!relayContext?.environment) throw new Error('useBridgeServices: RelayEnvironmentProvider not found in the component tree.');
    // Assembled fresh every render; updates the ref synchronously so any in-flight
    // bridge call that fires after this render always sees the latest values.
    servicesRef.current = {
        invoker: invoker,
        getContextToken: props.getContextToken ?? $b22670f2947f2693$var$nullGetContextToken,
        tracing: tracing,
        overlayController: overlayController,
        onThreeLO: renderThreeLOPrompt,
        productFetchClient: productFetchClient,
        permissionFetchClient: permissionFetchClient,
        remoteFetchClient: remoteFetchClient,
        relayEnvironment: relayContext.environment,
        analytics: {
            createAnalyticsEvent: createAnalyticsEvent,
            fireUIEvent: (payload)=>(0, $6oQb1.fireUIEvent)(createAnalyticsEvent, payload),
            tracker: analyticsTracker,
            captureUntrustedEvent: captureUntrustedEvent
        }
    };
    return {
        getServices: getServices
    };
};
// TODO: currently sandbox does not support getContextToken (unlike other products),
// so we provide a noop implementation to avoid having to guard every bridge method that uses it.
const $b22670f2947f2693$var$nullGetContextToken = ()=>undefined;



















/**
 * A single lazily-computed slot. Call `get(factory)` to read (computing on first access),
 * and `invalidate()` to clear so the next `get()` recomputes.
 *
 * Note: `T` must not be `null` — `null` is used as the uncomputed sentinel.
 */ class $368eadf79cf92bf5$var$LazyCell {
    get(compute) {
        if (this.value === null) this.value = compute();
        return this.value;
    }
    invalidate() {
        this.value = null;
    }
    constructor(){
        this.value = null;
    }
}
/**
 * Unified registry for per-instance bridge resources.
 * Each resource defines its own create and destroy lifecycle.
 * BridgeContextObject.destroy() calls destroy(state) for every claimed resource.
 */ class $368eadf79cf92bf5$var$BridgeResourceRegistry {
    destroy() {
        for (const { resource: resource, state: state } of this.entries.values())resource.destroy(state);
        this.entries.clear();
    }
    constructor(){
        this.entries = new Map();
        this.claimBridgeResource = (resource)=>{
            if (this.entries.has(resource.id)) return this.entries.get(resource.id).state;
            const state = resource.create();
            this.entries.set(resource.id, {
                resource: resource,
                state: state
            });
            return state;
        };
    }
}
class $368eadf79cf92bf5$export$692584c74926c9b3 {
    /**
   * Registers the live bridge-core v2 connection.
   * The iframe loads exactly once per component lifetime — setBridgeControl should
   * only ever be called once. A second call indicates an unexpected iframe reload
   * (guest navigation or host src change) and is an error in development.
   */ setBridgeControl(controls) {
        if (this.bridgeControls !== null) // eslint-disable-next-line no-console
        console.error('[forge-ui] setBridgeControl called with an existing connection open. Unexpected iframe reload');
        this.bridgeControls = controls;
    }
    /**
   * Tears down all resources owned by this object. Should be called on component
   * unmount to prevent memory leaks.
   */ destroy() {
        // Close the connection before destroying resources — prevents new bridge calls arriving after teardown.
        this.bridgeControls?.close();
        this.bridgeControls = null;
        this.resourceRegistry.destroy();
        this.changeListeners.clear();
    }
    /**
   * Registers a listener that is called whenever one or more props change.
   * The listener receives the previous props, the new props, and a lazy `getContext()`
   * accessor — call it only if you need the context, as it allocates on first call.
   * Returns an unsubscribe function — call it to stop receiving notifications.
   *
   * Listeners only fire when something actually changed (`changes.__all__` is true).
   * They are cleared automatically on `destroy()`.
   */ onChange(listener) {
        this.changeListeners.add(listener);
        return ()=>this.changeListeners.delete(listener);
    }
    /**
   * Diffs incoming props against stored props, clears the cache, and emits
   * change events for updated BridgeContext fields.
   *
   * Must be called inside useEffect (not during render) because it emits DOM events.
   */ update(nextProps) {
        const prevProps = this.props;
        const changes = this.computeChanges(nextProps);
        this.props = nextProps;
        if (changes.__all__) {
            this.resolverContextCell.invalidate();
            this.viewContextCell.invalidate();
            this.extensionDetailsCell.invalidate();
            // Lazy: computed at most once, only if a listener actually reads it.
            let contextCache;
            // note, ??= is currently not supported in our build environment, hence will need to be rewritten when we upgrade to a newer TypeScript version
            const getContext = ()=>contextCache !== undefined ? contextCache : contextCache = this.get();
            for (const listener of this.changeListeners)listener(prevProps, nextProps, getContext);
        }
    }
    /**
   * Returns the current BridgeContext.
   *
   * Fields that involve non-trivial work are getter properties — deferred until
   * the bridge method actually reads them.
   *
   * Pass-through fields are direct values, since reading a prop is O(1).
   */ get() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        return {
            // Deferred — resolved only when the bridge method accesses the field.
            get resolverContext () {
                return self.resolverContext;
            },
            get viewContext () {
                return self.viewContext;
            },
            get extensionDetails () {
                return self.extensionDetails;
            },
            get services () {
                return self.getServices();
            },
            // Immediate — direct prop reads, no benefit to deferring.
            bridgeConfig: this.props.bridge ?? {},
            bridgeControls: this.bridgeControls,
            claimBridgeResource: this.resourceRegistry.claimBridgeResource,
            contextIds: this.props.contextIds,
            environment: this.props.environment,
            page: this.props.page,
            extension: this.props.extension,
            extensionPayload: this.props.extensionPayload
        };
    }
    get resolverContext() {
        return this.resolverContextCell.get(()=>(0, $ge8sG.getResolverContext)({
                ...this.props.coreData,
                appVersion: this.props.extension.appVersion
            }, this.props.extensionData));
    }
    get extensionDetails() {
        return this.extensionDetailsCell.get(()=>{
            const { extension: extension } = this.props;
            return {
                appId: extension.appId ?? (0, $ijfiP.parseExtensionId)(extension.id).appId,
                id: extension.id.split('/').slice(0, 3).join('/'),
                installationId: extension.installationId
            };
        });
    }
    get viewContext() {
        return this.viewContextCell.get(()=>this.buildViewContext(this.props, this.resolverContext));
    }
    computeChanges(nextProps) {
        const allKeys = new Set([
            ...Object.keys(nextProps),
            ...Object.keys(this.props)
        ]);
        const changes = {
            __all__: false
        };
        for (const key of allKeys){
            const changed = nextProps[key] !== this.props[key];
            changes[key] = changed;
            if (changed) changes.__all__ = true;
        }
        // report the change fields with console output
        if (changes.__all__) {
            const changedFields = Object.keys(changes).filter((k)=>k !== '__all__' && changes[k]);
            // eslint-disable-next-line no-console
            console.log('BridgeContext changed:', changedFields);
        }
        return changes;
    }
    buildViewContext(props, resolverContext) {
        return (0, $UZU5S.getViewContext)({
            resolverContext: resolverContext,
            accountId: props.accountId,
            extension: props.extension,
            timezone: props.timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
            locale: props.locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionPayload: props.extensionPayload,
            extensionViewData: props.extensionViewData,
            theme: props.theme,
            surfaceColor: props.surfaceColor,
            location: window.location.toString()
        });
    }
    constructor(props, getServices){
        this.props = void 0;
        this.getServices = void 0;
        this.bridgeControls = null;
        this.changeListeners = new Set();
        this.resolverContextCell = new $368eadf79cf92bf5$var$LazyCell();
        this.viewContextCell = new $368eadf79cf92bf5$var$LazyCell();
        this.extensionDetailsCell = new $368eadf79cf92bf5$var$LazyCell();
        this.resourceRegistry = new $368eadf79cf92bf5$var$BridgeResourceRegistry();
        this.props = props;
        this.getServices = getServices;
    }
}








const $650e4e464f468af1$export$e28a9b61f2b3f391 = (props, getServices)=>{
    // Created once for the lifetime of the component.
    // BridgeContextObject owns all memoization and change notification internally.
    const contextObjectRef = (0, $42omo.useRef)(null);
    if (contextObjectRef.current === null) contextObjectRef.current = new (0, $368eadf79cf92bf5$export$692584c74926c9b3)(props, getServices);
    // Update after every commit. Bridge calls arrive via postRobot (async message events)
    // so the context will always be current before any bridge method is invoked.
    (0, $42omo.useEffect)(()=>{
        contextObjectRef.current.update(props);
    });
    const getBridgeContext = (0, $hQK66.useCallbackOne)(()=>contextObjectRef.current.get(), []);
    const destroy = (0, $hQK66.useCallbackOne)(()=>contextObjectRef.current.destroy(), []);
    const onChange = (0, $hQK66.useCallbackOne)((listener)=>contextObjectRef.current.onChange(listener), []);
    const setBridgeControl = (0, $hQK66.useCallbackOne)((controls)=>contextObjectRef.current.setBridgeControl(controls), []);
    // This registers general bridge context change events that is common to all
    // bridge runtimes and Forge modules.
    (0, $42omo.useEffect)(()=>{
        return onChange((prev, next)=>{
            if (prev.theme !== next.theme || prev.surfaceColor !== next.surfaceColor) (0, $luNHV.emit)('FORGE_CORE_THEME_CHANGED', {
                theme: next.theme
            });
            if (prev.extension !== next.extension) {
                // `config` is a Confluence-specific runtime field not present in the GQLExtension type.
                const prevConfig = prev.extension?.config;
                const nextConfig = next.extension?.config;
                // TODO: FORGE_CORE_MACRO_CONFIG_CHANGED is a Confluence-specific concept (macro config)
                // and does not belong in the forge-ui framework layer. Once product-level bridge
                // listener registration exists, Confluence should register this listener from its own
                // forge integration layer and this emit should be removed here.
                if ((0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(prevConfig) !== (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(nextConfig)) (0, $luNHV.emit)('FORGE_CORE_MACRO_CONFIG_CHANGED', {
                    config: nextConfig
                });
            }
        });
    }, [
        onChange
    ]);
    return {
        getBridgeContext: getBridgeContext,
        destroy: destroy,
        onChange: onChange,
        setBridgeControl: setBridgeControl
    };
};


const $a1b262b25c77d73e$export$31553aaa555c1514 = async ({ viewContext: viewContext })=>{
    return viewContext;
};
const $a1b262b25c77d73e$export$468cda29b159ee5d = async ({ services: { invoker: invoker, getContextToken: getContextToken, tracing: tracing, onThreeLO: onThreeLO }, resolverContext: resolverContext, extensionPayload: extensionPayload, contextIds: contextIds }, data)=>{
    const doInvoke = async ()=>{
        const contextToken = await getContextToken({
            contextIdsOverride: contextIds
        });
        tracing.recordGqlCall('invokeExtension - start');
        const { data: gqlData } = await invoker({
            call: data,
            context: {
                ...resolverContext
            },
            extensionPayload: extensionPayload,
            contextToken: contextToken
        });
        const resp = gqlData?.invokeExtension;
        if (!resp?.success) {
            const error = resp?.errors?.[0];
            if (error?.extensions.errorType === 'USER_CONSENT_REQUIRED') {
                const authUrl = error?.extensions.fields?.authInfoUrl;
                return new Promise((resolve, reject)=>{
                    onThreeLO(authUrl, async ()=>{
                        try {
                            resolve(await doInvoke());
                        } catch (e) {
                            reject(e);
                        }
                    }).catch(reject);
                });
            }
            throw new Error(error?.message ?? 'An error occurred while trying to invoke.');
        }
        tracing.recordGqlCall('invokeExtension - end');
        return resp.response?.body ?? {};
    };
    return doInvoke();
};
const $a1b262b25c77d73e$export$34bfdcdeb272e2c2 = async ({ extension: extension })=>{
    return extension.properties?.frameId ?? null;
};
const $a1b262b25c77d73e$export$32da5b5043dcd88c = async ()=>{
    window.location.reload();
};







var $b4nol = parcelRequire("b4nol");




const $3eda9c7596411f2d$export$7a88fe5d3687ebff = (extension)=>(0, $iqcSr.isCustomUI)(extension) ? 'CustomUI' : 'UIKit';


const $9815f75a5eca48fa$var$fireFeatureFlagAnalyticsEvent = (tracker, extension, appId, params)=>{
    tracker.trackForgeFeatureFlagEvent({
        appType: (0, $3eda9c7596411f2d$export$7a88fe5d3687ebff)(extension),
        appId: appId,
        baseUrl: window.location.origin,
        forgeEnvironment: extension.environmentType,
        ...params
    });
};
const $9815f75a5eca48fa$export$f9d0db67c92b2ab2 = async (context, payload)=>{
    const { extensionDetails: { appId: appId }, extension: extension, contextIds: contextIds, environment: environment, services: { getContextToken: getContextToken, tracing: tracing, analytics: analytics } } = context;
    if (!(0, $dh538.fg)('platform_forge_ff_client_sdk')) return {};
    const contextToken = await getContextToken({
        contextIdsOverride: contextIds
    });
    tracing.recordBridgeCall('getFeatureFlags - start');
    const featureFlagEnv = payload.user?.statsigEnvironment?.tier || (0, $b4nol.FeatureFlagEnv).development;
    const trackInit = (success)=>{
        if ((0, $dh538.fg)('platform_forge_ff_ui_analytics')) $9815f75a5eca48fa$var$fireFeatureFlagAnalyticsEvent(analytics.tracker, extension, appId, {
            eventType: (0, $b4nol.FeatureFlagEventTypes).INITIALIZATION,
            success: success,
            featureFlagEnv: featureFlagEnv
        });
    };
    try {
        const resp = await (0, $9c850cca6011a656$export$e02fc95a45760598)(appId, payload.user, payload.config, environment, contextToken);
        tracing.recordBridgeCall('getFeatureFlags - end');
        trackInit(true);
        return resp;
    } catch (err) {
        tracing.recordBridgeCall('getFeatureFlags - end');
        // eslint-disable-next-line no-console
        console.error('There were errors while initialising feature flags client ', err);
        trackInit(false);
        return {};
    }
};
const $9815f75a5eca48fa$var$ALLOWED_EVENT_TYPES = [
    (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
];
const $9815f75a5eca48fa$var$isValidFeatureFlagEventPayload = (data)=>{
    if (!data.type || !$9815f75a5eca48fa$var$ALLOWED_EVENT_TYPES.includes(data.type.toUpperCase())) return false;
    if (data.type.toUpperCase() === (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase() && data.properties.name && (data.properties.name.length < 3 || data.properties.name.length > 50)) return false;
    if (typeof data.properties.success !== 'boolean') return false;
    if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $b4nol.FeatureFlagEnv))) return false;
    return true;
};
const $9815f75a5eca48fa$export$40367c2ce2684f9b = async (context, data)=>{
    if (!(0, $dh538.fg)('platform_forge_ff_ui_analytics')) return;
    const { extensionDetails: { appId: appId }, extension: extension, services: { analytics: analytics } } = context;
    try {
        if (!$9815f75a5eca48fa$var$isValidFeatureFlagEventPayload(data)) return;
        $9815f75a5eca48fa$var$fireFeatureFlagAnalyticsEvent(analytics.tracker, extension, appId, {
            flagName: data.properties.name || '',
            eventType: data.type,
            success: data.properties.success,
            featureFlagEnv: data.properties.environment
        });
    } catch  {
    // all errors are ignored
    }
};



const $5a50fa18555d29bc$export$2052623e8b7dc210 = async (context, payload)=>{
    context.services.analytics.captureUntrustedEvent(payload);
};
const $5a50fa18555d29bc$export$ffaff761e5d8cf6c = async (context, payload)=>{
    context.services.analytics.captureUntrustedEvent(payload);
};
const $5a50fa18555d29bc$export$d39f84faa1bc5db6 = async (context, payload)=>{
    const { extension: extension, extensionDetails: { appId: appId }, services: { analytics: analytics } } = context;
    analytics.tracker.trackObjectStoreAction({
        appType: (0, $3eda9c7596411f2d$export$7a88fe5d3687ebff)(extension),
        appId: appId,
        action: payload.action,
        forgeEnvironment: extension.environmentType
    });
};


/**
 * Creates a bridge method that delegates to a single `BridgeConfig` callback.
 *
 * Contract (mirrors `createBridgeMethod` in the legacy bridge):
 *   - Callback present  → `(await callback(payload)) ?? true`
 *   - Callback absent   → `false`
 *
 * The callback is read from `bridgeConfig` at invocation time (not creation time),
 * so updates to the product's bridge prop are always reflected.
 */ const $55bae7f37a7a68d8$var$createBridgeConfigDelegate = (callbackName)=>async ({ bridgeConfig: bridgeConfig }, payload)=>{
        const callback = bridgeConfig[callbackName];
        if (!callback) return false;
        return await callback(payload) ?? true;
    };
/**
 * The subset of `BridgeConfig` keys exposed as bridge features.
 *
 * Keys excluded from this list (e.g. `spaPush`, `history`, `extensionBasePath`)
 * are used internally by other bridge methods and are not directly dispatched
 * from the app iframe.
 */ const $55bae7f37a7a68d8$var$BRIDGE_CONFIG_DELEGATE_KEYS = [
    'changeWindowTitle',
    'close',
    'closeFlag',
    'emitReadyEvent',
    'onClose',
    'onError',
    'open',
    'openModal',
    'reconcile',
    'refresh',
    'showFlag',
    'submit'
];
const $55bae7f37a7a68d8$export$966b3425a26d5e9f = Object.fromEntries($55bae7f37a7a68d8$var$BRIDGE_CONFIG_DELEGATE_KEYS.map((key)=>[
        key,
        $55bae7f37a7a68d8$var$createBridgeConfigDelegate(key)
    ]));





const $4c7afe794077cd89$export$28eb87eac4188ed6 = async ({ services: { productFetchClient: productFetchClient } }, { restPath: restPath, product: product, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
    const response = await productFetchClient(restPath, product, fetchRequestInit, isMultipartFormData);
    const { status: status, statusText: statusText } = response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const headers = Object.fromEntries(response.headers.entries());
    const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
    const body = response.body ? await response.text() : undefined;
    return {
        headers: headers,
        status: status,
        statusText: statusText,
        body: body,
        isAttachment: isAttachment
    };
};





const $b1098c5558ff5ddd$export$db36d2f1649120da = async ({ services: { getContextToken: getContextToken, remoteFetchClient: remoteFetchClient } }, { remoteKey: remoteKey, fetchRequestInit: fetchRequestInit, isMultipartFormData: isMultipartFormData })=>{
    const { path: path, ...init } = fetchRequestInit;
    const contextToken = await getContextToken();
    const response = await remoteFetchClient(remoteKey, init, isMultipartFormData, path, contextToken);
    const { status: status, statusText: statusText } = response;
    const headers = Object.fromEntries(response.headers.entries());
    const isAttachment = (0, $9XihO.isBinaryContentType)(response.headers.get('content-type'));
    const body = response.body ? await response.text() : undefined;
    return {
        headers: headers,
        status: status,
        statusText: statusText,
        body: body,
        isAttachment: isAttachment
    };
};



var $8z9j5 = parcelRequire("8z9j5");

const $31a41e3290348206$export$cee03385e28d6243 = async ({ environment: environment, bridgeControls: bridgeControls })=>{
    const currentTheme = (0, $8z9j5.default)();
    bridgeControls.setTheme(currentTheme, null, environment);
};





/**
 * Opaque handle describing a per-instance bridge resource: how to create its
 * state and how to tear it down when the BridgeContextObject is destroyed.
 *
 * Declare one resource per feature module (keep it private to the module unless
 * sharing across methods is intentional).
 *
 * Future lifecycle hooks (e.g. `onUpdate`, `onContextTokenRefresh`) can be
 * added here without changing existing callsites.
 */ const $a1d322db571e2009$export$c0f9ef43567dcb8a = (debugName, create, destroy)=>({
        id: Symbol(debugName),
        create: create,
        destroy: destroy
    });



var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");

const $dd0f09981f0dd0e2$export$dfbfa9404d7ff498 = (0, $a1d322db571e2009$export$c0f9ef43567dcb8a)('events', ()=>({
        subscriptions: new Set()
    }), ({ subscriptions: subscriptions })=>{
    for (const sub of subscriptions)sub.unsubscribe();
    subscriptions.clear();
});
const $dd0f09981f0dd0e2$export$af631764ddc44097 = async ({ extensionDetails: extensionDetails, claimBridgeResource: claimBridgeResource, page: page, services: { analytics: analytics } }, { event: event, callback: callback })=>{
    const state = claimBridgeResource($dd0f09981f0dd0e2$export$dfbfa9404d7ff498);
    const subscription = (0, $luNHV.on)(event, callback, extensionDetails);
    state.subscriptions.add(subscription);
    analytics.createAnalyticsEvent({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        data: {
            action: 'subscribed',
            actionSubject: 'bridgeEvent',
            attributes: {
                // TODO: remove the condition (and related test) once Developer UGC spec is ready
                event: event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
            },
            source: page,
            tags: [
                'forge'
            ]
        }
    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    return {
        unsubscribe: ()=>{
            if (state.subscriptions.delete(subscription)) subscription.unsubscribe();
        }
    };
};
const $dd0f09981f0dd0e2$export$8f35fbd5db0f3634 = async ({ extensionDetails: extensionDetails }, { event: event, payload: payload })=>{
    (0, $luNHV.emit)(event, payload, extensionDetails);
};


/**
 * @generated SignedSource<<0dd49360b048fbbc133c64511bef422a>>
 * @relayHash b17b87df0361e2b091063266ad414333
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4
const $04b69c81f887e002$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "add4418fa3b9922378db99ca8f4638f62a27cdbfc1ca37cb555b2c7463d0cdf4",
            "metadata": {},
            "name": "publicEventsBridgeMethod_getExtensionListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$04b69c81f887e002$var$node.hash = "7bbb57a8de2a877674c61a37fce31344";
var $04b69c81f887e002$export$2e2bcd8739ae039 = $04b69c81f887e002$var$node;



var $3e6Uc = parcelRequire("3e6Uc");











const $26de492c7928fc91$export$fc4b2a656c4af0a2 = (0, $a1d322db571e2009$export$c0f9ef43567dcb8a)('public-events', ()=>({
        subscriptions: new Set()
    }), ({ subscriptions: subscriptions })=>{
    for (const sub of subscriptions)sub.unsubscribe();
    subscriptions.clear();
});
// ─── Cache ────────────────────────────────────────────────────────────────────
/**
 * Module-level cache of allowed-recipients lists keyed on the sorted, joined
 * contextIds string. Sorting makes the key order-independent; joining with
 * a null byte avoids false collisions between adjacent entries.
 * The number of distinct keys in a session is bounded by the number of distinct
 * page contexts visited, so there is no meaningful memory growth.
 *
 * Exposed via `clearAllowedRecipientsCache` for test teardown.
 */ const $26de492c7928fc91$var$allowedRecipientsCache = new Map();
const $26de492c7928fc91$export$28205a69263b59e6 = ()=>$26de492c7928fc91$var$allowedRecipientsCache.clear();
// ─── GQL constants ────────────────────────────────────────────────────────────
const $26de492c7928fc91$var$CORE_EVENT = 'core:event';
const $26de492c7928fc91$var$CLIENT_EVENTS = 'client-events';
const $26de492c7928fc91$var$CLIENT_EVENT = 'client-event';
const $26de492c7928fc91$var$EVENT_PREFIX = 'forge.bridge.';
// ─── Shared helpers ───────────────────────────────────────────────────────────
/**
 * Mirrors `filterAllowedRecipients` in `useEmitPublicEvent.ts`.
 * Finds the `core:event` extension for this app with key `client-events` or
 * `client-event`, extracts the `allowedRecipients` property. The `*` wildcard
 * is not supported — it is discarded rather than treated as "broadcast to all".
 * Converts full ARIs to bare app IDs (last `/`-segment), and unconditionally
 * appends the sender's own `appId` so the emitting extension always receives
 * its own public events.
 */ const $26de492c7928fc91$var$filterAllowedRecipients = (allExtensions, extension)=>{
    const matchingExtension = allExtensions.find((ext)=>ext.appId && ext.key && ext.appId === extension.appId && (ext.key === $26de492c7928fc91$var$CLIENT_EVENTS || ext.key === $26de492c7928fc91$var$CLIENT_EVENT));
    const allowedRecipients = matchingExtension?.properties?.allowedRecipients ?? [];
    const filtered = allowedRecipients.filter((r)=>r !== '*').map((r)=>r.split('/').at(-1) ?? r);
    if (!filtered.includes(extension.appId)) filtered.push(extension.appId);
    return filtered;
};
/**
 * Fetches the allowed-recipients list for `emitPublic` by querying the
 * `core:event` extension manifest via Relay. Falls back to `[extensionDetails.appId]`
 * on network error so public events always reach the sending extension at minimum.
 */ const $26de492c7928fc91$var$fetchAllowedRecipients = (relayEnvironment, contextIds, extensionDetails)=>{
    const observable = (0, $3e6Uc.fetchQuery)(relayEnvironment, (0, $04b69c81f887e002$export$2e2bcd8739ae039), {
        contextIds: contextIds,
        filter: [
            {
                type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    $26de492c7928fc91$var$CORE_EVENT
                ]
            }
        ]
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                }
            }
        }
    });
    return new Promise((resolve)=>{
        observable.subscribe({
            next: (result)=>{
                const allExtensions = result?.extensionContexts?.[0]?.extensions ?? [];
                resolve($26de492c7928fc91$var$filterAllowedRecipients(Array.from(allExtensions), extensionDetails));
            },
            error: ()=>{
                resolve([
                    extensionDetails.appId
                ]);
            }
        });
    });
};
const $26de492c7928fc91$var$getOrFetchAllowedRecipients = async (relayEnvironment, contextIds, extensionDetails)=>{
    const cacheKey = [
        ...contextIds
    ].sort().join('\0');
    if (!$26de492c7928fc91$var$allowedRecipientsCache.has(cacheKey)) {
        const recipients = await $26de492c7928fc91$var$fetchAllowedRecipients(relayEnvironment, contextIds, extensionDetails);
        $26de492c7928fc91$var$allowedRecipientsCache.set(cacheKey, recipients);
        return recipients;
    }
    return $26de492c7928fc91$var$allowedRecipientsCache.get(cacheKey);
};
const $26de492c7928fc91$export$2b8594f1cc80daad = async ({ extensionDetails: extensionDetails, claimBridgeResource: claimBridgeResource }, { event: event, callback: callback })=>{
    const state = claimBridgeResource($26de492c7928fc91$export$fc4b2a656c4af0a2);
    const subscription = (0, $luNHV.onPublic)(event, callback, extensionDetails);
    state.subscriptions.add(subscription);
    return {
        unsubscribe: ()=>{
            if (state.subscriptions.delete(subscription)) subscription.unsubscribe();
        }
    };
};
const $26de492c7928fc91$export$343310a09924dfa5 = async ({ contextIds: contextIds, extensionDetails: extensionDetails, services: { relayEnvironment: relayEnvironment } }, { event: event, payload: payload })=>{
    const allowedRecipients = await $26de492c7928fc91$var$getOrFetchAllowedRecipients(relayEnvironment, contextIds, extensionDetails);
    const newEvent = new CustomEvent(`${$26de492c7928fc91$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extensionDetails,
            payload: payload,
            allowedRecipients: allowedRecipients
        }
    });
    window.document.dispatchEvent(newEvent);
};


/**
 * @generated SignedSource<<721dca5b05982d6fc435af7d2a1dd714>>
 * @relayHash 93b3893a8e9a1daa7b144c57b1a4a9d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876
const $25eecfcb0e365d16$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "installationId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isGlobal"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "payload"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "token"
    }, v6 = [
        {
            "concreteType": "EcosystemMutation",
            "kind": "LinkedField",
            "name": "ecosystem",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "installationId",
                            "variableName": "installationId"
                        },
                        {
                            "kind": "Variable",
                            "name": "isGlobal",
                            "variableName": "isGlobal"
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        },
                        {
                            "kind": "Variable",
                            "name": "payload",
                            "variableName": "payload"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ],
                    "concreteType": "EcosystemRealtimePublishBody",
                    "kind": "LinkedField",
                    "name": "publishRealtimeChannel",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "eventId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventTimestamp"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "realtimePublishChannelMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "realtimePublishChannelMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "id": "2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876",
            "metadata": {},
            "name": "realtimePublishChannelMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$25eecfcb0e365d16$var$node.hash = "5ea0f10b611a7938d84804613e71e265";
var $25eecfcb0e365d16$export$2e2bcd8739ae039 = $25eecfcb0e365d16$var$node;












const $80d3ad4501d9050f$export$77e681b21805710f = (0, $a1d322db571e2009$export$c0f9ef43567dcb8a)('realtime', ()=>({
        activeSubscriptions: new Map()
    }), (state)=>{
    for (const { subscription: subscription } of state.activeSubscriptions.values())if (!subscription.closed) subscription.unsubscribe();
    state.activeSubscriptions.clear();
});
const $80d3ad4501d9050f$var$getChannelKey = (context)=>{
    return Object.entries(context).sort((a, b)=>a[0].localeCompare(b[0])).toString();
};
/**
 * Computes the extension context hash used to scope realtime channels.
 * Matches the hash computed by the backend Realtime service and the legacy InnerIframe.tsx.
 */ const $80d3ad4501d9050f$var$computeExtensionContext = (resolverContext)=>{
    try {
        const { modal: _modal, ...productExtensionData } = resolverContext.extension ?? {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($39e5966e46da3777$exports)))(productExtensionData);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Product context is not a serializable object.');
        return '';
    }
};
const $80d3ad4501d9050f$export$361c332a01480dda = async (context, payload)=>{
    const { extension: extension, claimBridgeResource: claimBridgeResource, resolverContext: resolverContext, services: { getContextToken: getContextToken } } = context;
    const realtimeState = claimBridgeResource($80d3ad4501d9050f$export$77e681b21805710f);
    const { onEvent: onEvent } = payload;
    const extensionContext = $80d3ad4501d9050f$var$computeExtensionContext(resolverContext);
    const channelContext = payload.options?.contextOverrides ? JSON.stringify({
        context: extensionContext,
        contextOverrides: payload.options?.contextOverrides
    }) : extensionContext;
    const channelKey = $80d3ad4501d9050f$var$getChannelKey({
        channelName: payload.channelName,
        isGlobal: payload.isGlobal,
        channelContext: channelContext
    });
    const existingEntry = realtimeState.activeSubscriptions.get(channelKey);
    if (existingEntry) {
        existingEntry.subscription.addCallback(onEvent);
        onEvent('SUBSCRIPTION_STARTED');
    } else {
        const createSubscription = async ()=>{
            const subscriptionPayload = (0, $364771c9cefa2143$export$905d34fe81a9cf60)({
                // getSubscribePayload expects the v1-shaped { data: {...} } envelope.
                payload: {
                    data: payload
                },
                context: channelContext,
                installationId: extension.installationId,
                contextToken: await getContextToken()
            });
            // Declare before subscribe() so the sink closures can reference it.
            // Assignment happens synchronously before any sink callbacks fire.
            let subscription;
            subscription = (0, $b7f5501d28b11a4d$export$ec068583843480e7)(subscriptionPayload, {
                next: (result)=>{
                    subscription.onNext(result.data.ecosystem?.realtimeChannel?.payload);
                },
                error: async (err)=>{
                    const error = Array.isArray(err) ? err[0] : err;
                    if (error?.message === 'Unauthorized request') try {
                        const callbacksToCopy = [
                            ...subscription.subscriptionCallbacks
                        ];
                        await createSubscription();
                        const newEntry = realtimeState.activeSubscriptions.get(channelKey);
                        if (newEntry) newEntry.subscription.subscriptionCallbacks = callbacksToCopy;
                        subscription.unsubscribe();
                        // The new subscription is already at channelKey — don't delete the map entry.
                        return;
                    } catch (retryError) {
                        subscription.onError(retryError);
                        if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                        if (!subscription.closed) subscription.unsubscribe();
                        return;
                    }
                    subscription.onError(error);
                    if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                    if (!subscription.closed) subscription.unsubscribe();
                },
                complete: ()=>{
                    if (realtimeState.activeSubscriptions.get(channelKey)?.subscription === subscription) realtimeState.activeSubscriptions.delete(channelKey);
                    if (!subscription.closed) subscription.unsubscribe();
                }
            }, onEvent);
            realtimeState.activeSubscriptions.set(channelKey, {
                subscription: subscription
            });
            return subscription;
        };
        createSubscription();
    }
    return {
        unsubscribe: ()=>{
            const entry = realtimeState.activeSubscriptions.get(channelKey);
            if (entry) {
                entry.subscription.removeCallback(onEvent);
                if (entry.subscription.subscriptionCallbacks.length === 0) {
                    realtimeState.activeSubscriptions.delete(channelKey);
                    if (!entry.subscription.closed) entry.subscription.unsubscribe();
                }
            }
        }
    };
};
const $80d3ad4501d9050f$export$50666a6a6eccdc2e = async (context, payload)=>{
    const { extension: extension, resolverContext: resolverContext, services: { getContextToken: getContextToken, relayEnvironment: relayEnvironment } } = context;
    const extensionContext = $80d3ad4501d9050f$var$computeExtensionContext(resolverContext);
    const contextToken = await getContextToken();
    const { channelName: channelName, isGlobal: isGlobal, options: options } = payload;
    const { token: token, contextOverrides: contextOverrides } = options || {};
    const eventPayload = JSON.stringify(payload.eventPayload);
    const channelContext = contextOverrides ? JSON.stringify({
        context: extensionContext,
        contextOverrides: contextOverrides
    }) : extensionContext;
    return new Promise((resolve, reject)=>{
        (0, $irOoi.commitMutation)(relayEnvironment, {
            mutation: (0, $25eecfcb0e365d16$export$2e2bcd8739ae039),
            variables: {
                installationId: extension.installationId,
                name: channelName,
                payload: eventPayload,
                context: channelContext,
                isGlobal: isGlobal ?? false,
                token: token
            },
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(),
                        ...contextToken ? {
                            'x-forge-context-token': contextToken
                        } : {}
                    }
                }
            },
            onCompleted: (data, errors)=>{
                if (errors) {
                    reject(errors);
                    return;
                }
                if (data?.ecosystem?.publishRealtimeChannel) {
                    const { eventId: eventId, eventTimestamp: eventTimestamp } = data.ecosystem.publishRealtimeChannel;
                    if (eventId && eventTimestamp) {
                        resolve({
                            eventId: eventId,
                            eventTimestamp: eventTimestamp
                        });
                        return;
                    }
                }
                resolve(undefined);
            },
            onError: reject
        });
    });
};


/**
 * @generated SignedSource<<3fb58c950f3b1751cbefd015bbcf568e>>
 * @relayHash ada3e04d4a67a0cf753a63d3ffc29f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70
const $6a9ca4e123b07b6f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "18f7f0ebdb47541d86e76505147e1f52e7b4dc441ac13869211d7a904ef73b70",
            "metadata": {},
            "name": "navigationBridgeMethod_tenantUrlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6a9ca4e123b07b6f$var$node.hash = "537ee6daeedfde6695ff904bf976af02";
var $6a9ca4e123b07b6f$export$2e2bcd8739ae039 = $6a9ca4e123b07b6f$var$node;















var $kTcrU = parcelRequire("kTcrU");


var $i5CVI = parcelRequire("i5CVI");


var $2gNWY = parcelRequire("2gNWY");


var $cMiG0 = parcelRequire("cMiG0");


var $fYGGr = parcelRequire("fYGGr");








var $3Faxc = parcelRequire("3Faxc");

// ─── Module-level base URL cache ──────────────────────────────────────────────
const $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId = new Map();
const $ad08296303e30ee4$export$448f9742733bb2de = ()=>{
    $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.clear();
};
/**
 * Retrieves the base URL for the given cloud tenant using a Relay query,
 * caching the result for the lifetime of the module. Needed to support
 * cross-custom-domain routing when `isCustomDomain()` returns true.
 */ const $ad08296303e30ee4$var$getBaseUrl = (relayEnvironment, cloudId)=>{
    if (!cloudId) return Promise.resolve(window.location.origin);
    const cachedBaseUrl = $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.get(cloudId);
    if (cachedBaseUrl) return Promise.resolve(cachedBaseUrl);
    const observable = (0, $3e6Uc.fetchQuery)(relayEnvironment, (0, $6a9ca4e123b07b6f$export$2e2bcd8739ae039), {
        cloudIds: [
            cloudId
        ]
    });
    return new Promise((resolve, reject)=>{
        let settled = false;
        observable.subscribe({
            next: (data)=>{
                if (settled) return;
                settled = true;
                const baseUrl = data?.tenantContexts?.[0]?.cloudUrl ?? '';
                $ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.set(cloudId, baseUrl);
                resolve(baseUrl);
            },
            error: (err)=>{
                if (!settled) {
                    settled = true;
                    reject(err);
                }
            },
            complete: ()=>{
                if (!settled) {
                    settled = true;
                    resolve($ad08296303e30ee4$var$storedBaseUrlRelayByCloudId.get(cloudId) ?? '');
                }
            }
        });
    });
};
// ─── Extension query helper ───────────────────────────────────────────────────
/**
 * Returns a `getAppForgeUIExtensions` function compatible with `TargetURLUtils`,
 * pre-bound to the current extension's appId + environmentId. Uses Relay directly
 * (no Apollo fallback) since the bridge layer is Relay-only.
 */ const $ad08296303e30ee4$var$makeGetAppForgeUIExtensions = (relayEnvironment, contextIds, appId, environmentId, cloudId)=>{
    return (params)=>(0, $fYGGr.getForgeUIExtensionsRelayAsync)({
            contextIds: contextIds,
            extensionsFilter: [
                {
                    type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                    value: [
                        `${appId}:${environmentId}`
                    ]
                }
            ],
            cloudId: cloudId,
            relayEnvironment: relayEnvironment,
            ...params
        });
};
// ─── Shared onNavigate helper ─────────────────────────────────────────────────
/**
 * Validates the URL, navigates immediately for trusted links, and for external
 * links shows the ExternalLinkModal via overlayController before navigating.
 */ const $ad08296303e30ee4$var$onNavigate = async ({ type: type, url: urlString }, { extension: extension, overlayController: overlayController, analytics: { fireUIEvent: fireUIEvent } })=>{
    const url = (0, $kTcrU.makeUrl)(urlString);
    const egressService = (0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    const linkType = (0, $kZjf5.getLinkType)(url, egressService);
    if (linkType === 'invalid' || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
    if (linkType === 'trusted') {
        (0, $i5CVI.navigate)(url.href, type);
        return;
    }
    const analyticsAttributes = (0, $kZjf5.getAnalyticsAttributes)(url);
    fireUIEvent({
        action: 'viewed',
        actionSubject: 'externalLinkModal',
        attributes: analyticsAttributes
    });
    return new Promise((resolve, reject)=>{
        overlayController.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Faxc.ExternalLinkModal), {
            url: url,
            extensionTitle: extension.properties?.title,
            onConfirm: ()=>{
                (0, $i5CVI.navigate)(url.href, type);
                fireUIEvent({
                    action: 'approved',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                });
                overlayController.hide();
                resolve();
            },
            onCancel: ()=>{
                fireUIEvent({
                    action: 'cancelled',
                    actionSubject: 'externalLinkModal',
                    attributes: analyticsAttributes
                });
                overlayController.hide();
                reject(new (0, $kxKUs.BridgeClientError)('cancelled'));
            }
        }));
    });
};
const $ad08296303e30ee4$export$94df0e59ebebf4a7 = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, viewContext: viewContext, services: { relayEnvironment: relayEnvironment } }, data)=>{
    if (!data.target) return null;
    const { appId: appId } = extensionDetails;
    const { environmentId: environmentId } = extension;
    const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
        getContext: async ()=>viewContext,
        getAppForgeUIExtensions: $ad08296303e30ee4$var$makeGetAppForgeUIExtensions(relayEnvironment, contextIds, appId, environmentId, viewContext.cloudId)
    });
    if (!path) return null;
    const baseUrl = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? await $ad08296303e30ee4$var$getBaseUrl(relayEnvironment, viewContext.cloudId) : window.location.origin;
    return `${baseUrl}${path}`;
};
const $ad08296303e30ee4$export$ff7962acd6052c28 = async ({ extension: extension, extensionDetails: extensionDetails, contextIds: contextIds, viewContext: viewContext, services: { relayEnvironment: relayEnvironment, overlayController: overlayController, analytics: analytics } }, data)=>{
    if ('target' in data && data.target) {
        const targetData = data;
        const { appId: appId } = extensionDetails;
        const { environmentId: environmentId } = extension;
        const path = await (0, $cMiG0.createNavigateTargetPath)(targetData, {
            getContext: async ()=>viewContext,
            getAppForgeUIExtensions: $ad08296303e30ee4$var$makeGetAppForgeUIExtensions(relayEnvironment, contextIds, appId, environmentId, viewContext.cloudId)
        });
        if (!path) {
            // eslint-disable-next-line no-console
            console.warn('Path was not found for the parameters provided');
            return;
        }
        const url = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? `${await $ad08296303e30ee4$var$getBaseUrl(relayEnvironment, viewContext.cloudId)}${path}` : path;
        return $ad08296303e30ee4$var$onNavigate({
            type: targetData.type,
            url: url
        }, {
            extension: extension,
            overlayController: overlayController,
            analytics: analytics
        });
    }
    return $ad08296303e30ee4$var$onNavigate(data, {
        extension: extension,
        overlayController: overlayController,
        analytics: analytics
    });
};



var $hvvoj = parcelRequire("hvvoj");

const $1b2dcd1ebae61034$export$4178d7ac16e6cf7c = async ({ bridgeConfig: bridgeConfig })=>{
    return (0, $hvvoj.createHistory)({
        history: bridgeConfig.history,
        extensionBasePath: bridgeConfig.extensionBasePath
    });
};



var $974zo = parcelRequire("974zo");

const $e926d56b38388590$export$9be383b35c20e3cc = async (context, payload)=>{
    const cb = context.bridgeConfig.openRovo;
    if (!cb) return false;
    const result = await cb(payload);
    return result ?? true;
};
const $e926d56b38388590$export$243c13f4da40a98e = async (context)=>{
    const { cloudId: cloudId } = context.resolverContext;
    if (!cloudId) return false;
    return (0, $974zo.getIsRovoEnabled)({
        cloudId: cloudId,
        relayEnvironment: context.services.relayEnvironment
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









/* AdminConsentModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Shared styles from legacy AdminConsentModal for consistency. See go/DSP-18766 */ 



var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $ccHMk = parcelRequire("ccHMk");




var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $fJCAk = parcelRequire("fJCAk");


var $aXWIB = parcelRequire("aXWIB");

const $1a72623c304bea83$var$getHumanReadableName = (operation)=>{
    switch(operation){
        case 'FETCH_BACKEND_SIDE':
            return 'Fetch backend side';
        case 'FETCH_CLIENT_SIDE':
            return 'Fetch client side';
        case 'FONTS':
            return 'Fonts';
        case 'FRAMES':
            return 'Frames';
        case 'IMAGES':
            return 'Images';
        case 'MEDIA':
            return 'Media';
        case 'NAVIGATION':
            return 'Navigation';
        case 'SCRIPTS':
            return 'Scripts';
        case 'STYLES':
            return 'Styles';
        default:
            return 'Egress';
    }
};
const $1a72623c304bea83$export$a7839a1d0a383d1f = ({ appName: appName, domainInfo: domainInfo, onCancel: onCancel, onConfirm: onConfirm, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true);
    const intl = (0, $aXWIB.useIntl)();
    const handleCancel = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleConfirm = async ()=>{
        try {
            await onConfirm();
            setIsOpen(false);
        } catch  {}
    };
    const renderDomains = ()=>{
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : 'Remote'), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                xcss: (0, $fJCAk.styles).rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>c.type.map((t)=>/*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                        key: t,
                        xcss: (0, $fJCAk.styles).rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, $1a72623c304bea83$var$getHumanReadableName(t))))))));
    };
    const Notice = ()=>{
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $fJCAk.messages).termsOfUseLink)), ' ', intl.formatMessage((0, $fJCAk.messages).noticeAnd), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $fJCAk.messages).privacyPolicyLink)));
        if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage((0, $fJCAk.messages).termsOfUseLink)));
        if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).noticeForMoreDetails, {
            appName: appName
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage((0, $fJCAk.messages).privacyPolicyLink)));
        return null;
    };
    const ModalFooter = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: (0, $fJCAk.styles).modalFooterContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            space: "space.075"
        }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: handleCancel
        }, intl.formatMessage((0, $fJCAk.messages).declineButtonLabel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: handleConfirm,
            appearance: "primary"
        }, intl.formatMessage((0, $fJCAk.messages).approveButtonLabel)))));
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: handleCancel,
        width: "large"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $fJCAk.styles).titleContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, intl.formatMessage((0, $fJCAk.messages).modalTransitionTitle)))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.300"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage((0, $fJCAk.messages).modalTransitionText, {
        appName: appName
    })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, renderDomains(), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $fJCAk.styles).disclaimerContainer
    }, /*#__PURE__*/ $42omo.createElement(Notice, null))))), /*#__PURE__*/ $42omo.createElement(ModalFooter, null)));
};


/**
 * @generated SignedSource<<b1d995216e871942ad853a7b8ad41d24>>
 * @relayHash 6c8bbff92427f8f13a9f68ade35e1315
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8
const $af5efc942a2c5e73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "privacyPolicy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "termsOfService"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "extensionData"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getForgeApp_appByIdQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            {
                                "args": v5 /*: any*/ ,
                                "concreteType": "AppInstallationByIndexConnection",
                                "kind": "LinkedField",
                                "name": "installationsByContexts",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AppInstallationByIndexEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "AppInstallation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AppEnvironmentVersion",
                                                        "kind": "LinkedField",
                                                        "name": "appEnvironmentVersion",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AppVersionExtensions",
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AppVersionExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v6 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "app"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getForgeApp_appByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "AppInstallationByIndexConnection",
                            "kind": "LinkedField",
                            "name": "installationsByContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AppInstallationByIndexEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AppInstallation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AppEnvironmentVersion",
                                                    "kind": "LinkedField",
                                                    "name": "appEnvironmentVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AppVersionExtensions",
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AppVersionExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a614603202abfb55d7d7de64c2578f6deaab7e80d00892134b1cea54b0b6ade8",
            "metadata": {},
            "name": "getForgeApp_appByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af5efc942a2c5e73$var$node.hash = "e93ae1f09519a9c62b2154493dddce01";
var $af5efc942a2c5e73$export$2e2bcd8739ae039 = $af5efc942a2c5e73$var$node;






var $7MEO5 = parcelRequire("7MEO5");




class $6a9163af48013335$export$8814b2f3dd4388d5 extends Error {
}
const $6a9163af48013335$export$3d35432ad69f8123 = (relayEnvironment, appId, contextIds)=>{
    const appAri = (0, $7MEO5.createAppAri)({
        appId: appId
    }).toString();
    return new Promise((resolve, reject)=>{
        (0, $irOoi.fetchQuery)(relayEnvironment, (0, $af5efc942a2c5e73$export$2e2bcd8739ae039), {
            appAri: appAri,
            contextIds: contextIds
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                resolve(data.app);
            },
            error: (error)=>{
                reject(new $6a9163af48013335$export$8814b2f3dd4388d5(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${JSON.stringify(error)}`));
            }
        });
    });
};


const $b7ca193c69923706$var$RATE_LIMIT_MS = 5000;
const $b7ca193c69923706$var$permissionModalResource = (0, $a1d322db571e2009$export$c0f9ef43567dcb8a)('permissionModal', ()=>({
        isRateLimited: false,
        isModalOpen: false
    }), ()=>{}); // ─── Context type ─────────────────────────────────────────────────────────────
const $b7ca193c69923706$var$fetchAppData = async (relayEnvironment, appId, contextIds)=>{
    try {
        return await (0, $6a9163af48013335$export$3d35432ad69f8123)(relayEnvironment, appId, contextIds);
    } catch (e) {
        if (e instanceof Error) {
            const error = new (0, $kxKUs.BridgeClientError)(e.message);
            error.stack = e.stack;
            throw error;
        }
        throw new (0, $kxKUs.BridgeClientError)(typeof e === 'string' ? e : String(e));
    }
};
const $b7ca193c69923706$var$trackPermission = (analytics, appId, installationId, action)=>{
    analytics.tracker.trackPermissionAction({
        appId: appId,
        installationId: installationId,
        action: action
    });
};
const $b7ca193c69923706$var$canOpenModal = (state)=>!state.isModalOpen && !state.isRateLimited;
const $b7ca193c69923706$var$noteModalOpened = (state)=>{
    state.isModalOpen = true;
    state.isRateLimited = true;
    setTimeout(()=>{
        state.isRateLimited = false;
    }, $b7ca193c69923706$var$RATE_LIMIT_MS);
};
const $b7ca193c69923706$var$noteModalClosed = (state)=>{
    state.isModalOpen = false;
}; // ─── egressGet ────────────────────────────────────────────────────────────────
const $b7ca193c69923706$export$7d243a3c2dda5c06 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressGet');
    try {
        const resp = await permissionFetchClient.egressGet(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not get egress due to: ${err}`);
    }
};
const $b7ca193c69923706$export$ecdd54002a55cf8b = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressSet');
    const app = await $b7ca193c69923706$var$fetchAppData(relayEnvironment, appId, contextIds);
    const dryRunResp = await permissionFetchClient.egressSet(payload, true);
    if (!dryRunResp.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
     // Determine whether there are any new domains not yet in the allowlist.
    const getAllCurrentEgress = async ()=>{
        const r = await permissionFetchClient.egressGet({});
        return r.json();
    };
    try {
        const currentEgress = await getAllCurrentEgress();
        const currentDomainMap = (currentEgress?.results ?? []).reduce((acc, result)=>{
            result.configured.forEach((d)=>{
                acc[d.domain] = true;
            });
            return acc;
        }, {});
        const allDomains = payload.egresses.flatMap((group)=>group.configured.map((c)=>c.domain));
        const hasNewDomains = allDomains.some((d)=>!currentDomainMap[d]);
        if (!hasNewDomains) {
            // All domains already approved — apply without prompting.
            const setResp = await permissionFetchClient.egressSet(payload, false);
            const json = await setResp.json();
            if (!setResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
            return json;
        } // New domains: show the admin consent modal.
        const modalState = claimBridgeResource($b7ca193c69923706$var$permissionModalResource);
        if (!$b7ca193c69923706$var$canOpenModal(modalState)) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
        return new Promise((resolve, reject)=>{
            $b7ca193c69923706$var$noteModalOpened(modalState);
            overlayController.show(/*#__PURE__*/ $42omo.createElement((0, $1a72623c304bea83$export$a7839a1d0a383d1f), {
                appName: app.name,
                domainInfo: {
                    type: 'EGRESS',
                    payload: payload
                },
                termsOfUseLink: app.termsOfService ?? null,
                privacyPolicyLink: app.privacyPolicy ?? null,
                onCancel: ()=>{
                    $b7ca193c69923706$var$noteModalClosed(modalState);
                    reject(new (0, $kxKUs.BridgeClientError)('Setting egress was rejected by admin'));
                },
                onConfirm: async ()=>{
                    const setResp = await permissionFetchClient.egressSet(payload, false);
                    const json = await setResp.json();
                    if (!setResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                    $b7ca193c69923706$var$noteModalClosed(modalState);
                    resolve(json);
                }
            }), false);
        });
    } catch (err) {
        if (err instanceof (0, $kxKUs.BridgeClientError)) throw err;
        throw new (0, $kxKUs.BridgeClientError)(`Could not set egress due to ${err}`);
    }
};
const $b7ca193c69923706$export$370bd1f6454115f4 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressDeleteDomain');
    try {
        const resp = await permissionFetchClient.egressDeleteDomain(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress domain due to ${err}`);
    }
}; // ─── egressDeleteGroup ────────────────────────────────────────────────────────
const $b7ca193c69923706$export$f9aaf7f6a0038759 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'egressDeleteGroup');
    try {
        const resp = await permissionFetchClient.egressDeleteGroup(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress group due to ${err}`);
    }
}; // ─── remoteGet ────────────────────────────────────────────────────────────────
const $b7ca193c69923706$export$3eb5f19ac16138d9 = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics }, extensionDetails: { appId: appId }, extension: { installationId: installationId } }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'remoteGet');
    try {
        const resp = await permissionFetchClient.remoteGet(payload);
        const json = await resp.json();
        if (!resp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
        return json;
    } catch (err) {
        throw new (0, $kxKUs.BridgeClientError)(`Could not get remote due to: ${err}`);
    }
}; // ─── remoteSet ────────────────────────────────────────────────────────────────
const $b7ca193c69923706$export$9cf051d35cd846be = async ({ services: { permissionFetchClient: permissionFetchClient, analytics: analytics, overlayController: overlayController, relayEnvironment: relayEnvironment }, extensionDetails: { appId: appId }, extension: { installationId: installationId }, contextIds: contextIds, claimBridgeResource: claimBridgeResource }, payload)=>{
    if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
    $b7ca193c69923706$var$trackPermission(analytics, appId, installationId, 'remoteSet');
    const app = await $b7ca193c69923706$var$fetchAppData(relayEnvironment, appId, contextIds);
    const dryRunResp = await permissionFetchClient.remoteSet(payload, true);
    if (!dryRunResp.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
    const modalState = claimBridgeResource($b7ca193c69923706$var$permissionModalResource);
    if (!$b7ca193c69923706$var$canOpenModal(modalState)) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
     // Build the manifest remote map from the app's extension nodes so the modal
    // can show descriptive names and supported patterns for each remote key.
    const node = (app.installationsByContexts?.edges ?? [])[0]?.node;
    const payloadKeys = new Set(payload.remotes.map((r)=>r.key));
    const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e)=>e && e.extensionData.type === 'core:remote' && payloadKeys.has(e.extensionData.key)).reduce((acc, e)=>{
        if (e?.extensionData) acc[e.extensionData.key] = e.extensionData.configurable;
        return acc;
    }, {});
    return new Promise((resolve, reject)=>{
        $b7ca193c69923706$var$noteModalOpened(modalState);
        overlayController.show(/*#__PURE__*/ $42omo.createElement((0, $1a72623c304bea83$export$a7839a1d0a383d1f), {
            appName: app.name,
            domainInfo: {
                type: 'REMOTE',
                payload: payload,
                manifestRemoteMap: manifestRemoteMap
            },
            termsOfUseLink: app.termsOfService ?? null,
            privacyPolicyLink: app.privacyPolicy ?? null,
            onCancel: ()=>{
                $b7ca193c69923706$var$noteModalClosed(modalState);
                reject(new (0, $kxKUs.BridgeClientError)('Setting remote was rejected by admin'));
            },
            onConfirm: async ()=>{
                const setResp = await permissionFetchClient.remoteSet(payload, false);
                if (!setResp.ok) throw new (0, $kxKUs.BridgeClientError)(setResp.statusText);
                $b7ca193c69923706$var$noteModalClosed(modalState);
                resolve(undefined);
            }
        }), false);
    });
};
const $b7ca193c69923706$export$2e94858f69910d94 = {
    __permission__egressGet: $b7ca193c69923706$export$7d243a3c2dda5c06,
    __permission__egressSet: $b7ca193c69923706$export$ecdd54002a55cf8b,
    __permission__egressDeleteDomain: $b7ca193c69923706$export$370bd1f6454115f4,
    __permission__egressDeleteGroup: $b7ca193c69923706$export$f9aaf7f6a0038759,
    __permission__remoteGet: $b7ca193c69923706$export$3eb5f19ac16138d9,
    __permission__remoteSet: $b7ca193c69923706$export$9cf051d35cd846be
};


const $328c065070943708$export$d0f4e0785e15fc49 = {
    ...(0, $55bae7f37a7a68d8$export$966b3425a26d5e9f),
    getContext: // Core methods
    $a1b262b25c77d73e$export$31553aaa555c1514,
    invoke: $a1b262b25c77d73e$export$468cda29b159ee5d,
    getFrameId: $a1b262b25c77d73e$export$34bfdcdeb272e2c2,
    reload: $a1b262b25c77d73e$export$32da5b5043dcd88c,
    fetchProduct: // Fetch methods
    $4c7afe794077cd89$export$28eb87eac4188ed6,
    fetchRemote: $b1098c5558ff5ddd$export$db36d2f1649120da,
    enableTheming: // Theming methods
    $31a41e3290348206$export$cee03385e28d6243,
    on: // Event methods
    $dd0f09981f0dd0e2$export$af631764ddc44097,
    emit: $dd0f09981f0dd0e2$export$8f35fbd5db0f3634,
    onPublic: // Public event methods
    $26de492c7928fc91$export$2b8594f1cc80daad,
    emitPublic: $26de492c7928fc91$export$343310a09924dfa5,
    subscribeRealtimeChannel: // Realtime methods
    $80d3ad4501d9050f$export$361c332a01480dda,
    publishRealtimeChannel: $80d3ad4501d9050f$export$50666a6a6eccdc2e,
    getUrl: // Navigation methods
    $ad08296303e30ee4$export$94df0e59ebebf4a7,
    navigate: $ad08296303e30ee4$export$ff7962acd6052c28,
    createHistory: // History methods
    $1b2dcd1ebae61034$export$4178d7ac16e6cf7c,
    initFeatureFlags: // Feature flag methods
    $9815f75a5eca48fa$export$f9d0db67c92b2ab2,
    trackFeatureFlagEvent: $9815f75a5eca48fa$export$40367c2ce2684f9b,
    // Telemetry methods
    'iframe-analytics': (0, $5a50fa18555d29bc$export$2052623e8b7dc210),
    trackObjectStoreAction: $5a50fa18555d29bc$export$d39f84faa1bc5db6,
    'ufo-event': (0, $5a50fa18555d29bc$export$ffaff761e5d8cf6c),
    isRovoEnabled: // Rovo methods
    $e926d56b38388590$export$243c13f4da40a98e,
    openRovo: $e926d56b38388590$export$9be383b35c20e3cc,
    // Permission methods
    ...(0, $b7ca193c69923706$export$2e94858f69910d94)
};



var $7KMPr = parcelRequire("7KMPr");





var $dWSaf = parcelRequire("dWSaf");


var $fSMLG = parcelRequire("fSMLG");


var $ly9ul = parcelRequire("ly9ul");

const $fd3c13cdbd639d0c$export$14e56d7f5d3f917c = (method, methodName)=>async (context, payload)=>{
        const { services: { analytics: analytics, tracing: tracing }, extension: extension, environment: environment, page: page } = context;
        const forgeEnvironment = extension.environmentType;
        try {
            tracing.recordBridgeCall(`${methodName}() - start`);
            // invoke the original implementation
            const result = await method(context, payload);
            tracing.recordBridgeCall(`${methodName}() - end`);
            analytics.tracker.trackBridgeSucceed({
                method: methodName,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: (0, $dWSaf.prepareBridgeEventAttributes)(methodName, {
                    data: payload
                }, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $kxKUs.BridgeClientError))) {
                if (!(0, $fSMLG.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    analytics.tracker.trackBridgeFailed({
                        method: methodName,
                        errorName: error.name,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...(0, $dWSaf.prepareBridgeEventAttributes)(methodName, {
                                data: payload
                            }, false),
                            reason: error.message,
                            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
                        }
                    });
                    (0, $7KMPr.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: {
                            id: extension.id,
                            type: extension.type,
                            environmentType: extension.environmentType,
                            properties: extension.properties,
                            appOwnerAccountId: extension.appOwner?.accountId
                        },
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };


/**
 * Middlewares applied to every bridge method across all runtimes.
 * Order is outermost-first: the first entry wraps all subsequent ones.
 */ const $083504e283bb0724$var$DEFAULT_MIDDLEWARES = [
    (0, $fd3c13cdbd639d0c$export$14e56d7f5d3f917c)
];
const $083504e283bb0724$var$applyMiddleware = (method, methodName, middlewares)=>middlewares.reduce((m, mw)=>mw(m, methodName), method);
const $083504e283bb0724$export$35cddec71f2b332c = (getBridgeContext, extraMiddlewares = [])=>{
    const middlewares = [
        ...$083504e283bb0724$var$DEFAULT_MIDDLEWARES,
        ...extraMiddlewares
    ];
    return Object.entries((0, $328c065070943708$export$d0f4e0785e15fc49)).reduce((features, [methodName, method])=>{
        const wrapped = $083504e283bb0724$var$applyMiddleware(method, methodName, middlewares);
        features[methodName] = $083504e283bb0724$var$convertToBridgeInvokeHandler((payload)=>{
            // Call getBridgeContext() at invocation time, not creation time, so each
            // bridge call always uses the latest context rather than a stale snapshot.
            return wrapped(getBridgeContext(), payload);
        });
        return features;
    }, {});
};
const $083504e283bb0724$var$convertToBridgeInvokeHandler = (method)=>{
    return async ({ data: data })=>{
        if (method) return await method(data) ?? true;
        return false;
    };
};





const $d57816887e77fd9b$var$styles = {
    box: "_kqswh2mm",
    loadingOverlay: "_1bsb1osq _4t3i1osq"
}; // TODO: no styles defined for resizable modals yet.
// Only Jira enables resizing on modals at the moment.
const $d57816887e77fd9b$var$modalIframeStyles = null;
const $d57816887e77fd9b$var$iframeStyles = null; // We intentionally don't use `display: none` to hide the iframe, as some browsers (e.g. Safari) can suspend
// script execution in iframes that are not rendered, which would break the app initialization and bridge connection.
// Instead, we use `visibility: hidden` to keep the iframe active but invisible.
const $d57816887e77fd9b$var$hiddenIframeStyles = null;
const $d57816887e77fd9b$var$nonResizableIframeStyles = null;
const $d57816887e77fd9b$var$MACRO_MODULE_NAME = 'xen:macro'; // All permissions granted unconditionally — this is a fresh implementation with no legacy rollout gates.
const $d57816887e77fd9b$var$FRAME_PERMISSIONS_POLICY = 'camera; clipboard-write; display-capture; fullscreen; microphone; local-network-access'; // Base sandbox rules always applied to every hosted-resource iframe.
const $d57816887e77fd9b$var$BASE_SANDBOX_RULES = [
    'allow-downloads',
    'allow-forms',
    'allow-modals',
    'allow-pointer-lock',
    'allow-same-origin',
    'allow-scripts'
]; /**
                                                                                                                                                       * Returns the sandbox attribute string for the iframe.
                                                                                                                                                       * Apps with a wildcard egress rule are granted popup permissions so they can
                                                                                                                                                       * open third-party URLs in new tabs/windows.
                                                                                                                                                       */ 
const $d57816887e77fd9b$var$getSandboxAttribute = (egress)=>{
    const rules = [
        ...$d57816887e77fd9b$var$BASE_SANDBOX_RULES
    ];
    try {
        if ((0, $lMJg3.egressPermissionService)('FETCH_CLIENT_SIDE', egress).containsWildCardEgress()) rules.push('allow-popups', 'allow-popups-to-escape-sandbox');
         // eslint-disable-next-line no-unused-vars
    } catch (_) {}
    return rules.join(' ');
};
const $d57816887e77fd9b$export$3c4d31cb85fd39c5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, apolloClient: apolloClient, appId: appId, bridge: bridge, components: components, contextIds: contextIds, coreData: coreData, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, height: height = '100%', isHidden: isHidden, isInModal: isInModal, isResizable: isResizable, loadingComponent: loadingComponent, locale: locale, onLoad: onLoad, src: src, setIsLoading: setIsLoading, setIsThreeLOPromptVisible: setIsThreeLOPromptVisible, setShouldShowRenderer: setShouldShowRenderer, surfaceColor: surfaceColor, theme: theme, timezone: timezone, width: width = '100%' }, parentIframeRef)=>{
    const { overlay: overlay, overlayController: overlayController, isInlineActive: isInlineActive } = (0, $b44b52f09e1be159$export$38896ac4f3cfe88b)();
    const { userConsentRequired: userConsentRequired, renderThreeLOPrompt: renderThreeLOPrompt } = (0, $9d587b1ca74180de$export$3be8e8bcb6b54c3e)({
        extension: extension,
        appId: appId,
        accountId: accountId,
        components: components,
        onLoad: onLoad,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        overlayController: overlayController
    });
    const { getBridgeFeatures: getBridgeFeatures, destroy: cleanupBridge, setBridgeControl: setBridgeControl } = $d57816887e77fd9b$var$useBridgeFeatures({
        accountId: accountId,
        apolloClient: apolloClient,
        appId: appId,
        bridge: bridge,
        contextIds: contextIds,
        coreData: coreData,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        locale: locale,
        surfaceColor: surfaceColor,
        theme: theme,
        timezone: timezone
    }, overlayController, renderThreeLOPrompt);
    const localIframeRef = (0, $42omo.useRef)(null);
    const iframeRef = (0, $iP9n7.useMergeRefs)([
        parentIframeRef,
        localIframeRef
    ]);
    const iframeTitle = $d57816887e77fd9b$var$useIframeTitle(extension.properties.frameId, appId);
    const [isIframeLoaded, setIsIframeLoaded] = (0, $42omo.useState)(false);
    const { handleIframeLoad: openBridgeOnLoad, isBridgeReady: isBridgeReady } = $d57816887e77fd9b$var$useIframeBridgeConnection({
        iframeRef: localIframeRef,
        src: src,
        theme: theme,
        surfaceColor: surfaceColor,
        getBridgeFeatures: getBridgeFeatures,
        cleanupBridge: cleanupBridge,
        onLoad: onLoad,
        setBridgeControl: setBridgeControl
    }); // Wrap the bridge load handler to also mark the iframe as loaded for iframeResizer.
    // iframeResizer must start as soon as the iframe document is ready, before the
    // handshake completes — matching v1's synchronous setup order.
    const handleIframeLoad = (0, $hQK66.useCallbackOne)(()=>{
        setIsIframeLoaded(true);
        openBridgeOnLoad();
    }, [
        openBridgeOnLoad
    ]);
    const loading = !isBridgeReady;
    $d57816887e77fd9b$var$useIframeResizer({
        iframeRef: localIframeRef,
        isIframeLoaded: isIframeLoaded,
        isResizable: isResizable,
        height: height,
        layout: extension.properties.layout,
        type: extension.type
    });
    (0, $42omo.useEffect)(()=>{
        setIsLoading?.(loading);
    }, [
        loading,
        setIsLoading
    ]);
    const sandbox = $d57816887e77fd9b$var$getSandboxAttribute(extension.egress);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d57816887e77fd9b$var$styles.box,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isResizable || isInlineActive ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d57816887e77fd9b$var$IframeLoadingOverlay, {
        loading: loading,
        isInlineActive: isInlineActive,
        isHidden: isHidden,
        loadingComponent: loadingComponent
    }), overlay, !userConsentRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        "data-testid": "hosted-resources-iframe",
        "data-forge-iframe": true,
        sandbox: sandbox,
        allow: $d57816887e77fd9b$var$FRAME_PERMISSIONS_POLICY,
        src: src,
        ref: iframeRef,
        onLoad: handleIframeLoad,
        title: iframeTitle,
        className: (0, $gMc0m.default)([
            "_19itglyw _1e0c1ule _1bsb1osq",
            (loading || isInlineActive || isHidden) && "_3um015vq",
            isInModal && "_2rkofajl _4t3i1osq",
            !isResizable && "_4t3i1osq"
        ])
    }));
});
const $d57816887e77fd9b$var$IframeLoadingOverlay = ({ loading: loading, isInlineActive: isInlineActive, isHidden: isHidden, loadingComponent: loadingComponent })=>{
    if (!loading || isInlineActive || isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d57816887e77fd9b$var$styles.loadingOverlay
    }, (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent));
};
const $d57816887e77fd9b$var$useIframeTitle = (frameId, appId)=>{
    const idRef = (0, $42omo.useRef)(null);
    if (idRef.current === null) idRef.current = crypto.randomUUID();
    return `Iframe ${frameId ?? idRef.current} from ${appId}`;
};
const $d57816887e77fd9b$var$useIframeBridgeConnection = ({ iframeRef: iframeRef, src: src, theme: theme, surfaceColor: surfaceColor, getBridgeFeatures: getBridgeFeatures, cleanupBridge: cleanupBridge, onLoad: onLoad, setBridgeControl: setBridgeControl })=>{
    const [isBridgeReady, setIsBridgeReady] = (0, $42omo.useState)(false); // Guards against storing controls when the component has already been destroyed.
    const isDestroyedRef = (0, $42omo.useRef)(false); // Stable handler — src, getBridgeFeatures, and setBridgeControl are all stable references,
    // so this callback is recreated only if theme, surfaceColor, or onLoad change (rare near mount).
    const handleIframeLoad = (0, $hQK66.useCallbackOne)(()=>{
        const contentWindow = iframeRef.current?.contentWindow;
        if (!contentWindow) return;
        (0, $36a3b759c0c89f29$exports.createIframeBridge)({
            withWindow: contentWindow,
            withDomain: new URL(src).origin,
            features: getBridgeFeatures(),
            theme: theme,
            surfaceColor: surfaceColor,
            sendHandshakeMetric: ()=>{}
        }).open().then((controls)=>{
            if (isDestroyedRef.current) // Component was destroyed while open() was in-flight — close immediately.
            controls.close();
            else {
                setBridgeControl(controls);
                setIsBridgeReady(true);
                onLoad?.();
            }
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Failed to open iframe bridge', err);
        });
    }, [
        src,
        theme,
        surfaceColor,
        getBridgeFeatures,
        onLoad,
        setBridgeControl
    ]); // Tear down bridge and bridge context on unmount.
    // destroy() (called inside cleanupBridge) closes liveControls — no explicit call needed.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            isDestroyedRef.current = true;
            cleanupBridge();
        };
    }, [
        cleanupBridge
    ]);
    return {
        handleIframeLoad: handleIframeLoad,
        isBridgeReady: isBridgeReady
    };
};
const $d57816887e77fd9b$var$useIframeResizer = ({ iframeRef: iframeRef, isIframeLoaded: isIframeLoaded, isResizable: isResizable, height: height, layout: layout, type: type })=>{
    (0, $42omo.useEffect)(()=>{
        if (!isResizable || !isIframeLoaded) return;
        const iframeEl = iframeRef.current;
        if (!iframeEl) return;
        (0, $9zb43.iframeResizer)({
            heightCalculationMethod: 'bodyScroll',
            widthCalculationMethod: 'bodyScroll',
            scrolling: true,
            // @ts-expect-error minHeight accepts a CSS string at runtime but the TS type only allows number
            minHeight: height,
            // sizeWidth is enabled for resizing only for inline macros
            sizeWidth: layout === 'inline' && type === $d57816887e77fd9b$var$MACRO_MODULE_NAME,
            initCallback: (iframe)=>{
                iframe?.iFrameResizer?.resize();
            }
        }, iframeEl);
        return ()=>{
            iframeEl?.iFrameResizer?.removeListeners();
        };
    }, [
        isIframeLoaded,
        isResizable,
        height,
        layout,
        type,
        iframeRef
    ]);
};
const $d57816887e77fd9b$var$useBridgeFeatures = (props, overlayController, renderThreeLOPrompt)=>{
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { page: page } = (0, $5U2YR.useMetricsContext)(); // Assembles host-side capabilities (invoker, fetch client, tracing, etc.) for bridge methods.
    // Returns a getter rather than a snapshot so services are always current at call time.
    const { getServices: getServices } = (0, $b22670f2947f2693$export$74964fd55d087734)(props, overlayController, renderThreeLOPrompt); // [Important] getBridgeContext is stable and does not change across the lifecycle of the component,
    // so it is safe to include it in the dependency array of createBridgeFeatures without causing
    // unnecessary re-renders or re-creations of the bridge features.
    const { getBridgeContext: getBridgeContext, destroy: destroy, onChange: onChange, setBridgeControl: setBridgeControl } = (0, $650e4e464f468af1$export$e28a9b61f2b3f391)({
        ...props,
        environment: environment,
        page: page
    }, getServices); // Registered once — `onChange` is stable and `destroy()` clears the listener on unmount.
    (0, $42omo.useEffect)(()=>{
        return onChange((prev, next, getContext)=>{
            // Push theme/surfaceColor changes to the open bridge connection whenever they change.
            // Custom UI only — we only do this for iframe based runtime, as this is only
            // relevant for Custom UI app, as the Custom UI app will need to update the theme style assets.
            const themeChanged = prev.theme !== next.theme || prev.surfaceColor !== next.surfaceColor;
            if (themeChanged) getContext().bridgeControls?.setTheme(next.theme ?? null, next.surfaceColor ?? null, next.environment);
        });
    }, [
        onChange
    ]);
    return {
        destroy: destroy,
        getBridgeFeatures: ()=>(0, $083504e283bb0724$export$35cddec71f2b332c)(getBridgeContext),
        setBridgeControl: setBridgeControl
    };
};


const $f2c0519b4a165d40$var$styles = {
    hostedResourcesIframeContainer: "_kqswh2mm",
    box: "_1bsb1osq _4t3i1osq"
};
const $f2c0519b4a165d40$var$ReloadOnContextChangeWrapper = ({ context: context, children: children, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion })=>{
    if (getCurrentForgeReactMajorVersion) return /*#__PURE__*/ $42omo.createElement((0, $81f81791d185e0cc$export$5585193a0b9bb43d), {
        context: context,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion
    }, children);
    return /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), {
        key: (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(context)
    }, children);
};
const $f2c0519b4a165d40$export$5137ec99f248330b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ accountId: accountId, extension: extension, contextIds: contextIds, apolloClient: apolloClient, components: components, coreData: coreData, extensionData: extensionData, extensionViewData: extensionViewData, loadingComponent: loadingComponent, onLoad: onLoad, height: height = '100%', width: width = '100%', bridge: bridge, customBridgeMethods: customBridgeMethods, isResizable: isResizable = true, entryPoint: entryPoint, extensionPayload: extensionPayload, getContextToken: getContextToken, timezone: timezone, locale: locale, isHidden: isHidden = false, isInModal: isInModal = false, setShouldShowRenderer: setShouldShowRenderer, setIsLoading: setIsLoading, getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion, onError: onError, isEmbeddedMacro: isEmbeddedMacro = false, embeddedParentLocalId: embeddedParentLocalId }, iframeRef)=>{
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext)); // ARKEN-856: useThemeObserver() is a bit noisy, it returns copies of the same theme which breaks useBridge() dependencies
    // We use useMemoizedStateObject() to properly memoize its output doing a deep-equality check
    const theme = (0, $fbfcc51dc5b115ca$export$cc725e2aa41de44a)((0, $cOrQJ.default)());
    const iframeWrapperRef = (0, $42omo.useRef)(null);
    const [surfaceColor, setSurfaceColor] = (0, $42omo.useState)(null);
    const { trackExtensionLoaded: trackExtensionLoaded } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        if (!iframeWrapperRef.current) return;
        const nextSurfaceColor = getComputedStyle(iframeWrapperRef.current).getPropertyValue((0, $a9dFP.CURRENT_SURFACE_CSS_VAR));
        setSurfaceColor(nextSurfaceColor);
    }, [
        theme
    ]);
    const { appId: appId, moduleKey: moduleKey } = (0, $ijfiP.parseExtensionId)(extension.id);
    const { environmentId: environmentId, environmentType: environmentType } = extension;
    const extensionEntryPoint = (0, $6hkBe.getExtensionEntryPoint)(extension, entryPoint);
    const urlSafeContext = (0, $5oEbs.urlSafeB64)((0, $cqiXo.getEncodedAppContext)(extension, extensionViewData));
    const defaultSrc = (0, $42omo.useMemo)(()=>(0, $5oEbs.createSrcFromExtension)(appId, extension, environment, extensionEntryPoint), [
        appId,
        extension,
        environment,
        extensionEntryPoint
    ]);
    const isSignedCookieLoading = (0, $6baEI.useCDNAuthSignedCookie)();
    (0, $42omo.useEffect)(()=>{
        const renderType = extension?.properties?.render === 'native' ? 'UIKit' : 'CustomUI';
        const extensionType = (0, $jc2GP.getExtensionType)(extension);
        trackExtensionLoaded({
            forgeEnvironment: extension?.environmentType,
            renderType: renderType,
            extensionType: extensionType
        }); // This should run for each new unique appId/moduleKey combination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        appId,
        moduleKey
    ]);
    const [isThreeLOPromptVisible, setIsThreeLOPromptVisible] = (0, $42omo.useState)(false);
    const coreDataInner = {
        ...coreData,
        environmentId: environmentId,
        environmentType: environmentType,
        moduleKey: moduleKey,
        siteUrl: window.location.origin
    };
    const resizingEnabled = isResizable && !extension.properties.viewportSize; // moves specific macro extension data (isEditing, macro) to extensionData instead of extensionPayload as this is required for Tempo (#hot-300905)
    // the first check enables the feature for Tempo specifically, the second check enables the feature for all extensions if needed
    const enabledForTempo = appId === '76206a70-b9d6-4328-9e20-db79196c548a' && (0, $dh538.fg)('forge-ui-move-macro-data-for-tempo');
    const shouldIncludeMacroDataInExtensionData = enabledForTempo || (0, $dh538.fg)('forge-ui-move-macro-data-to-extension-data');
    const loading = (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading;
    if ((0, $dh538.fg)('forge-ui-refactor-iframe')) return /*#__PURE__*/ $42omo.createElement((0, $8ec10056009983e2$export$ac05e5a66b1a4559), {
        environmentType: extension.environmentType,
        appId: appId,
        contextIds: contextIds,
        environmentId: environmentId
    }, ({ tunnels: tunnels, loading: loading })=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            ref: iframeWrapperRef,
            testId: "hosted-resources-iframe-container",
            xcss: $f2c0519b4a165d40$var$styles.hostedResourcesIframeContainer,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: isThreeLOPromptVisible || isHidden || isEmbeddedMacro ? undefined : height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
                width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width
            }
        }, (loading || (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading) && /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f2c0519b4a165d40$var$styles.box
        }, loading && !isHidden && (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent))), !(loading || (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading) && /*#__PURE__*/ $42omo.createElement((0, $kaOT1.TracingProvider), null, (0, $dh538.fg)('forge-ui-bridge-core-reset') ? /*#__PURE__*/ $42omo.createElement((0, $d57816887e77fd9b$export$3c4d31cb85fd39c5), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            apolloClient: apolloClient,
            components: components,
            coreData: coreDataInner,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $4jZsH.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedParentLocalId: embeddedParentLocalId
        }) : /*#__PURE__*/ $42omo.createElement($f2c0519b4a165d40$var$ReloadOnContextChangeWrapper, {
            getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
            context: (0, $UZU5S.getViewContext)({
                resolverContext: (0, $ge8sG.getResolverContext)(coreDataInner, extensionData),
                accountId: accountId,
                extension: extension,
                timezone: timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
                locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
                extensionViewData: extensionViewData,
                extensionPayload: {
                    config: extensionPayload?.config,
                    macro: shouldIncludeMacroDataInExtensionData ? extensionData?.macro : extensionPayload?.macro,
                    isEditing: shouldIncludeMacroDataInExtensionData ? extensionData?.isEditing : extensionPayload?.isEditing
                }
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $ab5a832ac7acfeff$export$3c4d31cb85fd39c5), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            apolloClient: apolloClient,
            components: components,
            coreData: coreDataInner,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $4jZsH.getSrcUrl)(tunnels, extensionEntryPoint, defaultSrc, urlSafeContext),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedParentLocalId: embeddedParentLocalId
        })))));
     // TODO: To remove once forge-ui-refactor-iframe is fully rolled out
    if (extension.environmentType === 'DEVELOPMENT') return /*#__PURE__*/ $42omo.createElement((0, $8ec10056009983e2$export$ac05e5a66b1a4559), {
        environmentType: "DEVELOPMENT",
        appId: (0, $ijfiP.parseExtensionId)(extension.id).appId,
        contextIds: contextIds,
        environmentId: extension.environmentId
    }, ({ tunnels: relayTunnels, loading: isTunnelsLoading })=>{
        const combinedLoading = isTunnelsLoading || (0, $6baEI.shouldUseCDNAuth)() && isSignedCookieLoading;
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            ref: iframeWrapperRef,
            testId: "hosted-resources-iframe-container",
            xcss: $f2c0519b4a165d40$var$styles.hostedResourcesIframeContainer,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: isThreeLOPromptVisible || isHidden || isEmbeddedMacro ? undefined : height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
                width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width
            }
        }, combinedLoading && /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f2c0519b4a165d40$var$styles.box
        }, combinedLoading && !isHidden && (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent))), !combinedLoading && /*#__PURE__*/ $42omo.createElement((0, $kaOT1.TracingProvider), null, /*#__PURE__*/ $42omo.createElement($f2c0519b4a165d40$var$ReloadOnContextChangeWrapper, {
            getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
            context: (0, $UZU5S.getViewContext)({
                resolverContext: (0, $ge8sG.getResolverContext)(coreDataInner, extensionData),
                accountId: accountId,
                extension: extension,
                timezone: timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
                locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
                extensionViewData: extensionViewData,
                extensionPayload: {
                    config: extensionPayload?.config,
                    macro: shouldIncludeMacroDataInExtensionData ? extensionData?.macro : extensionPayload?.macro,
                    isEditing: shouldIncludeMacroDataInExtensionData ? extensionData?.isEditing : extensionPayload?.isEditing
                }
            })
        }, /*#__PURE__*/ $42omo.createElement((0, $ab5a832ac7acfeff$export$3c4d31cb85fd39c5), {
            accountId: accountId,
            extension: extension,
            contextIds: contextIds,
            components: components,
            coreData: coreDataInner,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            loadingComponent: loadingComponent,
            onLoad: onLoad,
            height: height,
            width: width,
            src: (0, $4jZsH.getSrcUrl)(relayTunnels, extensionEntryPoint, defaultSrc, urlSafeContext),
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            isResizable: resizingEnabled,
            getContextToken: getContextToken,
            timezone: timezone,
            locale: locale,
            setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
            setShouldShowRenderer: setShouldShowRenderer,
            extensionPayload: extensionPayload,
            isHidden: isHidden,
            theme: theme,
            surfaceColor: surfaceColor,
            appId: appId,
            ref: iframeRef,
            isInModal: isInModal,
            setIsLoading: setIsLoading,
            onError: onError,
            isEmbeddedMacro: isEmbeddedMacro,
            embeddedParentLocalId: embeddedParentLocalId
        }))));
    });
     // TODO: To remove once forge-ui-refactor-iframe is fully rolled out
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        ref: iframeWrapperRef,
        testId: "hosted-resources-iframe-container",
        xcss: $f2c0519b4a165d40$var$styles.hostedResourcesIframeContainer,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: isThreeLOPromptVisible || isHidden || isEmbeddedMacro ? undefined : height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: resizingEnabled || isThreeLOPromptVisible || isHidden ? undefined : height,
            width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width
        }
    }, loading && /*#__PURE__*/ $42omo.createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f2c0519b4a165d40$var$styles.box
    }, loading && !isHidden && (0, $13104cd2bb06c6a7$export$aee5524fcec014ce)(loadingComponent))), !loading && /*#__PURE__*/ $42omo.createElement((0, $kaOT1.TracingProvider), null, /*#__PURE__*/ $42omo.createElement($f2c0519b4a165d40$var$ReloadOnContextChangeWrapper, {
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        context: (0, $UZU5S.getViewContext)({
            resolverContext: (0, $ge8sG.getResolverContext)(coreDataInner, extensionData),
            accountId: accountId,
            extension: extension,
            timezone: timezone ?? (0, $130ab70bfb5bcaa7$export$9b96caef38763092)(),
            locale: locale ?? (0, $LiNdD.getBrowserLocale)(),
            extensionViewData: extensionViewData,
            extensionPayload: {
                config: extensionPayload?.config,
                macro: shouldIncludeMacroDataInExtensionData ? extensionData?.macro : extensionPayload?.macro,
                isEditing: shouldIncludeMacroDataInExtensionData ? extensionData?.isEditing : extensionPayload?.isEditing
            }
        })
    }, /*#__PURE__*/ $42omo.createElement((0, $ab5a832ac7acfeff$export$3c4d31cb85fd39c5), {
        accountId: accountId,
        extension: extension,
        contextIds: contextIds,
        components: components,
        coreData: coreDataInner,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        loadingComponent: loadingComponent,
        onLoad: onLoad,
        height: height,
        width: width,
        src: (0, $4jZsH.getSrcUrl)([], extensionEntryPoint, defaultSrc, urlSafeContext),
        bridge: bridge,
        customBridgeMethods: customBridgeMethods,
        isResizable: resizingEnabled,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        setIsThreeLOPromptVisible: setIsThreeLOPromptVisible,
        setShouldShowRenderer: setShouldShowRenderer,
        extensionPayload: extensionPayload,
        isHidden: isHidden,
        theme: theme,
        surfaceColor: surfaceColor,
        appId: appId,
        ref: iframeRef,
        isInModal: isInModal,
        setIsLoading: setIsLoading,
        onError: onError,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }))));
});



var $gj7hi = parcelRequire("gj7hi");











var $hnPaP = parcelRequire("hnPaP");


var $7hpmn = parcelRequire("7hpmn");










var $1c598 = parcelRequire("1c598");

/* custom-ui-modal-utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $dc67d857f203b917$var$smallModalStyles = null;
const $dc67d857f203b917$var$mediumModalStyles = null;
const $dc67d857f203b917$var$largeModalStyles = null;
const $dc67d857f203b917$var$xlargeModalStyles = null;
const $dc67d857f203b917$var$maxModalStyles = null;
const $dc67d857f203b917$var$fullscreenModalStyles = null;
const $dc67d857f203b917$var$resizableModalStyles = null; // TODO: Fix below styles once we move to compiled/react
const $dc67d857f203b917$export$a6d6b74199964ee4 = ({ children: children, size: size, styles: styles, isResizable: isResizable })=>{
    switch(size){
        case 'small':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i1tmh _1tkenklw _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'medium':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3ivzbd _1tke1lk4 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'large':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i1rxh _1tke1yw0 _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'xlarge':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i10fc _1tkezwhf _bfhk1bhr",
                    isResizable && "_1reo1wug _18m91wug _4t3i1wug"
                ])
            }, children);
        case 'max':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_2rkofajl _4t3i1osq _bfhk1bhr"
                ])
            }, children);
        case 'fullscreen':
            return /*#__PURE__*/ $42omo.createElement("div", {
                style: styles,
                className: (0, $gMc0m.default)([
                    "_4t3i1osq _bfhk1bhr"
                ])
            }, children);
        default:
            return /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, children);
    }
};
const $dc67d857f203b917$export$ca177c112881662a = (modalSize)=>{
    if (modalSize === 'xlarge') return 'x-large';
    if (modalSize === 'max') return '100%';
    return modalSize;
};



var $amyZ5 = parcelRequire("amyZ5");





var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jdPfT = parcelRequire("jdPfT");











var $jed12 = parcelRequire("jed12");







/**
 * @generated SignedSource<<af9717330be093c8cb3654fcd5dd2a22>>
 * @relayHash ebca7fca92ead3748b535be27a7da2d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9b2fb272613065d86d17a8320d95aabce6cbe3c4fe87e476268744b2c438c43
const $8f3869bffe483adc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "user_forge_ui_userQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "user_forge_ui_userQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9b2fb272613065d86d17a8320d95aabce6cbe3c4fe87e476268744b2c438c43",
            "metadata": {},
            "name": "user_forge_ui_userQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f3869bffe483adc$var$node.hash = "d05625ee70ba3d55ce9b8d550af8d0eb";
var $8f3869bffe483adc$export$2e2bcd8739ae039 = $8f3869bffe483adc$var$node;















var $9UyM5 = parcelRequire("9UyM5");


var $kpdGL = parcelRequire("kpdGL");

var $esRft = parcelRequire("esRft");


var $c4sKh = parcelRequire("c4sKh");


var $lCRfz = parcelRequire("lCRfz");

const $556ea5977eff619b$var$containerStyle = null;
const $556ea5977eff619b$var$messages = (0, $aXWIB.defineMessages)({
    unknownUser: {
        id: "confluence.user.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});
const $556ea5977eff619b$var$Avatar = ({ name: name, picture: picture, hideDisplayName: hideDisplayName })=>{
    if (hideDisplayName) return /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        name: name,
        src: picture
    });
    return /*#__PURE__*/ $42omo.createElement("div" // Reduce Atlaskit padding to vertically-align with other components
    , {
        className: (0, $gMc0m.default)([
            "_1gzjidpf _1plv1j28 _1r3373ad"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $kpdGL.default), {
        avatar: /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
            name: name,
            src: picture
        }),
        primaryText: name
    }));
};
function $556ea5977eff619b$var$UserInline({ name: name }) {
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $c4sKh.default), {
        appearance: "primary"
    }, name || intl.formatMessage($556ea5977eff619b$var$messages.unknownUser));
}
const $556ea5977eff619b$var$User = ({ accountId: accountId, hideDisplayName: hideDisplayName })=>{
    const data = (0, $irOoi.useLazyLoadQuery)((0, $8f3869bffe483adc$export$2e2bcd8739ae039), {
        accountId: accountId
    });
    const { picture: picture, name: name } = data?.user ?? {
        picture: '',
        name: ''
    };
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (!picture && !name) return null;
    if (inline) return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$UserInline, {
        name: name
    });
    return /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$Avatar, {
        name: name,
        picture: picture,
        hideDisplayName: hideDisplayName
    });
};
const $556ea5977eff619b$export$4e4c41e4152a9f8a = ()=>{
    return function UserFnNext({ forgeDoc: { props: props } }) {
        const { accountId: accountId, hideDisplayName: hideDisplayName } = props;
        return /*#__PURE__*/ $42omo.createElement((0, $lCRfz.RelaySuspensefulBoundary), null, /*#__PURE__*/ $42omo.createElement($556ea5977eff619b$var$User, {
            accountId: accountId,
            hideDisplayName: hideDisplayName
        }));
    };
};

/**
 * UI Kit 1 UserGroup / AvatarStack — not removed as still in use in the following:
 *
 * makeUserGroup (also exported as makeAvatarStack):
 *   - jira/src/packages/forge/forge-ui-controllers/.../wired-components/index.tsx (via @atlassian/forge-ui/ui)
 *   - jira/src/packages/forge/forge-ui-renderers/.../renderer-next/test.tsx (via @atlassian/forge-ui/ui)
 */ 






var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $diswb = parcelRequire("diswb");


var $eSUdr = parcelRequire("eSUdr");




const $d67925c3490b4618$export$25f4d46d5dabadfc = (0, $eSUdr.default)`query forge_ui_userQuery($accountId:ID!){user(accountId:$accountId){name picture}}`;
const $d67925c3490b4618$export$ef7fb495aeba8901 = (0, $eSUdr.default)`query forge_ui_usersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){name accountId picture}}`;
const $d67925c3490b4618$export$90f4370c54dd43c9 = (accountIds, client)=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const { data: data } = (0, $diswb.useQuery)($d67925c3490b4618$export$ef7fb495aeba8901, {
        variables: {
            accountIds: nonEmptyAccountIds
        },
        client: client,
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
            }
        }
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $d67925c3490b4618$export$23bbbc4533528f03 = (accountId, client)=>{
    const { data: data } = (0, $diswb.useQuery)($d67925c3490b4618$export$25f4d46d5dabadfc, {
        variables: {
            accountId: accountId
        },
        skip: !accountId,
        client: client,
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
            }
        }
    });
    if (data && data.user) {
        const { picture: picture, name: name } = data.user;
        return {
            name: name,
            picture: picture
        };
    }
    return {
        name: '',
        picture: ''
    };
};






const $ac41127a79653400$var$AKAvatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("fenwm")));

const $ac41127a79653400$var$AKBadge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6OBBH")));
function $ac41127a79653400$export$a2cdaa6af5c46e54(users, accountIds, intl) {
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($ac41127a79653400$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
}
function $ac41127a79653400$export$7962e827ea8ac95f({ data: data }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$AKAvatarGroup, {
        appearance: "stack",
        data: data
    });
}
function $ac41127a79653400$var$More({ data: data }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$AKBadge, null, `+${data.length}`);
}
function $ac41127a79653400$export$82c3b28526691c79({ data: data }) {
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, shown.map(({ name: name }, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$AKBadge, {
            appearance: "primary"
        }, name), hasMore || i !== end - 1 ? ' ' : null);
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$var$More, {
        data: more
    }) : null);
}
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $ac41127a79653400$var$avatarStackWrapper = (0, $ecnYn.xcss)({
    zIndex: 0,
    position: 'relative'
});
function $ac41127a79653400$export$2e2bcd8739ae039({ accountIds: accountIds, client: client }) {
    const users = (0, $d67925c3490b4618$export$90f4370c54dd43c9)(accountIds, client);
    const intl = (0, $aXWIB.useIntl)();
    const data = $ac41127a79653400$export$a2cdaa6af5c46e54(users, accountIds, intl);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$82c3b28526691c79, {
        data: data
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ac41127a79653400$var$avatarStackWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$7962e827ea8ac95f, {
        data: data
    })));
}
function $ac41127a79653400$export$63abfa3ed5832db7({ children: children }) {
    const accountIds = children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props } = child;
        const { accountId: accountId } = props;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$2e2bcd8739ae039, {
        accountIds: accountIds,
        client: undefined
    });
}
function $ac41127a79653400$export$30420ba0b3cd13e0({ client: client }) {
    return function avatarStackNext({ forgeDoc: { children: children } }) {
        const accountIds = children.map((child)=>{
            if (child.type !== 'User' && child.type !== 'Avatar') return '';
            const { props: props } = child;
            const { accountId: accountId } = props;
            return accountId;
        }).filter((x)=>x);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac41127a79653400$export$2e2bcd8739ae039, {
            accountIds: accountIds,
            client: client
        });
    };
}
const $ac41127a79653400$var$messages = (0, $aXWIB.defineMessages)({
    unknownUserMessage: {
        id: "confluence.user.group.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});


var $durRy = parcelRequire("durRy");


var $dx0OV = parcelRequire("dx0OV");

/**
 * @generated SignedSource<<bf5858309d93b3ad93a5acc187221c0b>>
 * @relayHash 803200a52f130572caf872b4e016fb1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12
const $d186ff71452c9d53$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usergroup_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usergroup_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2792700d56c071d783bc368a3b8cec5a1a1b6af55acd17a1b662a73ae865bd12",
            "metadata": {},
            "name": "usergroup_forge_ui_usersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d186ff71452c9d53$var$node.hash = "d0105c23c646ed326ba46ee28241752a";
var $d186ff71452c9d53$export$2e2bcd8739ae039 = $d186ff71452c9d53$var$node;














var $2Pg7f = parcelRequire("2Pg7f");













const $2674e7e6928452b6$export$fec8fa59b6e2a0db = (users, accountIds, intl)=>{
    // order should match accountIds
    return accountIds.map((key)=>{
        const { name: name = intl.formatMessage($2674e7e6928452b6$var$messages.unknownUserMessage), picture: picture = '' } = users[key] || {};
        return {
            key: key,
            name: name,
            src: picture
        };
    });
};
const $2674e7e6928452b6$export$7962e827ea8ac95f = ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        appearance: "stack",
        data: data
    });
};
const $2674e7e6928452b6$export$d440bfe209149ca5 = ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, `+${data.length}`);
};
const $2674e7e6928452b6$export$82c3b28526691c79 = ({ data: data })=>{
    const end = Math.max(Math.min(8, data.length), 0); // 4 would be the same as AvatarStack
    const shown = data.slice(0, end);
    const more = data.slice(end);
    const hasMore = more.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, shown.map(({ name: name }, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
            appearance: "primary"
        }, name), hasMore || i !== end - 1 ? ' ' : null);
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$d440bfe209149ca5, {
        data: more
    }) : null);
};
// @ts-ignore setting z index to 0 so that the avatars do not overlap other components
const $2674e7e6928452b6$var$avatarStackWrapper = (0, $ecnYn.xcss)({
    zIndex: 0,
    position: 'relative'
});
const $2674e7e6928452b6$export$2475c2afa469f7f7 = ({ accountIds: accountIds })=>{
    const nonEmptyAccountIds = accountIds.filter((id)=>!(id === ''));
    const data = (0, $irOoi.useLazyLoadQuery)((0, $d186ff71452c9d53$export$2e2bcd8739ae039), {
        accountIds: nonEmptyAccountIds
    });
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    const intl = (0, $aXWIB.useIntl)();
    const avatarStackData = $2674e7e6928452b6$export$fec8fa59b6e2a0db(users, accountIds, intl);
    const { inline: inline } = (0, $9UyM5.useInlineContext)();
    if (inline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$82c3b28526691c79, {
        data: avatarStackData
    });
    return(// Each avatar in an avatar stack has a z index value applied.
    // Setting a container with a z index here to 0 so that the avatars do no overlap other components such as the Select menu
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2674e7e6928452b6$var$avatarStackWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$7962e827ea8ac95f, {
        data: avatarStackData
    })));
};
const $2674e7e6928452b6$export$6f1d3bf96df15c79 = (props)=>{
    const accountIds = props.forgeDoc.children.map((child)=>{
        if (child.type !== 'User' && child.type !== 'Avatar') return '';
        const { props: props } = child;
        const { accountId: accountId } = props;
        return accountId;
    }).filter((x)=>x);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2674e7e6928452b6$export$2475c2afa469f7f7, {
        accountIds: accountIds
    }));
};
const $2674e7e6928452b6$var$messages = (0, $aXWIB.defineMessages)({
    unknownUserMessage: {
        id: "confluence.user.group.unknown.user.message",
        defaultMessage: "Unknown User"
    }
});


const $388fc69d2d887761$var$uuidRe = new RegExp('^{([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})}$');
const $388fc69d2d887761$export$3a1a8bfb58a690be = (uuid)=>{
    const match = $388fc69d2d887761$var$uuidRe.exec(uuid);
    if (!match) return '';
    return match[1];
};


const $21632699a983d1c1$export$58982618823f55fc = ({ accountId: accountId, bridge: bridge, client: client, cloudId: cloudId, workspaceId: workspaceId, mentionProvider: mentionProvider, product: product, components: components })=>{
    const injectedComponentsWithKey = (0, $42omo.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $42omo.useMemo)(()=>({
            Avatar: (0, $556ea5977eff619b$export$4e4c41e4152a9f8a)(),
            AvatarStack: (0, $ac41127a79653400$export$30420ba0b3cd13e0)({
                client: client
            }),
            // Override previous AvatarStack with Relay version
            ...(0, $dh538.fg)('forge-ui-relay-user-group') && {
                AvatarStack: (0, $2674e7e6928452b6$export$6f1d3bf96df15c79)
            },
            UserPicker: (0, $durRy.makeNativeUserPicker)({
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $388fc69d2d887761$export$3a1a8bfb58a690be)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            AdfRenderer: (0, $dx0OV.makeADFRenderer)({
                bridge: bridge,
                client: client
            })
        }), [
        accountId,
        client,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $42omo.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...injectedComponentsWithKey
        }), [
        injectedComponentsWithKey,
        wiredComponents
    ]);
    return getComponents;
};


const $ed3dec07128042c6$export$95197f008126b1a1 = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, coreData: coreData, extension: extension, forgeDoc: forgeDoc, loadingComponent: loadingComponent, mentionProvider: mentionProvider, modalExtension: modalExtension, onAppError: onAppError, onError: onError, onSuccess: onSuccess, product: product } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const getComponents = (0, $21632699a983d1c1$export$58982618823f55fc)({
        accountId: accountId,
        bridge: bridge,
        client: client,
        cloudId: cloudId,
        workspaceId: workspaceId,
        mentionProvider: mentionProvider,
        product: product,
        components: components
    });
    const handleError = (0, $42omo.useCallback)((err)=>{
        onError?.(err.message);
        onAppError?.(err.message);
    }, [
        onError,
        onAppError
    ]);
    if (!forgeDoc) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        components: getComponents,
        modalExtension: modalExtension,
        extensionType: 'xen:macro',
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        client: client,
        onSuccess: onSuccess
    });
};


const $8537409554582c9d$var$getExtensionIcon = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $8537409554582c9d$var$styles = {
    modalDeprecationMessage: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $8537409554582c9d$export$17d9f1e4832027c9 = ({ accountId: accountId, bridge: bridge, client: client, contextIds: contextIds, coreData: coreData, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, iframeRef: iframeRef, isInModal: isInModal, loadingComponent: loadingComponent, locale: locale, localId: localId, modalStyles: modalStyles, modalProvider: modalProvider, onIframeLoad: onIframeLoad, onModalCustomUIRendererClose: onModalCustomUIRendererClose, product: product, timezone: timezone, getModalWidth: getModalWidth, setIsLoading: setIsLoading, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId })=>{
    const [error, setError] = (0, $42omo.useState)(null); // modalOptions is null when no modal is open is non null when opened
    // Uses InternalModalState to allow extension property from FAUS forwarding
    const [modalOptions, setModalOptions] = (0, $42omo.useState)(null);
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    const [embeddedUIKitModalContext, setEmbeddedUIKitModalContext] = (0, $42omo.useState)(null);
    const onCloseFromModalClass = modalOptions?.onClose;
    const embeddedMacroModalProps = modalOptions?.isEmbeddedMacroModal ? {
        extensionPayload: modalOptions?.extensionPayload,
        // Extension view data in macro module is only reserved for bodied macro content.
        // Since we don't support embedded bodied macros, extensionViewData will always be undefined.
        extensionViewData: undefined,
        coreData: {
            ...coreData,
            localId: modalOptions?.embeddedMacroLocalId || ''
        }
    } : {};
    const iframeProps = {
        accountId: accountId,
        apolloClient: client,
        contextIds: contextIds,
        components: getThreeLOPrompt,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        isHidden: isIframeHidden,
        isResizable: isIframeResizable,
        locale: locale,
        timezone: timezone,
        loadingComponent: loadingComponent,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId,
        ...(0, $dh538.fg)('platform_faus_navigate_to_product') ? {} : embeddedMacroModalProps
    };
    const modalIframeProps = {
        ...iframeProps,
        ...embeddedMacroModalProps
    };
    const platformAddBridgeMessageForwardingFromFaus = (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus');
    const isBodiedMacro = extension.properties?.layout === 'bodied';
    const extensionInModal = (0, $42omo.useMemo)(()=>{
        if (platformAddBridgeMessageForwardingFromFaus) {
            // Use the embedded macro's extension if provided (for modals opened from embedded macros)
            const baseExtension = modalOptions?.extension || extension;
            return {
                ...baseExtension,
                // Pass a type that is not included in the dimensions presets so that it falls back to default
                type: `${baseExtension.type}::dynamic-modal`,
                properties: {
                    ...baseExtension.properties,
                    resource: modalOptions?.resource ?? baseExtension.properties.resource
                }
            };
        }
        return {
            ...extension,
            // Pass a type that is not included in the dimensions presets so that it falls back to default
            type: `${extension.type}::dynamic-modal`,
            properties: {
                ...extension.properties,
                resource: modalOptions?.resource ?? extension.properties.resource
            }
        };
    }, [
        extension,
        modalOptions?.resource,
        modalOptions?.extension,
        platformAddBridgeMessageForwardingFromFaus
    ]);
    const onError = (error)=>{
        error && setError(error);
    };
    const extensionDataInModal = (0, $42omo.useMemo)(()=>{
        // Use the embedded macro's extensionData if provided (for modals opened from embedded macros)
        const baseExtensionData = modalOptions?.extensionData || extensionData;
        return {
            ...baseExtensionData,
            ...modalOptions?.context ? {
                modal: modalOptions?.context
            } : {},
            // This is to handle an incompatibility issue with Compass and JSM where they are incorrectly currently spreading the context object on the top level instead of in the `modal` object.
            // Remove once Compass apps have been updated https://softwareteams.atlassian.net/browse/COMPASS-22051 and a notice to app developers have been sent out
            ...(product === 'compass' || extension.type.startsWith('jiraServiceManagement')) && modalOptions?.context ? {
                ...modalOptions?.context
            } : {}
        };
    }, [
        extension.type,
        extensionData,
        modalOptions?.context,
        modalOptions?.extensionData,
        product
    ]);
    const handleModalTearDown = (0, $42omo.useCallback)(()=>{
        setModalOptions(null);
    }, [
        setModalOptions
    ]);
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        onCloseFromModalClass?.(); // if reduced motion is enabled, we need to call handleModalTearDown here as it no longer calls `onCloseComplete` in `ModalCustomUIRenderer`
        if (isReducedMotion) handleModalTearDown();
    }, [
        isReducedMotion,
        onCloseFromModalClass,
        handleModalTearDown
    ]); // Confluence specific feature
    // Needed to show Forge modals in live pages. dialogs won't be passed in if the page isn't live.
    (0, $42omo.useEffect)(()=>{
        if (product !== 'confluence') return;
        if (dialogs && modalOptions) dialogs.showDialog($8537409554582c9d$export$5d28a207fd7621f6, {
            extension: extensionInModal,
            extensionData: extensionDataInModal,
            localId: localId,
            onTearDown: handleModalTearDown,
            bridge: bridge,
            size: modalOptions.size,
            closeOnEscape: modalOptions.closeOnEscape,
            closeOnOverlayClick: modalOptions.closeOnOverlayClick
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        modalOptions,
        dialogs
    ]);
    if (error) {
        // Sandbox deprecation error
        if (error === (0, $eahkE.SANDBOX_DEPRECATION_ERROR)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eahkE.ForgeDeprecationMessage), {
            extension: extension,
            error: error
        });
         // Currently no other error types are handled
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isBodiedMacro && embeddedUIKitModalContext?.forgeDoc && embeddedUIKitModalContext?.extension && (0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed3dec07128042c6$export$95197f008126b1a1), {
        accountId: accountId,
        bridge: bridge,
        client: client,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        forgeDoc: embeddedUIKitModalContext.forgeDoc,
        extension: embeddedUIKitModalContext.extension,
        getThreeLOPrompt: getThreeLOPrompt,
        loadingComponent: loadingComponent,
        product: product,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2c0519b4a165d40$export$5137ec99f248330b), {
        ...iframeProps,
        entryPoint: entryPoint,
        isResizable: isIframeResizable,
        bridge: {
            ...bridge,
            openModal: (opts)=>{
                setModalOptions(opts.data);
                return true;
            },
            ...onModalCustomUIRendererClose ? {
                close: (payload)=>{
                    if ((0, $dh538.fg)('forge-ui-on-close-bridge-method')) onModalCustomUIRendererClose().then(()=>{
                        bridge?.close?.(payload);
                    }).finally(()=>{
                        return true;
                    });
                    else {
                        // This bridge.close reference is defined below in ModalCustomUIRenderer.
                        onModalCustomUIRendererClose();
                        bridge?.close?.(payload);
                        return true;
                    }
                }
            } : {}
        },
        customBridgeMethods: {
            ...customBridgeMethods,
            ...isBodiedMacro && (0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent') ? {
                setEmbeddedMacroModalForgeDoc: (payload)=>{
                    setEmbeddedUIKitModalContext(payload?.embeddedUIKitModalContext);
                }
            } : {}
        },
        height: height,
        width: width,
        isInModal: isInModal,
        ref: iframeRef,
        onLoad: onIframeLoad,
        setIsLoading: setIsLoading,
        onError: onError
    }), modalOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8537409554582c9d$export$5d28a207fd7621f6, {
        ...(0, $dh538.fg)('platform_faus_navigate_to_product') ? modalIframeProps : iframeProps,
        product: product,
        getThreeLOPrompt: getThreeLOPrompt,
        dialogs: dialogs,
        client: client,
        extension: extensionInModal,
        extensionData: extensionDataInModal,
        localId: modalOptions?.embeddedMacroLocalId || localId,
        onTearDown: handleModalTearDown,
        bridge: {
            ...bridge,
            onClose: (callback)=>{
                setViewOnClose(()=>callback.data); // stores the callback for when modal is closed
                return true;
            },
            close: (payload)=>{
                onCloseFromModalClass?.(payload.data);
                return true;
            }
        },
        modalOnClose: handleModalClose,
        size: modalOptions.size,
        title: modalOptions.title,
        icon: modalOptions.icon,
        closeOnEscape: modalOptions.closeOnEscape,
        closeOnOverlayClick: modalOptions.closeOnOverlayClick,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        getModalWidth: getModalWidth,
        isIframeResizable: isIframeResizable,
        viewOnClose: viewOnClose
    }) : null);
};
const $8537409554582c9d$export$5d28a207fd7621f6 = ({ accountId: accountId, bridge: bridge, coreData: coreData, client: client, closeOnEscape: closeOnEscape, closeOnOverlayClick: closeOnOverlayClick, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, getThreeLOPrompt: getThreeLOPrompt, isIframeHidden: isIframeHidden = false, isIframeResizable: isIframeResizable = false, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: ModalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onTearDown: onTearDown, product: product, size: size, title: title, icon: icon, timezone: timezone, getModalWidth: getModalWidth, modalOnClose: // onClose from `Modal`
modalOnClose, viewOnClose: // onClose from `view`
viewOnClose })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(true); // This is for preventing inline dialog apps from being closed by an esc key press when a
    // modal is open until https://product-fabric.atlassian.net/browse/DSP-3552 is resolved.
    (0, $42omo.useEffect)(()=>{
        if (product !== 'confluence' || modalExtension?.type === 'macroConfig' || product === 'confluence' && modalExtension?.type === 'bylineItem') return;
        function dismissEscape(e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                if (closeOnEscape) {
                    modalOnClose?.();
                    setIsOpen(false);
                }
            }
        }
        if (isOpen) document.addEventListener('keydown', dismissEscape, {
            capture: true
        });
        return ()=>document.removeEventListener('keydown', dismissEscape, {
                capture: true
            });
    }, [
        isOpen,
        closeOnEscape,
        product,
        modalOnClose,
        modalExtension?.type
    ]);
    const { trackExtensionLoaded: trackExtensionLoaded, trackBridgeSucceed: trackBridgeSucceed, trackBridgeFailed: trackBridgeFailed } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const extensionType = (0, $jc2GP.getExtensionType)(extension?.properties);
    const environmentType = extension?.environmentType; // Only tracking fullscreen modals
    (0, $42omo.useEffect)(()=>{
        if (modalExtension?.modalWidth === 'fullscreen' && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config')) trackExtensionLoaded({
            forgeEnvironment: environmentType,
            renderType: 'CustomUI',
            extensionType: extensionType,
            viewportSize: 'fullscreen'
        });
    }, [
        modalExtension?.modalWidth,
        environmentType,
        extensionType,
        trackExtensionLoaded
    ]);
    const modalWidthForMacroCustomConfig = extension.type === (0, $1c598.ConfluenceExtension).MACRO && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') ? modalExtension?.modalWidth : undefined;
    const modalSize = modalWidthForMacroCustomConfig ?? size ?? extension.properties.viewportSize ?? 'medium';
    const modalWidth = getModalWidth ? getModalWidth(size) : (0, $dc67d857f203b917$export$ca177c112881662a)(modalSize); // If size is defined, iframe modal should not be resizable.
    // In JSM ONLY, iframe modal should ALWAYS be resizable.
    // Iframe should scale to 100% of the modal so that Select drop downs are not cut off
    const isJsmModule = extension.type.startsWith('jiraServiceManagement');
    const isModalResizable = isJsmModule || (size !== undefined ? false : isIframeResizable);
    const shouldShowFCFModalDeprecationMessage = (extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD || extension.type === (0, $1c598.JiraExtension).CUSTOM_FIELD_TYPE) && !(0, $dh538.fg)('forge_disable_fcf_modal_experience_on_issue_view');
    const executeViewOnCloseCallback = async ()=>{
        if (viewOnClose && (0, $dh538.fg)('forge-ui-on-close-bridge-method')) try {
            await viewOnClose();
            trackBridgeSucceed({
                method: 'onClose',
                forgeEnvironment: extension.environmentType
            });
        } catch (error) {
            trackBridgeFailed({
                method: 'onClose',
                errorName: error instanceof Error ? error.name : 'UnknownError',
                forgeEnvironment: extension.environmentType
            });
        }
    };
    const renderModal = ()=>{
        const closeProps = {
            onClose: async ()=>{
                try {
                    await executeViewOnCloseCallback();
                } finally{
                    modalOnClose?.();
                    setIsOpen(false);
                }
            },
            onCloseComplete: onTearDown
        };
        const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldShowFCFModalDeprecationMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $8537409554582c9d$var$styles.modalDeprecationMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amyZ5.ForgeModalDeprecationMessage), {
            extension: extension
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc67d857f203b917$export$a6d6b74199964ee4), {
            size: modalSize,
            styles: modalStyles,
            isResizable: (0, $dh538.fg)('forge-ui-fix-modal-resizing-in-jsm') ? isModalResizable : isIframeResizable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8537409554582c9d$export$17d9f1e4832027c9, {
            product: product,
            coreData: coreData,
            getThreeLOPrompt: getThreeLOPrompt,
            dialogs: dialogs,
            accountId: accountId,
            client: client,
            contextIds: contextIds,
            extension: extension,
            extensionData: extensionData,
            extensionViewData: extensionViewData,
            bridge: bridge,
            customBridgeMethods: customBridgeMethods,
            consentMessage: consentMessage,
            entryPoint: entryPoint,
            getContextToken: getContextToken,
            height: "100%",
            isIframeHidden: isIframeHidden,
            isIframeResizable: isModalResizable,
            locale: locale,
            localId: localId,
            mentionProvider: mentionProvider,
            modalExtension: modalExtension,
            onConsentSuccess: onConsentSuccess,
            onForgeDocUpdated: onForgeDocUpdated,
            timezone: timezone,
            onConsentModalClose: onConsentModalClose,
            onError: onError,
            onIframeLoad: onIframeLoad,
            loadingComponent: loadingComponent,
            extensionPayload: extensionPayload,
            modalStyles: modalStyles,
            onModalCustomUIRendererClose: async ()=>{
                try {
                    await executeViewOnCloseCallback();
                } finally{
                    setIsOpen(false); // If is a modal extension point, call modalOnClose to reset state from product
                    // This is required to reset the state of the modal in the product when view.close is called
                    if (modalExtension) modalOnClose?.();
                }
            },
            isInModal: true
        }))); /**
         * Logic for fullscreen modals as follows:
         * - Only available for bylineItem and macro custom config extension points
         * - Available for Modal from @forge/bridge
         */ 
        // Determine if this is a modal extension point vs bridge modal (Modal class from @forge/bridge)
        // Bridge modal: modalExtension is undefined (opened via view.modal.open())
        const isBridgeModal = !modalExtension;
        const isMacroExtension = extension.type === (0, $1c598.ConfluenceExtension).MACRO;
        const isBylineExtension = extension.type === (0, $1c598.ConfluenceExtension).BYLINE; /**
                                                                              * Determines if the modal should render as fullscreen based on:
                                                                              * - Modal size being set to 'fullscreen'
                                                                              * - Appropriate feature flag for the extension type or bridge modal
                                                                              * - Not a production environment during EAP (except for byline, which has already rolled out without the blocker)
                                                                              */ 
        const supportsFullscreenModal = (()=>{
            if (modalSize !== 'fullscreen') return false;
             // Bridge modals (opened via view.modal.open() with size: 'fullscreen')
            if (isBridgeModal) return true;
             // Extension point modals
            // Byline fullscreen modals rolled out to production Forge apps already
            if (isBylineExtension) return (0, $dh538.fg)('platform_add_modal_support_to_bylineitem_extension');
            if (isMacroExtension) return (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config');
            return false;
        })();
        const renderModalHeader = ()=>{
            /* Title/icon source priority:
       * - Bridge modals:
       *     - Use title/icon props (passed in from bridge call)
       *     - Fallback to extension.properties.title for fullscreen modals with empty title
       *     - For non-fullscreen modals, we won't render the header if the title prop is not provided
       * - Modal extension points: Use modalExtension.title and extensionIcon, defaults to extension name if not provided
       */ const modalTitle = isBridgeModal ? modalSize === 'fullscreen' && !title ? extension.properties.title : title : modalExtension?.title || extension.properties.title; /**
                                                                                                                                                                           * Icon rendering logic:
                                                                                                                                                                           * - Bridge modals: show icon section only if icon prop is provided
                                                                                                                                                                           * - Macro extension points: always show icon section (uses extension icon or AddonIcon fallback)
                                                                                                                                                                           * - Other modals: no icon section
                                                                                                                                                                           */ 
            const shouldShowIcon = isBridgeModal ? !!icon : isMacroExtension;
            const modalIcon = isBridgeModal ? icon : $8537409554582c9d$var$getExtensionIcon(extension);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, shouldShowIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                space: "space.100",
                alignBlock: "center"
            }, modalIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                src: modalIcon,
                alt: "",
                width: "24px",
                height: "24px"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: "",
                color: "var(--ds-icon-accent-gray, #7D818A)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, modalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                label: "Close Modal",
                onClick: isBridgeModal ? closeProps.onClose : async ()=>{
                    try {
                        await executeViewOnCloseCallback();
                    } finally{
                        modalExtension?.closeModalExtension();
                    }
                }
            }));
        };
        if (supportsFullscreenModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
            ...closeProps,
            testId: "custom-ui-fullscreen-modal-dialog",
            shouldCloseOnEscapePress: closeOnEscape
        }, isMacroExtension || isBridgeModal ? renderModalHeader() : null, modalContent);
        else {
            // Fallback to 'max' if modalSize is 'fullscreen' but fullscreen is not supported
            const shouldFallbackFromFullscreen = modalSize === 'fullscreen' && !supportsFullscreenModal;
            const fallbackSize = shouldFallbackFromFullscreen ? 'max' : modalSize;
            const fallbackWidth = shouldFallbackFromFullscreen ? '100%' : modalWidth;
            if (shouldFallbackFromFullscreen) // eslint-disable-next-line no-console
            console.warn('Forge fullscreen modal is in EAP. Please sign up here https://ecosystem.atlassian.net/servicedesk/customer/portal/1040/group/3496/create/18983. The modal will be rendered with max width instead.');
            const { height: modalHeight } = (0, $3b6c709f803268e6$export$b3b34c460afe006f)(fallbackSize);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
                ...closeProps,
                width: fallbackWidth,
                height: fallbackSize === 'max' ? modalHeight : undefined,
                testId: "custom-ui-modal-dialog",
                shouldCloseOnOverlayClick: closeOnOverlayClick,
                shouldCloseOnEscapePress: closeOnEscape
            }, isBridgeModal && title ? renderModalHeader() : null, modalContent);
        }
    };
    if (ModalProvider) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ModalProvider, null, renderModal()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && renderModal());
};






var $9JpPs = parcelRequire("9JpPs");





















const $b3ac0804570f3b11$export$aab0d259c363afda = ({ children: children, viewportDimensions: viewportDimensions })=>{
    const isEnabled = (0, $dh538.fg)('forge-ui-app-perf-tracking-enabled');
    const { containerRef: containerRef } = (0, $4db8dff54302fa45$export$1b708c663f12db29)({
        isEnabled: isEnabled,
        viewportDimensions: viewportDimensions
    });
    if (isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        id: "forge-ui-height-observer-wrapper"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};






















/**
 * Module-level singleton for a shared, lazily-created sandboxed iframe.
 *
 * A single hidden <iframe> is appended to document.body on first access and
 * reused by every WorkerWebRuntime instance in the same page. The iframe is
 * intentionally managed imperatively (outside of React) so that the React
 * reconciler can never unmount or reorder it.
 *
 * Usage:
 *   const iframe = getOrCreateSandboxIframe();
 *   destroySandboxIframe();                    // teardown / test cleanup
 */ 
var $aVZM7 = parcelRequire("aVZM7");







const $be0caa192fddc075$export$610aba4956682285 = (environment)=>{
    return `https://forge.${(0, $aVZM7.getForgeCDNBaseDomain)(environment)}`;
};
const $be0caa192fddc075$export$b13327eb43ebc8bd = (environment)=>{
    return `${$be0caa192fddc075$export$610aba4956682285(environment)}/runtime/sandbox.html`;
};
const $be0caa192fddc075$export$93ff7914791b9d75 = (extension)=>{
    return (0, $5oEbs.urlSafeB64)((0, $cqiXo.getEncodedAppContext)(extension));
};


const $462ad2a2c2816f62$export$6646fca33a54bb24 = '__forge-worker-sandbox__';
let $462ad2a2c2816f62$var$iframe = null;
const $462ad2a2c2816f62$var$createSandboxIframe = (document1, environment)=>{
    const iframeEl = document1.createElement('iframe');
    iframeEl.id = $462ad2a2c2816f62$export$6646fca33a54bb24;
    // technically we could remove 'allow-same-origin' and this will ensure all
    // worker runtime code is completely isolated (not able to read cookies or localStorage)
    // but this could prevent potential future features that require same-origin access,
    // (e.g. service-worker, indexdb etc.), so we'll keep it in place for now and revisit if needed.
    //
    // in order to secure the worker runtime, we will be utilising the security shim
    // script suggested in: https://hello.atlassian.net/wiki/x/dDy-hAE
    iframeEl.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    iframeEl.src = (0, $be0caa192fddc075$export$b13327eb43ebc8bd)(environment);
    // Keep the iframe invisible but laid out so the browser doesn't defer script
    // execution inside it. `display:none` can suspend execution in some browsers.
    Object.assign(iframeEl.style, {
        position: 'absolute',
        width: '0',
        height: '0',
        border: 'none',
        top: '-9999px',
        left: '-9999px',
        visibility: 'hidden'
    });
    iframeEl.setAttribute('tabindex', '-1');
    iframeEl.setAttribute('aria-hidden', 'true');
    return iframeEl;
};
const $462ad2a2c2816f62$export$174dd467067cc3dc = (environment)=>{
    if (typeof document === 'undefined') // SSR guard — no DOM available
    return null;
    // Fast path: module-level cache (same module instance, same call).
    if ($462ad2a2c2816f62$var$iframe !== null) return $462ad2a2c2816f62$var$iframe;
    // Recovery path: find an existing iframe created by a different module
    // instance (Module Federation) or a previous module load (HMR).
    const existing = document.getElementById($462ad2a2c2816f62$export$6646fca33a54bb24);
    if (existing !== null) {
        $462ad2a2c2816f62$var$iframe = existing;
        return $462ad2a2c2816f62$var$iframe;
    }
    // First-ever creation: build the element and stamp it with the stable id.
    const iframeEl = $462ad2a2c2816f62$var$createSandboxIframe(document, environment);
    document.body.appendChild(iframeEl);
    $462ad2a2c2816f62$var$iframe = iframeEl;
    return $462ad2a2c2816f62$var$iframe;
};
const $462ad2a2c2816f62$export$dce981fb8c927a47 = ()=>{
    // Query the DOM directly rather than relying solely on the module variable.
    // A different module instance may have been the one to create the iframe,
    // so `iframeEl` could be null here even if the element exists in the DOM.
    const el = $462ad2a2c2816f62$var$iframe ?? (typeof document !== 'undefined' ? document.getElementById($462ad2a2c2816f62$export$6646fca33a54bb24) : null);
    if (el !== null) el.remove();
    $462ad2a2c2816f62$var$iframe = null;
};




/**
 * Well-known key used to attach the connection promise directly to the iframe
 * DOM element.
 *
 * Storing it on the element means Module Federation / HMR cannot cause a
 * second handshake: any module instance that receives the same DOM node will
 * find the already-initiated promise.
 */ const $36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY = '__forge-sandbox-connection-promise__';
const $36d60b6a72d0a950$export$dd439767100c493e = (iframe)=>{
    const el = iframe;
    el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY]?.then((conn)=>conn.destroy()).catch(()=>{});
    delete el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY];
};
/**
 * Returns (and lazily initiates) the single shared sandbox connection promise.
 * The promise is stored on the iframe element so it survives across module
 * instances — only the first caller triggers the handshake.
 */ const $36d60b6a72d0a950$var$getOrCreateConnectionPromise = (iframe, contentWindow, environment)=>{
    const el = iframe;
    const existing = el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY];
    if (existing) return existing;
    const promise = (0, $36a3b759c0c89f29$exports.setupSandboxController)(contentWindow, (0, $be0caa192fddc075$export$610aba4956682285)(environment));
    el[$36d60b6a72d0a950$var$SANDBOX_CONNECTION_KEY] = promise;
    return promise;
};
const $36d60b6a72d0a950$export$e888e640efbbe682 = (environment)=>{
    const [connection, setConnection] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const iframe = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
        if (iframe === null) // Non-browser environment (SSR) — nothing to do.
        return;
        let cancelled = false;
        const initConnection = ()=>{
            const { contentWindow: contentWindow } = iframe;
            if (!contentWindow) // Should not happen after the load event — guard for detached iframe edge case.
            return;
            $36d60b6a72d0a950$var$getOrCreateConnectionPromise(iframe, contentWindow, environment).then((conn)=>{
                if (!cancelled) setConnection(conn);
            }).catch(()=>{
            // Handshake failed — connection remains null.
            });
        };
        // TODO: Will need a better way or API to detect when the sadbox is ready.
        if (iframe.contentDocument === null) // contentDocument is null when the iframe has navigated to a cross-origin
        // page (i.e. the CDN sandbox has already loaded) — safe to connect now.
        initConnection();
        else // Still at about:blank (same-origin, contentDocument accessible) —
        // wait for the actual CDN src to load before attempting the handshake.
        iframe.addEventListener('load', initConnection, {
            once: true
        });
        return ()=>{
            cancelled = true;
            iframe.removeEventListener('load', initConnection);
            // Do NOT destroy the shared connection on cleanup — other mounted
            // hook instances are still using it.
            setConnection(null);
        };
    }, [
        environment
    ]);
    const iframeEl = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
    if (iframeEl && connection !== null) return {
        ready: true,
        connection: connection,
        iframeEl: iframeEl
    };
    return {
        ready: false,
        connection: null,
        iframeEl: iframeEl
    };
};

















/**
 * Renders a Forge app using the worker-based runtime.
 *
 * Instead of an `<iframe>` per app (as the classic {@link Iframe} renderer does),
 * this component runs all app code inside dedicated module Workers spawned from a
 * single shared hidden sandbox `<iframe>`. This improves isolation and reduces
 * browser resource usage when multiple Forge apps are on the same page.
 *
 * **Lifecycle**
 * 1. On mount, waits for the shared sandbox connection to be established
 *    (see {@link useSharedSandbox}).
 * 2. Calls `connection.controller.createApp()` to spin up a Worker for this app
 *    and receives a `workerId`.
 * 3. Opens a {@link createWorkerBridge} channel to the Worker for bridge
 *    communication (UI events, resolver calls, etc.).
 * 4. On unmount, closes the bridge and calls `terminateApp(workerId)` to tear
 *    down the Worker.
 * 5. On page unload (`beforeunload`), destroys the shared sandbox connection and
 *    removes the singleton iframe from the DOM.
 *
 * This component renders `null` — it has no visible DOM output of its own.
 * The sandbox `<iframe>` is managed imperatively outside React so the reconciler
 * can never unmount or reorder it.
 */ const $94d639994bfb2178$var$WorkerWebRuntimeBase = (props)=>{
    const { appId: appId, extension: extension } = props;
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    // Shared, lazily-created sandbox iframe — a single <iframe> in document.body
    // is reused across all WorkerWebRuntime instances on the same page.
    const sandbox = (0, $36d60b6a72d0a950$export$e888e640efbbe682)(environment);
    // Tracks the active worker id so the unmount cleanup can terminate it.
    const workerIdRef = (0, $42omo.useRef)(null);
    const { getBridgeFeatures: getBridgeFeatures, destroy: cleanupBridgeFeatures, overlay: overlay } = $94d639994bfb2178$var$useBridgeFeatures(props);
    // Worker lifecycle: create on mount (once sandbox is ready), terminate on unmount.
    (0, $42omo.useEffect)(()=>{
        if (!sandbox.ready) return;
        const { connection: connection, iframeEl: iframeEl } = sandbox;
        const encodedAppContext = (0, $be0caa192fddc075$export$93ff7914791b9d75)(extension);
        // [TODO] we will need to review if it is possible that appContext can be changed during the lifecyle of the component.
        // If that is case, we might need to add appContext in the dependency array of useEffect and handle the update of appContext accordingly.
        const appContext = {
            appId: appId,
            extension: {
                installationId: extension.installationId,
                environmentId: extension.environmentId,
                appVersion: extension.appVersion,
                properties: {
                    resourceUploadId: extension.properties.resourceUploadId,
                    resource: extension.properties.resource
                },
                type: extension.type
            },
            environment: environment,
            encodedAppContext: encodedAppContext
        };
        let bridgeClose = null;
        let cancelled = false;
        connection.controller.createApp(appContext).then((workerId)=>{
            // If the component unmounted while createApp() was in-flight, immediately
            // tear down the spawned worker so it isn't leaked.
            if (cancelled) {
                connection.controller.terminateApp(workerId).catch(()=>{});
                return;
            }
            workerIdRef.current = workerId;
            const bridge = (0, $36a3b759c0c89f29$exports.createWorkerBridge)({
                workerId: workerId,
                withWindow: iframeEl.contentWindow,
                withDomain: (0, $be0caa192fddc075$export$610aba4956682285)(environment),
                features: getBridgeFeatures(),
                sendHandshakeMetric: (...args)=>{
                    // TODO: implement proper metrics here. For now we just log to console to verify that the bridge is working.
                    // eslint-disable-next-line no-console
                    console.log('[worker] Handshake metric', ...args);
                }
            });
            return bridge.open();
        }).then((result)=>{
            if (result) bridgeClose = result.close;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Failed to create worker app', err);
        });
        return ()=>{
            cancelled = true;
            cleanupBridgeFeatures();
            bridgeClose?.();
            if (workerIdRef.current !== null) {
                connection.controller.terminateApp(workerIdRef.current).catch((err)=>{
                    // eslint-disable-next-line no-console
                    console.error(`Failed to terminate worker with id ${workerIdRef.current}`, err);
                });
                workerIdRef.current = null;
            }
        };
    }, [
        sandbox.ready
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Page-level cleanup — fires when the tab/window is closed or navigated away.
    // Destroys the shared connection and removes the singleton iframe entirely.
    (0, $42omo.useEffect)(()=>{
        const handleUnload = ()=>{
            const iframe = (0, $462ad2a2c2816f62$export$174dd467067cc3dc)(environment);
            if (iframe !== null) {
                (0, $36d60b6a72d0a950$export$dd439767100c493e)(iframe);
                (0, $462ad2a2c2816f62$export$dce981fb8c927a47)();
            }
        };
        window.addEventListener('beforeunload', handleUnload);
        return ()=>window.removeEventListener('beforeunload', handleUnload);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Note that we intentionally do NOT include `environment` in the dependency array here.
    // The unload handler should be added only once and always refer to the same shared iframe,
    // The iframe is appended imperatively to document.body by the singleton —
    // overlay is null by default and populated only when a bridge method
    // calls overlayController.show().
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, overlay);
};
const $94d639994bfb2178$export$62283308bb95b4ba = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kaOT1.TracingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($94d639994bfb2178$var$WorkerWebRuntimeBase, props));
});
const $94d639994bfb2178$export$a84c406ba9bc5e09 = (extension)=>{
    return extension.properties?.renderRuntimeType === 'webworker';
};
const $94d639994bfb2178$var$useBridgeFeatures = (props)=>{
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    // Single overlay slot — bridge methods call overlayController.show()/hide() to
    // render overlay UI into this slot. Animated mode (default) wraps in
    // <ModalTransition> for ADS modals; inline mode (animated=false) renders
    // ThreeLOPrompt directly without transition.
    const { overlay: overlay, overlayController: overlayController } = (0, $b44b52f09e1be159$export$38896ac4f3cfe88b)();
    // WorkerWebRuntime has no iframe to hide and no setIsThreeLOPromptVisible prop
    // (IframeProps vs InnerIframeProps), so renderThreeLOPrompt is a minimal
    // implementation — retry queue only, no visibility side-effects.
    const invokeRetriesRef = (0, $42omo.useRef)([]);
    const latestRef = (0, $42omo.useRef)({
        overlayController: overlayController,
        extension: props.extension
    });
    latestRef.current = {
        overlayController: overlayController,
        extension: props.extension
    };
    const renderThreeLOPrompt = (0, $hQK66.useCallbackOne)((authUrl, retry)=>new Promise((resolve)=>{
            const { overlayController: overlayController, extension: extension } = latestRef.current;
            invokeRetriesRef.current.push(retry);
            overlayController.show(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4ZTaE.default), {
                authUrl: authUrl,
                onSuccess: async ()=>{
                    resolve();
                    overlayController.hide();
                    try {
                        await Promise.all(invokeRetriesRef.current.map((r)=>r()));
                    } finally{
                        invokeRetriesRef.current = [];
                    }
                },
                metadata: {
                    moduleType: extension.type
                }
            }), true);
        }), []);
    // Assembles host-side capabilities (invoker, tracing, token, modal) for bridge methods.
    // Returns a getter rather than a snapshot so services are always current at call time.
    const { getServices: getServices } = (0, $b22670f2947f2693$export$74964fd55d087734)(props, overlayController, renderThreeLOPrompt);
    // [Important] the implementation of getBridgeContext is stable and does not change across the lifecycle of the component, so it is safe to include it in the dependency array of createBridgeFeatures
    // without causing unnecessary re-renders or re-creations of the bridge features.
    const { getBridgeContext: getBridgeContext, destroy: destroy } = (0, $650e4e464f468af1$export$e28a9b61f2b3f391)({
        ...props,
        environment: environment,
        page: page
    }, getServices);
    const getBridgeFeatures = (0, $hQK66.useCallbackOne)(()=>(0, $083504e283bb0724$export$35cddec71f2b332c)(getBridgeContext), []);
    return {
        overlay: overlay,
        destroy: destroy,
        getBridgeFeatures: getBridgeFeatures
    };
};





const $6f2f66284b5f7b02$export$c9565324b088e0b8 = ({ setForgeDoc: setForgeDoc, setError: setError, accountId: accountId, apolloClient: apolloClient, contextIds: contextIds, extension: extension, components: components, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, getContextToken: getContextToken, timezone: timezone, locale: locale, bridge: bridge, ...restProps })=>{
    const forgeReactMajorVersion = (0, $42omo.useRef)(null);
    const combinedBridge = {
        onError: ({ error: error })=>{
            if (setError) setError(error);
        },
        ...bridge,
        reconcile: ({ forgeDoc: forgeDoc })=>{
            Object.freeze(forgeDoc);
            setForgeDoc(forgeDoc);
            if (forgeReactMajorVersion.current === null && forgeDoc.forgeReactMajorVersion) forgeReactMajorVersion.current = forgeDoc.forgeReactMajorVersion;
        }
    };
    const getCurrentForgeReactMajorVersion = (0, $hQK66.useCallbackOne)(()=>{
        return forgeReactMajorVersion.current;
    }, [
        forgeReactMajorVersion
    ]);
    // this is essential based on feature gate for now.
    // In the future, this check should inspect extension / manifest prop to
    // determine whether to use the worker runtime or not.
    if ((0, $94d639994bfb2178$export$a84c406ba9bc5e09)(extension) && (0, $dh538.fg)('forge-ui-worker-runtime')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94d639994bfb2178$export$62283308bb95b4ba), {
        accountId: accountId,
        apolloClient: apolloClient,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        appId: extension.appId,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2c0519b4a165d40$export$5137ec99f248330b), {
        accountId: accountId,
        apolloClient: apolloClient,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        components: components,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        timezone: timezone,
        locale: locale,
        bridge: combinedBridge,
        isHidden: true,
        getCurrentForgeReactMajorVersion: getCurrentForgeReactMajorVersion,
        ...restProps,
        onError: (err)=>setError && setError(new Error(err))
    });
};



const $e892f186f061f3fc$var$UIKitRendererOld = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, coreData: coreData, contextIds: contextIds, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    const injectedComponentsWithKey = (0, $42omo.useMemo)(()=>{
        return components ? Object.keys(components).reduce((acc, key)=>{
            const Component = components[key];
            return {
                ...acc,
                // A key is required to ensure React creates new component instances when forgeDoc.key changes.
                // Without this key, React reuses the same component instance across different forgeDoc updates,
                // causing hook call order violations when the component structure changes between renders.
                [key]: (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...args,
                        key: args.forgeDoc.key
                    })
            };
        }, {}) : {};
    }, [
        components
    ]);
    const wiredComponents = (0, $42omo.useMemo)(()=>({
            Avatar: (0, $556ea5977eff619b$export$4e4c41e4152a9f8a)(),
            AvatarStack: (0, $ac41127a79653400$export$30420ba0b3cd13e0)({
                client: client
            }),
            // Override previous AvatarStack with Relay version
            ...(0, $dh538.fg)('forge-ui-relay-user-group') && {
                AvatarStack: (0, $2674e7e6928452b6$export$6f1d3bf96df15c79)
            },
            UserPicker: (0, $durRy.makeNativeUserPicker)({
                mentionProvider: mentionProvider,
                accountId: accountId,
                ...workspaceId ? {
                    cloudId: 'bitbucket'
                } : {
                    cloudId: cloudId
                },
                productAttributes: workspaceId ? {
                    workspaceIds: [
                        (0, $388fc69d2d887761$export$3a1a8bfb58a690be)(workspaceId)
                    ]
                } : undefined,
                productKey: product
            }),
            AdfRenderer: (0, $dx0OV.makeADFRenderer)({
                bridge: bridge,
                client: client
            })
        }), [
        accountId,
        client,
        cloudId,
        mentionProvider,
        product,
        workspaceId,
        bridge
    ]);
    const getComponents = (0, $42omo.useCallback)((defaults)=>({
            ...defaults,
            ...wiredComponents,
            ...injectedComponentsWithKey
        }), [
        injectedComponentsWithKey,
        wiredComponents
    ]);
    const handleError = (0, $42omo.useCallback)((error)=>{
        if (onError) onError(error.message);
        if (onAppError) onAppError(error.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3ac0804570f3b11$export$aab0d259c363afda), {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension && (0, $dh538.fg)('forge-ui-on-close-bridge-method') ? {
            ...modalExtension,
            viewOnClose: viewOnClose
        } : modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        client: client,
        onSuccess: onSuccess
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc)=>{
            if (forgeDoc.type !== 'MacroConfig') setForgeDoc(forgeDoc);
            onForgeDocUpdated?.(forgeDoc);
        },
        setError: setError,
        apolloClient: client,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }));
};
const $e892f186f061f3fc$var$UIKitRendererNew = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, coreData: coreData, contextIds: contextIds, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionViewData: extensionViewData, getContextToken: getContextToken, mentionProvider: mentionProvider, product: product, locale: locale, modalExtension: modalExtension, onForgeDocUpdated: onForgeDocUpdated, getThreeLOPrompt: getThreeLOPrompt, customBridgeMethods: customBridgeMethods, loadingComponent: loadingComponent, onError: onError, extensionPayload: extensionPayload, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId, viewOnClose: viewOnClose, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    const { cloudId: cloudId, workspaceId: workspaceId } = coreData;
    const [forgeDoc, setForgeDoc] = (0, $42omo.useState)(undefined);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const [shouldShowRenderer, setShouldShowRenderer] = (0, $42omo.useState)(true);
    const isMacro = extension.type === 'xen:macro';
    const getComponents = (0, $21632699a983d1c1$export$58982618823f55fc)({
        accountId: accountId,
        bridge: bridge,
        client: client,
        cloudId: cloudId,
        workspaceId: workspaceId,
        mentionProvider: mentionProvider,
        product: product,
        components: components
    });
    const handleError = (0, $42omo.useCallback)((error)=>{
        if (onError) onError(error.message);
        if (onAppError) onAppError(error.message);
    }, [
        onError,
        onAppError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError && error) onError(error.message);
        if (onAppError && error) onAppError(error.message);
    }, [
        error,
        onError,
        onAppError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3ac0804570f3b11$export$aab0d259c363afda), {
        viewportDimensions: isMacro ? viewportDimensions : undefined
    }, shouldShowRenderer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jed12.default), {
        forgeDoc: forgeDoc,
        extension: extension,
        error: error?.message,
        components: getComponents,
        modalExtension: modalExtension && (0, $dh538.fg)('forge-ui-on-close-bridge-method') ? {
            ...modalExtension,
            viewOnClose: viewOnClose
        } : modalExtension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionType: extensionData.type,
        loading: true,
        loadingComponent: loadingComponent,
        onError: handleError,
        client: client,
        onSuccess: onSuccess,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f2f66284b5f7b02$export$c9565324b088e0b8), {
        accountId: accountId,
        setForgeDoc: (forgeDoc)=>{
            if (forgeDoc.type !== 'MacroConfig') setForgeDoc(forgeDoc);
            onForgeDocUpdated?.(forgeDoc);
        },
        setError: setError,
        apolloClient: client,
        components: getThreeLOPrompt,
        contextIds: contextIds,
        extension: extension,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        locale: locale,
        bridge: bridge,
        getContextToken: getContextToken,
        entryPoint: entryPoint,
        customBridgeMethods: customBridgeMethods,
        setShouldShowRenderer: setShouldShowRenderer,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    }));
};
const $e892f186f061f3fc$export$9ca39743052e068e = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent'), $e892f186f061f3fc$var$UIKitRendererNew, $e892f186f061f3fc$var$UIKitRendererOld);






var $69400 = parcelRequire("69400");


var $g7rOD = parcelRequire("g7rOD");

const $acc8ad845a033cd1$var$Frame = ({ forgeDoc: forgeDoc, IframeRenderer: IframeRenderer })=>{
    const { setFrameCount: setFrameCount } = (0, $42omo.useContext)((0, $69400.FrameCount));
    (0, $42omo.useEffect)(()=>{
        setFrameCount((prevCount)=>prevCount + 1);
        return ()=>setFrameCount((prevCount)=>prevCount - 1);
    }, [
        setFrameCount
    ]);
    const { resource: resource, height: height, width: width } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IframeRenderer, {
        resource: resource,
        height: height,
        width: width
    });
};
const $acc8ad845a033cd1$var$FrameMemo = /*#__PURE__*/ (0, $42omo.memo)($acc8ad845a033cd1$var$Frame, (0, $g7rOD.forgePropsAreEqual));
const $acc8ad845a033cd1$export$1f1ebfe6da5b177c = (IframeRenderer)=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($acc8ad845a033cd1$var$FrameMemo, {
            ...props,
            IframeRenderer: IframeRenderer
        });
};


var $2Fl4v = parcelRequire("2Fl4v");




var $HEA67 = parcelRequire("HEA67");


























var $fwDOR = parcelRequire("fwDOR");

// Maximum time we would expect an app initialization to take.
const $f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT = 6000;
const $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED = 2000;
const $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT = 5000;
const $f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS = 350;
const $f6ee5ed4b27f8132$var$holdResourceStartEvents = new Set([
    'product-api-request-initiated',
    'resolver-invoke-initiated'
]);
const $f6ee5ed4b27f8132$var$holdResourceEndEvents = new Set([
    'product-api-requested',
    'resolver-invoked'
]);
const $f6ee5ed4b27f8132$var$holdAffectingEvents = new Set([
    ...$f6ee5ed4b27f8132$var$holdResourceStartEvents,
    ...$f6ee5ed4b27f8132$var$holdResourceEndEvents,
    'navigation-timing',
    'user-interacted'
]);
const $f6ee5ed4b27f8132$export$e286348a1f2b0a60 = ({ children: children })=>{
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const appRuntimeInitiated = (0, $42omo.useRef)(false);
    const [holdState, setHoldState] = (0, $42omo.useState)('holding');
    const releaseTimeoutRef = (0, $42omo.useRef)();
    const holdResourcesStartedCountRef = (0, $42omo.useRef)(0);
    const holdResourcesFinishedCountRef = (0, $42omo.useRef)(0);
    const releaseHold = (0, $42omo.useCallback)(()=>{
        clearTimeout(releaseTimeoutRef.current);
        setHoldState('released');
    }, [
        setHoldState
    ]);
    const retainHoldFor = (0, $42omo.useCallback)((holdFor)=>{
        clearTimeout(releaseTimeoutRef.current);
        releaseTimeoutRef.current = setTimeout(releaseHold, holdFor);
    }, [
        releaseHold
    ]);
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        if (!$f6ee5ed4b27f8132$var$holdAffectingEvents.has(event.type)) return;
        // Drop holds on user interaction (timeline invalidated).
        if (event.type === 'user-interacted') {
            releaseHold();
            return;
        }
        // Keep track of requests starting and finished, don't consider in holding
        // logic until the app has initialised.
        const resourceHoldStarted = $f6ee5ed4b27f8132$var$holdResourceStartEvents.has(event.type);
        const resourceHoldFinished = $f6ee5ed4b27f8132$var$holdResourceEndEvents.has(event.type);
        if (resourceHoldStarted) holdResourcesStartedCountRef.current += 1;
        else if (resourceHoldFinished) holdResourcesFinishedCountRef.current += 1;
        const activeResourceRequests = holdResourcesStartedCountRef.current - holdResourcesFinishedCountRef.current;
        // Retain unconditional hold until 'navigation-timing' is received to indicate
        // that the frame runtime has initialised correctly.
        if (!appRuntimeInitiated.current) {
            if (event.type === 'navigation-timing') {
                appRuntimeInitiated.current = true;
                retainHoldFor(activeResourceRequests > 0 ? $f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT : $f6ee5ed4b27f8132$var$HOLD_MS_FRAME_INITIALISED);
            }
            return;
        }
        // On new resource holds, reset to default resource request timeout.
        if (resourceHoldStarted) retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_RESOURCE_REQUEST_TIMEOUT);
        // Retain hold until all active requests are finished.
        if (activeResourceRequests > 0) return;
        // No active resource requests, wait a moment to catch any new resource
        // requests initiated by the app runtime.
        retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_CATCH_LATENT_REQUESTS);
    }, [
        releaseHold,
        retainHoldFor
    ]);
    // Event listener management.
    (0, $42omo.useEffect)(()=>{
        // Default timeout for app init, so we don't indefinitely on e.g. for
        // unhandled app errors.
        retainHoldFor($f6ee5ed4b27f8132$var$HOLD_MS_APP_INIT_TIMEOUT);
        const { listeners: listeners } = timelineRef.current;
        listeners.add(handleEvent);
        return ()=>{
            clearTimeout(releaseTimeoutRef.current);
            listeners.delete(handleEvent);
        };
    }, [
        timelineRef,
        handleEvent,
        retainHoldFor
    ]);
    (0, $42omo.useEffect)(()=>{
        // On hold state change or component dismount: flag release in timeline.
        return ()=>{
            if (holdState === 'holding') captureEvent({
                type: 'page-hold-released',
                elapsed: (0, $1uzCd.getPerformanceMark)()
            });
        };
    }, [
        holdState,
        captureEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "forge-ui-app-content-ttai-wait-v2",
        hold: holdState === 'holding'
    }), children);
};
const $f6ee5ed4b27f8132$export$4304f91d6e983d05 = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled'), $f6ee5ed4b27f8132$export$e286348a1f2b0a60, (0, $42omo.Fragment));



var $9c0Ac = parcelRequire("9c0Ac");

/**
 * Inner wrapper rendered inside PerformanceAnalyticsProviderRollout so it can
 * access PerformanceAnalyticsContext and wire up UFOThirdPartySegment's iframe
 * behavior via onRegisterIframeEventListener.
 */ function $e2fd6b5eb27bb420$var$UFOThirdPartySegmentWithPerfTimeline({ children: children, name: name }) {
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    const onRegisterIframeEventListener = (0, $42omo.useCallback)((listener)=>{
        const timeline = timelineRef?.current;
        if (!timeline) return ()=>{};
        timeline.listeners.add(listener);
        return ()=>{
            timeline.listeners.delete(listener);
        };
    }, [
        timelineRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: name,
        onRegisterIframeEventListener: onRegisterIframeEventListener
    }, children);
}
const $e2fd6b5eb27bb420$export$b89b612df1c715da = (props)=>{
    const { accountId: accountId, bridge: bridge, client: client, components: components, consentMessage: consentMessage, contextIds: contextIds, customBridgeMethods: customBridgeMethods, dialogs: dialogs, entryPoint: entryPoint, extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, extensionViewData: extensionViewData, hasModalConsentPrompt: hasModalConsentPrompt, height: height, width: width, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, getContextToken: getContextToken, loadingComponent: loadingComponent, locale: locale, localId: localId, mentionProvider: mentionProvider, modalExtension: modalExtension, modalStyles: modalStyles, modalProvider: modalProvider, onConsentModalClose: onConsentModalClose, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, onError: onError, onForgeDocUpdated: onForgeDocUpdated, onIframeLoad: onIframeLoad, onInitialRender: onInitialRender, product: product, timezone: timezone, getModalWidth: getModalWidth, onModalExtensionClose: onModalExtensionClose, onSuccess: onSuccess, onAppError: onAppError, viewportDimensions: viewportDimensions, isEmbeddedMacro: isEmbeddedMacro, embeddedParentLocalId: embeddedParentLocalId, isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI } = props;
    let cloudId;
    let workspaceId;
    if ('cloudId' in props) cloudId = props.cloudId;
    else if ('workspaceId' in props) workspaceId = props.workspaceId;
    const cloudOrWorkspaceId = cloudId ? {
        cloudId: cloudId
    } : {
        workspaceId: workspaceId
    };
    const { id: extensionId, environmentId: environmentId, environmentType: environmentType } = extension;
    (0, $42omo.useEffect)(()=>{
        onInitialRender?.();
    }, [
        onInitialRender
    ]);
    const coreData = (0, $42omo.useMemo)(()=>({
            workspaceId: workspaceId,
            cloudId: cloudId,
            localId: localId || extensionId,
            environmentId: environmentId,
            environmentType: environmentType
        }), [
        cloudId,
        environmentId,
        environmentType,
        extensionId,
        localId,
        workspaceId
    ]);
    const getThreeLOPrompt = (0, $42omo.useCallback)(()=>({
            ThreeLOPrompt: modalExtension || hasModalConsentPrompt ? (0, $2Fl4v.makeModalThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                isBlanketHidden: true,
                onClose: onConsentModalClose
            }) : (0, $4ZTaE.makeThreeLOPromptForCustomUI)({
                appName: extension.properties.title,
                onSuccess: onConsentSuccess,
                message: consentMessage,
                onInitialization: onConsentInitialization
            })
        }), [
        extension.properties.title,
        consentMessage,
        hasModalConsentPrompt,
        modalExtension,
        onConsentSuccess,
        onConsentModalClose,
        onConsentInitialization
    ]);
    const customUIProps = {
        accountId: accountId,
        bridge: bridge,
        client: client,
        consentMessage: consentMessage,
        contextIds: contextIds,
        coreData: coreData,
        customBridgeMethods: customBridgeMethods,
        dialogs: dialogs,
        entryPoint: entryPoint,
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        extensionViewData: extensionViewData,
        getContextToken: getContextToken,
        getThreeLOPrompt: getThreeLOPrompt,
        height: height,
        loadingComponent: loadingComponent,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        modalStyles: modalStyles,
        modalProvider: modalProvider,
        onConsentModalClose: onConsentModalClose,
        onConsentSuccess: onConsentSuccess,
        onError: onError,
        onForgeDocUpdated: onForgeDocUpdated,
        onIframeLoad: onIframeLoad,
        product: product,
        timezone: timezone,
        isIframeHidden: isIframeHidden,
        isIframeResizable: isIframeResizable,
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const uiKitEmbeddedMacroProps = {
        isEmbeddedMacro: isEmbeddedMacro,
        embeddedParentLocalId: embeddedParentLocalId
    };
    const [viewOnClose, setViewOnClose] = (0, $42omo.useState)();
    // this function has known deps listed already in deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const FrameResizable = (0, $42omo.useCallback)((0, $acc8ad845a033cd1$export$1f1ebfe6da5b177c)((inputProps)=>{
        const { height: height, width: width } = inputProps;
        // If height or width is provided by app code, the iframe does not automatically resize to contents
        const isIframeResizable = height || width ? false : true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
            ...customUIProps,
            extension: {
                ...extension,
                properties: {
                    ...extension.properties,
                    resource: inputProps.resource
                }
            },
            // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
            entryPoint: undefined,
            // Ensures Frame is always resized to the full height of the content
            // Required because Jira leaves isIframeResizable as false
            isIframeResizable: isIframeResizable,
            height: height,
            width: width
        });
    }), // need eslint here as re-render only depends on extensionData & extensionPayload
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customUIProps.extensionData,
        customUIProps.extensionPayload,
        extension
    ]);
    if ((0, $dh538.fg)('platform_ufo_3p_segment_timings')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eI4ye.PerformanceAnalyticsProviderRollout), {
        profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
        appType: (0, $iqcSr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
        forgeEnvironment: props.extension.environmentType,
        extensionType: props.extension.type,
        appVersion: props.extension.appVersion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e2fd6b5eb27bb420$var$UFOThirdPartySegmentWithPerfTimeline, {
        name: "forge-ui-app-content-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6ee5ed4b27f8132$export$4304f91d6e983d05), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c0Ac.UserAccessProvider), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        hidden: true,
        id: "forge-ui-renderer"
    }), !(0, $iqcSr.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e892f186f061f3fc$export$9ca39743052e068e), {
        coreData: coreData,
        getThreeLOPrompt: getThreeLOPrompt,
        accountId: accountId,
        client: client,
        contextIds: contextIds,
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        product: product,
        bridge: {
            // spread down here so product can override the default onClose
            ...modalExtension && (0, $dh538.fg)('forge-ui-on-close-bridge-method') ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose (EAP) is not available for production apps. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    return true;
                }
            } : {},
            ...bridge
        },
        customBridgeMethods: customBridgeMethods,
        components: {
            Frame: (0, $dh538.fg)('ditto-fcf-frame-support-on-issue-create') ? FrameResizable : (0, $acc8ad845a033cd1$export$1f1ebfe6da5b177c)((inputProps)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
                    ...customUIProps,
                    extension: {
                        ...extension,
                        properties: {
                            ...extension.properties,
                            ...inputProps
                        }
                    },
                    // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
                    entryPoint: undefined,
                    // Ensures Frame is always resized to the full height of the content
                    // Required because Jira leaves isIframeResizable as false
                    isIframeResizable: true
                });
            }),
            ...components
        },
        consentMessage: consentMessage,
        entryPoint: entryPoint,
        getContextToken: getContextToken,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        onConsentSuccess: onConsentSuccess,
        onForgeDocUpdated: onForgeDocUpdated,
        timezone: timezone,
        onConsentModalClose: onConsentModalClose,
        onError: onError,
        loadingComponent: loadingComponent,
        extensionPayload: extensionPayload,
        onSuccess: onSuccess,
        ...cloudOrWorkspaceId,
        onAppError: onAppError,
        viewportDimensions: viewportDimensions,
        viewOnClose: viewOnClose,
        ...(0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus') ? uiKitEmbeddedMacroProps : {},
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI
    }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$5d28a207fd7621f6), {
        ...customUIProps,
        bridge: {
            ...modalExtension && (0, $dh538.fg)('forge-ui-on-close-bridge-method') ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose is not available for production apps during EAP. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    // stores the callback for when modal is closed
                    return true;
                }
            } : {},
            // spread down here so product can override the default onClose
            ...customUIProps.bridge
        },
        modalOnClose: onModalExtensionClose,
        closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
        closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
        viewOnClose: viewOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
        ...customUIProps,
        getModalWidth: getModalWidth,
        width: width
    })))))));
    // TODO: Delete after cleaning up 'platform_ufo_3p_segment_timings' flag
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $HEA67.ForgeUIExtensionAnalyticsContext), {
        extensionId: props.extension.id,
        localId: props.localId || props.extension.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: "forge-ui-app-content-root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eI4ye.PerformanceAnalyticsProviderRollout), {
        profileKey: `${props.extension.id}-${props.extension.key}-${props.entryPoint}`,
        appType: (0, $iqcSr.isCustomUI)(props.extension, props.entryPoint) ? 'CustomUI' : 'UIKit',
        forgeEnvironment: props.extension.environmentType,
        extensionType: props.extension.type,
        appVersion: props.extension.appVersion
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6ee5ed4b27f8132$export$4304f91d6e983d05), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c0Ac.UserAccessProvider), {
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        hidden: true,
        id: "forge-ui-renderer"
    }), !(0, $iqcSr.isCustomUI)(extension, entryPoint) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e892f186f061f3fc$export$9ca39743052e068e), {
        coreData: coreData,
        getThreeLOPrompt: getThreeLOPrompt,
        accountId: accountId,
        client: client,
        contextIds: contextIds,
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        product: product,
        bridge: {
            // spread down here so product can override the default onClose
            ...modalExtension && (0, $dh538.fg)('forge-ui-on-close-bridge-method') ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose (EAP) is not available for production apps. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    return true;
                }
            } : {},
            ...bridge
        },
        customBridgeMethods: customBridgeMethods,
        components: {
            Frame: (0, $dh538.fg)('ditto-fcf-frame-support-on-issue-create') ? FrameResizable : (0, $acc8ad845a033cd1$export$1f1ebfe6da5b177c)((inputProps)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
                    ...customUIProps,
                    extension: {
                        ...extension,
                        properties: {
                            ...extension.properties,
                            ...inputProps
                        }
                    },
                    // Ensure extensions that are rendered as entryPoints aren't passing through the very same entryPoint to the Frame
                    entryPoint: undefined,
                    // Ensures Frame is always resized to the full height of the content
                    // Required because Jira leaves isIframeResizable as false
                    isIframeResizable: true
                });
            }),
            ...components
        },
        consentMessage: consentMessage,
        entryPoint: entryPoint,
        getContextToken: getContextToken,
        locale: locale,
        localId: localId,
        mentionProvider: mentionProvider,
        modalExtension: modalExtension,
        onConsentSuccess: onConsentSuccess,
        onForgeDocUpdated: onForgeDocUpdated,
        timezone: timezone,
        onConsentModalClose: onConsentModalClose,
        onError: onError,
        loadingComponent: loadingComponent,
        extensionPayload: extensionPayload,
        onSuccess: onSuccess,
        ...cloudOrWorkspaceId,
        onAppError: onAppError,
        viewportDimensions: viewportDimensions,
        viewOnClose: viewOnClose,
        ...(0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus') ? uiKitEmbeddedMacroProps : {},
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI
    }) : modalExtension ? // getModalWidth not applied here since all modal extensions are defaulted to medium width
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$5d28a207fd7621f6), {
        ...customUIProps,
        bridge: {
            ...modalExtension && (0, $dh538.fg)('forge-ui-on-close-bridge-method') ? {
                onClose: (callback)=>{
                    if (extension.environmentType === 'PRODUCTION') {
                        // eslint-disable-next-line no-console
                        console.warn('Forge view.onClose is not available for production apps during EAP. The callback will not be registered.');
                        return false;
                    }
                    setViewOnClose(()=>callback.data);
                    // stores the callback for when modal is closed
                    return true;
                }
            } : {},
            // spread down here so product can override the default onClose
            ...customUIProps.bridge
        },
        modalOnClose: onModalExtensionClose,
        closeOnEscape: modalExtension?.shouldCloseOnEscapePress ?? true,
        closeOnOverlayClick: modalExtension?.shouldCloseOnOverlayClick ?? true,
        viewOnClose: viewOnClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8537409554582c9d$export$17d9f1e4832027c9), {
        ...customUIProps,
        getModalWidth: getModalWidth,
        width: width
    })))))));
};
module.exports["ForgeUIRenderer"] = $e2fd6b5eb27bb420$export$b89b612df1c715da;

});

parcelRegister("dj2Gr", function(module, exports) {
/**
 * @generated SignedSource<<681771f6785809ce05e6b98fd428e543>>
 * @relayHash 0d63b7767d20e0fe07b77f6a9b75b657
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15f8fb5c1ac9cee3e5b2ed474f580b517d4e72506dcd62b730bc9bb5def9f479
const $ec5b20105029ea69$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "InvocationResponsePayload",
        "kind": "LinkedField",
        "name": "response",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "body"
            }
        ]
    }, v4 = {
        "concreteType": "ForgeContextToken",
        "kind": "LinkedField",
        "name": "contextToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jwt"
            },
            {
                "kind": "ScalarField",
                "name": "expiresAt"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InvokeExtensionPayloadErrorExtensionFields",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "authInfoUrl"
                    }
                ]
            }
        ],
        "type": "InvokeExtensionPayloadErrorExtension"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInvokeExtensionRelayMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInvokeExtensionRelayMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "InvokeExtensionResponse",
                    "kind": "LinkedField",
                    "name": "invokeExtension",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "15f8fb5c1ac9cee3e5b2ed474f580b517d4e72506dcd62b730bc9bb5def9f479",
            "metadata": {},
            "name": "useInvokeExtensionRelayMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ec5b20105029ea69$var$node.hash = "c0c91290aaf4ee74a6c4318945b6a1bd";
var $ec5b20105029ea69$export$2e2bcd8739ae039 = $ec5b20105029ea69$var$node;



var $hQK66 = parcelRequire("hQK66");


var $eSUdr = parcelRequire("eSUdr");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $1Igmn = parcelRequire("1Igmn");

const $7569106fed376473$export$46af696e5313090f = (0, $eSUdr.default)`mutation forge_ui_invokeExtension($input:InvokeExtensionInput!){invokeExtension(input:$input){success response{body}contextToken{jwt expiresAt}errors{message extensions{errorType statusCode ...on InvokeExtensionPayloadErrorExtension{fields{authInfoUrl}}}}}}`;
const $7569106fed376473$export$19d283d2f5a7d3c = (contextIds, extensionId)=>{
    const customCommitFn = (0, $hQK66.useCallbackOne)((environment, config)=>(0, $irOoi.commitMutation)(environment, {
            ...config,
            cacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }), [
        contextIds
    ]);
    const [commit] = (0, $irOoi.useMutation)((0, $ec5b20105029ea69$export$2e2bcd8739ae039), customCommitFn);
    return (0, $hQK66.useCallbackOne)((payload, entryPoint = 'resolver')=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        contextIds: contextIds,
                        extensionId: extensionId,
                        payload: payload,
                        entryPoint: entryPoint
                    }
                },
                onCompleted: (data, errors)=>{
                    if (Array.isArray(errors) && errors.length > 0 && (0, $dh538.fg)('forge-ui-preserve-invoke-remote-error-messages')) // We pass the error to `resolve` here so it can goes through the error handling logic found in packages/forge/forge-ui/src/custom-ui/iframe/InnerIframe.tsx - onInvoke
                    resolve({
                        data: {
                            invokeExtension: {
                                errors: errors,
                                success: false,
                                response: null,
                                contextToken: null
                            }
                        }
                    });
                    resolve({
                        data: data
                    });
                },
                onError: reject
            });
        }), [
        contextIds,
        extensionId,
        commit
    ]);
};
module.exports["useInvokeExtension"] = $7569106fed376473$export$19d283d2f5a7d3c;

});

parcelRegister("4ZTaE", function(module, exports) {
/* threeLOPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $aoVih = parcelRequire("aoVih");


var $ccHMk = parcelRequire("ccHMk");


var $i35rc = parcelRequire("i35rc");

const $e24cf88a4f07ee68$var$styles = {
    box: "_1h6d1xiv _1dqonqa1 _189e1dm9"
};
const $e24cf88a4f07ee68$var$ThreeLOPrompt = (props)=>{
    const { loading: loading, startAuth: startAuth, promptMessage: promptMessage, buttonText: buttonText } = (0, $i35rc.useAuth)(props);
    const { authUrl: authUrl, onInitialization: onInitialization } = props;
    (0, $42omo.useEffect)(()=>{
        if (onInitialization) onInitialization();
    }, [
        onInitialization
    ]);
    if (!authUrl || authUrl === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e24cf88a4f07ee68$var$messages.noAuthURLErrorMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onPointerDown: (e)=>e.stopPropagation(),
        padding: "space.250",
        xcss: $e24cf88a4f07ee68$var$styles.box
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "start",
        space: "space.250",
        grow: "hug",
        testId: "three-lo-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, promptMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: startAuth,
        isLoading: loading
    }, buttonText))));
};
var $e24cf88a4f07ee68$export$2e2bcd8739ae039 = $e24cf88a4f07ee68$var$ThreeLOPrompt;
const $e24cf88a4f07ee68$export$92dadb4ff2941f34 = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { message: message, authUrl: authUrl, promptText: promptText } = forgeDoc.props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
        message: message,
        authUrl: authUrl,
        promptText: promptText,
        onSuccess: ()=>dispatch({
                type: 'render',
                extensionData: {}
            })
    });
};
const $e24cf88a4f07ee68$export$388ff2bd3ce4e348 = ({ appName: appName, onSuccess: onSuccess })=>{
    return function threeLOPrompt({ forgeDoc: { props: props }, dispatch: dispatch }) {
        const { message: message, authUrl: authUrl, promptText: promptText } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return dispatch({
                    type: 'render',
                    extensionData: {}
                });
            }
        });
    };
};
const $e24cf88a4f07ee68$export$7519b5f6e74be543 = ({ appName: appName, onSuccess: onSuccess, message: message, onInitialization: onInitialization })=>{
    return function threeLOPrompt(props) {
        const { authUrl: authUrl, promptText: promptText, onSuccess: onSuccessFromIframeComponent } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e24cf88a4f07ee68$var$ThreeLOPrompt, {
            message: message,
            authUrl: authUrl,
            promptText: promptText,
            appName: appName,
            onSuccess: ()=>{
                if (onSuccess) onSuccess();
                return Promise.resolve(onSuccessFromIframeComponent);
            },
            onInitialization: onInitialization
        });
    };
};
const $e24cf88a4f07ee68$var$messages = (0, $aXWIB.defineMessages)({
    noAuthURLErrorMessage: {
        id: "confluence.threeLOPrompt.no.authURL.error-message",
        defaultMessage: "Consent URL not found. Please refresh the page and try again."
    }
});
module.exports["default"] = $e24cf88a4f07ee68$export$2e2bcd8739ae039;
module.exports["ThreeLOPromptRenderFn"] = $e24cf88a4f07ee68$export$92dadb4ff2941f34;
module.exports["makeThreeLOPromptForCustomUI"] = $e24cf88a4f07ee68$export$7519b5f6e74be543;

});

parcelRegister("1BqC1", function(module, exports) {
$parcel$export(module.exports, "iframeResize", () => $12ade3c53ffa5233$export$e284ab1b3bcdabe6, (v) => $12ade3c53ffa5233$export$e284ab1b3bcdabe6 = v);
$parcel$export(module.exports, "iframeResizer", () => $12ade3c53ffa5233$export$b6962bfb5a91d43, (v) => $12ade3c53ffa5233$export$b6962bfb5a91d43 = v);
$parcel$export(module.exports, "iframeResizerContentWindow", () => $12ade3c53ffa5233$export$1aafc108bc1f168c, (v) => $12ade3c53ffa5233$export$1aafc108bc1f168c = v);
var $12ade3c53ffa5233$export$e284ab1b3bcdabe6;
var $12ade3c53ffa5233$export$b6962bfb5a91d43// Backwards compatability
;
var $12ade3c53ffa5233$export$1aafc108bc1f168c;

var $9wL22 = parcelRequire("9wL22");

$12ade3c53ffa5233$export$e284ab1b3bcdabe6 = $9wL22;
$12ade3c53ffa5233$export$b6962bfb5a91d43 = $9wL22;

$12ade3c53ffa5233$export$1aafc108bc1f168c = (parcelRequire("hAXmP"));

});

parcelRegister("hAXmP", function(module, exports) {
/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 *
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var autoResize = true, base = 10, bodyBackground = '', bodyMargin = 0, bodyMarginStr = '', bodyObserver = null, bodyPadding = '', calculateWidth = false, doubleEventList = {
        resize: 1,
        click: 1
    }, eventCancelTimer = 128, firstRun = true, height = 1, heightCalcModeDefault = 'bodyOffset', heightCalcMode = heightCalcModeDefault, initLock = true, initMsg = '', inPageLinks = {}, interval = 32, intervalTimer = null, logging = false, mouseEvents = false, msgID = '[iFrameSizer]', msgIdLen = msgID.length, myID = '', resetRequiredMethods = {
        max: 1,
        min: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, resizeFrom = 'child', sendPermit = true, target = window.parent, targetOriginDefault = '*', tolerance = 0, triggerLocked = false, triggerLockedTimer = null, throttledTimer = 16, width = 1, widthCalcModeDefault = 'scroll', widthCalcMode = widthCalcModeDefault, win = window, onMessage = function() {
        warn('onMessage function not defined');
    }, onReady = function() {}, onPageInfo = function() {}, customCalcMethods = {
        height: function() {
            warn('Custom height calculation function not defined');
            return document.documentElement.offsetHeight;
        },
        width: function() {
            warn('Custom width calculation function not defined');
            return document.body.scrollWidth;
        }
    }, eventHandlersByName = {}, passiveSupported = false;
    function noop() {}
    try {
        var options = Object.create({}, {
            passive: {
                get: function() {
                    passiveSupported = true;
                }
            }
        });
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop, options);
    } catch (error) {
    /* */ }
    function addEventListener(el, evt, func, options) {
        el.addEventListener(evt, func, passiveSupported ? options || {} : false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // Based on underscore.js
    function throttle(func) {
        var context, args, result, timeout = null, previous = 0, later = function() {
            previous = Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) // eslint-disable-next-line no-multi-assign
            context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous) previous = now;
            var remaining = throttledTimer - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > throttledTimer) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) // eslint-disable-next-line no-multi-assign
                context = args = null;
            } else if (!timeout) timeout = setTimeout(later, remaining);
            return result;
        };
    }
    function formatLogMsg(msg) {
        return msgID + '[' + myID + '] ' + msg;
    }
    function log(msg) {
        if (logging && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console.log(formatLogMsg(msg));
    }
    function warn(msg) {
        if ('object' === typeof window.console) // eslint-disable-next-line no-console
        console.warn(formatLogMsg(msg));
    }
    function init() {
        readDataFromParent();
        log('Initialising iFrame (' + window.location.href + ')');
        readDataFromPage();
        setMargin();
        setBodyStyle('background', bodyBackground);
        setBodyStyle('padding', bodyPadding);
        injectClearFixIntoBodyElement();
        checkHeightMode();
        checkWidthMode();
        stopInfiniteResizingOfIFrame();
        setupPublicMethods();
        setupMouseEvents();
        startEventListeners();
        inPageLinks = setupInPageLinks();
        sendSize('init', 'Init message from host page');
        onReady();
    }
    function readDataFromParent() {
        function strBool(str) {
            return 'true' === str;
        }
        var data = initMsg.substr(msgIdLen).split(':');
        myID = data[0];
        bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; // For V1 compatibility
        calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
        logging = undefined !== data[3] ? strBool(data[3]) : logging;
        interval = undefined !== data[4] ? Number(data[4]) : interval;
        autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
        bodyMarginStr = data[7];
        heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
        bodyBackground = data[9];
        bodyPadding = data[10];
        tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
        inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
        resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
        widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
        mouseEvents = undefined !== data[15] ? Boolean(data[15]) : mouseEvents;
    }
    function depricate(key) {
        var splitName = key.split('Callback');
        if (splitName.length === 2) {
            var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
            this[name] = this[key];
            delete this[key];
            warn("Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
        }
    }
    function readDataFromPage() {
        function readData() {
            var data = window.iFrameResizer;
            log('Reading data from page: ' + JSON.stringify(data));
            Object.keys(data).forEach(depricate, data);
            onMessage = 'onMessage' in data ? data.onMessage : onMessage;
            onReady = 'onReady' in data ? data.onReady : onReady;
            targetOriginDefault = 'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
            heightCalcMode = 'heightCalculationMethod' in data ? data.heightCalculationMethod : heightCalcMode;
            widthCalcMode = 'widthCalculationMethod' in data ? data.widthCalculationMethod : widthCalcMode;
        }
        function setupCustomCalcMethods(calcMode, calcFunc) {
            if ('function' === typeof calcMode) {
                log('Setup custom ' + calcFunc + 'CalcMethod');
                customCalcMethods[calcFunc] = calcMode;
                calcMode = 'custom';
            }
            return calcMode;
        }
        if ('iFrameResizer' in window && Object === window.iFrameResizer.constructor) {
            readData();
            heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
            widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
        }
        log('TargetOrigin for parent set to: ' + targetOriginDefault);
    }
    function chkCSS(attr, value) {
        if (-1 !== value.indexOf('-')) {
            warn('Negative CSS value ignored for ' + attr);
            value = '';
        }
        return value;
    }
    function setBodyStyle(attr, value) {
        if (undefined !== value && '' !== value && 'null' !== value) {
            document.body.style[attr] = value;
            log('Body ' + attr + ' set to "' + value + '"');
        }
    }
    function setMargin() {
        // If called via V1 script, convert bodyMargin from int to str
        if (undefined === bodyMarginStr) bodyMarginStr = bodyMargin + 'px';
        setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
    }
    function stopInfiniteResizingOfIFrame() {
        document.documentElement.style.height = '';
        document.body.style.height = '';
        log('HTML & body height set to "auto"');
    }
    function manageTriggerEvent(options) {
        var listener = {
            add: function(eventName) {
                function handleEvent() {
                    sendSize(options.eventName, options.eventType);
                }
                eventHandlersByName[eventName] = handleEvent;
                addEventListener(window, eventName, handleEvent, {
                    passive: true
                });
            },
            remove: function(eventName) {
                var handleEvent = eventHandlersByName[eventName];
                delete eventHandlersByName[eventName];
                removeEventListener(window, eventName, handleEvent);
            }
        };
        if (options.eventNames && Array.prototype.map) {
            options.eventName = options.eventNames[0];
            options.eventNames.map(listener[options.method]);
        } else listener[options.method](options.eventName);
        log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
    }
    function manageEventListeners(method) {
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Start',
            eventNames: [
                'animationstart',
                'webkitAnimationStart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation Iteration',
            eventNames: [
                'animationiteration',
                'webkitAnimationIteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Animation End',
            eventNames: [
                'animationend',
                'webkitAnimationEnd'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Input',
            eventName: 'input'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Up',
            eventName: 'mouseup'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Mouse Down',
            eventName: 'mousedown'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Orientation Change',
            eventName: 'orientationchange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Print',
            eventName: [
                'afterprint',
                'beforeprint'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Ready State Change',
            eventName: 'readystatechange'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Start',
            eventName: 'touchstart'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch End',
            eventName: 'touchend'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Touch Cancel',
            eventName: 'touchcancel'
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Start',
            eventNames: [
                'transitionstart',
                'webkitTransitionStart',
                'MSTransitionStart',
                'oTransitionStart',
                'otransitionstart'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition Iteration',
            eventNames: [
                'transitioniteration',
                'webkitTransitionIteration',
                'MSTransitionIteration',
                'oTransitionIteration',
                'otransitioniteration'
            ]
        });
        manageTriggerEvent({
            method: method,
            eventType: 'Transition End',
            eventNames: [
                'transitionend',
                'webkitTransitionEnd',
                'MSTransitionEnd',
                'oTransitionEnd',
                'otransitionend'
            ]
        });
        if ('child' === resizeFrom) manageTriggerEvent({
            method: method,
            eventType: 'IFrame Resized',
            eventName: 'resize'
        });
    }
    function checkCalcMode(calcMode, calcModeDefault, modes, type) {
        if (calcModeDefault !== calcMode) {
            if (!(calcMode in modes)) {
                warn(calcMode + ' is not a valid option for ' + type + 'CalculationMethod.');
                calcMode = calcModeDefault;
            }
            log(type + ' calculation method set to "' + calcMode + '"');
        }
        return calcMode;
    }
    function checkHeightMode() {
        heightCalcMode = checkCalcMode(heightCalcMode, heightCalcModeDefault, getHeight, 'height');
    }
    function checkWidthMode() {
        widthCalcMode = checkCalcMode(widthCalcMode, widthCalcModeDefault, getWidth, 'width');
    }
    function startEventListeners() {
        if (true === autoResize) {
            manageEventListeners('add');
            setupMutationObserver();
        } else log('Auto Resize disabled');
    }
    //   function stopMsgsToParent() {
    //     log('Disable outgoing messages')
    //     sendPermit = false
    //   }
    //   function removeMsgListener() {
    //     log('Remove event listener: Message')
    //     removeEventListener(window, 'message', receiver)
    //   }
    function disconnectMutationObserver() {
        if (null !== bodyObserver) /* istanbul ignore next */ // Not testable in PhantonJS
        bodyObserver.disconnect();
    }
    function stopEventListeners() {
        manageEventListeners('remove');
        disconnectMutationObserver();
        clearInterval(intervalTimer);
    }
    //   function teardown() {
    //     stopMsgsToParent()
    //     removeMsgListener()
    //     if (true === autoResize) stopEventListeners()
    //   }
    function injectClearFixIntoBodyElement() {
        var clearFix = document.createElement('div');
        clearFix.style.clear = 'both';
        // Guard against the following having been globally redefined in CSS.
        clearFix.style.display = 'block';
        clearFix.style.height = '0';
        document.body.appendChild(clearFix);
    }
    function setupInPageLinks() {
        function getPagePosition() {
            return {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
        }
        function getElementPosition(el) {
            var elPosition = el.getBoundingClientRect(), pagePosition = getPagePosition();
            return {
                x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
                y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
            };
        }
        function findTarget(location) {
            function jumpToTarget(target) {
                var jumpPosition = getElementPosition(target);
                log('Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            }
            var hash = location.split('#')[1] || location, hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (undefined !== target) jumpToTarget(target);
            else {
                log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
                sendMsg(0, 0, 'inPageLink', '#' + hash);
            }
        }
        function checkLocationHash() {
            var hash = window.location.hash;
            var href = window.location.href;
            if ('' !== hash && '#' !== hash) findTarget(href);
        }
        function bindAnchors() {
            function setupLink(el) {
                function linkClicked(e) {
                    e.preventDefault();
                    /* jshint validthis:true */ findTarget(this.getAttribute('href'));
                }
                if ('#' !== el.getAttribute('href')) addEventListener(el, 'click', linkClicked);
            }
            Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'), setupLink);
        }
        function bindLocationHash() {
            addEventListener(window, 'hashchange', checkLocationHash);
        }
        function initCheck() {
            // Check if page loaded with location hash after init resize
            setTimeout(checkLocationHash, eventCancelTimer);
        }
        function enableInPageLinks() {
            /* istanbul ignore else */ // Not testable in phantonJS
            if (Array.prototype.forEach && document.querySelectorAll) {
                log('Setting up location.hash handlers');
                bindAnchors();
                bindLocationHash();
                initCheck();
            } else warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
        }
        if (inPageLinks.enable) enableInPageLinks();
        else log('In page linking not enabled');
        return {
            findTarget: findTarget
        };
    }
    function setupMouseEvents() {
        if (mouseEvents !== true) return;
        function sendMouse(e) {
            sendMsg(0, 0, e.type, e.screenY + ':' + e.screenX);
        }
        function addMouseListener(evt, name) {
            log('Add event listener: ' + name);
            addEventListener(window.document, evt, sendMouse);
        }
        addMouseListener('mouseenter', 'Mouse Enter');
        addMouseListener('mouseleave', 'Mouse Leave');
    }
    function setupPublicMethods() {
        log('Enable public methods');
        win.parentIFrame = {
            autoResize: function autoResizeF(resize) {
                if (true === resize && false === autoResize) {
                    autoResize = true;
                    startEventListeners();
                } else if (false === resize && true === autoResize) {
                    autoResize = false;
                    stopEventListeners();
                }
                sendMsg(0, 0, 'autoResize', JSON.stringify(autoResize));
                return autoResize;
            },
            close: function closeF() {
                sendMsg(0, 0, 'close');
            // teardown()
            },
            getId: function getIdF() {
                return myID;
            },
            getPageInfo: function getPageInfoF(callback) {
                if ('function' === typeof callback) {
                    onPageInfo = callback;
                    sendMsg(0, 0, 'pageInfo');
                } else {
                    onPageInfo = function() {};
                    sendMsg(0, 0, 'pageInfoStop');
                }
            },
            moveToAnchor: function moveToAnchorF(hash) {
                inPageLinks.findTarget(hash);
            },
            reset: function resetF() {
                resetIFrame('parentIFrame.reset');
            },
            scrollTo: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
            },
            scrollToOffset: function scrollToF(x, y) {
                sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
            },
            sendMessage: function sendMessageF(msg, targetOrigin) {
                sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
            },
            setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
                heightCalcMode = heightCalculationMethod;
                checkHeightMode();
            },
            setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
                widthCalcMode = widthCalculationMethod;
                checkWidthMode();
            },
            setTargetOrigin: function setTargetOriginF(targetOrigin) {
                log('Set targetOrigin: ' + targetOrigin);
                targetOriginDefault = targetOrigin;
            },
            size: function sizeF(customHeight, customWidth) {
                var valString = '' + (customHeight || '') + (customWidth ? ',' + customWidth : '');
                sendSize('size', 'parentIFrame.size(' + valString + ')', customHeight, customWidth);
            }
        };
    }
    function initInterval() {
        if (0 !== interval) {
            log('setInterval: ' + interval + 'ms');
            intervalTimer = setInterval(function() {
                sendSize('interval', 'setInterval: ' + interval);
            }, Math.abs(interval));
        }
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function setupBodyMutationObserver() {
        function addImageLoadListners(mutation) {
            function addImageLoadListener(element) {
                if (false === element.complete) {
                    log('Attach listeners to ' + element.src);
                    element.addEventListener('load', imageLoaded, false);
                    element.addEventListener('error', imageError, false);
                    elements.push(element);
                }
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'src') addImageLoadListener(mutation.target);
            else if (mutation.type === 'childList') Array.prototype.forEach.call(mutation.target.querySelectorAll('img'), addImageLoadListener);
        }
        function removeFromArray(element) {
            elements.splice(elements.indexOf(element), 1);
        }
        function removeImageLoadListener(element) {
            log('Remove listeners from ' + element.src);
            element.removeEventListener('load', imageLoaded, false);
            element.removeEventListener('error', imageError, false);
            removeFromArray(element);
        }
        function imageEventTriggered(event, type, typeDesc) {
            removeImageLoadListener(event.target);
            sendSize(type, typeDesc + ': ' + event.target.src);
        }
        function imageLoaded(event) {
            imageEventTriggered(event, 'imageLoad', 'Image loaded');
        }
        function imageError(event) {
            imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
        }
        function mutationObserved(mutations) {
            sendSize('mutationObserver', 'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
            // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
            mutations.forEach(addImageLoadListners);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            };
            observer = new MutationObserver(mutationObserved);
            log('Create body MutationObserver');
            observer.observe(target, config);
            return observer;
        }
        var elements = [], MutationObserver = window.MutationObserver || window.WebKitMutationObserver, observer = createMutationObserver();
        return {
            disconnect: function() {
                if ('disconnect' in observer) {
                    log('Disconnect body MutationObserver');
                    observer.disconnect();
                    elements.forEach(removeImageLoadListener);
                }
            }
        };
    }
    function setupMutationObserver() {
        var forceIntervalTimer = 0 > interval;
        // Not testable in PhantomJS
        /* istanbul ignore if */ if (window.MutationObserver || window.WebKitMutationObserver) {
            if (forceIntervalTimer) initInterval();
            else bodyObserver = setupBodyMutationObserver();
        } else {
            log('MutationObserver not supported in this browser!');
            initInterval();
        }
    }
    // document.documentElement.offsetHeight is not reliable, so
    // we have to jump through hoops to get a better value.
    function getComputedStyle(prop, el) {
        var retVal = 0;
        el = el || document.body; // Not testable in phantonJS
        retVal = document.defaultView.getComputedStyle(el, null);
        retVal = null !== retVal ? retVal[prop] : 0;
        return parseInt(retVal, base);
    }
    function chkEventThottle(timer) {
        if (timer > throttledTimer / 2) {
            throttledTimer = 2 * timer;
            log('Event throttle increased to ' + throttledTimer + 'ms');
        }
    }
    // Idea from https://github.com/guardian/iframe-messenger
    function getMaxElement(side, elements) {
        var elementsLength = elements.length, elVal = 0, maxVal = 0, Side = capitalizeFirstLetter(side), timer = Date.now();
        for(var i = 0; i < elementsLength; i++){
            elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin' + Side, elements[i]);
            if (elVal > maxVal) maxVal = elVal;
        }
        timer = Date.now() - timer;
        log('Parsed ' + elementsLength + ' HTML elements');
        log('Element position calculated in ' + timer + 'ms');
        chkEventThottle(timer);
        return maxVal;
    }
    function getAllMeasurements(dimensions) {
        return [
            dimensions.bodyOffset(),
            dimensions.bodyScroll(),
            dimensions.documentElementOffset(),
            dimensions.documentElementScroll()
        ];
    }
    function getTaggedElements(side, tag) {
        function noTaggedElementsFound() {
            warn('No tagged elements (' + tag + ') found on page');
            return document.querySelectorAll('body *');
        }
        var elements = document.querySelectorAll('[' + tag + ']');
        if (elements.length === 0) noTaggedElementsFound();
        return getMaxElement(side, elements);
    }
    function getAllElements() {
        return document.querySelectorAll('body *');
    }
    var getHeight = {
        bodyOffset: function getBodyOffsetHeight() {
            return document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
        },
        offset: function() {
            return getHeight.bodyOffset() // Backwards compatability
            ;
        },
        bodyScroll: function getBodyScrollHeight() {
            return document.body.scrollHeight;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.height();
        },
        documentElementOffset: function getDEOffsetHeight() {
            return document.documentElement.offsetHeight;
        },
        documentElementScroll: function getDEScrollHeight() {
            return document.documentElement.scrollHeight;
        },
        max: function getMaxHeight() {
            return Math.max.apply(null, getAllMeasurements(getHeight));
        },
        min: function getMinHeight() {
            return Math.min.apply(null, getAllMeasurements(getHeight));
        },
        grow: function growHeight() {
            return getHeight.max() // Run max without the forced downsizing
            ;
        },
        lowestElement: function getBestHeight() {
            return Math.max(getHeight.bodyOffset() || getHeight.documentElementOffset(), getMaxElement('bottom', getAllElements()));
        },
        taggedElement: function getTaggedElementsHeight() {
            return getTaggedElements('bottom', 'data-iframe-height');
        }
    }, getWidth = {
        bodyScroll: function getBodyScrollWidth() {
            return document.body.scrollWidth;
        },
        bodyOffset: function getBodyOffsetWidth() {
            return document.body.offsetWidth;
        },
        custom: function getCustomWidth() {
            return customCalcMethods.width();
        },
        documentElementScroll: function getDEScrollWidth() {
            return document.documentElement.scrollWidth;
        },
        documentElementOffset: function getDEOffsetWidth() {
            return document.documentElement.offsetWidth;
        },
        scroll: function getMaxWidth() {
            return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
        },
        max: function getMaxWidth() {
            return Math.max.apply(null, getAllMeasurements(getWidth));
        },
        min: function getMinWidth() {
            return Math.min.apply(null, getAllMeasurements(getWidth));
        },
        rightMostElement: function rightMostElement() {
            return getMaxElement('right', getAllElements());
        },
        taggedElement: function getTaggedElementsWidth() {
            return getTaggedElements('right', 'data-iframe-width');
        }
    };
    function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function resizeIFrame() {
            height = currentHeight;
            width = currentWidth;
            sendMsg(height, width, triggerEvent);
        }
        function isSizeChangeDetected() {
            function checkTolarance(a, b) {
                var retVal = Math.abs(a - b) <= tolerance;
                return !retVal;
            }
            currentHeight = undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
            currentWidth = undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
            return checkTolarance(height, currentHeight) || calculateWidth && checkTolarance(width, currentWidth);
        }
        function isForceResizableEvent() {
            return !(triggerEvent in {
                init: 1,
                interval: 1,
                size: 1
            });
        }
        function isForceResizableCalcMode() {
            return heightCalcMode in resetRequiredMethods || calculateWidth && widthCalcMode in resetRequiredMethods;
        }
        function logIgnored() {
            log('No change in size detected');
        }
        function checkDownSizing() {
            if (isForceResizableEvent() && isForceResizableCalcMode()) resetIFrame(triggerEventDesc);
            else if (!(triggerEvent in {
                interval: 1
            })) logIgnored();
        }
        var currentHeight, currentWidth;
        if (isSizeChangeDetected() || 'init' === triggerEvent) {
            lockTrigger();
            resizeIFrame();
        } else checkDownSizing();
    }
    var sizeIFrameThrottled = throttle(sizeIFrame);
    function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
        function recordTrigger() {
            if (!(triggerEvent in {
                reset: 1,
                resetPage: 1,
                init: 1
            })) log('Trigger event: ' + triggerEventDesc);
        }
        function isDoubleFiredEvent() {
            return triggerLocked && triggerEvent in doubleEventList;
        }
        if (!isDoubleFiredEvent()) {
            recordTrigger();
            if (triggerEvent === 'init') sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
            else sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
        } else log('Trigger event cancelled: ' + triggerEvent);
    }
    function lockTrigger() {
        if (!triggerLocked) {
            triggerLocked = true;
            log('Trigger event lock on');
        }
        clearTimeout(triggerLockedTimer);
        triggerLockedTimer = setTimeout(function() {
            triggerLocked = false;
            log('Trigger event lock off');
            log('--');
        }, eventCancelTimer);
    }
    function triggerReset(triggerEvent) {
        height = getHeight[heightCalcMode]();
        width = getWidth[widthCalcMode]();
        sendMsg(height, width, triggerEvent);
    }
    function resetIFrame(triggerEventDesc) {
        var hcm = heightCalcMode;
        heightCalcMode = heightCalcModeDefault;
        log('Reset trigger event: ' + triggerEventDesc);
        lockTrigger();
        triggerReset('reset');
        heightCalcMode = hcm;
    }
    function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
        function setTargetOrigin() {
            if (undefined === targetOrigin) targetOrigin = targetOriginDefault;
            else log('Message targetOrigin: ' + targetOrigin);
        }
        function sendToParent() {
            var size = height + ':' + width, message = myID + ':' + size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
            log('Sending message to host page (' + message + ')');
            target.postMessage(msgID + message, targetOrigin);
        }
        if (true === sendPermit) {
            setTargetOrigin();
            sendToParent();
        }
    }
    function receiver(event) {
        var processRequestFromParent = {
            init: function initFromParent() {
                initMsg = event.data;
                target = event.source;
                init();
                firstRun = false;
                setTimeout(function() {
                    initLock = false;
                }, eventCancelTimer);
            },
            reset: function resetFromParent() {
                if (!initLock) {
                    log('Page size reset by host page');
                    triggerReset('resetPage');
                } else log('Page reset ignored by init');
            },
            resize: function resizeFromParent() {
                sendSize('resizeParent', 'Parent window requested size check');
            },
            moveToAnchor: function moveToAnchorF() {
                inPageLinks.findTarget(getData());
            },
            inPageLink: function inPageLinkF() {
                this.moveToAnchor();
            },
            pageInfo: function pageInfoFromParent() {
                var msgBody = getData();
                log('PageInfoFromParent called from parent: ' + msgBody);
                onPageInfo(JSON.parse(msgBody));
                log(' --');
            },
            message: function messageFromParent() {
                var msgBody = getData();
                log('onMessage called from parent: ' + msgBody);
                // eslint-disable-next-line sonarjs/no-extra-arguments
                onMessage(JSON.parse(msgBody));
                log(' --');
            }
        };
        function isMessageForUs() {
            return msgID === ('' + event.data).substr(0, msgIdLen) // ''+ Protects against non-string messages
            ;
        }
        function getMessageType() {
            return event.data.split(']')[1].split(':')[0];
        }
        function getData() {
            return event.data.substr(event.data.indexOf(':') + 1);
        }
        function isMiddleTier() {
            return !module.exports && 'iFrameResize' in window || 'jQuery' in window && 'iFrameResize' in window.jQuery.prototype;
        }
        function isInitMsg() {
            // Test if this message is from a child below us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            return event.data.split(':')[2] in {
                true: 1,
                false: 1
            };
        }
        function callFromParent() {
            var messageType = getMessageType();
            if (messageType in processRequestFromParent) processRequestFromParent[messageType]();
            else if (!isMiddleTier() && !isInitMsg()) warn('Unexpected message (' + event.data + ')');
        }
        function processMessage() {
            if (false === firstRun) callFromParent();
            else if (isInitMsg()) processRequestFromParent.init();
            else log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
        }
        if (isMessageForUs()) processMessage();
    }
    // Normally the parent kicks things off when it detects the iFrame has loaded.
    // If this script is async-loaded, then tell parent page to retry init.
    function chkLateLoaded() {
        if ('loading' !== document.readyState) window.parent.postMessage('[iFrameResizerChild]Ready', '*');
    }
    addEventListener(window, 'message', receiver);
    addEventListener(window, 'readystatechange', chkLateLoaded);
    chkLateLoaded();
})();

});

parcelRegister("7KMPr", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $ijfiP = parcelRequire("ijfiP");


var $kaOT1 = parcelRequire("kaOT1");

const $9de26c8889125530$var$packageVersion = "0.0.0-use.local";
const $9de26c8889125530$export$bb9823fd3fb51f9c = 'https://1210cfc4338849588134f2c80b99f75c@o55978.ingest.sentry.io/5988824';
const $9de26c8889125530$export$b7f7efe8cd791eed = 'https://a377d38318350e08236b26b7b13c8016@sentry.atlassian-us-gov-mod.com/23';

const $9de26c8889125530$export$faf06bc0661c564c = async ({ error: error, environment: environment, errorExtensionDetails: errorExtensionDetails, page: page, errorInfo: errorInfo, tracing: tracing })=>{
    try {
        const module = await Promise.resolve((parcelRequire("7hGsm")));
        const { BrowserClient: BrowserClient, Hub: Hub } = module;
        // From https://sentry.io/settings/atlassian-2y/projects/forge-ui/keys/ and https://sentry.prod.services.kitt-inf-us-gov-mod.net/settings/sentry/projects/forge-ui/keys
        const dsn = (0, $lzcvT.isFedRamp)() ? $9de26c8889125530$export$b7f7efe8cd791eed : $9de26c8889125530$export$bb9823fd3fb51f9c;
        const client = new BrowserClient({
            environment: environment,
            dsn: dsn,
            release: `forge-ui@${$9de26c8889125530$var$packageVersion}`
        });
        const hub = new Hub(client);
        hub.withScope(async (scope)=>{
            if (tracing) {
                const breadcrumbs = tracing.getBreadcrumbs();
                breadcrumbs.forEach((bc)=>scope.addBreadcrumb(bc, 20));
            }
            if (errorInfo) scope.setExtra('componentTrace', {
                errorInfo: errorInfo,
                componentStack: errorInfo?.componentStack?.substring(0, 1000)
            });
            scope.setTag('extensionPoint', page);
            if (errorExtensionDetails) {
                scope.setExtra('extensionProperties', errorExtensionDetails.properties);
                try {
                    const appIdFromId = (0, $ijfiP.parseExtensionId)(errorExtensionDetails.id ?? '').appId;
                    if (appIdFromId) scope.setTag('appId', appIdFromId);
                } catch (e) {
                // parseExtensionId() uses parse() form @atlassian/cs-ari, which throws an error if the ID is not valid
                }
                if (errorExtensionDetails.environmentType) scope.setTag('forgeEnvironment', errorExtensionDetails.environmentType);
                if (errorExtensionDetails.type) scope.setTag('extensionType', errorExtensionDetails.type);
                if (errorExtensionDetails.appOwnerAccountId) scope.setTag('appOwner', errorExtensionDetails.appOwnerAccountId);
            }
            hub.captureException(error);
        });
        return client.close();
    } catch (e) {
    // Error reporting failed, we don't want to cause a unhandledrejection event
    }
};
module.exports["captureAndReportError"] = $9de26c8889125530$export$faf06bc0661c564c;

});

parcelRegister("6oQb1", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");


var $5U2YR = parcelRequire("5U2YR");


var $3Spjc = parcelRequire("3Spjc");


var $hQK66 = parcelRequire("hQK66");


var $dh538 = parcelRequire("dh538");


var $7oKJR = parcelRequire("7oKJR");


var $ly9ul = parcelRequire("ly9ul");

const $eccfed1aa8771b08$export$43835e9acf248a15 = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, source: source, attributes: attributes }, options)=>{
    const { sampleRate: sampleRate, filter: filter } = options ?? {};
    // If a sample rate is provided, we can use it to determine whether to fire the event
    if (sampleRate) {
        const randomValue = Math.random();
        if (randomValue > sampleRate) return; // Don't fire the event
    }
    const event = createAnalyticsEvent({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes,
            source: source,
            tags: [
                'forge'
            ]
        }
    });
    // Don't fire the event if there's a filter and event does not pass it
    if (filter && !filter(event)) return;
    event.fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
};
const $eccfed1aa8771b08$export$7eca133280843f9e = (createAnalyticsEvent, { action: action, actionSubject: actionSubject, attributes: attributes })=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        data: {
            action: action,
            actionSubject: actionSubject,
            attributes: attributes
        }
    }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
};
// Ideally this should be removed entirely in the future.
// see: https://hello.atlassian.net/wiki/spaces/ECO/pages/5687458412/Why+is+GASv3+Event+Costs+and+Volumes+Climbing+Cost+Saving+Proposal
const $eccfed1aa8771b08$var$legacyTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
// We limit the type of bridge methods we track to only the ones we are analysing in databricks to avoid sending too many events
const $eccfed1aa8771b08$var$allowedBridgeMethods = {
    navigate: {
        allowed: true,
        options: {
            sampleRate: 0.1
        }
    },
    openRovo: {
        allowed: true
    },
    isRovoEnabled: {
        allowed: true
    },
    // PIR-30455: The following three methods (openModal, close, onClose) are temporarily tracked as we have a high frequency of changes to the modal extension points
    // TODO cleanup: https://ecosystem-platform.atlassian.net/browse/EXT-4533
    openModal: {
        allowed: true
    },
    close: {
        allowed: true
    },
    onClose: {
        allowed: true
    }
};
const $eccfed1aa8771b08$var$optimisedTrackBridgeSucceed = (createAnalyticsEvent, { source: source, method: method, additionalAttributes: additionalAttributes, forgeEnvironment: forgeEnvironment })=>{
    if ($eccfed1aa8771b08$var$allowedBridgeMethods[method]?.allowed) $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    }, $eccfed1aa8771b08$var$allowedBridgeMethods[method]?.options);
};
const $eccfed1aa8771b08$var$trackForgeFeatureFlagEvent = (createAnalyticsEvent, { source: source, appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: eventType,
        actionSubject: 'forge.ui.feature_flag',
        source: source,
        attributes: {
            appType: appType,
            baseUrl: baseUrl,
            appId: appId,
            flagName: flagName,
            eventType: eventType,
            success: success,
            featureFlagEnv: featureFlagEnv,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $eccfed1aa8771b08$var$trackObjectStoreAction = (createAnalyticsEvent, { source: source, appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.object_store',
        source: source,
        attributes: {
            appType: appType,
            appId: appId,
            forgeEnvironment: forgeEnvironment
        }
    });
};
const $eccfed1aa8771b08$var$trackPermissionAction = (createAnalyticsEvent, { source: source, appId: appId, installationId: installationId, action: action })=>{
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: action,
        actionSubject: 'forge.ui.permission',
        source: source,
        attributes: {
            appId: appId,
            installationId: installationId
        }
    });
};
const $eccfed1aa8771b08$export$f4ca3aaa7a36404 = (createAnalyticsEvent, payload)=>(0, $dh538.fg)('forge-ui-event-cost-optimisation') ? $eccfed1aa8771b08$var$optimisedTrackBridgeSucceed(createAnalyticsEvent, payload) : $eccfed1aa8771b08$var$legacyTrackBridgeSucceed(createAnalyticsEvent, payload);
const $eccfed1aa8771b08$export$5c425ded9b0e7602 = (createAnalyticsEvent, { source: source, errorName: errorName, method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            ...additionalAttributes ?? {},
            error: errorName,
            method: method,
            forgeEnvironment: forgeEnvironment
        }
    });
const $eccfed1aa8771b08$export$d84d2f0ce1c82c0 = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.analytics.component_usage',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            components: components,
            forgeReactMajorVersion: forgeReactMajorVersion
        }
    });
const $eccfed1aa8771b08$export$7e97f0f47f75f097 = (createAnalyticsEvent, { source: source, target: target })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rendered',
        actionSubject: 'forge.ui.renderer',
        source: source,
        attributes: {
            target: target
        }
    });
const $eccfed1aa8771b08$var$trackExtensionLoaded = (createAnalyticsEvent, { source: source, forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting, viewportSize: viewportSize })=>{
    const options = (0, $dh538.fg)('forge-ui-event-cost-optimisation') ? {
        filter: (0, $7oKJR.extensionLoadedEventFilter)
    } : undefined;
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'loaded',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            forgeEnvironment: forgeEnvironment,
            renderType: renderType,
            extensionType: extensionType,
            isConfiguring: isConfiguring,
            isInserting: isInserting,
            viewportSize: viewportSize
        }
    }, options);
};
const $eccfed1aa8771b08$var$trackExtensionRemounted = (createAnalyticsEvent, { source: source, mountCount: mountCount, isUseBridgeReinit: isUseBridgeReinit })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'remounted',
        actionSubject: 'forge.ui.extension',
        source: source,
        attributes: {
            mountCount: mountCount,
            isUseBridgeReinit: isUseBridgeReinit
        }
    });
const $eccfed1aa8771b08$var$trackHandShakeMetric = (createAnalyticsEvent, { source: source, success: success, error: error })=>{
    if (error) $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'failed',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            target: 'handshake',
            success: success,
            reason: error instanceof Error ? error.message : 'Unknown error',
            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
        }
    });
    else // Sample 10% of the events to reduce the costs
    // We only need 10% of the good events for the same SLO target
    $eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'succeeded',
        actionSubject: 'forge.ui.bridge',
        source: source,
        attributes: {
            target: 'handshake',
            success: success
        }
    }, {
        sampleRate: 0.1
    });
};
const $eccfed1aa8771b08$export$b6445106a2f749a7 = (createAnalyticsEvent, { source: source, extensionId: extensionId, reason: reason })=>$eccfed1aa8771b08$export$43835e9acf248a15(createAnalyticsEvent, {
        action: 'rejected',
        actionSubject: 'forge.ui.embedded_macro',
        source: source,
        attributes: {
            extensionId: extensionId,
            extensionType: 'xen:macro',
            reason: reason
        }
    });
const $eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers = ({ createAnalyticsEvent: createAnalyticsEvent, source: source })=>{
    return {
        trackHandShakeMetric: ({ source: source, success: success, error: error })=>$eccfed1aa8771b08$var$trackHandShakeMetric(createAnalyticsEvent, {
                source: source,
                success: success,
                error: error
            }),
        trackComponentUsageRendered: ({ forgeEnvironment: forgeEnvironment, components: components, forgeReactMajorVersion: forgeReactMajorVersion })=>$eccfed1aa8771b08$export$d84d2f0ce1c82c0(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                components: components,
                forgeReactMajorVersion: forgeReactMajorVersion
            }),
        trackRendererRendered: ({ target: target })=>$eccfed1aa8771b08$export$7e97f0f47f75f097(createAnalyticsEvent, {
                source: source,
                target: target
            }),
        trackExtensionLoaded: ({ forgeEnvironment: forgeEnvironment, renderType: renderType, extensionType: extensionType, isConfiguring: isConfiguring, isInserting: isInserting, viewportSize: viewportSize })=>$eccfed1aa8771b08$var$trackExtensionLoaded(createAnalyticsEvent, {
                source: source,
                forgeEnvironment: forgeEnvironment,
                renderType: renderType,
                extensionType: extensionType,
                isConfiguring: isConfiguring,
                isInserting: isInserting,
                viewportSize: viewportSize
            }),
        trackExtensionRemounted: ({ mountCount: mountCount })=>$eccfed1aa8771b08$var$trackExtensionRemounted(createAnalyticsEvent, {
                source: source,
                mountCount: mountCount
            }),
        trackBridgeSucceed: ({ method: method, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$f4ca3aaa7a36404(createAnalyticsEvent, {
                source: source,
                method: method,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: additionalAttributes
            }),
        trackBridgeFailed: ({ method: method, errorName: errorName, forgeEnvironment: forgeEnvironment, additionalAttributes: additionalAttributes })=>$eccfed1aa8771b08$export$5c425ded9b0e7602(createAnalyticsEvent, {
                source: source,
                errorName: errorName,
                method: method,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: additionalAttributes
            }),
        trackForgeFeatureFlagEvent: ({ appType: appType, baseUrl: baseUrl, appId: appId, flagName: flagName, eventType: eventType, success: success, featureFlagEnv: featureFlagEnv, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackForgeFeatureFlagEvent(createAnalyticsEvent, {
                source: source,
                appType: appType,
                baseUrl: baseUrl,
                appId: appId,
                flagName: flagName,
                eventType: eventType,
                success: success,
                featureFlagEnv: featureFlagEnv,
                forgeEnvironment: forgeEnvironment
            }),
        trackObjectStoreAction: ({ appType: appType, appId: appId, action: action, forgeEnvironment: forgeEnvironment })=>$eccfed1aa8771b08$var$trackObjectStoreAction(createAnalyticsEvent, {
                source: source,
                appType: appType,
                appId: appId,
                action: action,
                forgeEnvironment: forgeEnvironment
            }),
        trackPermissionAction: ({ appId: appId, installationId: installationId, action: action })=>$eccfed1aa8771b08$var$trackPermissionAction(createAnalyticsEvent, {
                source: source,
                appId: appId,
                installationId: installationId,
                action: action
            })
    };
};
const $eccfed1aa8771b08$export$4b165c4db6e19dc5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const cachedTrackers = (0, $hQK66.useMemoOne)(()=>$eccfed1aa8771b08$var$createForgeUiAnalyticsEventTrackers({
            createAnalyticsEvent: createAnalyticsEvent,
            source: source
        }), [
        createAnalyticsEvent,
        source
    ]);
    return cachedTrackers;
};
module.exports["fireEvent"] = $eccfed1aa8771b08$export$43835e9acf248a15;
module.exports["fireUIEvent"] = $eccfed1aa8771b08$export$7eca133280843f9e;
module.exports["trackBridgeSucceed"] = $eccfed1aa8771b08$export$f4ca3aaa7a36404;
module.exports["trackBridgeFailed"] = $eccfed1aa8771b08$export$5c425ded9b0e7602;
module.exports["trackComponentUsageRendered"] = $eccfed1aa8771b08$export$d84d2f0ce1c82c0;
module.exports["trackRendererRendered"] = $eccfed1aa8771b08$export$7e97f0f47f75f097;
module.exports["trackEmbeddedMacroRejected"] = $eccfed1aa8771b08$export$b6445106a2f749a7;
module.exports["useForgeUiAnalyticsEvent"] = $eccfed1aa8771b08$export$4b165c4db6e19dc5;

});

parcelRegister("luNHV", function(module, exports) {
// This prefix is also used in ConfigPanelFieldsLoader.tsx in the
// @atlaskit/editor-plugin-extension package. The Editor package is public, so it
// cannot import this constant from @atlassian/forge-ui. Do not update this prefix
// without also doing so in the Editor package.
const $6d065658f7ab57e8$var$EVENT_PREFIX = 'forge.bridge.';
function $6d065658f7ab57e8$export$af631764ddc44097(event, callback, extension) {
    const wrappedCallback = (e)=>{
        if (!extension || !e.detail?.extension || extension.id === e.detail?.extension?.id && extension.installationId === e.detail?.extension?.installationId) callback(e.detail?.payload, e.detail?.extension);
    };
    window.document.addEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
}
const $6d065658f7ab57e8$export$2b8594f1cc80daad = (event, callback, extension)=>{
    const wrappedCallback = (e)=>{
        const allowedRecipients = e.detail?.allowedRecipients || [];
        if (allowedRecipients.includes('*') || allowedRecipients.includes(extension.appId)) callback(e.detail?.payload);
    };
    window.document.addEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback);
    return {
        unsubscribe: ()=>window.document.removeEventListener(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, wrappedCallback)
    };
};
function $6d065658f7ab57e8$export$8f35fbd5db0f3634(event, payload, extension) {
    const newEvent = new CustomEvent(`${$6d065658f7ab57e8$var$EVENT_PREFIX}${event}`, {
        detail: {
            extension: extension,
            payload: payload
        }
    });
    window.document.dispatchEvent(newEvent);
} // emitPublic is implemented in useEmitPublicEvent hook
module.exports["on"] = $6d065658f7ab57e8$export$af631764ddc44097;
module.exports["onPublic"] = $6d065658f7ab57e8$export$2b8594f1cc80daad;
module.exports["emit"] = $6d065658f7ab57e8$export$8f35fbd5db0f3634;

});

parcelRegister("iqcSr", function(module, exports) {
const $017ffa7c15d62dd2$export$4c5241daa4566af8 = (extension, entryPoint)=>{
    const { render: render, resource: resource } = extension.properties;
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
        return entryPointResource != null && entryPointRender !== 'native';
    }
    return resource != null && render !== 'native';
};
module.exports["isCustomUI"] = $017ffa7c15d62dd2$export$4c5241daa4566af8;

});

parcelRegister("fYGGr", function(module, exports) {
/**
 * @generated SignedSource<<df9226959da23dd7fa622e272bfcaf01>>
 * @relayHash 10bf7b8f8a0a27b56d7488a90abd1f4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15591e3b366a8b1e0b52de49b0cb781b2c83797c2deaf3b53bc2216d78467042
const $4a1f59567f907cdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dataClassificationTags"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "environmentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "environmentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "environmentKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "AppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            },
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
            },
            {
                "kind": "ScalarField",
                "name": "trialEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "isEvaluation"
            },
            {
                "kind": "ScalarField",
                "name": "billingPeriod"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
            },
            {
                "kind": "ScalarField",
                "name": "capabilitySet"
            },
            {
                "kind": "ScalarField",
                "name": "modes"
            }
        ]
    }, v16 = {
        "concreteType": "UserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "enabled"
            },
            {
                "kind": "ScalarField",
                "name": "hasAccess"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "appVersion"
    }, v18 = {
        "kind": "ScalarField",
        "name": "installationId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "migrationKey"
    }, v20 = {
        "concreteType": "EcosystemAppInstallationConfigExtension",
        "kind": "LinkedField",
        "name": "installationConfig",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v21 = {
        "concreteType": "AppNetworkEgressPermissionExtension",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "addresses"
            },
            {
                "kind": "ScalarField",
                "name": "category"
            },
            {
                "kind": "ScalarField",
                "name": "inScopeEUD"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "scopes"
    }, v23 = {
        "kind": "ScalarField",
        "name": "consentUrl"
    }, v24 = {
        "concreteType": "UserConsentExtension",
        "kind": "LinkedField",
        "name": "currentUserConsent",
        "plural": false,
        "selections": [
            {
                "concreteType": "UserConsentExtensionUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "aaid"
                    }
                ]
            },
            {
                "concreteType": "UserConsentExtensionAppEnvironmentVersion",
                "kind": "LinkedField",
                "name": "appEnvironmentVersion",
                "plural": false,
                "selections": [
                    v5 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "consentedAt"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "requiresUserConsent"
    }, v26 = {
        "args": [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "dataClassificationTags",
                        "variableName": "dataClassificationTags"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            }
        ],
        "concreteType": "DataClassificationPolicyDecision",
        "kind": "LinkedField",
        "name": "dataClassificationPolicyDecision",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getForgeUIExtensionsAsync_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getForgeUIExtensionsAsync_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "15591e3b366a8b1e0b52de49b0cb781b2c83797c2deaf3b53bc2216d78467042",
            "metadata": {},
            "name": "getForgeUIExtensionsAsync_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4a1f59567f907cdf$var$node.hash = "0d2f8184c249f6d367df44b3d6f390eb";
var $4a1f59567f907cdf$export$2e2bcd8739ae039 = $4a1f59567f907cdf$var$node;


/**
 * @generated SignedSource<<b2fc6df79e32b6847e806445e127d084>>
 * @relayHash 5d987a62c02b64e7e7a5988082fb62f2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 890af040690b65aacfb01bbd1fe559d9974962954f4033400b4cc47cbb56e0ae
const $985615f75add3776$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "890af040690b65aacfb01bbd1fe559d9974962954f4033400b4cc47cbb56e0ae",
            "metadata": {},
            "name": "getForgeUIExtensionsAsync_prefetchedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$985615f75add3776$var$node.hash = "28b01d2e9aae97b40422b2e1e799d7e9";
var $985615f75add3776$export$2e2bcd8739ae039 = $985615f75add3776$var$node;



var $irOoi = parcelRequire("irOoi");


var $bsX2q = parcelRequire("bsX2q");

var $7zIsq = parcelRequire("7zIsq");


var $39Ajm = parcelRequire("39Ajm");


var $1Igmn = parcelRequire("1Igmn");

const $cf16612a3c00cd2e$export$f276dc1a7d0b17c5 = async ({ client: client, contextIds: contextIds, moduleType: moduleType, context: context, queryOptions: queryOptions, expandAppOwner: expandAppOwner, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false })=>{
    if (bypassNewForgeExtensionListCall === false) {
        const types = moduleType ? [
            moduleType
        ] : [];
        const requestOptions = (0, $7zIsq.createUsePrefilteredExtensionListQueryOptions)(cloudId ?? contextIds[0], context ?? {}, client, types, locale, includeHidden, queryOptions, contextIds);
        const { fetchPolicy: fetchPolicy, ...rest } = requestOptions;
        const { loading: loading, data: data, errors: errors } = await client.query({
            ...rest,
            query: (0, $39Ajm.FetchPreFilteredForgeAppsQuery),
            fetchPolicy: fetchPolicy === 'cache-and-network' ? 'network-only' : fetchPolicy
        });
        const extensions = (0, $7zIsq.getPrefilteredExtensionsGQLResult)({
            loading: loading,
            data: data
        });
        return {
            extensions: extensions,
            errors: errors
        };
    } else {
        const requestOptions = (0, $bsX2q.createExtensionListQueryOptions)(client, contextIds, queryOptions, expandAppOwner, extensionsFilter, moduleType, dataClassificationTagIds, locale);
        const queryResult = await client.query(requestOptions);
        return {
            extensions: (0, $bsX2q.getExtensionsFromGQLResult)(queryResult),
            errors: queryResult.errors
        };
    }
};
const $cf16612a3c00cd2e$export$d9a2a57bbfd1461b = async ({ contextIds: contextIds, moduleType: moduleType, context: context, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, cloudId: cloudId, includeHidden: includeHidden, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall = false, relayEnvironment: relayEnvironment })=>{
    if (!relayEnvironment) return {
        extensions: null,
        errors: [
            new Error('Relay environment is required for getForgeUIExtensionsRelayAsync')
        ]
    };
    if (!bypassNewForgeExtensionListCall) {
        const types = moduleType ? [
            moduleType
        ] : [];
        return new Promise((resolve)=>{
            (0, $irOoi.fetchQuery)(relayEnvironment, (0, $985615f75add3776$export$2e2bcd8739ae039), {
                cloudId: cloudId ?? contextIds[0],
                // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                context: context ?? {},
                includeHidden: includeHidden,
                locale: locale,
                types: types
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(cloudId)
                        },
                        allowOnExternalPage: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const extensions = (0, $7zIsq.getPrefilteredExtensionsGQLResult)({
                        data: data,
                        loading: false
                    });
                    resolve({
                        extensions: extensions
                    });
                },
                error: (error)=>{
                    resolve({
                        errors: [
                            error
                        ],
                        extensions: null
                    });
                }
            });
        });
    }
    const filter = extensionsFilter ?? [
        {
            type: 'EXTENSION_TYPE',
            value: [
                moduleType
            ]
        }
    ];
    return new Promise((resolve)=>{
        (0, $irOoi.fetchQuery)(relayEnvironment, (0, $4a1f59567f907cdf$export$2e2bcd8739ae039), {
            contextIds: contextIds,
            locale: locale,
            filter: filter,
            dataClassificationTags: dataClassificationTagIds || []
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                const extensions = (0, $bsX2q.getExtensionsFromGQLResult)({
                    data: data,
                    loading: false
                });
                resolve({
                    extensions: extensions
                });
            },
            error: (error)=>{
                resolve({
                    errors: [
                        error
                    ],
                    extensions: null
                });
            }
        });
    });
};
module.exports["getForgeUIExtensionsRelayAsync"] = $cf16612a3c00cd2e$export$d9a2a57bbfd1461b;

});

parcelRegister("1uzCd", function(module, exports) {
const $3034561136ba9291$export$a728e3e4d9df1392 = ()=>{
    if (!performance) return 0;
    return Math.trunc(performance.now());
};
module.exports["getPerformanceMark"] = $3034561136ba9291$export$a728e3e4d9df1392;

});

parcelRegister("iUjrf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eI4ye = parcelRequire("eI4ye");


var $dh538 = parcelRequire("dh538");


var $gLLcz = parcelRequire("gLLcz");

const $169953af4b6e4ccf$export$8da39d297b8df514 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('click')
}).strip();
const $169953af4b6e4ccf$export$1226cd123c17e5c1 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('navigation-timing'),
    transferSize: (0, $gLLcz.z).number().nonnegative().finite(),
    duration: (0, $gLLcz.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$var$initiatorTypeValues = (0, $gLLcz.z).enum([
    'script',
    'fetch',
    'css',
    'link',
    'iframe',
    'img',
    'image',
    'xmlhttprequest',
    'other'
]);
const $169953af4b6e4ccf$export$53d51f558d70545c = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('resource-timing'),
    start: (0, $gLLcz.z).number().nonnegative().finite(),
    duration: (0, $gLLcz.z).number().nonnegative().finite(),
    transferSize: (0, $gLLcz.z).number().nonnegative().finite(),
    initiatorType: (0, $gLLcz.z).string().pipe($169953af4b6e4ccf$var$initiatorTypeValues.catch($169953af4b6e4ccf$var$initiatorTypeValues.Values.other)).pipe((0, $gLLcz.z).string())
}).strict();
const $169953af4b6e4ccf$export$dcaedcbfb2a9bf04 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('dcls-score'),
    score: (0, $gLLcz.z).number().nonnegative().finite(),
    timestamp: (0, $gLLcz.z).number().nonnegative().finite(),
    inputFlag: (0, $gLLcz.z).boolean()
}).strict();
const $169953af4b6e4ccf$export$ea631521a752c0a8 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('fcp-snapshot'),
    start: (0, $gLLcz.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$export$23e438485c66108 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('lcp-snapshot'),
    size: (0, $gLLcz.z).number().nonnegative().finite(),
    start: (0, $gLLcz.z).number().nonnegative().finite()
}).strict();
const $169953af4b6e4ccf$var$serialisableValueSchema = (0, $gLLcz.z).lazy(()=>(0, $gLLcz.z).union([
        (0, $gLLcz.z).string(),
        (0, $gLLcz.z).number().finite(),
        (0, $gLLcz.z).boolean(),
        (0, $gLLcz.z).null(),
        (0, $gLLcz.z).array($169953af4b6e4ccf$var$serialisableValueSchema),
        (0, $gLLcz.z).record((0, $gLLcz.z).string(), $169953af4b6e4ccf$var$serialisableValueSchema)
    ]));
const $169953af4b6e4ccf$export$a4b565c65b9cd65 = (0, $gLLcz.z).object({
    event: (0, $gLLcz.z).literal('ufo-event'),
    name: (0, $gLLcz.z).string().min(1).max(256),
    payload: (0, $gLLcz.z).record((0, $gLLcz.z).string(), $169953af4b6e4ccf$var$serialisableValueSchema)
}).strict();
const $169953af4b6e4ccf$export$d659b0ed364a2533 = (0, $gLLcz.z).discriminatedUnion('event', [
    $169953af4b6e4ccf$export$8da39d297b8df514,
    $169953af4b6e4ccf$export$1226cd123c17e5c1,
    $169953af4b6e4ccf$export$53d51f558d70545c,
    $169953af4b6e4ccf$export$dcaedcbfb2a9bf04,
    $169953af4b6e4ccf$export$ea631521a752c0a8,
    $169953af4b6e4ccf$export$23e438485c66108,
    $169953af4b6e4ccf$export$a4b565c65b9cd65
]);



var $1uzCd = parcelRequire("1uzCd");

const $e9d25c3abed1c1e7$var$ClickedProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$8da39d297b8df514).transform((_)=>{
    return {
        type: 'user-interacted',
        elapsed: (0, $1uzCd.getPerformanceMark)()
    };
});
const $e9d25c3abed1c1e7$var$NavigationTimingProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$1226cd123c17e5c1).transform((e)=>{
    return {
        type: 'navigation-timing',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        duration: Math.trunc(e.duration),
        transferSize: e.transferSize
    };
});
const $e9d25c3abed1c1e7$var$ResourceTimingProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$53d51f558d70545c).transform((e)=>{
    return {
        type: 'resource-timing',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start),
        duration: Math.trunc(e.duration),
        transferSize: Math.trunc(e.transferSize),
        initiatorType: e.initiatorType
    };
});
const $e9d25c3abed1c1e7$var$LayoutShiftProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$dcaedcbfb2a9bf04).transform((e)=>{
    return {
        type: 'dcls-score',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        timestamp: Math.trunc(e.timestamp),
        // Transport 2dp truncated to avoid precision errors.
        score: Math.trunc(e.score * 100),
        inputFlag: e.inputFlag
    };
});
const $e9d25c3abed1c1e7$var$FCPProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$ea631521a752c0a8).transform((e)=>{
    return {
        type: 'fcp-snapshot',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start)
    };
});
const $e9d25c3abed1c1e7$var$LCPProfilingCapturableEventTransform = (0, $169953af4b6e4ccf$export$23e438485c66108).transform((e)=>{
    return {
        type: 'lcp-snapshot',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        start: Math.trunc(e.start),
        size: Math.trunc(e.size)
    };
});
const $e9d25c3abed1c1e7$var$UFOFrameCapturableEventTransform = (0, $169953af4b6e4ccf$export$a4b565c65b9cd65).transform((e)=>({
        type: 'ufo-event',
        elapsed: (0, $1uzCd.getPerformanceMark)(),
        name: e.name,
        payload: e.payload
    }));
// For each in-frame event type, there should be a transformer to a safely ingestible event.
const $e9d25c3abed1c1e7$var$transformers = {
    'navigation-timing': $e9d25c3abed1c1e7$var$NavigationTimingProfilingCapturableEventTransform,
    'resource-timing': $e9d25c3abed1c1e7$var$ResourceTimingProfilingCapturableEventTransform,
    'dcls-score': $e9d25c3abed1c1e7$var$LayoutShiftProfilingCapturableEventTransform,
    click: $e9d25c3abed1c1e7$var$ClickedProfilingCapturableEventTransform,
    'fcp-snapshot': $e9d25c3abed1c1e7$var$FCPProfilingCapturableEventTransform,
    'lcp-snapshot': $e9d25c3abed1c1e7$var$LCPProfilingCapturableEventTransform,
    'ufo-event': $e9d25c3abed1c1e7$var$UFOFrameCapturableEventTransform
};
const $e9d25c3abed1c1e7$export$d85e1d6e65aaba29 = (0, $169953af4b6e4ccf$export$d659b0ed364a2533).transform((e)=>$e9d25c3abed1c1e7$var$transformers[e.event].parse(e));


const $031ec269e4b6a566$export$a8c9835719b09864 = ()=>{
    const timelineRef = (0, $42omo.useContext)((0, $eI4ye.PerformanceAnalyticsContext));
    // Use for out-of-frame capture in platform code.
    const captureEvent = (0, $42omo.useCallback)((event)=>{
        if (!(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled') || !timelineRef?.current) return;
        if (event.type === 'ufo-event' && !(0, $dh538.fg)('forge-ui-ufo-frame-event-support')) return;
        timelineRef.current.events.push(event);
        timelineRef.current.listeners.forEach((listener)=>listener(event));
    }, [
        timelineRef
    ]);
    // Use for capturing events from untrusted sources (e.g. in-frame via bridge).
    const captureUntrustedEvent = (0, $42omo.useCallback)((event)=>{
        if (!(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) return;
        const result = (0, $e9d25c3abed1c1e7$export$d85e1d6e65aaba29).safeParse(event);
        if (!result.success) // TODO: log failed validations to detect contract mismatches/tampering.
        return;
        captureEvent(result.data);
    }, [
        captureEvent
    ]);
    return {
        captureEvent: captureEvent,
        captureUntrustedEvent: captureUntrustedEvent
    };
};
module.exports["usePerformanceAnalytics"] = $031ec269e4b6a566$export$a8c9835719b09864;

});

parcelRegister("kZjf5", function(module, exports) {
/* useNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Faxc = parcelRequire("3Faxc");


var $6xdDU = parcelRequire("6xdDU");


var $3Spjc = parcelRequire("3Spjc");


var $kxKUs = parcelRequire("kxKUs");


var $i5CVI = parcelRequire("i5CVI");


var $2kGKp = parcelRequire("2kGKp");


var $lMJg3 = parcelRequire("lMJg3");


var $kTcrU = parcelRequire("kTcrU");


var $9v4R2 = parcelRequire("9v4R2");

function $c92260a0208e3eb8$export$d0fd4b7106de2769({ extension: extension, push: push }) {
    const [modalState, setModalState] = (0, $42omo.useState)({
        state: 'closed'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const egressService = (0, $lMJg3.useEgressPermissionService)('FETCH_CLIENT_SIDE', extension.egress);
    return {
        onNavigate: async ({ type: type, url: urlString })=>{
            const url = (0, $kTcrU.makeUrl)(urlString);
            const linkType = $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService);
            if (linkType === 'invalid' || !url) throw new (0, $kxKUs.BridgeClientError)(`link is invalid: ${urlString}`);
            if (linkType === 'trusted') {
                (0, $i5CVI.navigate)(url.href, type, push);
                return;
            }
            const analyticsAttributes = $c92260a0208e3eb8$export$e748b6351ba5f204(url);
            return new Promise((resolve, reject)=>{
                // TODO: remove this event once we have switched over to the new event schema
                // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                createAnalyticsEvent({
                    eventType: (0, $7TH2w.UI_EVENT_TYPE),
                    data: {
                        action: 'viewed',
                        actionSubject: 'externalLinkModal',
                        attributes: analyticsAttributes
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setModalState({
                    state: 'open',
                    url: url,
                    onConfirm: ()=>{
                        (0, $i5CVI.navigate)(url.href, type, push); // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'approved',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        resolve();
                    },
                    onCancel: ()=>{
                        // TODO: remove this event once we have switched over to the new event schema
                        // https://ecosystem-platform.atlassian.net/browse/EXT-2196
                        createAnalyticsEvent({
                            eventType: (0, $7TH2w.UI_EVENT_TYPE),
                            data: {
                                action: 'cancelled',
                                actionSubject: 'externalLinkModal',
                                attributes: analyticsAttributes
                            }
                        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                        reject(new (0, $kxKUs.BridgeClientError)('cancelled'));
                    }
                });
            });
        },
        getModalJsx: ()=>{
            if (modalState.state === 'closed') return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
            return /*#__PURE__*/ $42omo.createElement((0, $3Faxc.ExternalLinkModal), {
                url: modalState.url,
                extensionTitle: extension.properties?.title,
                onCancel: ()=>{
                    setModalState({
                        state: 'closed'
                    });
                    modalState.onCancel();
                },
                onConfirm: ()=>{
                    modalState.onConfirm();
                    setModalState({
                        state: 'closed'
                    });
                }
            });
        }
    };
}
const $c92260a0208e3eb8$var$getRootDomain = (url)=>{
    const hostnameParts = url.hostname.split('.'); // Root domain consists of the last two parts of the hostname
    if (hostnameParts.length > 1) return hostnameParts.slice(-2).join('.');
    else // If there's only one part, return it (e.g., 'localhost')
    return url.hostname;
};
function $c92260a0208e3eb8$export$8071740a02e53ce2(url, egressService) {
    if (!url) return 'invalid';
    if (url.protocol === 'mailto:') return 'trusted';
    if (url.protocol === 'tel:') return 'trusted';
    try {
        // URL is listed under permissions in manifest
        if (egressService.isValidUrl(url.href)) return 'trusted';
         // URL is from same origin
        if (url.origin === (0, $2kGKp.getOrigin)()) return 'trusted';
         // URL is under a trusted atlassian domain
        const rootDomain = $c92260a0208e3eb8$var$getRootDomain(url);
        if ((0, $9v4R2.TRUSTED_ROOT_DOMAINS).includes(rootDomain)) return 'trusted';
        if ([
            'https:',
            'http:'
        ].includes(url.protocol)) return 'external';
    } catch  {}
    return 'invalid';
}
function $c92260a0208e3eb8$export$e748b6351ba5f204(url) {
    // Don't count the initial `?` in the query string length.
    const queryStringSize = url.search.length > 1 ? url.search.length - 1 : 0;
    return {
        url: url.href,
        queryStringSize: queryStringSize
    };
}
module.exports["useNavigation"] = $c92260a0208e3eb8$export$d0fd4b7106de2769;
module.exports["getLinkType"] = $c92260a0208e3eb8$export$8071740a02e53ce2;
module.exports["getAnalyticsAttributes"] = $c92260a0208e3eb8$export$e748b6351ba5f204;

});

parcelRegister("kRUUL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("5ExMm")), module.exports);

$hXuPC.__exportStar((parcelRequire("bJnpv")), module.exports);

$hXuPC.__exportStar((parcelRequire("fgfHi")), module.exports);

});

parcelRegister("5ExMm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EgressFilteringService = void 0;

var $bJnpv = parcelRequire("bJnpv");


var $fgfHi = parcelRequire("fgfHi");

class $41dae3f6a51269f4$var$EgressFilteringService {
    parseUrl(url) {
        return (0, $bJnpv.parseUrl)(url);
    }
    containsWildCardEgress() {
        return this.allowsEverything;
    }
    isValidUrl(url) {
        if (this.allowsEverything) return true;
        const parsedUrl = this.parseUrl(url);
        return this.allowedDomainExact(parsedUrl, this.URLs) || this.allowedDomainPattern(parsedUrl, this.wildcardDomains);
    }
    allowedDomainExact(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((url)=>url.hostname === domain.hostname);
    }
    allowedDomainPattern(domain, allowList) {
        return allowList.filter((allowed)=>allowed.protocol === domain.protocol).some((pattern)=>pattern.regex.test(domain.hostname));
    }
    constructor(allowList){
        this.URLs = allowList.filter((domainOrURL)=>!domainOrURL.startsWith('*')).map((url)=>this.parseUrl(url));
        this.wildcardDomains = allowList.filter((domainOrURL)=>domainOrURL !== '*').map((url)=>this.parseUrl(url)).filter((url)=>decodeURIComponent(url.hostname).startsWith('*')).map((url)=>({
                ...url,
                regex: (0, $fgfHi.globToRegex)(decodeURIComponent(url.hostname))
            }));
        this.allowsEverything = allowList.includes('*');
    }
}
module.exports.EgressFilteringService = $41dae3f6a51269f4$var$EgressFilteringService;

});

parcelRegister("bJnpv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseUrl = void 0;
function $88a60e7f5ad1cf39$var$parseUrl(url) {
    var _a, _b;
    const protocol = (_b = (_a = url.match(/^(.*?:)/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 'https:';
    const hostname = url.replace(protocol, '').replace(/^\/*/, '').replace(/^\\*/, '').split(/[\?\/]/)[0];
    return {
        protocol: protocol,
        hostname: hostname
    };
}
module.exports.parseUrl = $88a60e7f5ad1cf39$var$parseUrl;

});

parcelRegister("fgfHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEgressesBasedOnToggles = module.exports.sortAndGroupEgressPermissionsByDomain = module.exports.EgressCategory = module.exports.EgressType = module.exports.globToRegex = void 0;

var $bJnpv = parcelRequire("bJnpv");

function $b1c486d357da07ae$var$globToRegex(pattern) {
    const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
    const regexPattern = escaped.replace(/\*/g, '.*');
    return new RegExp(`^${regexPattern}$`);
}
module.exports.globToRegex = $b1c486d357da07ae$var$globToRegex;
const $b1c486d357da07ae$var$sortAndGroupEgressPermissionsByDomain = (egressAddresses)=>{
    if ((egressAddresses === null || egressAddresses === void 0 ? void 0 : egressAddresses.length) === 0) return [];
    const protocolRegex = /^(.*?:\/\/)/;
    const domains = new Set();
    const wildcardDomains = [];
    egressAddresses.forEach((item)=>{
        const itemWithProtocol = protocolRegex.test(item) ? item : `https://${item}`;
        const url = (0, $bJnpv.parseUrl)(itemWithProtocol);
        if (url.hostname.startsWith('*')) {
            domains.add(url.hostname.substring(2));
            wildcardDomains.push($b1c486d357da07ae$var$globToRegex(url.hostname));
        } else domains.add(url.hostname);
    });
    return [
        ...domains
    ].sort().reduce((grouped, domain)=>{
        if (!wildcardDomains.some((pattern)=>pattern.test(domain))) grouped.push(domain);
        return grouped;
    }, []);
};
module.exports.sortAndGroupEgressPermissionsByDomain = $b1c486d357da07ae$var$sortAndGroupEgressPermissionsByDomain;
var $b1c486d357da07ae$var$EgressType;
(function(EgressType) {
    EgressType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    EgressType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    EgressType["Fonts"] = "FONTS";
    EgressType["Frames"] = "FRAMES";
    EgressType["Images"] = "IMAGES";
    EgressType["Media"] = "MEDIA";
    EgressType["Navigation"] = "NAVIGATION";
    EgressType["Scripts"] = "SCRIPTS";
    EgressType["Styles"] = "STYLES";
})($b1c486d357da07ae$var$EgressType = module.exports.EgressType || (module.exports.EgressType = {}));
var $b1c486d357da07ae$var$EgressCategory;
(function(EgressCategory) {
    EgressCategory["ANALYTICS"] = "ANALYTICS";
})($b1c486d357da07ae$var$EgressCategory = module.exports.EgressCategory || (module.exports.EgressCategory = {}));
const $b1c486d357da07ae$var$getEgressesBasedOnToggles = (input)=>{
    const filteredEgresses = input.egress.filter((egress)=>{
        var _a;
        if (((_a = egress.category) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === $b1c486d357da07ae$var$EgressCategory.ANALYTICS) {
            if (input.installationConfig) {
                const analyticsConfig = input.installationConfig.find((config)=>config.key.toUpperCase() === 'ALLOW_EGRESS_ANALYTICS');
                return (analyticsConfig === null || analyticsConfig === void 0 ? void 0 : analyticsConfig.value) !== false;
            } else return input.overrides.ALLOW_EGRESS_ANALYTICS !== false;
        }
        return true;
    });
    const egressByType = new Map();
    for (const egress of filteredEgresses){
        if (!egressByType.has(egress.type)) egressByType.set(egress.type, egress.addresses);
        egressByType.set(egress.type, [
            ...egressByType.get(egress.type),
            ...egress.addresses
        ]);
    }
    return [
        ...egressByType.entries()
    ].map(([type, egresses])=>({
            type: type,
            addresses: [
                ...new Set(egresses)
            ]
        }));
};
module.exports.getEgressesBasedOnToggles = $b1c486d357da07ae$var$getEgressesBasedOnToggles;

});

parcelRegister("CMcde", function(module, exports) {
/* loader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $a7bb558f45760cd7$export$3b0d6d7590275603 = ()=>{
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "forge-app-loading-spinner",
        size: "large"
    }));
};
module.exports["Loader"] = $a7bb558f45760cd7$export$3b0d6d7590275603;

});

parcelRegister("jc2GP", function(module, exports) {
const $45b69e870d2a465f$export$45b306f42e1402e5 = (extension)=>{
    const { properties: properties } = extension;
    if (properties?.layout === 'bodied') return 'bodiedExtension';
    else if (properties?.layout === 'inline') return 'inlineExtension';
    return 'extension';
};
module.exports["getExtensionType"] = $45b69e870d2a465f$export$45b306f42e1402e5;

});

parcelRegister("jed12", function(module, exports) {
$parcel$export(module.exports, "default", () => $9248c53ed364f1d5$export$2e2bcd8739ae039);
/* eslint-disable import/dynamic-import-chunkname */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hWJfj = parcelRequire("hWJfj");




var $1c598 = parcelRequire("1c598");


var $gvvHu = parcelRequire("gvvHu");


var $5U2YR = parcelRequire("5U2YR");


var $7KMPr = parcelRequire("7KMPr");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");

class $3a7e2bde20e8f4eb$export$a707936a384f62f9 extends Error {
    constructor(error){
        super(error.logMessage);
        this.logMessage = void 0;
        this.errorTitle = void 0;
        this.errorBody = void 0;
        this.errorTitle = error.errorTitle;
        this.logMessage = error.logMessage;
        this.errorBody = error.errorBody;
    }
}
class $3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        const { page: page, environment: environment } = this.context;
        const { createAnalyticsEvent: createAnalyticsEvent, extension: extension } = this.props;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment || (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        if (error instanceof $3a7e2bde20e8f4eb$export$a707936a384f62f9) this.setState({
            thrownError: {
                error: {
                    name: 'error',
                    message: error.errorTitle,
                    errorMessage: error.errorBody
                },
                errorInfo: errorInfo
            }
        });
        else this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $3a7e2bde20e8f4eb$var$GenericErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a7e2bde20e8f4eb$var$GenericErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $3a7e2bde20e8f4eb$export$2e2bcd8739ae039 = $3a7e2bde20e8f4eb$var$GenericErrorBoundary;




class $49e1d4758686470f$var$IntegrationErrorHandlerBoundary extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (this.props.onError) this.props.onError(error);
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var $49e1d4758686470f$export$2e2bcd8739ae039 = $49e1d4758686470f$var$IntegrationErrorHandlerBoundary;



var $JmaBh = parcelRequire("JmaBh");


var $jIiuI = parcelRequire("jIiuI");

var $gGmck = parcelRequire("gGmck");




var $4JDbp = parcelRequire("4JDbp");

const $e15251f056a7fc02$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(0);
const $e15251f056a7fc02$var$SCROLLBAR_WIDTH = 30;
const $e15251f056a7fc02$export$7921e18173e8c666 = ({ children: children })=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const handleWidthChange = (newWidth)=>{
        // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
        if (!newWidth || Math.abs(width - newWidth) < $e15251f056a7fc02$var$SCROLLBAR_WIDTH) return;
        setWidth(newWidth);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
        setWidth: handleWidthChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e15251f056a7fc02$export$27e39f636459b9f.Provider, {
        value: width
    }, children));
};
const $e15251f056a7fc02$export$5d8538aa831b6ebb = $e15251f056a7fc02$export$27e39f636459b9f.Consumer;



var $CMcde = parcelRequire("CMcde");







class $cec67f48175aa836$export$51ac3312edef55d7 extends Error {
    get issue() {
        return this._issue;
    }
    get property() {
        return this._property;
    }
    set property(value) {
        this._property = value;
    }
    constructor({ issue: issue, message: message }){
        super(message);
        this._issue = void 0;
        this._property = void 0;
        this._issue = issue;
        this._property = '';
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $cec67f48175aa836$export$51ac3312edef55d7.prototype);
    }
}
class $cec67f48175aa836$var$StyleErrorBoundary extends (0, $42omo.Component) {
    componentDidCatch(error) {
        if (!(error instanceof $cec67f48175aa836$export$51ac3312edef55d7)) throw error;
        this.setState({
            error: error
        });
    }
    render() {
        const { error: error } = this.state;
        if (!error) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: {
                name: 'style-error',
                message: `Error was thrown on style property: ${error.property}`,
                errorMessage: `${error.issue}\n${error.message}`
            },
            isReloadPage: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: null
        };
    }
}
var $cec67f48175aa836$export$2e2bcd8739ae039 = $cec67f48175aa836$var$StyleErrorBoundary;



var $69400 = parcelRequire("69400");


var $ijfiP = parcelRequire("ijfiP");


var $5oEbs = parcelRequire("5oEbs");


var $eahkE = parcelRequire("eahkE");








var $6oQb1 = parcelRequire("6oQb1");




const $fbc50d5752c05105$export$1e4237f96323a8a1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    (0, $42omo.useEffect)(()=>{
        (0, $6oQb1.trackRendererRendered)(createAnalyticsEvent, {
            source: source,
            target: 'renderer'
        });
    });
};



var $ahOA5 = parcelRequire("ahOA5");

const $9248c53ed364f1d5$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) // Wrapping loadingComponent in a valid react element (fragment)
    // ReactNode type is not necessarily a valid React element, unable to change this type as different extension points pass in various loadingComponent types
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};
const $9248c53ed364f1d5$var$getAppDomainName = (extension, environment)=>{
    const parsedExtension = extension && extension?.id ? (0, $ijfiP.parseExtensionId)(extension.id) : undefined;
    if (parsedExtension) {
        const iframeSrc = (0, $5oEbs.createSrcFromExtension)(parsedExtension.appId, extension, environment, '');
        const iframeUrl = new URL(iframeSrc);
        return iframeUrl.host;
    }
    return;
};

const $9248c53ed364f1d5$var$RendererNextLatest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>/* webpackChunkName: "forge-ui-renderer-with-components" */ (parcelRequire("4jv6P")).then((module)=>({
            default: module.RendererNextLatest
        })));
const $9248c53ed364f1d5$var$shouldRenderDeprecationErrorMessage = (forgeReactMajorVersion, error)=>{
    if (error === (0, $eahkE.SANDBOX_DEPRECATION_ERROR)) return true;
    // Currently supported - @forge/react >=10
    if (forgeReactMajorVersion) return false;
    // Deprecated
    return true;
};
// This extra component exists so errors from the "render" function are caught in the an error boundary
// Also the error boundary requires a suspense fallback
const $9248c53ed364f1d5$var$RendererNextWithProviders = (props)=>{
    const { extension: extension, forgeDoc: forgeDoc, dispatch: dispatch, locale: locale, error: error } = props;
    const defaultDispatch = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async ()=>{}, []);
    const forgeReactMajorVersion = forgeDoc?.forgeReactMajorVersion;
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const domainName = $9248c53ed364f1d5$var$getAppDomainName(extension, environment);
    // true while fetching initial forgeDoc
    if (props.loading && !forgeDoc) return $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent);
    if ($9248c53ed364f1d5$var$shouldRenderDeprecationErrorMessage(forgeReactMajorVersion, error)) return props.modalExtension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahOA5.ForgeExtensionPointModal), {
        modalExtension: props.modalExtension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eahkE.ForgeDeprecationMessage), {
        extension: extension,
        error: error
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eahkE.ForgeDeprecationMessage), {
        extension: extension,
        error: error
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: $9248c53ed364f1d5$var$getLoadingComponent(props.loadingComponent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3a7e2bde20e8f4eb$export$2e2bcd8739ae039), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hWJfj.default), {
        dispatch: dispatch,
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cec67f48175aa836$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $49e1d4758686470f$export$2e2bcd8739ae039), {
        onError: props.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e15251f056a7fc02$export$7921e18173e8c666), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: locale ?? 'en',
        defaultLocale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gGmck.RendererContext).Provider, {
        value: {
            egress: extension?.egress,
            properties: extension?.properties,
            forgeEnvironment: extension?.environmentType,
            forgeReactMajorVersion: forgeReactMajorVersion,
            appDomainName: domainName,
            extensionType: extension?.type
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $69400.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RenderTrackingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextLatest, {
        ...props,
        dispatch: dispatch ?? defaultDispatch
    }))))))))))));
};
const $9248c53ed364f1d5$var$RenderTrackingWrapper = ({ children: children })=>{
    (0, $fbc50d5752c05105$export$1e4237f96323a8a1)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
var $9248c53ed364f1d5$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9248c53ed364f1d5$var$RendererNextWithProviders, props);
};

});

parcelRegister("hWJfj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1c598 = parcelRequire("1c598");


var $gvvHu = parcelRequire("gvvHu");


var $7KMPr = parcelRequire("7KMPr");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $5U2YR = parcelRequire("5U2YR");

class $2104b77b1f0c0326$export$925737f92c0570a1 extends Error {
    constructor(message, component){
        super(message);
        this.component = void 0;
        this.component = component;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2104b77b1f0c0326$export$925737f92c0570a1.prototype);
    }
}
class $2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent extends (0, $42omo.Component) {
    componentDidCatch(error, errorInfo) {
        // Filters out reporting errors for components that are not valid e.g. <Buton/>
        if (!(error instanceof $2104b77b1f0c0326$export$925737f92c0570a1)) throw error;
        const { extension: extension } = this.props;
        const { page: page, environment: environment } = this.context;
        (0, $7KMPr.captureAndReportError)({
            error: error,
            errorInfo: errorInfo,
            page: page,
            environment: environment ?? (0, $1c598.ProductEnvironment).DEVELOPMENT,
            errorExtensionDetails: extension ? {
                type: extension.type,
                environmentType: extension.environmentType,
                appOwnerAccountId: extension.appOwner?.accountId,
                properties: extension.properties,
                id: extension?.id
            } : undefined
        });
        this.props.createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: 'componentError',
                    component: error.component
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvvHu.default), {
            error: thrownError.error,
            dispatch: this.props.dispatch
        });
    }
    constructor(...args){
        super(...args);
        this.context = void 0;
        this.state = {
            thrownError: undefined
        };
    }
}
$2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent.contextType = (0, $5U2YR.MetricsContext);
const $2104b77b1f0c0326$var$ComponentErrorBoundary = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2104b77b1f0c0326$var$ComponentErrorBoundaryWithCreateAnalyticsEvent, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
var $2104b77b1f0c0326$export$2e2bcd8739ae039 = $2104b77b1f0c0326$var$ComponentErrorBoundary;
module.exports["ComponentError"] = $2104b77b1f0c0326$export$925737f92c0570a1;
module.exports["default"] = $2104b77b1f0c0326$export$2e2bcd8739ae039;

});

parcelRegister("fLmnB", function(module, exports) {

let $b79c9af6b2d86be8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b79c9af6b2d86be8$var$load("Wowvf"),
    $b79c9af6b2d86be8$var$load("cjJTJ")
]).then(()=>parcelRequire('hkbHJ'));

});

parcelRegister("JmaBh", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");


var $g5lKx = parcelRequire("g5lKx");

const $f76408e65cd851d4$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $f76408e65cd851d4$var$Provider = $f76408e65cd851d4$var$dest.Provider;
const $f76408e65cd851d4$export$7d41556b227a95c9 = $f76408e65cd851d4$var$dest.Consumer;
const $f76408e65cd851d4$export$6df4068a17305b10 = ({ children: children })=>{
    const [portal, setPortal] = (0, $42omo.useState)();
    const [isPortalReady, setIsPortalReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (portal !== null) setIsPortalReady(true);
    }, [
        portal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isPortalReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f76408e65cd851d4$var$Provider, {
        value: portal
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $g5lKx.layers).modal() + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "forge-ui-portal",
        ref: setPortal
    })));
};
module.exports["PortalConsumer"] = $f76408e65cd851d4$export$7d41556b227a95c9;
module.exports["PortalProvider"] = $f76408e65cd851d4$export$6df4068a17305b10;

});

parcelRegister("ahOA5", function(module, exports) {
/* ForgeExtensionPointModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $jdPfT = parcelRequire("jdPfT");


var $gj7hi = parcelRequire("gj7hi");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $hnPaP = parcelRequire("hnPaP");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $amyZ5 = parcelRequire("amyZ5");


var $gIr1J = parcelRequire("gIr1J");


var $dh538 = parcelRequire("dh538");


var $1c598 = parcelRequire("1c598");


var $6oQb1 = parcelRequire("6oQb1");


var $jc2GP = parcelRequire("jc2GP");

const $10efe874cdee2bbf$var$styles = {
    modalWrapper: "_n3td1ejb"
};
const $10efe874cdee2bbf$var$getExtensionIcon = (extension)=>{
    return extension?.properties?.config?.icon ?? extension?.properties?.icon;
};
const $10efe874cdee2bbf$var$ModalWrapper = (props)=>{
    const { closeModalExtension: closeModalExtension, extensionType: extensionType, width: width, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress } = props;
    const isFullscreenAllowed = extensionType === (0, $1c598.ConfluenceExtension).MACRO && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') || extensionType === (0, $1c598.ConfluenceExtension).BYLINE && (0, $dh538.fg)('platform_add_modal_support_to_bylineitem_extension');
    if (width === 'fullscreen' && isFullscreenAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnPaP.FullScreenModalDialog), {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension
    }, props.children);
     // Fallback to 'x-large' if width is 'fullscreen' but not supported
    const shouldFallbackFromFullscreen = width === 'fullscreen' && !isFullscreenAllowed;
    const modalWidth = shouldFallbackFromFullscreen ? 'x-large' : width;
    if (shouldFallbackFromFullscreen) // eslint-disable-next-line no-console
    console.warn('Forge fullscreen extension point modal is in EAP and only available for macro (non-production) and byline (all environments) modules. Please sign up here https://ecosystem.atlassian.net/servicedesk/customer/portal/1040/group/3496/create/18983. The modal will be rendered with xlarge width instead.');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        onClose: closeModalExtension,
        width: modalWidth
    }, props.children);
};
const $10efe874cdee2bbf$export$bf4fcca1fb0dca1e = ({ children: children, modalExtension: modalExtension, shouldShowFCFModalDeprecationMessage: shouldShowFCFModalDeprecationMessage, extension: extension })=>{
    const { closeModalExtension: closeModalExtension, title: title, modalWidth: modalWidth, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, viewOnClose: viewOnClose } = modalExtension;
    const environmentType = extension?.environmentType;
    const extensionType = extension ? (0, $jc2GP.getExtensionType)(extension?.properties) : 'extension';
    const isMacroExtension = extensionType === 'extension' && extension?.type === (0, $1c598.ConfluenceExtension).MACRO;
    const isFullscreenModal = modalWidth === 'fullscreen';
    const extensionIcon = isMacroExtension ? $10efe874cdee2bbf$var$getExtensionIcon(extension) : undefined;
    const ADSModalWidth = modalWidth ? (0, $gIr1J.getADSModalWidth)(modalWidth) : undefined;
    const { trackExtensionLoaded: trackExtensionLoaded, trackBridgeSucceed: trackBridgeSucceed, trackBridgeFailed: trackBridgeFailed } = (0, $6oQb1.useForgeUiAnalyticsEvent)(); // Only tracking fullscreen modals
    (0, $42omo.useEffect)(()=>{
        if (isFullscreenModal && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config')) trackExtensionLoaded({
            forgeEnvironment: environmentType,
            renderType: 'UIKit',
            extensionType: extensionType,
            viewportSize: 'fullscreen'
        });
    }, [
        isFullscreenModal,
        extensionType,
        environmentType,
        trackExtensionLoaded
    ]);
    const handleClose = async ()=>{
        if (viewOnClose && (0, $dh538.fg)('forge-ui-on-close-bridge-method')) try {
            await viewOnClose();
            trackBridgeSucceed({
                method: 'onClose',
                forgeEnvironment: extension?.environmentType
            });
        } catch (error) {
            // Track failure but still close the modal
            trackBridgeFailed({
                method: 'onClose',
                errorName: error instanceof Error ? error.name : 'UnknownError',
                forgeEnvironment: extension?.environmentType
            });
        } finally{
            closeModalExtension();
        }
        else closeModalExtension();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($10efe874cdee2bbf$var$ModalWrapper, {
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        closeModalExtension: handleClose,
        extensionType: extension?.type,
        width: ADSModalWidth,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, isMacroExtension && isFullscreenModal && (0, $dh538.fg)('forge_enable_fullscreen_viewport_for_custom_config') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, extensionIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: extensionIcon,
        alt: "Macro custom config icon",
        width: "24px",
        height: "24px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close Modal",
        onClick: handleClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), {
        hasInlinePadding: isFullscreenModal && (0, $dh538.fg)('forge-ui-kit-fullscreen-modal') ? false : true
    }, shouldShowFCFModalDeprecationMessage && extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amyZ5.ForgeModalDeprecationMessage), {
        extension: extension
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $10efe874cdee2bbf$var$styles.modalWrapper
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $10efe874cdee2bbf$var$styles.modalWrapper
    }, children)));
};
module.exports["ForgeExtensionPointModal"] = $10efe874cdee2bbf$export$bf4fcca1fb0dca1e;

});

parcelRegister("gIr1J", function(module, exports) {
const $6740a775674ef88d$export$2d5db5bd91fc0e = (modalSize)=>{
    switch(modalSize){
        case 'xlarge':
            return 'x-large';
        case 'max':
            return '100%';
        default:
            return modalSize;
    }
};
module.exports["getADSModalWidth"] = $6740a775674ef88d$export$2d5db5bd91fc0e;

});

parcelRegister("4jv6P", function(module, exports) {

let $3241116059eaa728$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3241116059eaa728$var$load("9qfB8"),
    $3241116059eaa728$var$load("jDjSj"),
    $3241116059eaa728$var$load("6wr18"),
    $3241116059eaa728$var$load("cf5vC"),
    $3241116059eaa728$var$load("lPQcc"),
    $3241116059eaa728$var$load("knC1t"),
    $3241116059eaa728$var$load("khyhL"),
    $3241116059eaa728$var$load("7EorR"),
    $3241116059eaa728$var$load("ffEVr"),
    $3241116059eaa728$var$load("37ldp"),
    $3241116059eaa728$var$load("kHOMt"),
    $3241116059eaa728$var$load("hhss7"),
    $3241116059eaa728$var$load("Wowvf"),
    $3241116059eaa728$var$load("9Ozjy")
]).then(()=>parcelRequire('2Jivw'));

});

parcelRegister("9UyM5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d399cb7128821634$export$75ab56226e2d3efd = /*#__PURE__*/ (0, $42omo.createContext)({
    inline: false
});
const $d399cb7128821634$export$3828d4e780bd54a = ()=>(0, $42omo.useContext)($d399cb7128821634$export$75ab56226e2d3efd);
module.exports["InlineContext"] = $d399cb7128821634$export$75ab56226e2d3efd;
module.exports["useInlineContext"] = $d399cb7128821634$export$3828d4e780bd54a;

});

parcelRegister("fenwm", function(module, exports) {

let $b16a689135b45714$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b16a689135b45714$var$load("28arV"),
    $b16a689135b45714$var$load("19qJC")
]).then(()=>parcelRequire('jl3SG'));

});

parcelRegister("6OBBH", function(module, exports) {

let $4f64959523164cc6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f64959523164cc6$var$load("2lpnu").then(()=>parcelRequire('byMHr'));

});

parcelRegister("durRy", function(module, exports) {
/**
 * @generated SignedSource<<5e11b2eaaf46fbf4abd647c6854e44fb>>
 * @relayHash 31980ab6c38bae595f082e75d7d0e4e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702
const $063fedceddcc0e64$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userpicker_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userpicker_forge_ui_usersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae24380b92626cb5b9d090bf5964371d7239e6db55abf05be39369ed495e6702",
            "metadata": {},
            "name": "userpicker_forge_ui_usersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$063fedceddcc0e64$var$node.hash = "bfc99cc46adea62c7037b11c133b2a46";
var $063fedceddcc0e64$export$2e2bcd8739ae039 = $063fedceddcc0e64$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");




// Key for registering and unregistering the subscriber
const $d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY = 'forge-ui-user-select';
const $d0f49770ff4f5279$var$mentionResultsToUsers = (results)=>{
    return results.map((result)=>({
            id: result.id,
            name: result.name,
            avatarUrl: result.avatarUrl || '',
            type: 'user'
        })).filter((user)=>typeof user.name !== 'undefined');
};
const $d0f49770ff4f5279$export$f4d09562dcb13ab = (mentionProvider)=>{
    const query = (0, $42omo.useCallback)(async (search)=>{
        const provider = await mentionProvider;
        if (provider && search) return new Promise((resolve)=>{
            provider.filter(search);
            provider.subscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY, (results)=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve($d0f49770ff4f5279$var$mentionResultsToUsers(results));
            }, ()=>{
                provider.unsubscribe($d0f49770ff4f5279$var$MENTION_SUBSCRIBER_KEY);
                resolve([]);
            });
        });
        return Promise.resolve([]);
    }, [
        mentionProvider
    ]);
    if (mentionProvider) return query;
};






var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $gQhRa = parcelRequire("gQhRa");


var $JmaBh = parcelRequire("JmaBh");





var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


const $4dadbd8988869e85$var$AKLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("3hFwA")).then((module)=>({
            default: module.Label
        })));
const $4dadbd8988869e85$export$b04be29aa201d4f5 = ({ isRequired: isRequired, label: label, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4dadbd8988869e85$var$AKLabel, {
        htmlFor: name,
        id: `${name}-label`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.025"
    }, label, isRequired && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong",
        color: "color.text.danger",
        size: "small"
    }, "*")));
};


const $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID = 'BitbucketMentions';
// the value prop in UserPicker component can only take undefined for empty value.
// null is not allowed and will resulted in unexpected behavior.
const $a8c4b840c9ca4704$var$ensureUserPickerValue = (value)=>{
    if (!value || Array.isArray(value) && value.length === 0) return undefined;
    return value;
};
// by forcing a key update when defaultValue is present, we force the SmartUserPicker to re-render.
// this is because the SmartUserPicker does not re-render when the defaultValue changes in its
// current implementation.
const $a8c4b840c9ca4704$var$makeUserPickerKey = (id, defaultValue)=>{
    if (!defaultValue || Array.isArray(defaultValue) && defaultValue.length === 0) return id;
    return `${id}-with-default`;
};
const $a8c4b840c9ca4704$var$RawUserPicker = ({ id: id, name: name, description: description, placeholder: placeholder, isMulti: isMulti, includeUsers: includeUsers = true, includeGroups: includeGroups = false, accountId: currentAccountId, cloudId: suppliedCloudId, productKey: productKey, baseUrl: baseUrl, onChange: onChange, query: query, defaultValue: defaultValue, value: providedValue, width: width, productAttributes: productAttributes })=>{
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JmaBh.PortalConsumer), null, (portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, suppliedCloudId && productKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
            key: $a8c4b840c9ca4704$var$makeUserPickerKey(id, defaultValue),
            onChange: (user)=>onChange?.(user),
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            fieldId: // Bitbucket User Recommendations does not support generic contextType
            productKey === 'bitbucket' ? $a8c4b840c9ca4704$var$BITBUCKET_FIELD_ID : id,
            debounceTime: 400,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            siteId: suppliedCloudId,
            productAttributes: productAttributes,
            // If principalId === 'Context', upstream attempts to use other context
            // to discover the principal ID
            principalId: currentAccountId ?? 'Context',
            productKey: productKey,
            baseUrl: baseUrl,
            inputId: name || id,
            defaultValue: defaultValue,
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base)=>({
                        ...base,
                        minHeight: '40px',
                        height: '40px'
                    })
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
            value: $a8c4b840c9ca4704$var$ensureUserPickerValue(providedValue ?? value),
            onChange: (user)=>{
                setValue(user);
                onChange?.(user);
            },
            // Override the default height of user picker so that it aligns with other input components from design system
            styles: {
                control: (base)=>({
                        ...base,
                        minHeight: '40px',
                        height: '40px'
                    })
            },
            isMulti: isMulti,
            menuPortalTarget: portal || undefined,
            noOptionsMessage: ()=>null,
            placeholder: placeholder,
            width: width,
            loadOptions: query,
            fieldId: null,
            inputId: id,
            defaultValue: defaultValue
        }), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, description)));
};
const $a8c4b840c9ca4704$export$83e0c73b09b3a9cd = (props)=>{
    const uid = (0, $42omo.useId)();
    const { name: name, isRequired: isRequired, label: label } = props;
    const id = name || uid;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dadbd8988869e85$export$b04be29aa201d4f5), {
        name: name,
        isRequired: isRequired,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a8c4b840c9ca4704$var$RawUserPicker, {
        id: id,
        width: "100%",
        ...props
    }));
};



// Format the values(UserData) returned from useUsers hook, to pass to defaultValue prop
const $482c9d0ed1050096$var$hydrateDefaultValue = (users, isMulti = false)=>{
    const defaultValues = [];
    for(const userId in users){
        const { name: name, picture: picture } = users[userId];
        // Only grabbing the values where user name exist
        if (name) defaultValues.push({
            name: name,
            avatarUrl: picture,
            id: userId,
            type: 'user'
        });
    }
    return isMulti ? defaultValues : defaultValues[0];
};
const $482c9d0ed1050096$var$extractUsers = (data)=>{
    let users = {};
    if (data && data.users) users = data.users.reduce((prev, user)=>{
        if (user.accountId) prev[user.accountId] = {
            picture: user.picture,
            accountId: user.accountId,
            name: user.name
        };
        return prev;
    }, {});
    return users;
};
const $482c9d0ed1050096$var$UserPickerFn = ({ mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productAttributes: productAttributes, productKey: productKey, baseUrl: baseUrl, props: props })=>{
    const { name: name, label: label, placeholder: placeholder, description: description, // Warning: Smart user picker ONLY supports default value hydration
    // of *users*, not groups!
    defaultValue: defaultUserValue = '', isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange } = props;
    const query = (0, $d0f49770ff4f5279$export$f4d09562dcb13ab)(mentionProvider);
    const accountIds = Array.isArray(defaultUserValue) ? defaultUserValue : [
        defaultUserValue
    ];
    const data = (0, $irOoi.useLazyLoadQuery)((0, $063fedceddcc0e64$export$2e2bcd8739ae039), {
        accountIds: accountIds
    });
    // Hydrate the default value ourselves, since we are controlling value from <Field>
    // component value. It will get passed into the user picker as simply `value`.
    const users = $482c9d0ed1050096$var$extractUsers(data);
    const hydratedDefaultValue = $482c9d0ed1050096$var$hydrateDefaultValue(users, isMulti);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8c4b840c9ca4704$export$83e0c73b09b3a9cd), {
        accountId: accountId,
        cloudId: cloudId,
        productAttributes: productAttributes,
        productKey: productKey,
        mentionProvider: mentionProvider,
        name: name,
        label: label,
        placeholder: placeholder,
        description: description,
        defaultValue: hydratedDefaultValue,
        isRequired: isRequired,
        isMulti: isMulti,
        includeUsers: includeUsers,
        includeGroups: includeGroups,
        baseUrl: baseUrl,
        onChange: onChange,
        query: query
    });
};
const $482c9d0ed1050096$export$89c0f5a165dc562a = ({ query: query, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        const { name: name, label: label, placeholder: placeholder, description: description, isRequired: isRequired, isMulti: isMulti, includeUsers: includeUsers, includeGroups: includeGroups, onChange: onChange, defaultValue: defaultUserId } = props;
        const [defaultValueLoaded, setDefaultValueLoaded] = (0, $42omo.useState)(!defaultUserId);
        const [defaultValue, setDefaultValue] = (0, $42omo.useState)();
        (0, $42omo.useEffect)(()=>{
            if (defaultUserId && !defaultValueLoaded) query().then((users)=>{
                const targetUsers = users.filter(({ id: id })=>Array.isArray(defaultUserId) ? defaultUserId.includes(id) : defaultUserId === id);
                if (targetUsers.length === 0) setDefaultValue(undefined);
                else if (isMulti) setDefaultValue(targetUsers);
                else setDefaultValue(targetUsers[0]);
                setDefaultValueLoaded(true);
            });
        }, [
            isMulti,
            defaultUserId,
            defaultValueLoaded,
            setDefaultValue,
            setDefaultValueLoaded
        ]);
        if (!defaultValueLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8c4b840c9ca4704$export$83e0c73b09b3a9cd), {
            accountId: accountId,
            cloudId: cloudId,
            productKey: productKey,
            baseUrl: baseUrl,
            name: name,
            label: label,
            placeholder: placeholder,
            description: description,
            isRequired: isRequired,
            isMulti: isMulti,
            includeUsers: includeUsers,
            includeGroups: includeGroups,
            onChange: onChange,
            query: query,
            defaultValue: defaultValue
        });
    };
};
const $482c9d0ed1050096$export$57fb7dc1c2438e62 = ({ mentionProvider: mentionProvider, accountId: accountId, cloudId: cloudId, productKey: productKey, baseUrl: baseUrl, productAttributes: productAttributes })=>{
    return function UserPickerNext({ forgeDoc: { props: props } }) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($482c9d0ed1050096$var$UserPickerFn, {
            props: props,
            mentionProvider: mentionProvider,
            accountId: accountId,
            cloudId: cloudId,
            productAttributes: productAttributes,
            productKey: productKey,
            baseUrl: baseUrl
        });
    };
};
module.exports["makeMockUserPicker"] = $482c9d0ed1050096$export$89c0f5a165dc562a;
module.exports["makeNativeUserPicker"] = $482c9d0ed1050096$export$57fb7dc1c2438e62;

});

parcelRegister("3hFwA", function(module, exports) {

let $26432b86eec44c8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $26432b86eec44c8a$var$load("hhss7"),
    $26432b86eec44c8a$var$load("kHOMt"),
    $26432b86eec44c8a$var$load("2BKk9")
]).then(()=>parcelRequire('aDVvJ'));

});

parcelRegister("dx0OV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $67O0h = parcelRequire("67O0h");


var $6jPem = parcelRequire("6jPem");


var $lspPP = parcelRequire("lspPP");


var $jRNsq = parcelRequire("jRNsq");


var $er4dw = parcelRequire("er4dw");


var $gGmck = parcelRequire("gGmck");


var $lMJg3 = parcelRequire("lMJg3");


var $kS0x0 = parcelRequire("kS0x0");


var $kZjf5 = parcelRequire("kZjf5");


var $clpPd = parcelRequire("clpPd");


var $fgm2d = parcelRequire("fgm2d");

const $d2c1e8bb42c60a10$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $kS0x0.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $6jPem.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $d2c1e8bb42c60a10$var$useSupportsMedia = ()=>{
    try {
        (0, $jRNsq.useMediaClient)();
        return true;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $d2c1e8bb42c60a10$export$a504d7ec22d4b3f4 = ({ client: client, bridge: bridge })=>{
    return function ADFRendererNext(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d2c1e8bb42c60a10$export$c334f442ba514f7d, {
            bridge: bridge,
            client: client,
            ...props
        });
    };
};
const $d2c1e8bb42c60a10$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $d2c1e8bb42c60a10$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const client = props.client;
    const bridge = props.bridge;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $d2c1e8bb42c60a10$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        ...adfRendererProps,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: filteredDocument,
        extensionHandlers: client ? {
            'com.atlassian.ecosystem': (props)=>{
                const { localId: localId, parameters: parameters } = props;
                const { extension: extension, extensionData: extensionData, accountId: accountId, cloudId: cloudId, contextIds: contextIds } = parameters.extensionProperties;
                // Extract config from extension parameters (can be in guestParams or config)
                const config = parameters.guestParams || parameters.config;
                // ForgeUIRenderer will fetch fresh extension data from XLS when isEmbeddedMacro is true
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), {
                    accountId: accountId,
                    cloudId: cloudId,
                    client: client,
                    contextIds: contextIds,
                    extension: extension,
                    extensionData: extensionData,
                    // Pass config via extensionPayload so it's available in context.extension.config
                    extensionPayload: config ? {
                        config: config
                    } : undefined,
                    localId: localId,
                    product: 'confluence',
                    bridge: bridge,
                    // Only required for bodied macros. Since we are currently not supporting embedded bodied macros, this should be empty.
                    extensionViewData: {},
                    isEmbeddedMacro: true
                });
            }
        } : undefined
    })));
};
module.exports["makeADFRenderer"] = $d2c1e8bb42c60a10$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $d2c1e8bb42c60a10$export$c334f442ba514f7d;

});

parcelRegister("er4dw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gGmck = parcelRequire("gGmck");


var $iXCQx = parcelRequire("iXCQx");


var $aoVih = parcelRequire("aoVih");


var $2Nwuj = parcelRequire("2Nwuj");


var $aXWIB = parcelRequire("aXWIB");

const $4da241c59eddfab6$var$messages = (0, $aXWIB.defineMessages)({
    pleaseUseThe: {
        id: "forge-ui.egressErrorMessage.please-use-the",
        defaultMessage: "Please use the"
    },
    dataImage: {
        id: "forge-ui.egressErrorMessage.data-image",
        defaultMessage: "data:image"
    },
    schemeForAnImageSource: {
        id: "forge-ui.egressErrorMessage.scheme-for-an-image-source",
        defaultMessage: "scheme for an image source"
    },
    egressPermissionsFor: {
        id: "forge-ui.egressErrorMessage.egress-permissions-for",
        defaultMessage: "Egress permissions for"
    },
    missingInTheManifestForMoreInformation: {
        id: "forge-ui.egressErrorMessage.missing-in-the-manifest-for-more-information",
        defaultMessage: "missing in the manifest. For more information"
    },
    seeReferenceDocs: {
        id: "forge-ui.egressErrorMessage.see-reference-docs",
        defaultMessage: "see reference docs"
    },
    unableToDisplayDueToImageLinkIssue: {
        id: "forge-ui.egressErrorMessage.unableToDisplayDueToImageLinkIssue",
        defaultMessage: "Unable to display due to an image link issue."
    }
});
const $4da241c59eddfab6$export$5cfbc54f19d7d1a4 = ({ url: url })=>{
    const { forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const dataUriRegex = /^data/;
    const isDataUri = dataUriRegex.test(url);
    const intl = (0, $aXWIB.useIntl)();
    if (forgeEnvironment === 'DEVELOPMENT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error",
        testId: "egress-error-message"
    }, isDataUri ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4da241c59eddfab6$var$messages.pleaseUseThe), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, intl.formatMessage($4da241c59eddfab6$var$messages.dataImage)), ' ', intl.formatMessage($4da241c59eddfab6$var$messages.schemeForAnImageSource)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, intl.formatMessage($4da241c59eddfab6$var$messages.egressPermissionsFor), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: url,
        target: "_blank"
    }, url), ' ', intl.formatMessage($4da241c59eddfab6$var$messages.missingInTheManifestForMoreInformation), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: "https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images",
        target: "_blank"
    }, intl.formatMessage($4da241c59eddfab6$var$messages.seeReferenceDocs)), "."));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: "error"
    }, intl.formatMessage($4da241c59eddfab6$var$messages.unableToDisplayDueToImageLinkIssue));
};
module.exports["EgressErrorMessage"] = $4da241c59eddfab6$export$5cfbc54f19d7d1a4;

});

parcelRegister("kS0x0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $1c598 = parcelRequire("1c598");


var $lMJg3 = parcelRequire("lMJg3");


var $jIiuI = parcelRequire("jIiuI");

var $gGmck = parcelRequire("gGmck");


var $b7qxC = parcelRequire("b7qxC");


var $dh538 = parcelRequire("dh538");


var $dRFAM = parcelRequire("dRFAM");

// --------------------------------------------------------------------------------------------------------------------
//
// NOTE: any changes to these hosts MUST BE applied to the Forge Monorepo -- and vice versa.
// See packages/forge-csp/src/csp/csp-injection-service.ts for the original source code.
//
// --------------------------------------------------------------------------------------------------------------------
/**
 * Media API is used to store product attachments.
 * URLs are defined here: https://developer.atlassian.com/platform/media/support/faq/#which-environment-should-i-use-
 */ const $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST = {
    dev: 'https://api.dev.atlassian.com',
    stg: 'https://api.stg.atlassian.com',
    prod: 'https://api.atlassian.com',
    'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST = {
    dev: 'https://media.dev.atl-paas.net',
    stg: 'https://media.staging.atl-paas.net',
    prod: 'https://api.media.atlassian.com',
    'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST = {
    dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
    prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
    'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST = {
    dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
    stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
    prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
    'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST = {
    dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
    prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
    'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
    'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/'
};
const $576cfccaadb64755$var$ATLASSIAN_FOS_HOST = {
    dev: 'https://tdp-os.dev.services.atlassian.com',
    stg: 'https://tdp-os.stg.services.atlassian.com',
    prod: 'https://tdp-os.services.atlassian.com',
    'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
    'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com'
};
const $576cfccaadb64755$var$getFOSHosts = (env)=>[
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos-eap/download/*`,
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos/app/download/*`,
        `${$576cfccaadb64755$var$ATLASSIAN_FOS_HOST[env]}/fos/cdn/download/*`
    ];
/**
 * Atlassian products use Wordpress as a proxy to serve avatar images in certain conditions.
 * Not allowing them by default forces developers to add the `*.wp.com` domain to the CSP image policy.
 * See: https://hello.atlassian.net/wiki/x/XJpuCgE
 */ const $576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS = {
    dev: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['dev']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['dev'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['dev']
    ],
    stg: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['stg']
    ],
    prod: [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['prod']
    ],
    'fedramp-stg': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-stg']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-stg'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-stg']
    ],
    'fedramp-prod': [
        `https://${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}`,
        `https://*.wp.com/${$576cfccaadb64755$var$ATLASSIAN_AVATAR_HOST['fedramp-prod']}/`,
        $576cfccaadb64755$var$ATLASSIAN_API_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_MEDIA_GATEWAY_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_EMOJIS_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_AVATAR_HOST['fedramp-prod'],
        $576cfccaadb64755$var$ATLASSIAN_TEAM_HEADER_HOST['fedramp-prod']
    ]
};
// --------------------------------------------------------------------------------------------------------------------
/**
 * Gravatar is still used internally to serve legacy Atlassian avatars.
 * Unsplash is integrated by default in Confluence to the header image picker functionality.
 */ const $576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
const $576cfccaadb64755$export$189ea7794c50ff15 = (url, iframeDomainName)=>{
    if (!iframeDomainName) return false;
    let imageSrcUrl;
    try {
        imageSrcUrl = new URL(url);
        // Image is valid if it comes from the same domain as the iframe OR if it's being served from localhost (when using forge tunnel)
        return iframeDomainName === imageSrcUrl.host || imageSrcUrl.hostname === 'localhost';
    } catch (e) {
        return false;
    }
};
const $576cfccaadb64755$var$getImageHostsEnvironment = (environment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (environment === (0, $1c598.ProductEnvironment).STAGING) return 'fedramp-stg';
        return 'fedramp-prod';
    }
    return (0, $b7qxC.getCDNEnvironment)(environment);
};
const $576cfccaadb64755$var$getImageHostsEnvironmentForIC = (environment)=>{
    return environment === (0, $1c598.ProductEnvironment).PRODUCTION ? 'ic-prod' : 'ic-stg';
};
const $576cfccaadb64755$var$getAtlassianImageHosts = (environment)=>{
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) {
        if ((0, $T9xHm.isIsolatedCloud)()) {
            const icImageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironmentForIC(environment);
            return (0, $dRFAM.getAtlassianImageHost)(icImageHostsEnvironment, {
                getICDomain: ()=>(0, $T9xHm.isolatedCloudDomain)()
            });
        }
        const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
        return (0, $dRFAM.getAtlassianImageHost)(imageHostsEnvironment);
    }
    return $576cfccaadb64755$var$getAtlassianImageHostsForCommercialAndFedRamp(environment);
};
const $576cfccaadb64755$var$getAtlassianImageHostsForCommercialAndFedRamp = (environment)=>{
    const imageHostsEnvironment = $576cfccaadb64755$var$getImageHostsEnvironment(environment);
    return [
        ...$576cfccaadb64755$var$ATLASSIAN_IMAGES_HOSTS[imageHostsEnvironment],
        ...$576cfccaadb64755$var$getFOSHosts(imageHostsEnvironment)
    ];
};
const $576cfccaadb64755$export$3a08b61b3ed9a4da = (url)=>{
    const { egress: egress, appDomainName: appDomainName } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const environment = (0, $42omo.useContext)((0, $jIiuI.EnvironmentContext));
    const allowListedImageHosts = [
        window.location.hostname,
        ...$576cfccaadb64755$var$getAtlassianImageHosts(environment),
        ...$576cfccaadb64755$var$EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS
    ];
    const egressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', [
        ...egress || [],
        {
            type: 'IMAGES',
            addresses: allowListedImageHosts
        }
    ]);
    return $576cfccaadb64755$export$6e0a24fd7459483a(url, egressService, appDomainName);
};
const $576cfccaadb64755$export$6e0a24fd7459483a = (url, egressService, appDomainName)=>{
    const dataImageUrlRegex = /^data:image/;
    try {
        const isValidUrl = $576cfccaadb64755$export$189ea7794c50ff15(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
        return isValidUrl;
    } catch (e) {
        return false;
    }
};
module.exports["useIsValidImageUrl"] = $576cfccaadb64755$export$3a08b61b3ed9a4da;
module.exports["isValidImageUrl"] = $576cfccaadb64755$export$6e0a24fd7459483a;

});

parcelRegister("9FlsF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("3kxyJ")), module.exports);

$hXuPC.__exportStar((parcelRequire("3HJQU")), module.exports);

});

parcelRegister("3kxyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPInjectionService = module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = module.exports.getAtlassianImageHost = void 0;

var $87m1m = parcelRequire("87m1m");

const $26cd45857053dc7c$var$isICEnvKey = (env)=>env === 'ic-prod' || env === 'ic-stg';
const $26cd45857053dc7c$var$makeICDomain = (env, icLabel)=>`${icLabel}.${env === 'ic-prod' ? 'atlassian-isolated.net' : 'oasis-stg.com'}`;
const $26cd45857053dc7c$var$getICDomain = (env, icOptions)=>{
    if ('getICDomain' in icOptions) return icOptions.getICDomain();
    return $26cd45857053dc7c$var$makeICDomain(env, icOptions.icLabel);
};
const $26cd45857053dc7c$var$makeICHosts = (targetHostFunction)=>{
    return {
        'ic-stg': (icOptions)=>targetHostFunction('ic-stg', icOptions),
        'ic-prod': (icOptions)=>targetHostFunction('ic-prod', icOptions)
    };
};
const $26cd45857053dc7c$var$ATLASSIAN_HOST = {
    ATLASSIAN_API_GATEWAY_HOST: {
        dev: 'https://api.dev.atlassian.com',
        stg: 'https://api.stg.atlassian.com',
        prod: 'https://api.atlassian.com',
        'fedramp-stg': 'https://api.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://api.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_MEDIA_GATEWAY_HOST: {
        dev: 'https://media.dev.atl-paas.net',
        stg: 'https://media.staging.atl-paas.net',
        prod: 'https://api.media.atlassian.com',
        'fedramp-stg': 'https://api-media.stg.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://api-media.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://media-api.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_AVATAR_HOST: {
        dev: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        stg: 'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        prod: 'avatar-management--avatars.us-west-2.prod.public.atl-paas.net',
        'fedramp-stg': 'avatar-management--avatars.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'avatar-management--avatars.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        'ic-stg': (_icOptions)=>'avatar-management--avatars.us-west-2.staging.public.atl-paas.net',
        'ic-prod': (_icOptions)=>'avatar-management--avatars.us-west-2.prod.public.atl-paas.net'
    },
    ATLASSIAN_TEAM_HEADER_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/gradients/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/gradients/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_TEAM_AVATAR_HOST: {
        dev: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        stg: 'https://teams-directory-frontend.stg-east.frontend.public.atl-paas.net/assets/',
        prod: 'https://teams-directory-frontend.prod-east.frontend.public.atl-paas.net/assets/',
        'fedramp-stg': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        'fedramp-prod': 'https://teams-directory-frontend.frontend.cdn.atlassian-us-gov-mod.com/assets/',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://teams-directory-frontend.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}/bfa/`)
    },
    ATLASSIAN_EMOJIS_HOST: {
        dev: 'https://pf-emoji-service--cdn.ap-southeast-2.dev.public.atl-paas.net',
        stg: 'https://pf-emoji-service--cdn.us-east-1.staging.public.atl-paas.net',
        prod: 'https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net',
        'fedramp-stg': 'https://pf-emoji-service--cdn.us-east-1.staging.cdn.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://pf-emoji-service--cdn.us-east-1.prod.cdn.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://pf-emoji-service.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    },
    ATLASSIAN_FOP_GE_HOST: {
        dev: 'https://forge-outbound-proxy.dev.services.atlassian.com',
        stg: 'https://forge-outbound-proxy.stg.services.atlassian.com',
        prod: 'https://forge-outbound-proxy.services.atlassian.com',
        'fedramp-stg': '',
        'fedramp-prod': '',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>'')
    },
    ATLASSIAN_FOS_HOST: {
        dev: 'https://tdp-os.dev.services.atlassian.com',
        stg: 'https://tdp-os.stg.services.atlassian.com',
        prod: 'https://tdp-os.services.atlassian.com',
        'fedramp-stg': 'https://tdp-os.stg.services.atlassian-us-gov-mod.com',
        'fedramp-prod': 'https://tdp-os.services.atlassian-us-gov-mod.com',
        ...$26cd45857053dc7c$var$makeICHosts((env, icOptions)=>`https://tdp-os.services.${$26cd45857053dc7c$var$getICDomain(env, icOptions)}`)
    }
};
const $26cd45857053dc7c$var$getAtlassianHost = (hostType, microsEnv, icOptions)=>{
    const hostMap = $26cd45857053dc7c$var$ATLASSIAN_HOST[hostType];
    if ($26cd45857053dc7c$var$isICEnvKey(microsEnv)) {
        if (!icOptions) throw new Error('Missing IC label');
        return hostMap[microsEnv](icOptions);
    }
    return hostMap[microsEnv];
};
const $26cd45857053dc7c$var$getFOSHostDownload = (microsEnv, icOptions)=>{
    const fosHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $26cd45857053dc7c$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ] : [
        `${fosHost}/fos-eap/download/`,
        `${fosHost}/fos/app/download/`,
        `${fosHost}/fos/cdn/download/`
    ];
};
const $26cd45857053dc7c$var$getFOSHostUpload = (microsEnv, icOptions)=>{
    const fosHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOS_HOST', microsEnv, icOptions);
    return $26cd45857053dc7c$var$isICEnvKey(microsEnv) ? [
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ] : [
        `${fosHost}/fos-eap/upload/`,
        `${fosHost}/fos/app/upload/`,
        `${fosHost}/fos/cdn/upload/`
    ];
};
const $26cd45857053dc7c$var$getAtlassianImageHost = (microsEnv, icOptions)=>{
    return [
        `https://${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}`,
        `https://*.wp.com/${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_AVATAR_HOST', microsEnv, icOptions)}/`,
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_EMOJIS_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_TEAM_AVATAR_HOST', microsEnv, icOptions),
        $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_TEAM_HEADER_HOST', microsEnv, icOptions),
        ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
    ];
};
module.exports.getAtlassianImageHost = $26cd45857053dc7c$var$getAtlassianImageHost;
module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS = [
    'https://secure.gravatar.com',
    'https://images.unsplash.com'
];
class $26cd45857053dc7c$var$CSPInjectionService {
    getCSPReportUri(microsEnv, icOptions) {
        const serviceName = $26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions ? icOptions.serviceName : 'forge-cdn';
        if (microsEnv === 'dev' || microsEnv === 'stg') return `https://web-security-reports.stg.services.atlassian.com/csp-report/${serviceName}`;
        return `https://web-security-reports.services.atlassian.com/csp-report/${serviceName}`;
    }
    getForgeGlobalCSP(microsEnv, isFedRAMP = false, icOptions) {
        if ($26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions) return `https://forge.forge-cdn.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}`;
        return isFedRAMP ? `https://forge.cdn.${microsEnv.split('-')[1]}.atlassian-dev-us-gov-mod.net` : `https://forge.cdn.${microsEnv}.atlassian-dev.net`;
    }
    getMetalClientCSP(microsEnv, icOptions) {
        if ($26cd45857053dc7c$var$isICEnvKey(microsEnv) && icOptions) return `https://api.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}/metal/ingest`;
        return `https://api.${microsEnv === 'prod' ? '' : 'stg.'}atlassian.com/metal/ingest`;
    }
    getExistingCSPDetails(cspType, cspDetails) {
        var _a;
        return (_a = cspDetails[cspType]) !== null && _a !== void 0 ? _a : [];
    }
    getConnectSrc(microsEnv, isTunnelling, icOptions) {
        const allowed = [];
        if (isTunnelling) allowed.push(...[
            'ws://localhost:*',
            'http://localhost:*'
        ]);
        const metalClientCSP = this.getMetalClientCSP(microsEnv, icOptions);
        allowed.push(metalClientCSP);
        allowed.push(`${$26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_API_GATEWAY_HOST', microsEnv, icOptions)}/gateway/api/emoji/`);
        allowed.push($26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions));
        const fopGeHost = $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_FOP_GE_HOST', microsEnv, icOptions);
        if (fopGeHost) allowed.push(fopGeHost);
        allowed.push(...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions));
        allowed.push(...$26cd45857053dc7c$var$getFOSHostUpload(microsEnv, icOptions));
        return allowed;
    }
    getFrameAncestors(microsEnv, hostname, icOptions) {
        let frameAncestors = [];
        switch(microsEnv){
            case 'dev':
            case 'stg':
                frameAncestors = [
                    '*.jira-dev.com',
                    'http://localhost:*',
                    'http://devbucket.localhost',
                    'https://integration.bb-inf.net',
                    '*.atl-paas.net',
                    '*.stg.atlassian.com'
                ];
                break;
            case 'fedramp-stg':
                frameAncestors = [
                    '*.atlassian-stg-fedm.net'
                ];
                break;
            case 'fedramp-prod':
                frameAncestors = [
                    '*.atlassian-us-gov-mod.net'
                ];
                break;
            case 'ic-stg':
            case 'ic-prod':
                if (icOptions) frameAncestors = [
                    `*.${$26cd45857053dc7c$var$getICDomain(microsEnv, icOptions)}`
                ];
                break;
            case 'prod':
            default:
                frameAncestors = [
                    '*.atlassian.net',
                    'bitbucket.org',
                    '*.jira.com',
                    '*.atlassian.com',
                    '*.frontend.public.atl-paas.net'
                ];
                break;
        }
        if (hostname) frameAncestors.push(hostname);
        return frameAncestors;
    }
    constructor(){
        this.getInjectableCSP = ({ existingCSPDetails: existingCSPDetails, microsEnv: microsEnv, tunnelCSPReporterUri: tunnelCSPReporterUri, hostname: hostname, isFedRAMP: isFedRAMP, icOptions: icOptions })=>{
            const reportUri = tunnelCSPReporterUri || this.getCSPReportUri(microsEnv, icOptions);
            const defaultSrc = [
                "'self'",
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].join(' ');
            const frameAncestors = [
                "'self'",
                ...this.getFrameAncestors(microsEnv, hostname, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].join(' ');
            const frameSrc = [
                "'self'",
                hostname,
                $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.FRAME_SRC, existingCSPDetails),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].filter((a)=>a).join(' ');
            const fontSrc = [
                "'self'",
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.FONT_SRC, existingCSPDetails)
            ].join(' ');
            const imgSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                ...module.exports.EXTERNAL_ALLOW_LISTED_IMAGES_HOSTS,
                ...(0, module.exports.getAtlassianImageHost)(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.IMG_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            const mediaSrc = [
                "'self'",
                'data:',
                'blob:',
                hostname,
                $26cd45857053dc7c$var$getAtlassianHost('ATLASSIAN_MEDIA_GATEWAY_HOST', microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.MEDIA_SRC, existingCSPDetails),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions)
            ].filter((a)=>a).join(' ');
            const connectSrc = [
                "'self'",
                ...this.getConnectSrc(microsEnv, !!tunnelCSPReporterUri, icOptions),
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.CONNECT_SRC, existingCSPDetails)
            ].join(' ');
            const scriptSrc = [
                "'self'",
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.SCRIPT_SRC, existingCSPDetails)
            ].join(' ');
            const styleSrc = [
                "'self'",
                hostname,
                this.getForgeGlobalCSP(microsEnv, isFedRAMP, icOptions),
                ...$26cd45857053dc7c$var$getFOSHostDownload(microsEnv, icOptions),
                ...this.getExistingCSPDetails($87m1m.ExternalCspType.STYLE_SRC, existingCSPDetails)
            ].filter((a)=>a).join(' ');
            return [
                `default-src ${defaultSrc}`,
                `frame-ancestors ${frameAncestors}`,
                `frame-src ${frameSrc}`,
                `font-src ${fontSrc}`,
                `img-src ${imgSrc}`,
                `media-src ${mediaSrc}`,
                `connect-src ${connectSrc}`,
                `script-src ${scriptSrc}`,
                `style-src ${styleSrc}`,
                `form-action 'self'`,
                `sandbox allow-popups allow-popups-to-escape-sandbox allow-downloads allow-forms allow-modals allow-pointer-lock allow-same-origin allow-scripts`,
                `report-uri ${reportUri}`
            ];
        };
    }
}
module.exports.CSPInjectionService = $26cd45857053dc7c$var$CSPInjectionService;

});

parcelRegister("87m1m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalCspType = void 0;
var $5e900f11265deb7e$var$ExternalCspType;
(function(ExternalCspType) {
    ExternalCspType["IMG_SRC"] = "img-src";
    ExternalCspType["MEDIA_SRC"] = "media-src";
    ExternalCspType["SCRIPT_SRC"] = "script-src";
    ExternalCspType["STYLE_SRC"] = "style-src";
    ExternalCspType["CONNECT_SRC"] = "connect-src";
    ExternalCspType["FONT_SRC"] = "font-src";
    ExternalCspType["FRAME_SRC"] = "frame-src";
})($5e900f11265deb7e$var$ExternalCspType = module.exports.ExternalCspType || (module.exports.ExternalCspType = {}));

});

parcelRegister("3HJQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSPProcessingService = module.exports.InvalidConnectSrc = void 0;

var $hXuPC = parcelRequire("hXuPC");


const $2b28f4994d3f7e47$var$content_security_policy_parser_1 = $hXuPC.__importDefault((parcelRequire("bqRJT")));

const $2b28f4994d3f7e47$var$crypto_1 = $hXuPC.__importDefault((parcelRequire("7UOIm")));
class $2b28f4994d3f7e47$var$InvalidConnectSrc extends Error {
    constructor(){
        super('fetch.client should be an array of strings');
    }
}
module.exports.InvalidConnectSrc = $2b28f4994d3f7e47$var$InvalidConnectSrc;
class $2b28f4994d3f7e47$var$CSPProcessingService {
    getCspDetails(body, permissions) {
        var _a, _b;
        const { scripts: scripts, styles: styles } = (_a = permissions === null || permissions === void 0 ? void 0 : permissions.content) !== null && _a !== void 0 ? _a : {
            scripts: [],
            styles: []
        };
        const external = (_b = permissions === null || permissions === void 0 ? void 0 : permissions.external) !== null && _b !== void 0 ? _b : {};
        const $ = this.cheerioLoader(body, {
            xml: {
                xmlMode: false
            }
        });
        const { 'script-src': scriptSrc, 'style-src': styleSrc, ...mappedExternalCsp } = this.mapExternalPermissionsToCsp(external);
        return {
            'style-src': [
                ...this.getStyleSrc($, styles),
                ...styleSrc
            ],
            'script-src': [
                ...this.getScriptSrc($, scripts),
                ...scriptSrc
            ],
            ...mappedExternalCsp
        };
    }
    getInvalidCspPermissions(contentPermissions) {
        var _a, _b;
        const { styles: styles, scripts: scripts } = contentPermissions;
        const invalidStyles = (_a = styles === null || styles === void 0 ? void 0 : styles.filter((styleSrc)=>!this.isValidUserStyleSrc(`'${styleSrc}'`))) !== null && _a !== void 0 ? _a : [];
        const invalidScripts = (_b = scripts === null || scripts === void 0 ? void 0 : scripts.filter((scriptSrc)=>!this.isValidUserScriptSrc(scriptSrc))) !== null && _b !== void 0 ? _b : [];
        return [
            ...invalidStyles,
            ...invalidScripts
        ];
    }
    assertValidFetchClient(fetch) {
        if (fetch === null || fetch === void 0 ? void 0 : fetch.client) for (const client of fetch === null || fetch === void 0 ? void 0 : fetch.client){
            if (typeof client !== 'string') throw new $2b28f4994d3f7e47$var$InvalidConnectSrc();
        }
    }
    egressesToStringMap(externalPermissions) {
        return externalPermissions === null || externalPermissions === void 0 ? void 0 : externalPermissions.map((egress)=>typeof egress === 'object' ? egress.address : egress);
    }
    mapExternalPermissionsToCsp(externalPermissions) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { images: images, media: media, scripts: scripts, fetch: fetch, styles: styles, fonts: fonts, frames: frames } = externalPermissions;
        this.assertValidFetchClient(fetch);
        return {
            'img-src': (_a = this.egressesToStringMap(images)) !== null && _a !== void 0 ? _a : [],
            'media-src': (_b = this.egressesToStringMap(media)) !== null && _b !== void 0 ? _b : [],
            'script-src': (_c = this.egressesToStringMap(scripts)) !== null && _c !== void 0 ? _c : [],
            'style-src': (_d = this.egressesToStringMap(styles)) !== null && _d !== void 0 ? _d : [],
            'connect-src': (_e = fetch === null || fetch === void 0 ? void 0 : fetch.client) !== null && _e !== void 0 ? _e : [],
            'font-src': (_f = this.egressesToStringMap(fonts)) !== null && _f !== void 0 ? _f : [],
            'frame-src': (_g = this.egressesToStringMap(frames)) !== null && _g !== void 0 ? _g : []
        };
    }
    getStyleSrc($, userStyleSrc) {
        var _a, _b;
        const quotedUserStyleSrc = (_a = userStyleSrc === null || userStyleSrc === void 0 ? void 0 : userStyleSrc.map((x)=>`'${x}'`)) !== null && _a !== void 0 ? _a : [];
        const deprecatedUserStyleSrc = (_b = this.getDeprecatedUserCsp($)['style-src']) !== null && _b !== void 0 ? _b : [];
        const uniqueStyleSrc = [
            ...new Set([
                ...deprecatedUserStyleSrc,
                ...quotedUserStyleSrc
            ])
        ];
        return uniqueStyleSrc.filter((x)=>this.isValidUserStyleSrc(x));
    }
    getScriptSrc($, userScriptSrc) {
        var _a;
        const validUserScriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((x)=>this.isValidUserScriptSrc(x))) !== null && _a !== void 0 ? _a : [];
        const generatedScriptHashes = validUserScriptSrc.includes('unsafe-inline') ? [] : this.getInlineScriptHashes($);
        const { scriptSrc: scriptSrc, userScriptHashes: userScriptHashes } = this.extractUniqueHashes(validUserScriptSrc, generatedScriptHashes);
        return [
            ...scriptSrc,
            ...generatedScriptHashes,
            ...userScriptHashes
        ].map((x)=>this.formatScriptSrc(x));
    }
    extractUniqueHashes(userScriptSrc, existingScriptHashes) {
        var _a;
        const userScriptHashes = [];
        const scriptSrc = (_a = userScriptSrc === null || userScriptSrc === void 0 ? void 0 : userScriptSrc.filter((scriptSrc)=>{
            const isValidHash = this.isValidHash(scriptSrc);
            if (isValidHash && !existingScriptHashes.includes(scriptSrc)) userScriptHashes.push(scriptSrc);
            return !isValidHash;
        })) !== null && _a !== void 0 ? _a : [];
        return {
            scriptSrc: scriptSrc,
            userScriptHashes: userScriptHashes
        };
    }
    getInlineScriptHashes($) {
        return $('script:not([src])').map((_index, script)=>{
            const html = $(script).html();
            return html && `sha256-${this.hashScript(html)}`;
        }).get();
    }
    hashScript(content) {
        const sha256 = $2b28f4994d3f7e47$var$crypto_1.default.createHash('sha256');
        return sha256.update(content).digest('base64');
    }
    formatScriptSrc(scriptSrc) {
        if (this.UNQUOTED_SCRIPT_SRC_ALLOWLIST.includes(scriptSrc)) return scriptSrc;
        return `'${scriptSrc}'`;
    }
    isValidUserScriptSrc(scriptSrc) {
        if (!this.isSafeCsp(scriptSrc)) return false;
        return this.isValidHash(scriptSrc) || this.SCRIPT_SRC_ALLOWLIST.includes(scriptSrc);
    }
    isValidUserStyleSrc(styleSrc) {
        if (!this.isSafeCsp(styleSrc)) {
            this.logger.info('discarding potentially-malicious CSP');
            return false;
        }
        return this.STYLE_SRC_ALLOWLIST.includes(styleSrc);
    }
    isSafeCsp(cspString) {
        return /^([a-zA-Z0-9='"+\/ -]|blob:)*$/.test(cspString);
    }
    isValidHash(cspString) {
        return this.BASE_64_HASH_PATTERNS.some((pattern)=>pattern.test(cspString));
    }
    getDeprecatedUserCsp($) {
        const cspContent = $('meta[http-equiv="Content-Security-Policy"]').attr('content');
        if (!cspContent) return {};
        if (!this.isSafeCsp(cspContent)) {
            this.logger.info('discarding potentially-malicious CSP');
            return {};
        }
        return (0, $2b28f4994d3f7e47$var$content_security_policy_parser_1.default)(cspContent);
    }
    constructor(logger, cheerioLoader){
        this.logger = logger;
        this.cheerioLoader = cheerioLoader;
        this.STYLE_SRC_ALLOWLIST = [
            `'unsafe-inline'`
        ];
        this.QUOTED_SCRIPT_SRC_ALLOWLIST = [
            'unsafe-inline',
            'unsafe-eval',
            'unsafe-hashes'
        ];
        this.UNQUOTED_SCRIPT_SRC_ALLOWLIST = [
            'blob:'
        ];
        this.SCRIPT_SRC_ALLOWLIST = [
            ...this.QUOTED_SCRIPT_SRC_ALLOWLIST,
            ...this.UNQUOTED_SCRIPT_SRC_ALLOWLIST
        ];
        this.BASE_64_HASH_PATTERNS = [
            /^sha256-[a-zA-Z0-9=+/]{44}$/,
            /^sha384-[a-zA-Z0-9=+/]{64}$/,
            /^sha512-[a-zA-Z0-9=+/]{88}$/
        ];
    }
}
module.exports.CSPProcessingService = $2b28f4994d3f7e47$var$CSPProcessingService;

});

parcelRegister("bqRJT", function(module, exports) {
"use strict";
module.exports = (policy)=>{
    const result = {};
    policy.split(";").forEach((directive)=>{
        const [directiveKey, ...directiveValue] = directive.trim().split(/\s+/g);
        if (directiveKey && !Object.prototype.hasOwnProperty.call(result, directiveKey)) {
            if (directiveKey === "__proto__") Object.defineProperty(result, directiveKey, {
                configurable: true,
                enumerable: true,
                writable: true,
                value: directiveValue
            });
            else result[directiveKey] = directiveValue;
        }
    });
    return result;
};

});

parcelRegister("clpPd", function(module, exports) {
// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const $1501019f8cb42aef$export$4da13fcc37d580b4 = [
    'javascript:',
    'data:',
    'vbscript:',
    'view-source:',
    'resource:',
    'about:',
    'chrome:',
    'livescript:',
    'mocha:',
    'file:',
    'mhtml:',
    'smb:'
];
const $1501019f8cb42aef$export$300bd6d67c49dbfc = (urlString)=>{
    const url = new URL(urlString || '', window.location.href);
    return $1501019f8cb42aef$export$4da13fcc37d580b4.includes(url.protocol) ? 'about:blank' : url.toString();
};
module.exports["sanitizeUrl"] = $1501019f8cb42aef$export$300bd6d67c49dbfc;

});

parcelRegister("g7rOD", function(module, exports) {
/**
 * this function assume the inputs are not same object, and hence
 * it doesn't check for reference equality.
 *
 * Additionally, it check keys of the object and then check the values
 * for better performance.
 */ const $9678c1c47c1b0bc2$var$objectValuesAreEqual = (prev, next, valuesAreEqual)=>{
    const keys = Object.keys(prev);
    const length = keys.length;
    if (length !== Object.keys(next).length) return false;
    // there are two small optimization techniques used in this file:
    // 1. using decrementing for loop instead of incrementing for loop,
    //    to reduce 1 instruction per iteration.
    // 2. for object equality check, we check the key match first and then
    //    the value match. This is to identify the inequality as soon as possible.
    for(let i = length; i-- !== 0;){
        if (!(keys[i] in next)) return false;
    }
    for(let i = length; i-- !== 0;){
        const key = keys[i];
        if (!valuesAreEqual(prev[key], next[key])) return false;
    }
    return true;
};
/**
 * Some of the ideas are based on https://github.com/FormidableLabs/react-fast-compare
 */ const $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    else if (typeof prev === 'function' && typeof next === 'function') // if the function is a crossDomainFunctionWrapper (i.e. post-bot),
    // then we can check if the function is the same by looking at the
    // __id__ property.
    return prev.__id__ === next.__id__;
    else if (typeof prev === 'object' && typeof next === 'object') {
        if (prev.constructor !== next.constructor) return false;
        else if (Array.isArray(prev)) {
            const length = prev.length;
            if (length !== next.length) return false;
            for(let i = length; i-- !== 0;){
                if (!$9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual(prev[i], next[i])) return false;
            }
            return true;
        } else if (prev.valueOf !== Object.prototype.valueOf && typeof prev.valueOf === 'function' && typeof next.valueOf === 'function') return prev.valueOf() === next.valueOf();
        else if (prev.toString !== Object.prototype.toString && typeof prev.toString === 'function' && typeof next.toString === 'function') return prev.toString() === next.toString();
        return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
    }
    return false;
};
const $9678c1c47c1b0bc2$var$forgeDocPropsAreEqual = (prev, next)=>{
    if (prev === next) return true;
    else if (!prev || !next) return false;
    return $9678c1c47c1b0bc2$var$objectValuesAreEqual(prev, next, $9678c1c47c1b0bc2$var$forgeDocPropValuesAreEqual);
};
/**
 * the function is used to cache the hasChanged value in the ForgeDoc.
 * Please note, the cached result need to be stored in the next prop not the prev prop.
 * This is because react internally caches the props, and the cache become stale
 * at every render, if the calculation depends on the prev prop, the stale cache
 * will impact the accuracy of the result.
 */ const $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged = (nextDoc, hasChanged)=>{
    nextDoc.hasChanged = hasChanged;
    return !hasChanged;
};
const $9678c1c47c1b0bc2$var$forgeDocsAreEqual = (prev, next)=>{
    if (next.hasChanged !== undefined) return !next.hasChanged;
    else if (prev === next) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, false);
    else if (!prev || !next) return next ? $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true) : false;
    if (prev.type !== next.type || prev.key !== next.key) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
    else if (prev.children !== next.children) {
        if (prev.children?.length !== next.children?.length) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        const length = prev.children?.length ?? 0;
        for(let i = length; i-- !== 0;){
            if (!$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.children[i], next.children[i])) return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, true);
        }
    }
    return $9678c1c47c1b0bc2$var$cacheForgeDocHasChanged(next, !$9678c1c47c1b0bc2$var$forgeDocPropsAreEqual(prev.props, next.props));
};
const $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f = (prev, next)=>$9678c1c47c1b0bc2$var$forgeDocsAreEqual(prev.forgeDoc, next.forgeDoc);
module.exports["forgePropsAreEqual"] = $9678c1c47c1b0bc2$export$5d1c9ea31ee6a28f;

});

parcelRegister("1l37u", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a816caaccdbc6f4f$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $a816caaccdbc6f4f$export$6107f09ca09b8b5f;

});

parcelRegister("7pHhJ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7EEGh = parcelRequire("7EEGh");


var $h9yJL = parcelRequire("h9yJL");


var $eTuC8 = parcelRequire("eTuC8");

const $f4dc0d6b8df1531b$export$5252bd745392dcde = (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    const transformer = (0, $42omo.useMemo)(()=>new (0, $h9yJL.JSONTransformer)(), []);
    const { preset: preset } = (0, $eTuC8.usePresetByFeatures)('chromeless', features);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7EEGh.ChromelessEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onChange: (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        }
    });
};
module.exports["ChromelessEditor"] = $f4dc0d6b8df1531b$export$5252bd745392dcde;

});

parcelRegister("ivfUe", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $lesF8 = parcelRequire("lesF8");


var $gdv5Z = parcelRequire("gdv5Z");


var $eTuC8 = parcelRequire("eTuC8");

const $e8e906385914cd2a$export$4153d6fbc2386422 = (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $eTuC8.usePresetByFeatures)('comment', features);
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const element = wrapperRef.current;
        if (!element) return;
        return (0, $fFa3V.bind)(element, {
            type: 'keypress',
            listener: (e)=>e.stopImmediatePropagation()
        });
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lesF8.CommentEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onSave: onSave ? ()=>{
                editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                    onSave?.(jsonDocNode);
                });
            } : undefined,
            onCancel: onCancel ? ()=>onCancel() : undefined,
            onChange: ()=>{
                editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                    onChange?.(jsonDocNode);
                });
            }
        })
    });
};
module.exports["CommentEditor"] = $e8e906385914cd2a$export$4153d6fbc2386422;

});

parcelRegister("ha5sn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6jPem = parcelRequire("6jPem");


var $c6GJD = parcelRequire("c6GJD");


var $jRNsq = parcelRequire("jRNsq");


var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");


var $er4dw = parcelRequire("er4dw");




var $gWF6I = parcelRequire("gWF6I");


var $dh538 = parcelRequire("dh538");


var $bsX2q = parcelRequire("bsX2q");


var $grQpA = parcelRequire("grQpA");


var $CMcde = parcelRequire("CMcde");


var $fgm2d = parcelRequire("fgm2d");





var $aXWIB = parcelRequire("aXWIB");


var $aoVih = parcelRequire("aoVih");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $6oQb1 = parcelRequire("6oQb1");

const $b0c103dd0654b698$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "forge.ui.extension.not.installed.title",
        defaultMessage: "App not available"
    },
    message: {
        id: "forge.ui.extension.not.installed.message",
        defaultMessage: "We can't display this content because the app isn't installed. Contact your administrator to install it."
    }
});
const $b0c103dd0654b698$export$8fa4e6bbdc2e95d1 = ({ extensionId: extensionId })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        (0, $6oQb1.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
            source: 'forgeUIRenderer',
            extensionId: extensionId,
            reason: 'not_installed'
        });
    }, [
        createAnalyticsEvent,
        extensionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($b0c103dd0654b698$var$messages.title),
        appearance: "warning",
        testId: "extension-not-installed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b0c103dd0654b698$var$messages.message)));
};



var $1l37u = parcelRequire("1l37u");


var $3qMxz = parcelRequire("3qMxz");


var $iqcSr = parcelRequire("iqcSr");

let $b26fff63e4d71746$var$cachedPostRobotSend;

const $b26fff63e4d71746$var$getPostRobotSend = ()=>{
    if ($b26fff63e4d71746$var$cachedPostRobotSend !== undefined) $b26fff63e4d71746$var$cachedPostRobotSend;
    if (typeof window === 'undefined') return null;
    try {
        $b26fff63e4d71746$var$cachedPostRobotSend = (parcelRequire("eLUTa")).postRobotSend;
    } catch (_) {
        $b26fff63e4d71746$var$cachedPostRobotSend = null;
    }
    return $b26fff63e4d71746$var$cachedPostRobotSend;
};
const $b26fff63e4d71746$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $CMcde.Loader), null);
};
const $b26fff63e4d71746$var$EmbeddedMacroRendererInner = (props)=>{
    const { extensionId: extensionId, client: client, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, entryPoint: entryPoint, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $42omo.useState)(undefined);
    const { extensions: extensions, loading: loading } = (0, $bsX2q.useExtensionListRelay)({
        contextIds: contextIds,
        filter: [
            {
                type: (0, $grQpA.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    'xen:macro'
                ]
            }
        ]
    });
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $dh538.fg)('platform_validate_embedded_macro_installation');
    if (loading || !queryCompleted) return $b26fff63e4d71746$var$getLoadingComponent(loadingComponent);
    if (notInstalled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b0c103dd0654b698$export$8fa4e6bbdc2e95d1), {
        extensionId: extensionId
    });
    if (!extension) return null;
    let getContextToken = props.getContextToken;
    // Create getContextToken function with fresh extension object
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    const isEmbeddedUIKitInCustomUI = isInCustomUI && !(0, $iqcSr.isCustomUI)(extension, entryPoint);
    const forgeRendererProps = {
        ...rest,
        client: client,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: getContextToken,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: true
    };
    if (isEmbeddedUIKitInCustomUI && (0, $dh538.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent')) {
        const postRobotSend = $b26fff63e4d71746$var$getPostRobotSend(); // This prop is used to determine if the embedded macro is rendered within a Custom UI macro. Since the EmbeddedMacroRenderer is only used for rendering macros within Custom UI, we can set this to true.
        const forwarder = (0, $3qMxz.createMessageForwarder)('setEmbeddedMacroModalForgeDoc', {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? '',
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? '',
            id: extension?.id ?? '',
            installationId: extension?.installationId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1l37u.EmbeddedModalContext).Provider, {
            value: {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), forgeRendererProps));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgm2d.ForgeUIRenderer), forgeRendererProps);
};
const $b26fff63e4d71746$export$329644bef0dce3f7 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b26fff63e4d71746$var$EmbeddedMacroRendererInner, props));
};


var $kS0x0 = parcelRequire("kS0x0");

var $gGmck = parcelRequire("gGmck");

var $clpPd = parcelRequire("clpPd");

var $lMJg3 = parcelRequire("lMJg3");

var $kZjf5 = parcelRequire("kZjf5");

/* ConnectMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * ConnectMacroRenderer - Renders Connect/native Confluence macros inside Forge UIKit ADF
 *
 * This component handles Connect macros (extensionType: 'com.atlassian.confluence.macro.core')
 * by querying the backend for rendered output and evaluating initialization scripts.
 *
 * NOTE: This code is duplicated from Confluence Connect utilities to avoid circular dependencies.
 * Original source: confluence/next/packages/connect-utils/src/
 * See also: confluence/next/packages/fabric-extension-handlers/src/extensions/connect/
 *
 * TODO(brizvash): Extract shared Connect macro rendering utilities to a platform package to avoid
 * code duplication between Confluence and Forge UI Kit.
 */ 
var $gMc0m = parcelRequire("gMc0m");





var $eSUdr = parcelRequire("eSUdr");

const $da8e7e2b18c101c3$var$hiddenStyles = null; // GraphQL query to fetch rendered macro output
const $da8e7e2b18c101c3$var$MACRO_BODY_RENDERER_QUERY = (0, $eSUdr.default)`query ConnectMacroRendererQuery($adf:String!$containedRender:Boolean=false$contentId:ID$mode:ContentRendererMode=RENDERER)@allowHigherTimeout{macroBodyRenderer(adf:$adf containedRender:$containedRender contentId:$contentId mode:$mode){value representation mediaToken{token}webResourceDependencies{contexts keys tags{js css}}}}`;
// WRM resources required for Connect framework
const $da8e7e2b18c101c3$var$CONNECT_WRM_RESOURCES = [
    'wr!confluence.web.resources:querystring',
    'wr!confluence.web.resources:navigator-context',
    'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
]; // TypeScript interfaces
/**
 * Load WRM resources using window.WRM.require
 */ const $da8e7e2b18c101c3$var$loadWrmResources = (resources, onSuccess, onError)=>{
    const wrm = window.WRM;
    if (!wrm?.require) {
        // WRM not available - this can happen in non-Confluence contexts
        onError();
        return;
    }
    wrm.require(resources, onSuccess);
};
/**
 * Evaluate Connect inline scripts within a container
 * Connect macros have inline scripts with class 'ap-iframe-body-script' that initialize the iframe
 */ const $da8e7e2b18c101c3$var$evalConnectScripts = (container)=>{
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = [
        ...connectScripts,
        ...macroScripts
    ];
    allScripts.forEach((script)=>{
        // Use indirect eval to execute in global scope (required for AMD modules)
        // eslint-disable-next-line no-eval
        const evalInGlobalScope = eval;
        try {
            evalInGlobalScope(script.innerHTML);
        } catch (e) {
            // Log error but don't throw - allow other scripts to continue
            // eslint-disable-next-line no-console
            console.error('[ConnectMacroRenderer] Error evaluating Connect script:', e);
        }
    });
};
// Serialize extension to ADF format for GraphQL query
const $da8e7e2b18c101c3$var$serializeExtensionToAdf = (extension)=>{
    const adfNode = {
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'extension',
                attrs: {
                    extensionType: extension.extensionType,
                    extensionKey: extension.extensionKey,
                    parameters: extension.parameters || {},
                    localId: extension.localId
                }
            }
        ]
    };
    return JSON.stringify(adfNode);
}; /**
    * Cleanup Connect iframes and scripts within a container.
    * This prevents memory leaks and race conditions when the component unmounts.
    *
    * Note: This cleanup is more thorough than what Confluence currently does.
    * Confluence relies on DOM removal, but in SPA contexts (like Forge macros),
    * explicit cleanup helps prevent issues with stale iframe references.
    *
    * See: confluence/next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx
    * which removes Connect scripts during SSR to avoid race conditions.
    */ 
const $da8e7e2b18c101c3$var$cleanupConnectResources = (container)=>{
    if (!container) return;
     // Remove Connect iframes to ensure they're properly destroyed
    // This prevents issues where Connect scripts might send events to destroyed iframes
    const iframes = container.querySelectorAll('iframe');
    iframes.forEach((iframe)=>{
        // Remove src first to stop any pending loads
        iframe.removeAttribute('src');
        iframe.remove();
    }); // Remove Connect inline scripts to prevent them from being re-evaluated
    // if the component remounts (similar to TinyMCEServerFullRenderer SSR cleanup)
    container.querySelectorAll('script.ap-iframe-body-script').forEach((el)=>el.remove());
    container.querySelectorAll('script.cc-macro-body-script').forEach((el)=>el.remove());
}; /**
    * ConnectMacroRenderer Component
    *
    * Renders Connect macros by:
    * 1. Querying the Confluence backend for rendered macro HTML
    * 2. Loading required WRM resources
    * 3. Rendering the HTML
    * 4. Evaluating Connect inline scripts
    * 5. Cleaning up iframes and scripts on unmount
    */ 
const $da8e7e2b18c101c3$export$801d0752bd033250 = ({ client: client, extension: extension, contentId: contentId, loadingComponent: loadingComponent, errorComponent: errorComponent })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [macroHtml, setMacroHtml] = (0, $42omo.useState)(null);
    const [cssHtml, setCssHtml] = (0, $42omo.useState)(null);
    const [resourcesLoaded, setResourcesLoaded] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null);
    const initTimeoutRef = (0, $42omo.useRef)(null); // Fetch macro rendered output from GraphQL
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const fetchMacroData = async ()=>{
            try {
                setIsLoading(true);
                setError(null);
                const adf = $da8e7e2b18c101c3$var$serializeExtensionToAdf(extension);
                const result = await client.query({
                    query: $da8e7e2b18c101c3$var$MACRO_BODY_RENDERER_QUERY,
                    variables: {
                        adf: adf,
                        contentId: contentId,
                        mode: 'RENDERER',
                        containedRender: false
                    },
                    fetchPolicy: 'cache-first'
                }); // Only update state if component is still mounted
                if (!isMounted) return;
                const macroBody = result.data?.macroBodyRenderer;
                if (macroBody?.value) {
                    setMacroHtml(macroBody.value);
                    setCssHtml(macroBody.webResourceDependencies?.tags?.css || null);
                } else setError(new Error('No macro content returned from server'));
            } catch (e) {
                if (isMounted) setError(e instanceof Error ? e : new Error('Failed to fetch macro data'));
            } finally{
                if (isMounted) setIsLoading(false);
            }
        };
        fetchMacroData();
        return ()=>{
            isMounted = false;
        };
    }, [
        client,
        extension,
        contentId
    ]);
    // Load WRM resources and evaluate scripts after HTML is rendered
    const initializeConnect = (0, $42omo.useCallback)(()=>{
        if (!containerRef.current || !macroHtml) return;
         // Check if resources are already preloaded
        if (window.__CONNECT_RESOURCES_PRELOADED__) {
            $da8e7e2b18c101c3$var$evalConnectScripts(containerRef.current);
            setResourcesLoaded(true);
            return;
        } // Load WRM resources then evaluate scripts
        $da8e7e2b18c101c3$var$loadWrmResources($da8e7e2b18c101c3$var$CONNECT_WRM_RESOURCES, ()=>{
            if (containerRef.current) $da8e7e2b18c101c3$var$evalConnectScripts(containerRef.current);
            setResourcesLoaded(true);
        }, ()=>{
            // WRM loading failed - still try to render, Connect may not work
            setResourcesLoaded(true);
        });
    }, [
        macroHtml
    ]); // Initialize Connect after HTML is in DOM
    (0, $42omo.useEffect)(()=>{
        if (macroHtml && containerRef.current) // Use setTimeout to ensure DOM is updated
        initTimeoutRef.current = setTimeout(initializeConnect, 0);
         // Cleanup on unmount or when dependencies change
        return ()=>{
            // Clear pending initialization timeout
            if (initTimeoutRef.current) {
                clearTimeout(initTimeoutRef.current);
                initTimeoutRef.current = null;
            }
        };
    }, [
        macroHtml,
        initializeConnect
    ]); // Cleanup Connect resources when component unmounts
    (0, $42omo.useEffect)(()=>{
        // Copy ref to variable for cleanup function (react-hooks/exhaustive-deps requirement)
        const container = containerRef.current;
        return ()=>{
            $da8e7e2b18c101c3$var$cleanupConnectResources(container);
        };
    }, []); // Loading state
    if (isLoading) {
        if (loadingComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "connect-macro-renderer-loading"
        }, loadingComponent);
         // No loading indicator provided - show nothing while loading
        return null;
    } // Error state
    if (error) {
        if (errorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "connect-macro-renderer-error"
        }, errorComponent);
         // No error component provided - show nothing on error (error is logged via console.error in fetch)
        return null;
    } // No content
    if (!macroHtml) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "connect-macro-renderer"
    }, cssHtml && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: cssHtml
        },
        "data-testid": "connect-macro-css",
        className: (0, $gMc0m.default)([
            "_1e0cglyw"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        "data-testid": "connect-macro-content",
        "data-resources-loaded": resourcesLoaded,
        dangerouslySetInnerHTML: {
            __html: macroHtml
        }
    }));
};


const $28b4b46ff5265566$var$filterInvalidMediaUrls = (appDomainName, egressServices, document)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $kS0x0.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $6jPem.traverse)(document, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : document,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $28b4b46ff5265566$var$useSupportsMedia = ()=>{
    try {
        (0, $jRNsq.useMediaClient)();
        return true;
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
};
const $28b4b46ff5265566$export$a504d7ec22d4b3f4 = ({ client: client, bridge: bridge, customBridgeMethods: customBridgeMethods, getContextToken: getContextToken, extensionData: extensionData, isEditing: isEditing, productExtensionHandlers: productExtensionHandlers })=>{
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($28b4b46ff5265566$export$c334f442ba514f7d, {
            client: client,
            bridge: bridge,
            getContextToken: getContextToken,
            extensionData: extensionData,
            customBridgeMethods: customBridgeMethods,
            isEditing: isEditing,
            productExtensionHandlers: productExtensionHandlers,
            ...props
        });
};
/**
 * The AdfRenderer component provides a way to render a valid ADF document, using the same renderer that Atlassian uses internally to render ADF content in Confluence pages, Jira work items, and so on.
 * It allows you to replace node types that are unsupported in the context of a Forge app with replacement content, or remove them entirely.
 * See [Atlassian Document Format](/cloud/jira/platform/apis/document/structure/) for information on valid nodes.
 *
 * This component uses [@atlaskit/renderer](https://www.npmjs.com/package/@atlaskit/renderer) under the hood.
 *
 * Visit [Renderer editor](https://atlaskit.atlassian.com/examples/editor/renderer/basic) for a comprehensive list of different ADF document examples
 */ const $28b4b46ff5265566$var$makeExtensionHandlers = ({ client: client, bridge: bridge, embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods, extensionData: extensionData, isEditing: isEditing, getContextToken: getContextToken, productExtensionHandlers: productExtensionHandlers = {} })=>{
    if (!client) return undefined;
    const forgeMacroHandler = (props)=>{
        const { localId: localId, parameters: parameters } = props;
        const autoConvertLink = parameters?.autoConvertLink;
        // Extract config from extension parameters (can be in guestParams or config)
        const config = parameters.guestParams || parameters.config;
        const extensionPayload = {
            config: config,
            isEditing: isEditing
        };
        const embeddedMacroContext = parameters.embeddedMacroContext;
        const extensionId = parameters.extensionId;
        if (!embeddedMacroContext || !extensionId) return null;
        const { accountId: accountId, cloudId: cloudId, contextIds: contextIds, extensionData: extensionData } = embeddedMacroContext;
        const augmentedExtensionData = {
            ...extensionData,
            autoConvertLink: autoConvertLink
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b26fff63e4d71746$export$329644bef0dce3f7), {
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            extensionId: extensionId,
            extensionData: augmentedExtensionData,
            extensionPayload: extensionPayload,
            localId: localId,
            product: "confluence",
            extensionViewData: {},
            bridge: bridge,
            customBridgeMethods: embeddedMacroCustomBridgeMethods,
            getContextToken: getContextToken
        });
    };
    // Handler for Connect macros (including native Confluence macros like TOC, Chart, Details, etc.)
    const connectMacroHandler = (props)=>{
        const { localId: localId, parameters: parameters } = props;
        const extensionKey = props.extensionKey;
        // Get contentId from the Forge extension's context (extensionData) first,
        // which is the page containing the Forge app.
        // Fallback to _parentId for cross-page macros (e.g., include-page macro).
        // See: confluence/next/packages/fabric-extension-legacy-macro-renderer/src/LegacyMacroRendererQuery.tsx
        const contentId = extensionData?.content?.id || parameters?.macroParams?._parentId?.value || '';
        // Build extension object for ConnectMacroRenderer
        const connectExtension = {
            extensionType: 'com.atlassian.confluence.macro.core',
            extensionKey: extensionKey,
            localId: localId,
            parameters: {
                macroParams: parameters?.macroParams,
                macroMetadata: parameters?.macroMetadata,
                guestParams: parameters?.guestParams
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $da8e7e2b18c101c3$export$801d0752bd033250), {
            client: client,
            extension: connectExtension,
            contentId: contentId
        });
    };
    const baseExtensionHandlers = {
        'com.atlassian.ecosystem': forgeMacroHandler
    };
    if ((0, $c6GJD.default).getExperimentValue('platform_forge_add_product_extension_handler', 'isEnabled', false)) {
        if (productExtensionHandlers?.['com.atlassian.confluence.macro.core']) return {
            ...baseExtensionHandlers,
            'com.atlassian.confluence.macro.core': productExtensionHandlers['com.atlassian.confluence.macro.core']
        };
        return baseExtensionHandlers;
    }
    return {
        ...baseExtensionHandlers,
        'com.atlassian.confluence.macro.core': connectMacroHandler
    };
};
const $28b4b46ff5265566$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $28b4b46ff5265566$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment } = (0, $42omo.useContext)((0, $gGmck.RendererContext));
    const imagesEgressService = (0, $lMJg3.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $lMJg3.useEgressPermissionService)('MEDIA', egress);
    const egressServices = [
        imagesEgressService,
        mediaEgressService
    ];
    const { client: client, bridge: bridge, customBridgeMethods: embeddedMacroCustomBridgeMethods, extensionData: extensionData, isEditing: isEditing, getContextToken: getContextToken, productExtensionHandlers: productExtensionHandlers } = props;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $kZjf5.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        }
    });
    const { document: document, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : document;
    if (!doc) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = $28b4b46ff5265566$var$filterInvalidMediaUrls(appDomainName, egressServices, doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $er4dw.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        ...adfRendererProps,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $clpPd.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: filteredDocument,
        extensionHandlers: $28b4b46ff5265566$var$makeExtensionHandlers({
            client: client,
            bridge: bridge,
            embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods,
            extensionData: extensionData,
            isEditing: isEditing,
            getContextToken: getContextToken,
            productExtensionHandlers: productExtensionHandlers
        })
    })));
};
module.exports["makeADFRenderer"] = $28b4b46ff5265566$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $28b4b46ff5265566$export$c334f442ba514f7d;

});

parcelRegister("kaOT1", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $74f9941a52315579$export$e775b9769343d051 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $74f9941a52315579$export$73f470ced5fdc319 = (props)=>{
    const breadCrumbs = (0, $42omo.useRef)([]);
    const tracingService = (0, $42omo.useRef)({
        getBreadcrumbs: ()=>breadCrumbs.current,
        recordBridgeCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `forge.bridge`,
                    message: description,
                    timestamp: new Date().toISOString()
                }
            ],
        recordGqlCall: (description)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    type: 'http',
                    category: 'gql',
                    timestamp: new Date().toISOString(),
                    data: {
                        url: description
                    }
                }
            ],
        recordConsentFlow: (description, result)=>breadCrumbs.current = [
                ...breadCrumbs.current,
                {
                    category: `user.consent`,
                    message: description,
                    timestamp: new Date().toISOString(),
                    ...result ? {
                        data: {
                            result: result
                        }
                    } : {}
                }
            ]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74f9941a52315579$export$e775b9769343d051.Provider, {
        value: tracingService.current
    }, props.children);
};
const $74f9941a52315579$export$1bd6b93107e60cf1 = ()=>{
    const tracingContext = (0, $42omo.useContext)($74f9941a52315579$export$e775b9769343d051);
    return tracingContext;
};
module.exports["TracingProvider"] = $74f9941a52315579$export$73f470ced5fdc319;
module.exports["useTracingContext"] = $74f9941a52315579$export$1bd6b93107e60cf1;

});

parcelRegister("5oEbs", function(module, exports) {

var $T9xHm = parcelRequire("T9xHm");


var $1c598 = parcelRequire("1c598");


var $dh538 = parcelRequire("dh538");


var $aVZM7 = parcelRequire("aVZM7");


var $cqiXo = parcelRequire("cqiXo");

const $83c738174c625218$export$9b5c32eaf7c2ac3d = {
    [(0, $1c598.ProductEnvironment).PRODUCTION]: 'prod',
    [(0, $1c598.ProductEnvironment).STAGING]: 'stg',
    [(0, $1c598.ProductEnvironment).DEVELOPMENT]: 'stg'
};
const $83c738174c625218$export$158d41afab8f2af8 = (appId, extension, environment, entryPoint)=>{
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) return (0, $T9xHm.isIsolatedCloud)() ? $83c738174c625218$export$d68551323b971eed(appId, extension, entryPoint) : $83c738174c625218$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint);
    return $83c738174c625218$export$b1a4a6ad329e6bd2(appId, extension, environment, entryPoint);
};
const $83c738174c625218$export$b1a4a6ad329e6bd2 = (appId, extension, environment, entryPoint)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.${(0, $aVZM7.getForgeCDNBaseDomain)(environment)}`;
    /**
	 * The appId is also included in the subdomain so that it can be compared against the appId in the
	 * resource path. This comparison is performed by the routing Lambda@ Edge to prevent a malicious
	 * developer from appending their malicious app path to a legitimate installation id.
	 */ const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension);
    const urlSafeContext = $83c738174c625218$export$223741b87b7c6af6(encodedAppContext);
    return `https://${domain}/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/_ctx_${urlSafeContext}/`;
};
const $83c738174c625218$export$d68551323b971eed = (appId, extension, entryPoint)=>{
    const { installationId: installationId, environmentId: environmentId, appVersion: appVersion, properties: properties } = extension;
    const resourceUploadId = properties.resourceUploadId || appVersion;
    const icDomain = (0, $T9xHm.isolatedCloudDomain)();
    const domain = `${$83c738174c625218$export$d4a94ef9062fefbf(installationId)}--${$83c738174c625218$export$d4a94ef9062fefbf(appId)}.forge-cdn.${icDomain}`;
    const encodedAppContext = (0, $cqiXo.getEncodedAppContext)(extension);
    const urlSafeContext = $83c738174c625218$export$223741b87b7c6af6(encodedAppContext);
    return `https://${domain}/forge-cdn/${appId}/${environmentId}/${resourceUploadId}/${entryPoint}/${(0, $dh538.fg)('forge-ui-ic-hostname-remove') ? '' : `_hostname_${window.location.hostname}/`}_ctx_${urlSafeContext}/`;
};
function $83c738174c625218$export$d4a94ef9062fefbf(uuid) {
    const [a, b, c, d, e] = uuid.split('-');
    const combinedUuid = [
        a,
        `${b}${c}${d}`,
        e
    ];
    return combinedUuid.map((s)=>parseInt(s, 16)).map((s)=>s.toString(36)).join('-');
}
function $83c738174c625218$export$824f5b1835a75769(shortenedUuid) {
    const [a, b, c] = shortenedUuid.split('-').map((s)=>parseInt(s, 36)).map((s)=>s.toString(16));
    // expands the middle segment into the original UUID
    // ffffffff-abcdabcdabcd-ffffffffffff ===> ffffffff-abcd-abcd-abcd-ffffffffffff
    const middleExpanded = b.match(/.{1,4}/g) || b;
    return [
        a,
        ...middleExpanded,
        c
    ].join('-');
}
function $83c738174c625218$export$223741b87b7c6af6(str) {
    return str.replace(/\+/g, '-') // Replace '+' with '-'
    .replace(/\//g, '_') // Replace '/' with '_'
    .replace(/=+$/, ''); // Remove padding
}
module.exports["createSrcFromExtension"] = $83c738174c625218$export$158d41afab8f2af8;
module.exports["urlSafeB64"] = $83c738174c625218$export$223741b87b7c6af6;

});

parcelRegister("LiNdD", function(module, exports) {
const $3ac7139ae0ef30fb$export$563e375d286a76a7 = ()=>{
    if (navigator.languages) return navigator.languages[0];
    return navigator.language;
};
module.exports["getBrowserLocale"] = $3ac7139ae0ef30fb$export$563e375d286a76a7;

});

parcelRegister("4jZsH", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $337f83d71a1a0efc$export$bd17c6970f4d989e = ()=>{
    const platformFeatureFlags = [];
    // Add feature flags that are required to be passed down to the iframe
    // EXAMPLE:
    // if (fg(<flag-name>)) {
    // 	platformFeatureFlags.push(<flag-name>);
    // }
    if ((0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) platformFeatureFlags.push('forge-ui-iframe-analytics');
    if ((0, $dh538.fg)('forge-ui-bridge-core-reset')) platformFeatureFlags.push('forge-ui-bridge-core-reset');
    return platformFeatureFlags;
};


const $f045517dec5f1afb$export$6dd3d030a75d6dba = (tunnels, extensionResource, defaultUrl, urlSafeContext)=>{
    const matchTunnel = tunnels.find((tunnel)=>tunnel.resourceKey === extensionResource);
    const platformFeatureFlags = (0, $337f83d71a1a0efc$export$bd17c6970f4d989e)();
    const queryParams = new URLSearchParams({
        ...platformFeatureFlags.length > 0 ? {
            platformFeatureFlags: platformFeatureFlags.join(',')
        } : {},
        // when tunnelling, pass hostname into query param to be passed into CSP
        ...matchTunnel ? {
            hostname: window.location.hostname,
            ctx: urlSafeContext
        } : {}
    }).toString();
    const query = queryParams ? `?${queryParams}` : '';
    if (matchTunnel) return `${matchTunnel.tunnelUrl}${query}`;
    return `${defaultUrl}${query}`;
};
module.exports["getSrcUrl"] = $f045517dec5f1afb$export$6dd3d030a75d6dba;

});

parcelRegister("6hkBe", function(module, exports) {
const $79126e23f70deddc$export$5dfdba3e408a8d60 = (extension, entryPoint)=>{
    const defaultEntryPoint = extension.properties.resource;
    const alternativeEntryPoint = entryPoint && extension.properties[entryPoint]?.resource;
    return alternativeEntryPoint || defaultEntryPoint;
};
module.exports["getExtensionEntryPoint"] = $79126e23f70deddc$export$5dfdba3e408a8d60;

});

parcelRegister("ge8sG", function(module, exports) {
const $ac41360860378247$export$c34ac5b863279caa = (coreData, extensionData)=>({
        ...coreData,
        extension: extensionData
    });
module.exports["getResolverContext"] = $ac41360860378247$export$c34ac5b863279caa;

});

parcelRegister("UZU5S", function(module, exports) {
const $fff5b396b669afc2$export$68ca3577dbf1f96c = (scopes = [], egress = [])=>{
    // Create a map to store egress data by type then loop through the map to populate the external permissions object
    const egressMap = new Map();
    egress.forEach(({ type: type, addresses: addresses })=>{
        egressMap.set(type, addresses);
    });
    // Construct external permissions from the map
    const externalPermissions = {
        fetch: {
            backend: egressMap.get('FETCH_BACKEND_SIDE') ?? [],
            client: egressMap.get('FETCH_CLIENT_SIDE') ?? []
        },
        fonts: egressMap.get('FONTS') ?? [],
        styles: egressMap.get('STYLES') ?? [],
        frames: egressMap.get('FRAMES') ?? [],
        images: egressMap.get('IMAGES') ?? [],
        media: egressMap.get('MEDIA') ?? [],
        scripts: egressMap.get('SCRIPTS') ?? []
    };
    return {
        scopes: scopes,
        external: externalPermissions
    };
};
const $fff5b396b669afc2$export$20af16720c0f9c71 = ({ resolverContext: resolverContext, accountId: accountId, extension: extension, timezone: timezone, locale: locale, location: location, extensionPayload: extensionPayload, extensionViewData: extensionViewData, theme: theme, surfaceColor: surfaceColor })=>{
    // Combine the static macro extension data with the dynamic extension view data (macro body) into a single macro object
    const macro = {
        ...resolverContext.extension?.macro,
        ...extensionViewData?.macro,
        ...extensionPayload?.macro
    };
    /* adding hasAccess separately instead of using userAccess as a whole is to avoid appending __typename in the context */ const userAccess = extension.userAccess ?? {
        enabled: false,
        hasAccess: false
    };
    // Construct permissions object from scopes and egress
    const permissions = $fff5b396b669afc2$export$68ca3577dbf1f96c(extension?.scopes || [], extension?.egress || []);
    const isGlobalUIModule = extension?.type === 'global:ui';
    return {
        ...resolverContext,
        extension: {
            ...resolverContext.extension,
            ...extensionViewData,
            ...extensionPayload,
            ...Object.keys(macro).length > 0 ? {
                macro: macro
            } : {},
            location: location
        },
        accountId: accountId,
        ...isGlobalUIModule ? {
            installationId: extension.installationId
        } : {},
        license: extension?.license || null,
        timezone: timezone,
        locale: locale,
        theme: theme,
        surfaceColor: surfaceColor,
        userAccess: userAccess,
        permissions: permissions
    };
};
module.exports["getViewContext"] = $fff5b396b669afc2$export$20af16720c0f9c71;

});

parcelRegister("6baEI", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $T9xHm = parcelRequire("T9xHm");

const $3169be2c7bdce757$export$98b91f32256d29a8 = ()=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)($3169be2c7bdce757$export$a6dd2b5c1fe5c76e());
    (0, $42omo.useEffect)(()=>{
        let cancelled = false;
        if (isLoading) $3169be2c7bdce757$var$loadCDNAuthSignedCookie().catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('Error loading CDN auth signed cookie:', err);
        }).finally(()=>{
            if (!cancelled) setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        isLoading
    ]);
    return isLoading;
};
const $3169be2c7bdce757$var$MAX_SIGNED_COOKIE_AGE_MS = 1800000; // 30 minutes
let $3169be2c7bdce757$var$lastSignedCookieFetchTime = 0;
let $3169be2c7bdce757$var$loadingPromise = null;
const $3169be2c7bdce757$var$doLoadCDNAuthSignedCookie = async ()=>{
    // Step 1: Get the signed cookies URL from our backend -> session token based auth
    const signedCookiesUrlResponse = await fetch('/gateway/api/forge-cdn/signed-cookies-url');
    if (!signedCookiesUrlResponse.ok) throw new Error(`Failed to get signed cookies URL: ${signedCookiesUrlResponse.statusText}`);
    // Step 2: Fetch the signed cookies using the obtained URL (with signed URL) -> this will set the cookies in the browser
    const { data: signedCookiesUrl } = await signedCookiesUrlResponse.json();
    if (!signedCookiesUrl || typeof signedCookiesUrl !== 'string') throw new Error('Invalid signed cookies URL received from backend');
    const response = await fetch(signedCookiesUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch signed cookies: ${response.statusText}`);
};
const $3169be2c7bdce757$var$loadCDNAuthSignedCookie = async ()=>{
    if (Date.now() - $3169be2c7bdce757$var$lastSignedCookieFetchTime < $3169be2c7bdce757$var$MAX_SIGNED_COOKIE_AGE_MS) return;
    // this is to ensure only one loadingPromise is active at a time (to avoid multiple simultaneous requests)
    if ($3169be2c7bdce757$var$loadingPromise) await $3169be2c7bdce757$var$loadingPromise;
    else {
        $3169be2c7bdce757$var$loadingPromise = (async ()=>{
            try {
                await $3169be2c7bdce757$var$doLoadCDNAuthSignedCookie();
                $3169be2c7bdce757$var$lastSignedCookieFetchTime = Date.now();
            } finally{
                $3169be2c7bdce757$var$loadingPromise = null;
            }
        })();
        await $3169be2c7bdce757$var$loadingPromise;
    }
};
const $3169be2c7bdce757$export$a6dd2b5c1fe5c76e = ()=>{
    return (0, $dh538.fg)('forge-ui-cdn-auth') && (0, $T9xHm.isIsolatedCloud)();
};
const $3169be2c7bdce757$export$1b22f04514004ab6 = ()=>{
    $3169be2c7bdce757$var$lastSignedCookieFetchTime = 0;
    $3169be2c7bdce757$var$loadingPromise = null;
};
module.exports["useCDNAuthSignedCookie"] = $3169be2c7bdce757$export$98b91f32256d29a8;
module.exports["shouldUseCDNAuth"] = $3169be2c7bdce757$export$a6dd2b5c1fe5c76e;

});

parcelRegister("471wb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("kRUUL")), module.exports);

});

parcelRegister("i35rc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fgbwU = parcelRequire("fgbwU");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");


var $ebrpi = parcelRequire("ebrpi");


var $9P47v = parcelRequire("9P47v");


var $dh538 = parcelRequire("dh538");

// TODO: We should make appName non-optional later: http://go/j/AUX-570
// appName was made optional because it isn't in already inserted apps prior to the change in http://go/j/AUX-411
const $cf1792e251a9a919$var$defaultPromptMessage = (intl, appName)=>{
    return intl.formatMessage((0, $dh538.fg)('product-terminology-refresh') ? $cf1792e251a9a919$var$messages.defaultPromptMessageAppify : $cf1792e251a9a919$var$messages.defaultPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppLower)
    });
};
const $cf1792e251a9a919$var$externalAuthPromptMessage = (intl, appName)=>{
    return intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthPromptMessage, {
        appString: appName ? appName : intl.formatMessage($cf1792e251a9a919$var$messages.thisAppUpper)
    });
};
const $cf1792e251a9a919$export$1d39dc5b47e56ff0 = ({ message: message, promptText: promptText, appName: appName, authUrl: authUrl, onSuccess: onSuccess, metadata: metadata })=>{
    const [failedToAuthenticate, setFailedToAuthenticate] = (0, $42omo.useState)(false);
    const [authFailureMessage, setAuthFailureMessage] = (0, $42omo.useState)(false);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const promptIsForExternalAuth = (0, $fgbwU.isExternalAuth)(authUrl);
    const intl = (0, $aXWIB.useIntl)();
    const startAuth = (0, $42omo.useCallback)(()=>{
        setLoading(true);
        setAuthFailureMessage(false);
        (0, $fgbwU.safeAuth)(authUrl).then(()=>{
            onSuccess().then((callbackAfterConsentFlowHasFinished)=>{
                setLoading(false);
                setFailedToAuthenticate(false);
                if (callbackAfterConsentFlowHasFinished && typeof callbackAfterConsentFlowHasFinished === 'function') callbackAfterConsentFlowHasFinished();
            });
        }, (err)=>{
            setLoading(false);
            setFailedToAuthenticate(true);
            if ((0, $9P47v.isOfTypeAuthError)(err.type)) setAuthFailureMessage(err.message);
        });
    }, [
        authUrl,
        onSuccess,
        setLoading,
        setFailedToAuthenticate,
        setAuthFailureMessage
    ]);
    const promptMessage = failedToAuthenticate ? authFailureMessage || intl.formatMessage($cf1792e251a9a919$var$messages.defaultFailedToAuthMessage) : message || (promptIsForExternalAuth ? $cf1792e251a9a919$var$externalAuthPromptMessage(intl, appName) : $cf1792e251a9a919$var$defaultPromptMessage(intl, appName));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: intl.formatMessage($cf1792e251a9a919$var$messages.externalAuthWarning),
        color: "var(--ds-icon-warning, #E06C00)",
        spacing: "spacious"
    }), promptMessage);
    const externalAuthButtonText = intl.formatMessage($cf1792e251a9a919$var$messages.configureAccess);
    const buttonText = promptText || (promptIsForExternalAuth ? externalAuthButtonText : intl.formatMessage($cf1792e251a9a919$var$messages.allowAccess));
    return {
        loading: loading,
        startAuth: startAuth,
        promptMessage: content,
        buttonText: buttonText
    };
};
const $cf1792e251a9a919$var$messages = (0, $aXWIB.defineMessages)({
    defaultPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message",
        defaultMessage: "For {appString} to display, you need to allow the app to access Atlassian products on your behalf."
    },
    defaultPromptMessageAppify: {
        id: "confluence.threeLOPrompt.use-auth.default.prompt.message-appify",
        defaultMessage: "For {appString} to display, you need to grant it access to Atlassian apps on your behalf."
    },
    externalAuthPromptMessage: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.prompt.message",
        defaultMessage: "{appString} requires additional access to your account."
    },
    thisAppUpper: {
        id: "confluence.threeLOPrompt.use-auth.this.app.upper.message",
        defaultMessage: "This app"
    },
    thisAppLower: {
        id: "confluence.threeLOPrompt.use-auth.this.app.lower.message",
        defaultMessage: "this app"
    },
    defaultFailedToAuthMessage: {
        id: "confluence.threeLOPrompt.use-auth.default.failed.to.auth.message",
        defaultMessage: "Failed to authenticate."
    },
    externalAuthWarning: {
        id: "confluence.threeLOPrompt.use-auth.external.auth.warning.message",
        defaultMessage: "External Auth Warning"
    },
    configureAccess: {
        id: "confluence.threeLOPrompt.use-auth.configure.access.button.text",
        defaultMessage: "Configure access"
    },
    allowAccess: {
        id: "confluence.threeLOPrompt.use-auth.allow.access.button.text",
        defaultMessage: "Allow access"
    }
});
module.exports["useAuth"] = $cf1792e251a9a919$export$1d39dc5b47e56ff0;

});

parcelRegister("9wL22", function(module, exports) {
/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */ // eslint-disable-next-line sonarjs/cognitive-complexity, no-shadow-restricted-names
(function(undefined) {
    if (typeof window === 'undefined') return; // don't run for server side render
    var count = 0, logEnabled = false, hiddenCheckEnabled = false, msgHeader = 'message', msgHeaderLen = msgHeader.length, msgId = '[iFrameSizer]', msgIdLen = msgId.length, pagePosition = null, requestAnimationFrame = window.requestAnimationFrame, resetRequiredMethods = {
        max: 1,
        scroll: 1,
        bodyScroll: 1,
        documentElementScroll: 1
    }, settings = {}, timer = null, defaults = {
        autoResize: true,
        bodyBackground: null,
        bodyMargin: null,
        bodyMarginV1: 8,
        bodyPadding: null,
        checkOrigin: true,
        inPageLinks: false,
        enablePublicMethods: true,
        heightCalculationMethod: 'bodyOffset',
        id: 'iFrameResizer',
        interval: 32,
        log: false,
        maxHeight: Infinity,
        maxWidth: Infinity,
        minHeight: 0,
        minWidth: 0,
        mouseEvents: true,
        resizeFrom: 'parent',
        scrolling: false,
        sizeHeight: true,
        sizeWidth: false,
        warningTimeout: 5000,
        tolerance: 0,
        widthCalculationMethod: 'scroll',
        onClose: function() {
            return true;
        },
        onClosed: function() {},
        onInit: function() {},
        onMessage: function() {
            warn('onMessage function not defined');
        },
        onMouseEnter: function() {},
        onMouseLeave: function() {},
        onResized: function() {},
        onScroll: function() {
            return true;
        }
    };
    function getMutationObserver() {
        return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }
    function addEventListener(el, evt, func) {
        el.addEventListener(evt, func, false);
    }
    function removeEventListener(el, evt, func) {
        el.removeEventListener(evt, func, false);
    }
    function setupRequestAnimationFrame() {
        var vendors = [
            'moz',
            'webkit',
            'o',
            'ms'
        ];
        var x;
        // Remove vendor prefixing if prefixed and break early if not
        for(x = 0; x < vendors.length && !requestAnimationFrame; x += 1)requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        if (!requestAnimationFrame) log('setup', 'RequestAnimationFrame not supported');
        else // Firefox extension content-scripts have a globalThis object that is not the same as window.
        // Binding `requestAnimationFrame` to window allows the function to work and prevents errors
        // being thrown when run in that context, and should be a no-op in every other context.
        requestAnimationFrame = requestAnimationFrame.bind(window);
    }
    function getMyID(iframeId) {
        var retStr = 'Host page: ' + iframeId;
        if (window.top !== window.self) retStr = window.parentIFrame && window.parentIFrame.getId ? window.parentIFrame.getId() + ': ' + iframeId : 'Nested host page: ' + iframeId;
        return retStr;
    }
    function formatLogHeader(iframeId) {
        return msgId + '[' + getMyID(iframeId) + ']';
    }
    function isLogEnabled(iframeId) {
        return settings[iframeId] ? settings[iframeId].log : logEnabled;
    }
    function log(iframeId, msg) {
        output('log', iframeId, msg, isLogEnabled(iframeId));
    }
    function info(iframeId, msg) {
        output('info', iframeId, msg, isLogEnabled(iframeId));
    }
    function warn(iframeId, msg) {
        output('warn', iframeId, msg, true);
    }
    function output(type, iframeId, msg, enabled) {
        if (true === enabled && 'object' === typeof window.console) // eslint-disable-next-line no-console
        console[type](formatLogHeader(iframeId), msg);
    }
    function iFrameListener(event) {
        function resizeIFrame() {
            function resize() {
                setSize(messageData);
                setPagePosition(iframeId);
                on('onResized', messageData);
            }
            ensureInRange('Height');
            ensureInRange('Width');
            syncResize(resize, messageData, 'init');
        }
        function processMsg() {
            var data = msg.substr(msgIdLen).split(':');
            var height = data[1] ? parseInt(data[1], 10) : 0;
            var iframe = settings[data[0]] && settings[data[0]].iframe;
            var compStyle = getComputedStyle(iframe);
            return {
                iframe: iframe,
                id: data[0],
                height: height + getPaddingEnds(compStyle) + getBorderEnds(compStyle),
                width: data[2],
                type: data[3]
            };
        }
        function getPaddingEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.paddingTop ? parseInt(compStyle.paddingTop, 10) : 0;
            var bot = compStyle.paddingBottom ? parseInt(compStyle.paddingBottom, 10) : 0;
            return top + bot;
        }
        function getBorderEnds(compStyle) {
            if (compStyle.boxSizing !== 'border-box') return 0;
            var top = compStyle.borderTopWidth ? parseInt(compStyle.borderTopWidth, 10) : 0;
            var bot = compStyle.borderBottomWidth ? parseInt(compStyle.borderBottomWidth, 10) : 0;
            return top + bot;
        }
        function ensureInRange(Dimension) {
            var max = Number(settings[iframeId]['max' + Dimension]), min = Number(settings[iframeId]['min' + Dimension]), dimension = Dimension.toLowerCase(), size = Number(messageData[dimension]);
            log(iframeId, 'Checking ' + dimension + ' is in range ' + min + '-' + max);
            if (size < min) {
                size = min;
                log(iframeId, 'Set ' + dimension + ' to min value');
            }
            if (size > max) {
                size = max;
                log(iframeId, 'Set ' + dimension + ' to max value');
            }
            messageData[dimension] = '' + size;
        }
        function isMessageFromIFrame() {
            function checkAllowedOrigin() {
                function checkList() {
                    var i = 0, retCode = false;
                    log(iframeId, 'Checking connection is from allowed list of origins: ' + checkOrigin);
                    for(; i < checkOrigin.length; i++)if (checkOrigin[i] === origin) {
                        retCode = true;
                        break;
                    }
                    return retCode;
                }
                function checkSingle() {
                    var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
                    log(iframeId, 'Checking connection is from: ' + remoteHost);
                    return origin === remoteHost;
                }
                return checkOrigin.constructor === Array ? checkList() : checkSingle();
            }
            var origin = event.origin, checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
            if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) throw new Error('Unexpected message received from: ' + origin + ' for ' + messageData.iframe.id + '. Message was: ' + event.data + '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.');
            return true;
        }
        function isMessageForUs() {
            return msgId === ('' + msg).substr(0, msgIdLen) && msg.substr(msgIdLen).split(':')[0] in settings // ''+Protects against non-string msg
            ;
        }
        function isMessageFromMetaParent() {
            // Test if this message is from a parent above us. This is an ugly test, however, updating
            // the message format would break backwards compatibity.
            var retCode = messageData.type in {
                true: 1,
                false: 1,
                undefined: 1
            };
            if (retCode) log(iframeId, 'Ignoring init message from meta parent page');
            return retCode;
        }
        function getMsgBody(offset) {
            return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
        }
        function forwardMsgFromIFrame(msgBody) {
            log(iframeId, 'onMessage passed: {iframe: ' + messageData.iframe.id + ', message: ' + msgBody + '}');
            on('onMessage', {
                iframe: messageData.iframe,
                message: JSON.parse(msgBody)
            });
            log(iframeId, '--');
        }
        function getPageInfo() {
            var bodyPosition = document.body.getBoundingClientRect(), iFramePosition = messageData.iframe.getBoundingClientRect();
            return JSON.stringify({
                iframeHeight: iFramePosition.height,
                iframeWidth: iFramePosition.width,
                clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                clientWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
                offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
                scrollTop: window.pageYOffset,
                scrollLeft: window.pageXOffset,
                documentHeight: document.documentElement.clientHeight,
                documentWidth: document.documentElement.clientWidth,
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            });
        }
        function sendPageInfoToIframe(iframe, iframeId) {
            function debouncedTrigger() {
                trigger('Send Page Info', 'pageInfo:' + getPageInfo(), iframe, iframeId);
            }
            debounceFrameEvents(debouncedTrigger, 32, iframeId);
        }
        function startPageInfoMonitor() {
            function setListener(type, func) {
                function sendPageInfo() {
                    if (settings[id]) sendPageInfoToIframe(settings[id].iframe, id);
                    else stop();
                }
                [
                    'scroll',
                    'resize'
                ].forEach(function(evt) {
                    log(id, type + evt + ' listener for sendPageInfo');
                    func(window, evt, sendPageInfo);
                });
            }
            function stop() {
                setListener('Remove ', removeEventListener);
            }
            function start() {
                setListener('Add ', addEventListener);
            }
            var id = iframeId // Create locally scoped copy of iFrame ID
            ;
            start();
            if (settings[id]) settings[id].stopPageInfo = stop;
        }
        function stopPageInfoMonitor() {
            if (settings[iframeId] && settings[iframeId].stopPageInfo) {
                settings[iframeId].stopPageInfo();
                delete settings[iframeId].stopPageInfo;
            }
        }
        function checkIFrameExists() {
            var retBool = true;
            if (null === messageData.iframe) {
                warn(iframeId, 'IFrame (' + messageData.id + ') not found');
                retBool = false;
            }
            return retBool;
        }
        function getElementPosition(target) {
            var iFramePosition = target.getBoundingClientRect();
            getPagePosition(iframeId);
            return {
                x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
                y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
            };
        }
        function scrollRequestFromChild(addOffset) {
            /* istanbul ignore next */ // Not testable in Karma
            function reposition() {
                pagePosition = newPosition;
                scrollTo();
                log(iframeId, '--');
            }
            function calcOffset() {
                return {
                    x: Number(messageData.width) + offset.x,
                    y: Number(messageData.height) + offset.y
                };
            }
            function scrollParent() {
                if (window.parentIFrame) window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](newPosition.x, newPosition.y);
                else warn(iframeId, 'Unable to scroll to requested position, window.parentIFrame not found');
            }
            var offset = addOffset ? getElementPosition(messageData.iframe) : {
                x: 0,
                y: 0
            }, newPosition = calcOffset();
            log(iframeId, 'Reposition requested from iFrame (offset x:' + offset.x + ' y:' + offset.y + ')');
            if (window.top !== window.self) scrollParent();
            else reposition();
        }
        function scrollTo() {
            if (false !== on('onScroll', pagePosition)) setPagePosition(iframeId);
            else unsetPagePosition();
        }
        function findTarget(location) {
            function jumpToTarget() {
                var jumpPosition = getElementPosition(target);
                log(iframeId, 'Moving to in page link (#' + hash + ') at x: ' + jumpPosition.x + ' y: ' + jumpPosition.y);
                pagePosition = {
                    x: jumpPosition.x,
                    y: jumpPosition.y
                };
                scrollTo();
                log(iframeId, '--');
            }
            function jumpToParent() {
                if (window.parentIFrame) window.parentIFrame.moveToAnchor(hash);
                else log(iframeId, 'In page link #' + hash + ' not found and window.parentIFrame not found');
            }
            var hash = location.split('#')[1] || '', hashData = decodeURIComponent(hash), target = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
            if (target) jumpToTarget();
            else if (window.top !== window.self) jumpToParent();
            else log(iframeId, 'In page link #' + hash + ' not found');
        }
        function onMouse(event) {
            var mousePos = {};
            if (Number(messageData.width) === 0 && Number(messageData.height) === 0) {
                var data = getMsgBody(9).split(':');
                mousePos = {
                    x: data[1],
                    y: data[0]
                };
            } else mousePos = {
                x: messageData.width,
                y: messageData.height
            };
            on(event, {
                iframe: messageData.iframe,
                screenX: Number(mousePos.x),
                screenY: Number(mousePos.y),
                type: messageData.type
            });
        }
        function on(funcName, val) {
            return chkEvent(iframeId, funcName, val);
        }
        function actionMsg() {
            if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
            switch(messageData.type){
                case 'close':
                    closeIFrame(messageData.iframe);
                    break;
                case 'message':
                    forwardMsgFromIFrame(getMsgBody(6));
                    break;
                case 'mouseenter':
                    onMouse('onMouseEnter');
                    break;
                case 'mouseleave':
                    onMouse('onMouseLeave');
                    break;
                case 'autoResize':
                    settings[iframeId].autoResize = JSON.parse(getMsgBody(9));
                    break;
                case 'scrollTo':
                    scrollRequestFromChild(false);
                    break;
                case 'scrollToOffset':
                    scrollRequestFromChild(true);
                    break;
                case 'pageInfo':
                    sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe, iframeId);
                    startPageInfoMonitor();
                    break;
                case 'pageInfoStop':
                    stopPageInfoMonitor();
                    break;
                case 'inPageLink':
                    findTarget(getMsgBody(9));
                    break;
                case 'reset':
                    resetIFrame(messageData);
                    break;
                case 'init':
                    resizeIFrame();
                    on('onInit', messageData.iframe);
                    break;
                default:
                    if (Number(messageData.width) === 0 && Number(messageData.height) === 0) warn('Unsupported message received (' + messageData.type + '), this is likely due to the iframe containing a later ' + 'version of iframe-resizer than the parent page');
                    else resizeIFrame();
            }
        }
        function hasSettings(iframeId) {
            var retBool = true;
            if (!settings[iframeId]) {
                retBool = false;
                warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
            }
            return retBool;
        }
        function iFrameReadyMsgReceived() {
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for(var iframeId in settings)trigger('iFrame requested init', createOutgoingMsg(iframeId), settings[iframeId].iframe, iframeId);
        }
        function firstRun() {
            if (settings[iframeId]) settings[iframeId].firstRun = false;
        }
        var msg = event.data, messageData = {}, iframeId = null;
        if ('[iFrameResizerChild]Ready' === msg) iFrameReadyMsgReceived();
        else if (isMessageForUs()) {
            messageData = processMsg();
            iframeId = messageData.id;
            if (settings[iframeId]) settings[iframeId].loaded = true;
            if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
                log(iframeId, 'Received: ' + msg);
                if (checkIFrameExists() && isMessageFromIFrame()) actionMsg();
            }
        } else info(iframeId, 'Ignored: ' + msg);
    }
    function chkEvent(iframeId, funcName, val) {
        var func = null, retVal = null;
        if (settings[iframeId]) {
            func = settings[iframeId][funcName];
            if ('function' === typeof func) retVal = func(val);
            else throw new TypeError(funcName + ' on iFrame[' + iframeId + '] is not a function');
        }
        return retVal;
    }
    function removeIframeListeners(iframe) {
        var iframeId = iframe.id;
        delete settings[iframeId];
    }
    function closeIFrame(iframe) {
        var iframeId = iframe.id;
        if (chkEvent(iframeId, 'onClose', iframeId) === false) {
            log(iframeId, 'Close iframe cancelled by onClose event');
            return;
        }
        log(iframeId, 'Removing iFrame: ' + iframeId);
        try {
            // Catch race condition error with React
            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        } catch (error) {
            warn(error);
        }
        chkEvent(iframeId, 'onClosed', iframeId);
        log(iframeId, '--');
        removeIframeListeners(iframe);
    }
    function getPagePosition(iframeId) {
        if (null === pagePosition) {
            pagePosition = {
                x: window.pageXOffset !== undefined ? window.pageXOffset : document.documentElement.scrollLeft,
                y: window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop
            };
            log(iframeId, 'Get page position: ' + pagePosition.x + ',' + pagePosition.y);
        }
    }
    function setPagePosition(iframeId) {
        if (null !== pagePosition) {
            window.scrollTo(pagePosition.x, pagePosition.y);
            log(iframeId, 'Set page position: ' + pagePosition.x + ',' + pagePosition.y);
            unsetPagePosition();
        }
    }
    function unsetPagePosition() {
        pagePosition = null;
    }
    function resetIFrame(messageData) {
        function reset() {
            setSize(messageData);
            trigger('reset', 'reset', messageData.iframe, messageData.id);
        }
        log(messageData.id, 'Size reset requested by ' + ('init' === messageData.type ? 'host page' : 'iFrame'));
        getPagePosition(messageData.id);
        syncResize(reset, messageData, 'reset');
    }
    function setSize(messageData) {
        function setDimension(dimension) {
            if (!messageData.id) {
                log('undefined', 'messageData id not set');
                return;
            }
            messageData.iframe.style[dimension] = messageData[dimension] + 'px';
            log(messageData.id, 'IFrame (' + iframeId + ') ' + dimension + ' set to ' + messageData[dimension] + 'px');
        }
        function chkZero(dimension) {
            // FireFox sets dimension of hidden iFrames to zero.
            // So if we detect that set up an event to check for
            // when iFrame becomes visible.
            /* istanbul ignore next */ // Not testable in PhantomJS
            if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
                hiddenCheckEnabled = true;
                log(iframeId, 'Hidden iFrame detected, creating visibility listener');
                fixHiddenIFrames();
            }
        }
        function processDimension(dimension) {
            setDimension(dimension);
            chkZero(dimension);
        }
        var iframeId = messageData.iframe.id;
        if (settings[iframeId]) {
            if (settings[iframeId].sizeHeight) processDimension('height');
            if (settings[iframeId].sizeWidth) processDimension('width');
        }
    }
    function syncResize(func, messageData, doNotSync) {
        /* istanbul ignore if */ // Not testable in PhantomJS
        if (doNotSync !== messageData.type && requestAnimationFrame && // including check for jasmine because had trouble getting spy to work in unit test using requestAnimationFrame
        !window.jasmine) {
            log(messageData.id, 'Requesting animation frame');
            requestAnimationFrame(func);
        } else func();
    }
    function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
        function postMessageToIFrame() {
            var target = settings[id] && settings[id].targetOrigin;
            log(id, '[' + calleeMsg + '] Sending msg to iframe[' + id + '] (' + msg + ') targetOrigin: ' + target);
            iframe.contentWindow.postMessage(msgId + msg, target);
        }
        function iFrameNotFound() {
            warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
        }
        function chkAndSend() {
            if (iframe && 'contentWindow' in iframe && null !== iframe.contentWindow) // Null test for PhantomJS
            postMessageToIFrame();
            else iFrameNotFound();
        }
        function warnOnNoResponse() {
            function warning() {
                if (settings[id] && !settings[id].loaded && !errorShown) {
                    errorShown = true;
                    warn(id, 'IFrame has not responded within ' + settings[id].warningTimeout / 1000 + ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
                }
            }
            if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
        }
        var errorShown = false;
        id = id || iframe.id;
        if (settings[id]) {
            chkAndSend();
            warnOnNoResponse();
        }
    }
    function createOutgoingMsg(iframeId) {
        return iframeId + ':' + settings[iframeId].bodyMarginV1 + ':' + settings[iframeId].sizeWidth + ':' + settings[iframeId].log + ':' + settings[iframeId].interval + ':' + settings[iframeId].enablePublicMethods + ':' + settings[iframeId].autoResize + ':' + settings[iframeId].bodyMargin + ':' + settings[iframeId].heightCalculationMethod + ':' + settings[iframeId].bodyBackground + ':' + settings[iframeId].bodyPadding + ':' + settings[iframeId].tolerance + ':' + settings[iframeId].inPageLinks + ':' + settings[iframeId].resizeFrom + ':' + settings[iframeId].widthCalculationMethod + ':' + settings[iframeId].mouseEvents;
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    function setupIFrame(iframe, options) {
        function setLimits() {
            function addStyle(style) {
                var styleValue = settings[iframeId][style];
                if (Infinity !== styleValue && 0 !== styleValue) {
                    iframe.style[style] = isNumber(styleValue) ? styleValue + 'px' : styleValue;
                    log(iframeId, 'Set ' + style + ' = ' + iframe.style[style]);
                }
            }
            function chkMinMax(dimension) {
                if (settings[iframeId]['min' + dimension] > settings[iframeId]['max' + dimension]) throw new Error('Value for min' + dimension + ' can not be greater than max' + dimension);
            }
            chkMinMax('Height');
            chkMinMax('Width');
            addStyle('maxHeight');
            addStyle('minHeight');
            addStyle('maxWidth');
            addStyle('minWidth');
        }
        function newId() {
            var id = options && options.id || defaults.id + count++;
            if (null !== document.getElementById(id)) id += count++;
            return id;
        }
        function ensureHasId(iframeId) {
            if ('' === iframeId) {
                // eslint-disable-next-line no-multi-assign
                iframe.id = iframeId = newId();
                logEnabled = (options || {}).log;
                log(iframeId, 'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')');
            }
            return iframeId;
        }
        function setScrolling() {
            log(iframeId, 'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
            iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
            switch(settings[iframeId] && settings[iframeId].scrolling){
                case 'omit':
                    break;
                case true:
                    iframe.scrolling = 'yes';
                    break;
                case false:
                    iframe.scrolling = 'no';
                    break;
                default:
                    iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
            }
        }
        // The V1 iFrame script expects an int, where as in V2 expects a CSS
        // string value such as '1px 3em', so if we have an int for V2, set V1=V2
        // and then convert V2 to a string PX value.
        function setupBodyMarginValues() {
            if ('number' === typeof (settings[iframeId] && settings[iframeId].bodyMargin) || '0' === (settings[iframeId] && settings[iframeId].bodyMargin)) {
                settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
                settings[iframeId].bodyMargin = '' + settings[iframeId].bodyMargin + 'px';
            }
        }
        function checkReset() {
            // Reduce scope of firstRun to function, because IE8's JS execution
            // context stack is borked and this value gets externally
            // changed midway through running this function!!!
            var firstRun = settings[iframeId] && settings[iframeId].firstRun, resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;
            if (!firstRun && resetRequertMethod) resetIFrame({
                iframe: iframe,
                height: 0,
                width: 0,
                type: 'init'
            });
        }
        function setupIFrameObject() {
            if (settings[iframeId]) settings[iframeId].iframe.iFrameResizer = {
                close: closeIFrame.bind(null, settings[iframeId].iframe),
                removeListeners: removeIframeListeners.bind(null, settings[iframeId].iframe),
                resize: trigger.bind(null, 'Window resize', 'resize', settings[iframeId].iframe),
                moveToAnchor: function(anchor) {
                    trigger('Move to anchor', 'moveToAnchor:' + anchor, settings[iframeId].iframe, iframeId);
                },
                sendMessage: function(message) {
                    message = JSON.stringify(message);
                    trigger('Send Message', 'message:' + message, settings[iframeId].iframe, iframeId);
                }
            };
        }
        // We have to call trigger twice, as we can not be sure if all
        // iframes have completed loading when this code runs. The
        // event listener also catches the page changing in the iFrame.
        function init(msg) {
            function iFrameLoaded() {
                trigger('iFrame.onload', msg, iframe, undefined, true);
                checkReset();
            }
            function createDestroyObserver(MutationObserver) {
                if (!iframe.parentNode) return;
                var destroyObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        var removedNodes = Array.prototype.slice.call(mutation.removedNodes) // Transform NodeList into an Array
                        ;
                        removedNodes.forEach(function(removedNode) {
                            if (removedNode === iframe) closeIFrame(iframe);
                        });
                    });
                });
                destroyObserver.observe(iframe.parentNode, {
                    childList: true
                });
            }
            var MutationObserver = getMutationObserver();
            if (MutationObserver) createDestroyObserver(MutationObserver);
            addEventListener(iframe, 'load', iFrameLoaded);
            trigger('init', msg, iframe, undefined, true);
        }
        function checkOptions(options) {
            if ('object' !== typeof options) throw new TypeError('Options is not an object');
        }
        function copyOptions(options) {
            // eslint-disable-next-line no-restricted-syntax
            for(var option in defaults)if (Object.prototype.hasOwnProperty.call(defaults, option)) settings[iframeId][option] = Object.prototype.hasOwnProperty.call(options, option) ? options[option] : defaults[option];
        }
        function getTargetOrigin(remoteHost) {
            return '' === remoteHost || null !== remoteHost.match(/^(about:blank|javascript:|file:\/\/)/) ? '*' : remoteHost;
        }
        function depricate(key) {
            var splitName = key.split('Callback');
            if (splitName.length === 2) {
                var name = 'on' + splitName[0].charAt(0).toUpperCase() + splitName[0].slice(1);
                this[name] = this[key];
                delete this[key];
                warn(iframeId, "Deprecated: '" + key + "' has been renamed '" + name + "'. The old method will be removed in the next major version.");
            }
        }
        function processOptions(options) {
            options = options || {};
            settings[iframeId] = {
                firstRun: true,
                iframe: iframe,
                remoteHost: iframe.src && iframe.src.split('/').slice(0, 3).join('/')
            };
            checkOptions(options);
            Object.keys(options).forEach(depricate, options);
            copyOptions(options);
            if (settings[iframeId]) settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
        }
        function beenHere() {
            return iframeId in settings && 'iFrameResizer' in iframe;
        }
        var iframeId = ensureHasId(iframe.id);
        if (!beenHere()) {
            processOptions(options);
            setScrolling();
            setLimits();
            setupBodyMarginValues();
            init(createOutgoingMsg(iframeId));
            setupIFrameObject();
        } else warn(iframeId, 'Ignored iFrame, already setup.');
    }
    function debouce(fn, time) {
        if (null === timer) timer = setTimeout(function() {
            timer = null;
            fn();
        }, time);
    }
    var frameTimer = {};
    function debounceFrameEvents(fn, time, frameId) {
        if (!frameTimer[frameId]) frameTimer[frameId] = setTimeout(function() {
            frameTimer[frameId] = null;
            fn();
        }, time);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function fixHiddenIFrames() {
        function checkIFrames() {
            function checkIFrame(settingId) {
                function chkDimension(dimension) {
                    return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
                }
                function isVisible(el) {
                    return null !== el.offsetParent;
                }
                if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
            }
            Object.keys(settings).forEach(function(key) {
                checkIFrame(key);
            });
        }
        function mutationObserved(mutations) {
            log('window', 'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
            debouce(checkIFrames, 16);
        }
        function createMutationObserver() {
            var target = document.querySelector('body'), config = {
                attributes: true,
                attributeOldValue: false,
                characterData: true,
                characterDataOldValue: false,
                childList: true,
                subtree: true
            }, observer = new MutationObserver(mutationObserved);
            observer.observe(target, config);
        }
        var MutationObserver = getMutationObserver();
        if (MutationObserver) createMutationObserver();
    }
    function resizeIFrames(event) {
        function resize() {
            sendTriggerMsg('Window ' + event, 'resize');
        }
        log('window', 'Trigger event: ' + event);
        debouce(resize, 16);
    }
    // Not testable in PhantomJS
    /* istanbul ignore next */ function tabVisible() {
        function resize() {
            sendTriggerMsg('Tab Visable', 'resize');
        }
        if ('hidden' !== document.visibilityState) {
            log('document', 'Trigger event: Visiblity change');
            debouce(resize, 16);
        }
    }
    function sendTriggerMsg(eventName, event) {
        function isIFrameResizeEnabled(iframeId) {
            return settings[iframeId] && 'parent' === settings[iframeId].resizeFrom && settings[iframeId].autoResize && !settings[iframeId].firstRun;
        }
        Object.keys(settings).forEach(function(iframeId) {
            if (isIFrameResizeEnabled(iframeId)) trigger(eventName, event, settings[iframeId].iframe, iframeId);
        });
    }
    function setupEventListeners() {
        addEventListener(window, 'message', iFrameListener);
        addEventListener(window, 'resize', function() {
            resizeIFrames('resize');
        });
        addEventListener(document, 'visibilitychange', tabVisible);
        addEventListener(document, '-webkit-visibilitychange', tabVisible);
    }
    function factory() {
        function init(options, element) {
            function chkType() {
                if (!element.tagName) throw new TypeError('Object is not a valid DOM element');
                else if ('IFRAME' !== element.tagName.toUpperCase()) throw new TypeError('Expected <IFRAME> tag, found <' + element.tagName + '>');
            }
            if (element) {
                chkType();
                setupIFrame(element, options);
                iFrames.push(element);
            }
        }
        function warnDeprecatedOptions(options) {
            if (options && options.enablePublicMethods) warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
        }
        var iFrames;
        setupRequestAnimationFrame();
        setupEventListeners();
        return function iFrameResizeF(options, target) {
            iFrames = []; // Only return iFrames past in on this call
            warnDeprecatedOptions(options);
            switch(typeof target){
                case 'undefined':
                case 'string':
                    Array.prototype.forEach.call(document.querySelectorAll(target || 'iframe'), init.bind(undefined, options));
                    break;
                case 'object':
                    init(options, target);
                    break;
                default:
                    throw new TypeError('Unexpected data type (' + typeof target + ')');
            }
            return iFrames;
        };
    }
    function createJQueryPublicMethod($) {
        if (!$.fn) info('', 'Unable to bind to jQuery, it is not fully loaded.');
        else if (!$.fn.iFrameResize) $.fn.iFrameResize = function $iFrameResizeF(options) {
            function init(index, element) {
                setupIFrame(element, options);
            }
            return this.filter('iframe').each(init).end();
        };
    }
    if (window.jQuery) createJQueryPublicMethod(window.jQuery);
    if (typeof define === 'function' && define.amd) define([], factory);
    else if (typeof module.exports === 'object') // Node for browserfy
    module.exports = factory();
    window.iFrameResize = window.iFrameResize || factory();
})();

});

parcelRegister("ijfiP", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");

const $e2d7503e18a8780a$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $7MEO5.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};
module.exports["parseExtensionId"] = $e2d7503e18a8780a$export$bae42cbaf7fa3e1b;

});

parcelRegister("7oKJR", function(module, exports) {

var $c4TO3 = parcelRequire("c4TO3");

const $65eef95050715244$var$SESSION_APPS_KEY = 'forge-ui.seen-app-keys';
/**
 *  This module is used to track the seen app context keys in session storage specifically
 *  for the forge.ui.extension loaded analytic event
 *  - Stores the last accessed date and the seen app context keys in session storage
 *  - The last accessed date is used to determine if the session is expired
 *  - The seen app context keys are used to determine if the event has already been sent
 *  - Session storage is used to avoid sending duplicate events on page refreshes or navigations
 */ let $65eef95050715244$var$storageState = {
    lastUpdated: null,
    appKeys: null
};
// Use a number for faster comparisons
const $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch = ()=>{
    return Math.floor(Date.now() / 86400000);
};
const $65eef95050715244$var$checkIsExpired = ()=>{
    const today = $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch();
    // If the last updated date is not today, the state has expired and so we reset it
    return today !== $65eef95050715244$var$storageState.lastUpdated;
};
const $65eef95050715244$var$resetState = ()=>{
    $65eef95050715244$var$storageState.appKeys = new Set();
    $65eef95050715244$var$storageState.lastUpdated = $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch();
};
const $65eef95050715244$export$b103ab7a7dac10e9 = ()=>{
    // If the app context keys have values, this call has already been made by another renderer and so we can return here
    if ($65eef95050715244$var$storageState.appKeys !== null) return;
    // Check for the app context keys in session storage and store it into memory
    // This is called once across any number of ForgeUIRenderers on the page guarded by the above `if` statement
    try {
        const appKeyfilterSessionStorageContextInStorage = JSON.parse((0, $c4TO3.AtlBrowserStorageSession).getItem($65eef95050715244$var$SESSION_APPS_KEY) ?? '{}');
        $65eef95050715244$var$storageState = {
            appKeys: new Set(appKeyfilterSessionStorageContextInStorage.appKeys),
            lastUpdated: Number(appKeyfilterSessionStorageContextInStorage.lastUpdated)
        };
        // If the state is expired, we reset it
        if ($65eef95050715244$var$checkIsExpired()) {
            $65eef95050715244$var$resetState();
            return;
        }
    } catch  {
        $65eef95050715244$var$resetState();
    }
};
const $65eef95050715244$var$writeToSessionStorage = ()=>{
    try {
        // Set a limit to avoid overloading session storage
        if ($65eef95050715244$var$storageState?.appKeys?.size && $65eef95050715244$var$storageState?.appKeys?.size < 100) (0, $c4TO3.AtlBrowserStorageSession).setItem($65eef95050715244$var$SESSION_APPS_KEY, JSON.stringify({
            appKeys: Array.from($65eef95050715244$var$storageState.appKeys ?? []),
            lastUpdated: $65eef95050715244$var$getTodayAsNumberOfDaysSinceEpoch()
        }));
    } catch  {
    // If session storage is not available, we don't want to throw an error
    }
};
// Catches navigation or page refresh events and writes to session storage synchronously
window.addEventListener('beforeunload', ()=>{
    $65eef95050715244$var$writeToSessionStorage();
});
const $65eef95050715244$var$shouldAllowAndTrackEvent = (contextKey)=>{
    // State has expired
    if ($65eef95050715244$var$checkIsExpired()) {
        $65eef95050715244$var$resetState();
        $65eef95050715244$var$storageState.appKeys?.add(contextKey);
        return true;
    }
    if ($65eef95050715244$var$storageState.appKeys?.has(contextKey)) return false;
    $65eef95050715244$var$storageState.appKeys?.add(contextKey);
    return true;
};
const $65eef95050715244$var$findAppContextKeyInEvent = (event)=>{
    if (!event.context) return undefined;
    for (const context of event.context){
        const { appId: appId, extensionKey: extensionKey } = context.forgeUIAttributes ?? {};
        if (appId && extensionKey) return `${appId}/${extensionKey}`;
    }
    return undefined;
};
const $65eef95050715244$export$8869481ff1a02956 = (event)=>{
    try {
        const appContextKey = $65eef95050715244$var$findAppContextKeyInEvent(event);
        if (appContextKey) {
            const shouldAllow = $65eef95050715244$var$shouldAllowAndTrackEvent(appContextKey);
            return shouldAllow;
        }
    } catch  {
    // in case of any error, we let the event through, so we don't accidentally break analytics
    }
    return true;
};
module.exports["setupContextKeysFromSessionStorage"] = $65eef95050715244$export$b103ab7a7dac10e9;
module.exports["extensionLoadedEventFilter"] = $65eef95050715244$export$8869481ff1a02956;

});

parcelRegister("ly9ul", function(module, exports) {
const $b9631ed1ce649aaf$var$messages = [
    'Window closed for',
    'Window did not load after'
];
const $b9631ed1ce649aaf$export$fab3177d2bcbd98a = (error)=>error instanceof Error && $b9631ed1ce649aaf$var$messages.some((message)=>error.message.startsWith(message));
module.exports["isUnrecoverableError"] = $b9631ed1ce649aaf$export$fab3177d2bcbd98a;

});

parcelRegister("eI4ye", function(module, exports) {

var $9JpPs = parcelRequire("9JpPs");


var $dh538 = parcelRequire("dh538");


var $42omo = parcelRequire("42omo");


var $1uzCd = parcelRequire("1uzCd");


var $kynWP = parcelRequire("kynWP");


var $IiIMy = parcelRequire("IiIMy");


var $cUcZ5 = parcelRequire("cUcZ5");

const $7f6ed9fbce688d04$export$433ff3d294755246 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $7f6ed9fbce688d04$export$e943a7fca26f09e4 = 10000;
const $7f6ed9fbce688d04$var$offsetElapsedTimestamps = (events, elapsedBaselineMark)=>{
    return events.map((event)=>{
        const evaluatedElapsedTime = event.elapsed - elapsedBaselineMark;
        event.elapsed = evaluatedElapsedTime;
        return event;
    });
};
const $7f6ed9fbce688d04$export$9cdba3450d9c6cdc = ({ children: children, appType: appType, forgeEnvironment: forgeEnvironment, profileKey: profileKey, extensionType: extensionType, appVersion: appVersion })=>{
    // Rely on refs to avoid re-rendering all children components when the state changes
    const performanceTimelineRef = (0, $42omo.useRef)({
        events: [],
        listeners: new Set()
    });
    const hasSent = (0, $42omo.useRef)(false);
    const elapsedBaselineMark = (0, $42omo.useRef)(0);
    // Store profile ID in ref to generate once per session and reuse
    const profileIdRef = (0, $42omo.useRef)(null);
    const captureConfig = (0, $kynWP.getAppPerfCaptureConfig)({
        module: extensionType
    });
    const { enabled: enabled, capture: capture } = (0, $IiIMy.useAppPerfCaptureStrategy)({
        config: captureConfig,
        samplingKey: profileKey
    });
    // Reset state when profileKey changes
    (0, $42omo.useEffect)(()=>{
        hasSent.current = false;
        performanceTimelineRef.current.events = [];
        elapsedBaselineMark.current = (0, $1uzCd.getPerformanceMark)();
        profileIdRef.current = null; // Reset profile ID for new session
    // Use `profileKey` to reset all state when the extension or entryPoint changes to collect a new set of analytics
    }, [
        profileKey
    ]);
    // Memoize static attributes to avoid recreating on every render
    const staticAttributes = (0, $42omo.useMemo)(()=>({
            appType: appType,
            forgeEnvironment: forgeEnvironment,
            appVersion: appVersion,
            eventVersion: captureConfig.version
        }), [
        appType,
        forgeEnvironment,
        appVersion,
        captureConfig.version
    ]);
    // Create stable callback for capturing analytics
    const captureAnalytics = (0, $42omo.useCallback)(()=>{
        // Generate profile ID once per session
        if (!profileIdRef.current) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        profileIdRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        capture({
            profileId: profileIdRef.current,
            events: $7f6ed9fbce688d04$var$offsetElapsedTimestamps(performanceTimelineRef.current.events, elapsedBaselineMark.current),
            // Time difference since this event was fired and since page loaded
            navigationTimeStart: elapsedBaselineMark.current,
            ...staticAttributes
        });
        hasSent.current = true;
    }, [
        capture,
        staticAttributes
    ]);
    // Send all collected performance related analytics in a single event
    (0, $42omo.useEffect)(()=>{
        if (!enabled || hasSent.current) return;
        const timeout = setTimeout(()=>{
            captureAnalytics();
        }, $7f6ed9fbce688d04$export$e943a7fca26f09e4);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        enabled,
        captureAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f6ed9fbce688d04$export$433ff3d294755246.Provider, {
        value: performanceTimelineRef
    }, children);
};
const $7f6ed9fbce688d04$export$ec3453941beb4064 = (0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled'), $7f6ed9fbce688d04$export$9cdba3450d9c6cdc, (0, $42omo.Fragment));
module.exports["PerformanceAnalyticsContext"] = $7f6ed9fbce688d04$export$433ff3d294755246;
module.exports["PERFORMANCE_ANALYTICS_INTERVAL"] = $7f6ed9fbce688d04$export$e943a7fca26f09e4;
module.exports["PerformanceAnalyticsProviderRollout"] = $7f6ed9fbce688d04$export$ec3453941beb4064;

});

parcelRegister("3Faxc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $iXCQx = parcelRequire("iXCQx");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");

const $addf217f71a4534b$var$cssActionItem = null;
const $addf217f71a4534b$var$messages = (0, $aXWIB.defineMessages)({
    navigationWarningTitle: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-title",
        defaultMessage: "Opening external page on {hostname}"
    },
    navigationWarningBody: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-body",
        defaultMessage: "is sending you to an external page. Ensure you trust that page before you continue."
    },
    navigationWarningBodyNoAppName: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-body-no-app-name",
        defaultMessage: "This app is sending you to an external page. Ensure you trust that page before you continue."
    },
    navigationWarningAppSecurityLink: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-app-security-link",
        defaultMessage: "Learn more about app security"
    },
    navigationWarningCancelButton: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-cancel-button",
        defaultMessage: "Cancel"
    },
    navigationWarningContinueButton: {
        id: "forge-ui.custom-ui.bridge.messages.navigation-warning-continue-button",
        defaultMessage: "Continue"
    }
});
const $addf217f71a4534b$var$ModalFooter = ({ onCancel: onCancel, onConfirm: onConfirm })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- to avoid import of css module from @compiled/react
    , {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        href: "https://go.atlassian.com/forge-help-app-security",
        appearance: "subtle-link",
        target: "_blank",
        rel: "noopener noreferrer",
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf"
        ])
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningAppSecurityLink)), /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_1e0c116y _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onCancel
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningCancelButton))), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _19pkidpf _2hwx1b66 _otyridpf _18u01b66"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onConfirm
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningContinueButton))))));
};
const $addf217f71a4534b$export$72ece4fe8d8dbff9 = ({ url: url, extensionTitle: extensionTitle, onConfirm: onConfirm, onCancel: onCancel })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onCancel
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningTitle, {
        hostname: url.hostname
    }))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, extensionTitle ? /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "strong"
    }, extensionTitle), ' ', intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningBody)) : /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p"
    }, intl.formatMessage($addf217f71a4534b$var$messages.navigationWarningBodyNoAppName)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p",
        maxLines: 1
    }, url.href)), /*#__PURE__*/ $42omo.createElement($addf217f71a4534b$var$ModalFooter, {
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};
module.exports["ExternalLinkModal"] = $addf217f71a4534b$export$72ece4fe8d8dbff9;

});

parcelRegister("kxKUs", function(module, exports) {

var $4No1R = parcelRequire("4No1R");


var $42omo = parcelRequire("42omo");


var $5yfLD = parcelRequire("5yfLD");


var $9zb43 = parcelRequire("9zb43");


var $inPa6 = parcelRequire("inPa6");


var $lzcvT = parcelRequire("lzcvT");


var $8z9j5 = parcelRequire("8z9j5");


var $dWSaf = parcelRequire("dWSaf");


var $4c2yb = parcelRequire("4c2yb");


var $b4nol = parcelRequire("b4nol");


var $luNHV = parcelRequire("luNHV");


var $7KMPr = parcelRequire("7KMPr");

var $kaOT1 = parcelRequire("kaOT1");


var $5U2YR = parcelRequire("5U2YR");


var $cMiG0 = parcelRequire("cMiG0");


var $3e6Uc = parcelRequire("3e6Uc");


var $irOoi = parcelRequire("irOoi");


var $iqcSr = parcelRequire("iqcSr");

var $ijfiP = parcelRequire("ijfiP");


var $1JDPF = parcelRequire("1JDPF");


var $dh538 = parcelRequire("dh538");


var $974zo = parcelRequire("974zo");


var $2gNWY = parcelRequire("2gNWY");


var $6oQb1 = parcelRequire("6oQb1");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $buzAL = parcelRequire("buzAL");


var $hQK66 = parcelRequire("hQK66");


var $3qMxz = parcelRequire("3qMxz");


var $fyIiK = parcelRequire("fyIiK");

let $2472ed5b4088eda9$var$storedBaseUrlRelay = '';
let $2472ed5b4088eda9$var$createIframeBridge = null;
let $2472ed5b4088eda9$var$postRobotSend = null;


// bridge-core import relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    $2472ed5b4088eda9$var$createIframeBridge = (parcelRequire("eLUTa")).createIframeBridge;
    $2472ed5b4088eda9$var$postRobotSend = (parcelRequire("eLUTa")).postRobotSend;
}
const $2472ed5b4088eda9$var$mapCustomBridgeMethods = ({ customBridgeMethods: customBridgeMethods, withFausMessageForwarder: withFausMessageForwarder, isUIKitEmbeddedMacro: isUIKitEmbeddedMacro, embeddedMacroLocalId: embeddedMacroLocalId })=>{
    if (!customBridgeMethods) return {};
    return Object.keys(customBridgeMethods).reduce((acc, key)=>{
        return {
            ...acc,
            [key]: withFausMessageForwarder(key, (payload)=>{
                const data = isUIKitEmbeddedMacro ? (0, $fyIiK.transformDataForEmbeddedMacros)(key, embeddedMacroLocalId, payload?.data) : payload?.data;
                return customBridgeMethods[key](data);
            })
        };
    }, {});
};
class $2472ed5b4088eda9$export$d86296fe47e644cc extends Error {
    constructor(cause){
        super(cause);
    }
}
const $2472ed5b4088eda9$var$MACRO_MODULE_NAME = 'xen:macro';
const $2472ed5b4088eda9$export$c2bd95920a67f979 = 'forge-adf-renderer';
// Tracks re-initialisation of the bridge and logs a warning to console and analytics
const $2472ed5b4088eda9$var$useBridgeReinitTracker = ()=>{
    const { trackExtensionRemounted: trackExtensionRemounted } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const mountedCount = (0, $42omo.useRef)(0);
    const trackBridgeReinited = (0, $hQK66.useCallbackOne)(()=>{
        try {
            mountedCount.current += 1;
            if (mountedCount.current > 1) {
                trackExtensionRemounted({
                    mountCount: mountedCount.current,
                    isUseBridgeReinit: true
                });
                // eslint-disable-next-line no-console
                console.warn(`Warning: useBridge re-initialised the bridge ${mountedCount.current} times.`);
            }
        } catch  {}
    }, [
        mountedCount,
        trackExtensionRemounted
    ]);
    return trackBridgeReinited;
};
const $2472ed5b4088eda9$export$23a7a1286dcfa590 = ({ cloudId: cloudId, theme: theme, surfaceColor: surfaceColor, origin: origin, api: api, customBridgeMethods: customBridgeMethods, onLoad: onLoad, isResizable: isResizable, height: height, environment: environment, extension: extension, iframeRef: iframeRef, contextIds: contextIds, isInModal: isInModal, localId: localId, isEmbeddedMacro: isEmbeddedMacro = false, embeddedParentLocalId: embeddedParentLocalId, extensionPayload: extensionPayload, extensionData: extensionData })=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [loadedAt, setLoadedAt] = (0, $42omo.useState)(null);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    // This ref avoids the api object ending up in the dep array
    // of the effect that calls createIframeBridge. It means that
    // people can pass anonymous functions as the api without the
    // bridge being re-created every render.
    const apiRef = (0, $42omo.useRef)(api);
    (0, $42omo.useEffect)(()=>{
        apiRef.current = api;
    }, [
        api
    ]);
    // Used for passing embedded macro extension object to
    // parent bodied macro Custom UI renderer.
    const extensionRef = (0, $42omo.useRef)(extension);
    // Used for passing embedded macro extensionPayload to  modal renderer.
    // Only used in editor view mode so config will always be up to date.
    const extensionPayloadRef = (0, $42omo.useRef)(extensionPayload);
    // Used for passing embedded macro extensionData to modal renderer
    // Extension data is a static object containing context values for the app, so no update needed.
    const extensionDataRef = (0, $42omo.useRef)(extensionData);
    const enableThemingRef = (0, $42omo.useRef)();
    const setThemeRef = (0, $42omo.useRef)();
    // this ref tracks the initial theme to avoid unnecessary theme updates.
    // specifically, it is used in createIframeBridge during the initial forge runtime initialization,
    // so that the iframe can set the theme correctly on the ready event (initial handshake).
    // however, subsequent theme should not cause createIframeBridge to be called again.
    const initialThemeRef = (0, $42omo.useRef)({
        theme: theme,
        surfaceColor: surfaceColor
    });
    const trackBridgeReinited = $2472ed5b4088eda9$var$useBridgeReinitTracker();
    (0, $42omo.useEffect)(()=>{
        if (!setThemeRef.current) return;
        // we track the theme changes here to avoid calling createIframeBridge (expensive and error prone) unnecessarily
        initialThemeRef.current = {
            theme: theme,
            surfaceColor: surfaceColor
        };
        setThemeRef.current(theme, surfaceColor, environment);
        (0, $dh538.fg)('forge-ui-use-theme') && (0, $luNHV.emit)('FORGE_CORE_THEME_CHANGED', {
            theme: theme
        });
    }, [
        theme,
        surfaceColor,
        loading,
        environment
    ]);
    // same as above, but for customBridgeMethods
    const customBridgeMethodsRef = (0, $42omo.useRef)(customBridgeMethods);
    (0, $42omo.useEffect)(()=>{
        customBridgeMethodsRef.current = customBridgeMethods;
    }, [
        customBridgeMethods
    ]);
    const [errorExtensionDetails, setErrorExtensionDetails] = (0, $42omo.useState)({
        id: extension.id,
        properties: extension.properties,
        type: extension.type,
        environmentType: extension.environmentType,
        appOwnerAccountId: extension.appOwner?.accountId
    });
    const tracing = (0, $kaOT1.useTracingContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackForgeFeatureFlagEvent: trackForgeFeatureFlagEvent, trackObjectStoreAction: trackObjectStoreAction, trackHandShakeMetric: trackHandShakeMetric } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    (0, $42omo.useEffect)(()=>{
        const { type: type, environmentType: environmentType, properties: properties, appOwnerAccountId: appOwnerAccountId, id: id } = errorExtensionDetails;
        if (extension.id !== id || extension.type !== type || extension.environmentType !== environmentType || extension.appOwner?.accountId !== appOwnerAccountId || !(0, (/*@__PURE__*/$parcel$interopDefault($5yfLD)))(extension.properties, properties)) setErrorExtensionDetails({
            id: extension.id,
            properties: extension.properties,
            type: extension.type,
            environmentType: extension.environmentType,
            appOwnerAccountId: extension.appOwner?.accountId
        });
    }, [
        extension,
        errorExtensionDetails
    ]);
    const { id: id, installationId: installationId } = extension;
    // Need to retrieve appId here because extension.appId could be undefined in certain products. For example, Jira extensions do not provide the appId.
    const appId = extension.appId ?? (0, $ijfiP.parseExtensionId)(extension.id).appId;
    const getAppForgeUIExtensions = (0, $1JDPF.useGetAppForgeUIExtensions)({
        appId: appId,
        environmentId: extension.environmentId,
        moduleType: extension.type,
        contextIds: contextIds,
        context: {},
        includeHidden: false,
        cloudId: cloudId,
        bypassNewForgeExtensionListCall: true
    });
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    // Query to retrieve the base url of a tenant.
    // The same Atlassian tenant could have a different custom domain for each product.
    // We retrieve the underlying Atlassian domain here to use for URL creation in routing to support cross custom domain routing
    const getBaseUrl = (0, $42omo.useCallback)(async ()=>{
        if (!cloudId) return window.location.origin;
        if (relayEnvironment) {
            if ($2472ed5b4088eda9$var$storedBaseUrlRelay) return $2472ed5b4088eda9$var$storedBaseUrlRelay;
            const observable = (0, $3e6Uc.fetchQuery)(relayEnvironment, (0, $4No1R.default), {
                cloudIds: [
                    cloudId
                ]
            });
            return new Promise((resolve, reject)=>{
                let settled = false;
                observable.subscribe({
                    next: (data)=>{
                        if (settled) return;
                        settled = true;
                        const baseUrl = data?.tenantContexts?.[0]?.cloudUrl ?? '';
                        $2472ed5b4088eda9$var$storedBaseUrlRelay = baseUrl;
                        resolve(baseUrl);
                    },
                    error: (err)=>{
                        if (!settled) {
                            settled = true;
                            reject(err);
                        }
                    },
                    complete: ()=>{
                        if (!settled) {
                            settled = true;
                            resolve($2472ed5b4088eda9$var$storedBaseUrlRelay ?? '');
                        }
                    }
                });
            });
        } else return window.location.origin;
    }, [
        cloudId,
        relayEnvironment
    ]);
    const appType = (0, $42omo.useMemo)(()=>(0, $iqcSr.isCustomUI)(extension) ? 'CustomUI' : 'UIKit', [
        extension
    ]);
    const { captureEvent: captureEvent, captureUntrustedEvent: captureUntrustedEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    // The event subscription need to be maintained outside of useEffect to avoid missing events when the createIframeBridge is re-created
    // specifically, createIframeBridge could be re-created when the app "re-render", however, in such cases we do not want to lose the existing event subscriptions
    // after all, we should consider ensure createIframeBridge not to be re-created unnecessarily (only when completely app re-mount is really needed)
    const eventCallbacksRef = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            for (const subscription of eventCallbacksRef.current)subscription.unsubscribe();
            eventCallbacksRef.current = [];
        };
    }, []);
    const { properties: { layout: layout }, type: type, environmentType: environmentType } = extension;
    (0, $42omo.useEffect)(()=>{
        //this should never happen on client side
        if (!$2472ed5b4088eda9$var$createIframeBridge) return;
        const iframeEl = iframeRef.current;
        if (iframeEl?.contentWindow && !loading && typeof loadedAt === 'number') {
            const extensionDetails = {
                appId: appId,
                id: id.split('/').slice(0, 3).join('/'),
                installationId: installationId
            };
            const sendHandshakeMetric = (page)=>{
                return (success, error)=>{
                    trackHandShakeMetric({
                        source: page,
                        success: success,
                        error: error
                    });
                    if (error) {
                        const handshakeError = error instanceof Error ? new Error(`Bridge handshake error: ${error.message}`) : new Error('Unknown bridge handshake error');
                        (0, $7KMPr.captureAndReportError)({
                            error: handshakeError,
                            environment: environment,
                            errorExtensionDetails: errorExtensionDetails,
                            page: page,
                            tracing: tracing
                        });
                    }
                };
            };
            const platform_add_bridge_message_forwarding_from_faus = (0, $dh538.fg)('platform_add_bridge_message_forwarding_from_faus');
            // Only forward when we're the gateway (FAUS). Product (e.g. forge-ui-kit adf-renderer) uses bridge directly.
            const isRenderedInFAUS = page === $2472ed5b4088eda9$export$c2bd95920a67f979;
            const embeddedMacroAdditionalForwardedData = {
                sourceAppId: appId,
                sourceInstallationId: extensionRef.current.installationId,
                sourceEnvironmentId: extensionRef.current.environmentId,
                extension: extensionRef.current,
                isEmbeddedMacroModal: true,
                extensionPayload: extensionPayloadRef.current,
                extensionData: extensionDataRef.current,
                embeddedMacroExtensionDetails: extensionDetails,
                embeddedMacroLocalId: localId
            };
            const withFausMessageForwarder = (methodName, bridgeMethodFn)=>{
                // Only forward when we're the gateway (FAUS). Product (e.g. forge-ui-kit adf-renderer) uses bridge directly.
                const isRenderedInFAUS = page === $2472ed5b4088eda9$export$c2bd95920a67f979;
                const shouldUseMessageForwarder = platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro && isRenderedInFAUS;
                return shouldUseMessageForwarder ? (0, $3qMxz.createMessageForwarder)(methodName, embeddedMacroAdditionalForwardedData, $2472ed5b4088eda9$var$postRobotSend, embeddedParentLocalId, extensionDetails) : bridgeMethodFn;
            };
            // Only bodied macros should receive embedded macro messages
            const isBodiedMacro = layout === 'bodied';
            // Confluence embed card has the same origin as top level product
            const isNativeConfluenceEmbeddedCard = ()=>{
                try {
                    window.parent.location.href;
                    return true;
                } catch  {
                    return false;
                }
            };
            const isProductLevel = typeof window !== 'undefined' && (window.location.ancestorOrigins?.length === 0 || isNativeConfluenceEmbeddedCard()) && !isInModal;
            const { open: open } = $2472ed5b4088eda9$var$createIframeBridge({
                theme: initialThemeRef.current.theme,
                surfaceColor: initialThemeRef.current.surfaceColor,
                withDomain: origin,
                withWindow: iframeEl.contentWindow,
                metadata: {
                    env: environment,
                    module: type,
                    product: type.split(':')[0],
                    isFedRamp: (0, $lzcvT.isFedRamp)(),
                    localId: localId
                },
                features: (0, $dWSaf.withMetricsAndAnalytics)({
                    features: {
                        invoke: async ({ data: data })=>{
                            const performanceStart = (0, $1uzCd.getPerformanceMark)();
                            captureEvent({
                                type: 'resolver-invoke-initiated',
                                elapsed: performanceStart
                            });
                            const { onInvoke: onInvoke, onThreeLO: onThreeLO } = apiRef.current;
                            const result = await onInvoke(data);
                            if (result.type === '3lo') return new Promise((resolve, reject)=>{
                                onThreeLO(result.authUrl, ()=>{
                                    const performanceAuthEnd = (0, $1uzCd.getPerformanceMark)();
                                    return onInvoke(data).then((res)=>{
                                        const performanceEnd = (0, $1uzCd.getPerformanceMark)();
                                        captureEvent({
                                            type: 'resolver-invoked',
                                            duration: performanceEnd - performanceStart,
                                            authDuration: performanceAuthEnd - performanceStart,
                                            elapsed: performanceEnd
                                        });
                                        if (res.type === 'ok') resolve(res.response);
                                        // Unexpected case where 3LO consent requested again after consenting
                                        reject();
                                    }, reject);
                                });
                            });
                            const performanceEnd = (0, $1uzCd.getPerformanceMark)();
                            captureEvent({
                                type: 'resolver-invoked',
                                duration: performanceEnd - performanceStart,
                                authDuration: 0,
                                elapsed: performanceEnd
                            });
                            if (result.type === 'err') throw new Error(result.message);
                            return result.response;
                        },
                        initFeatureFlags: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_ff_client_sdk')) return {};
                            const { onInitFeatureFlags: onInitFeatureFlags } = apiRef.current;
                            const result = await onInitFeatureFlags(data);
                            if ((0, $dh538.fg)('platform_forge_ff_ui_analytics')) trackForgeFeatureFlagEvent({
                                appType: appType,
                                appId: appId,
                                baseUrl: window.location.origin,
                                eventType: (0, $b4nol.FeatureFlagEventTypes).INITIALIZATION,
                                success: result.type !== 'err',
                                featureFlagEnv: data.user?.statsigEnvironment?.tier || (0, $b4nol.FeatureFlagEnv).development,
                                forgeEnvironment: environmentType
                            });
                            if (result.type === 'err') return {};
                            return result.response;
                        },
                        trackFeatureFlagEvent: async ({ data: data })=>{
                            if (!(0, $dh538.fg)('platform_forge_ff_ui_analytics')) return;
                            const allowedEventTypes = [
                                (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase()
                            ];
                            try {
                                // basic validations
                                if (!data.type || !allowedEventTypes.includes(data.type.toUpperCase())) return;
                                if (data.type.toUpperCase() === (0, $b4nol.FeatureFlagEventTypes).CHECKFLAG.toUpperCase() && data.properties.name && (data.properties.name.length < 3 || data.properties.name.length > 50)) return;
                                if (typeof data.properties.success !== 'boolean') return;
                                if (!(data.properties.environment && data.properties.environment.toLowerCase() in (0, $b4nol.FeatureFlagEnv))) return;
                                trackForgeFeatureFlagEvent({
                                    appType: appType,
                                    appId: appId,
                                    baseUrl: window.location.origin,
                                    flagName: data.properties.name || '',
                                    eventType: data.type,
                                    success: data.properties.success,
                                    featureFlagEnv: data.properties.environment,
                                    forgeEnvironment: environmentType
                                });
                            } catch  {
                            // all errors are ignored
                            }
                            return;
                        },
                        'iframe-analytics': async ({ data: data })=>{
                            captureUntrustedEvent(data);
                        },
                        ...(0, $dh538.fg)('forge-ui-ufo-frame-event-support') ? {
                            'ufo-event': async ({ data: data })=>{
                                captureUntrustedEvent(data);
                            }
                        } : {},
                        getUrl: async ({ data: data })=>{
                            if (data.target) {
                                const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) return null;
                                // If the current domain is a custom domain, we need to request for the base url
                                const baseUrl = (0, $2gNWY.isCustomDomain)(window.location.hostname) ? await getBaseUrl() : window.location.origin;
                                // `getUrl` from `@forge/bridge` will return a URL object.
                                // We are returning a string here as a URL object will serialised into a string when being passed across the bridge
                                return `${baseUrl}${path}`;
                            }
                            return null;
                        },
                        navigate: withFausMessageForwarder('navigate', async ({ data: data })=>{
                            // If a NavigationLocation object was provided:
                            if ('target' in data && data.target) {
                                const path = await (0, $cMiG0.createNavigateTargetPath)(data, {
                                    getContext: apiRef.current.getContext,
                                    getAppForgeUIExtensions: getAppForgeUIExtensions
                                });
                                if (!path) {
                                    // eslint-disable-next-line no-console
                                    console.warn('Path was not found for the parameters provided');
                                    return;
                                }
                                // Request for the base url if the current domain is a custom domain
                                if ((0, $2gNWY.isCustomDomain)(window.location.hostname)) {
                                    const baseUrl = await getBaseUrl();
                                    return apiRef.current.onNavigate({
                                        type: data.type,
                                        url: `${baseUrl}${path}`
                                    });
                                } else return apiRef.current.onNavigate({
                                    type: data.type,
                                    url: path
                                });
                            }
                            return apiRef.current.onNavigate(data);
                        }),
                        reconcile: async ({ data: data })=>{
                            return apiRef.current.reconcile(data);
                        },
                        onError: async ({ data: data })=>{
                            return apiRef.current.onError(data);
                        },
                        reload: withFausMessageForwarder('reload', async ()=>{
                            (0, $4c2yb.reload)();
                        }),
                        refresh: async ()=>{
                            return apiRef.current.refresh();
                        },
                        submit: async (payload)=>{
                            return apiRef.current.submit(payload);
                        },
                        open: withFausMessageForwarder('open', async ()=>{
                            return apiRef.current.open();
                        }),
                        onClose: async (payload)=>{
                            return apiRef.current.onClose(payload);
                        },
                        close: async (payload)=>{
                            return apiRef.current.close(payload);
                        },
                        emitReadyEvent: withFausMessageForwarder('emitReadyEvent', async ()=>{
                            captureEvent({
                                type: 'emit-ready-event',
                                elapsed: (0, $1uzCd.getPerformanceMark)()
                            });
                            return apiRef.current.emitReadyEvent();
                        }),
                        getContext: ()=>{
                            return apiRef.current.getContext();
                        },
                        openModal: withFausMessageForwarder('openModal', async (payload)=>{
                            return apiRef.current.openModal(payload);
                        }),
                        createHistory: async ()=>{
                            return apiRef.current.createHistory();
                        },
                        fetchProduct: async ({ data: data })=>{
                            return apiRef.current.fetchProduct(data);
                        },
                        fetchRemote: async ({ data: data })=>{
                            return apiRef.current.fetchRemote(data);
                        },
                        showFlag: withFausMessageForwarder('showFlag', async ({ data: data })=>{
                            const flagActions = data.actions?.map((action)=>{
                                const { onClick: onClick } = action;
                                return {
                                    ...action,
                                    onClick: onClick ? ()=>onClick() : ()=>{}
                                };
                            });
                            return apiRef.current.showFlag({
                                ...data,
                                actions: flagActions
                            });
                        }),
                        closeFlag: withFausMessageForwarder('closeFlag', async ({ data: data })=>apiRef.current.closeFlag(data)),
                        on: async (payload)=>{
                            const { event: event, callback: callback } = payload.data;
                            const subscription = (0, $luNHV.on)(event, callback, extensionDetails);
                            eventCallbacksRef.current.push(subscription);
                            return {
                                unsubscribe: ()=>{
                                    eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                    subscription.unsubscribe();
                                }
                            };
                        },
                        ...(0, $dh538.fg)('forge-ui-add-public-event-methods') ? {
                            onPublic: async (payload)=>{
                                const { event: event, callback: callback } = payload.data;
                                const subscription = (0, $luNHV.onPublic)(event, callback, extensionDetails);
                                eventCallbacksRef.current.push(subscription);
                                return {
                                    unsubscribe: ()=>{
                                        eventCallbacksRef.current.splice(eventCallbacksRef.current.indexOf(subscription), 1);
                                        subscription.unsubscribe();
                                    }
                                };
                            },
                            emitPublic: async (payload)=>{
                                return apiRef.current.emitPublic?.(payload.data);
                            }
                        } : {},
                        emit: withFausMessageForwarder('emit', async (payload)=>{
                            return (0, $luNHV.emit)(payload.data.event, payload.data.payload, payload.data.embeddedMacroExtensionDetails || extensionDetails);
                        }),
                        enableTheming: async ()=>{
                            await enableThemingRef.current?.();
                            const currentTheme = (0, $8z9j5.default)();
                            const surfaceColor = null;
                            setThemeRef.current?.(currentTheme, surfaceColor, environment);
                        },
                        changeWindowTitle: async ({ data: data })=>{
                            apiRef.current.changeWindowTitle(data);
                        },
                        getFrameId: async ()=>{
                            return apiRef.current.getFrameId();
                        },
                        subscribeRealtimeChannel: async (payload)=>{
                            return apiRef.current.subscribeRealtimeChannel?.(payload);
                        },
                        publishRealtimeChannel: async (payload)=>{
                            return apiRef.current.publishRealtimeChannel?.(payload);
                        },
                        openRovo: withFausMessageForwarder('openRovo', async ({ data: data })=>{
                            return apiRef.current.openRovo?.(data);
                        }),
                        isRovoEnabled: withFausMessageForwarder('isRovoEnabled', async ()=>{
                            if (!cloudId) return false;
                            return (0, $974zo.getIsRovoEnabled)({
                                cloudId: cloudId,
                                relayEnvironment: relayEnvironment
                            });
                        }),
                        trackObjectStoreAction: async ({ data: data })=>{
                            trackObjectStoreAction({
                                appType: appType,
                                appId: appId,
                                action: data.action,
                                forgeEnvironment: environmentType
                            });
                        },
                        ...(0, $buzAL.getUseBridgePermissionFunctions)(apiRef),
                        ...$2472ed5b4088eda9$var$mapCustomBridgeMethods({
                            customBridgeMethods: customBridgeMethodsRef.current,
                            isUIKitEmbeddedMacro: platform_add_bridge_message_forwarding_from_faus && isEmbeddedMacro && !isRenderedInFAUS,
                            embeddedMacroLocalId: localId,
                            withFausMessageForwarder: withFausMessageForwarder
                        })
                    },
                    page: page,
                    environment: environment,
                    forgeEnvironment: environmentType,
                    errorExtensionDetails: errorExtensionDetails,
                    createAnalyticsEvent: createAnalyticsEvent,
                    tracing: tracing
                }),
                sendHandshakeMetric: sendHandshakeMetric(page),
                shouldReceiveEmbeddedMacroMessages: platform_add_bridge_message_forwarding_from_faus && isBodiedMacro && isProductLevel
            });
            if (isResizable) (0, $9zb43.iframeResizer)({
                heightCalculationMethod: 'bodyScroll',
                widthCalculationMethod: 'bodyScroll',
                scrolling: true,
                // @ts-ignore minHeight can be a string
                minHeight: height,
                // sizeWidth is enabled for resizing only for inline macros
                sizeWidth: layout === 'inline' && type === $2472ed5b4088eda9$var$MACRO_MODULE_NAME,
                initCallback: (iframe)=>{
                    iframe?.iFrameResizer?.resize();
                }
            }, iframeEl);
            const { close: close, enableTheming: enableTheming, setTheme: setTheme } = open();
            setThemeRef.current = setTheme;
            enableThemingRef.current = enableTheming;
            // this tracking is to identify re-initializations of the bridge, which should never happen (or we should try avoid)
            // during the lifecycle of a Forge app. re-initialise bridge could be expensive and error prone (losing existing event subscriptions, etc)
            trackBridgeReinited();
            return ()=>{
                close?.(); // close may be undefined here if createIframeBridge call fails
                iframeEl?.iFrameResizer && iframeEl?.iFrameResizer.removeListeners();
            };
        }
    // We intentionally add react-hooks/exhaustive-deps disable here, so that we don't blindly
    // add new dependencies without considering the impact of re-creating the bridge.
    // The following dependencies are excluded for the reasons stated:
    //   - trackBridgeReinited - it's memoised and used for observability and should not trigger bridge recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getBaseUrl,
        iframeRef,
        origin,
        loading,
        page,
        isResizable,
        height,
        environment,
        errorExtensionDetails,
        id,
        layout,
        type,
        environmentType,
        installationId,
        tracing,
        createAnalyticsEvent,
        loadedAt,
        getAppForgeUIExtensions,
        appType,
        captureEvent,
        captureUntrustedEvent,
        appId,
        trackForgeFeatureFlagEvent,
        trackObjectStoreAction,
        isInModal,
        localId,
        isEmbeddedMacro,
        embeddedParentLocalId
    ]);
    // [WARN] Please take careful consideration when adding new dependencies to the above useEffect.
    // createIframeBridge is expensive to call and re-creating the bridge could lead to lost event subscriptions.
    // - Try to avoid adding dependencies that could change on every render (e.g. objects or functions defined inline).
    // - If you need to add a function, consider wrapping it in useCallbackOne / useRef / useMemoOne to stabilise the reference.
    // - Please ensure multiple revewers in the Forge UI team review and approve the change.
    // - As the standard lint for dependency array is disabled, please ensure the dependency array is kept up to date with necessary dependencies.
    return {
        loading: loading,
        iframeProps: {
            ref: iframeRef,
            onLoad: ()=>{
                onLoad && onLoad();
                setLoading(false);
                setLoadedAt(Date.now());
            }
        }
    };
};
module.exports["BridgeClientError"] = $2472ed5b4088eda9$export$d86296fe47e644cc;
module.exports["useBridge"] = $2472ed5b4088eda9$export$23a7a1286dcfa590;

});

parcelRegister("i5CVI", function(module, exports) {
function $6828e685c7239bdd$export$ff7962acd6052c28(url, type, push) {
    switch(type){
        case 'new-tab':
            window.open(url, '_blank', 'noopener noreferrer');
            break;
        case 'same-tab':
            if (push) push(url);
            else window.location.href = url;
            break;
    }
}
module.exports["navigate"] = $6828e685c7239bdd$export$ff7962acd6052c28;

});

parcelRegister("2kGKp", function(module, exports) {
const $676d2d098e4ba6be$export$5a759dc7a1cfb72a = ()=>{
    return window.location.origin;
};
module.exports["getOrigin"] = $676d2d098e4ba6be$export$5a759dc7a1cfb72a;

});

parcelRegister("lMJg3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $471wb = parcelRequire("471wb");

const $462f7dce88626787$export$440f6339165c68d2 = (permissionType, egress)=>{
    const egressUrls = (egress || []).find((permission)=>permission.type === permissionType);
    const allowedUrls = egressUrls ? egressUrls.addresses : [];
    return new (0, $471wb.EgressFilteringService)(allowedUrls);
};
const $462f7dce88626787$export$8a0b6b45ac3015d5 = (permissionType, egress)=>{
    return (0, $42omo.useMemo)(()=>{
        return $462f7dce88626787$export$440f6339165c68d2(permissionType, egress);
    }, [
        permissionType,
        egress
    ]);
};
module.exports["egressPermissionService"] = $462f7dce88626787$export$440f6339165c68d2;
module.exports["useEgressPermissionService"] = $462f7dce88626787$export$8a0b6b45ac3015d5;

});

parcelRegister("kTcrU", function(module, exports) {

var $2kGKp = parcelRequire("2kGKp");

const $3716a239e20d61f7$var$emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Filters out all parameters that may be used for malicious purposes such as attaching local files or adding bcc recipients
// Only subject and body are allowed
const $3716a239e20d61f7$var$filterMailtoParams = (mailtoLink)=>{
    try {
        const url = new URL(mailtoLink);
        const params = url.searchParams;
        const email = url.pathname;
        let newParams = '';
        if (!$3716a239e20d61f7$var$emailRegex.test(email)) // throw empty error for makeUrl to catch
        throw new Error();
        if (params.has('subject')) newParams += 'subject=' + encodeURIComponent(params.get('subject') || '');
        if (params.has('body')) {
            newParams += newParams ? '&body=' : 'body=';
            newParams += encodeURIComponent(params.get('body') || '');
        }
        return `${url.protocol}${email}` + (newParams ? '?' + newParams : '');
    } catch (error) {
        // throw empty error for makeUrl to catch
        throw new Error();
    }
};
function $3716a239e20d61f7$export$e98ca45c96b2aafe(urlString) {
    try {
        if (urlString.startsWith('mailto:')) return new URL($3716a239e20d61f7$var$filterMailtoParams(urlString));
        if (urlString.startsWith('tel:')) // For telephone links, we just return the URL as is
        return new URL(urlString);
        // Check if URL starts with a custom URL scheme (e.g., forge:\\, spotify:, etc.)
        const customURLSchemeRegex = /^[a-zA-Z]+:(\\\\)?/;
        if (customURLSchemeRegex.test(urlString)) return new URL(urlString);
        // We decode the URL string to handle cases where a malicious app might pass in a URL with encoded characters to bypass our egress checks
        const decodedUrlString = decodeURIComponent(urlString);
        const fullUrl = decodedUrlString.startsWith('/') ? `${(0, $2kGKp.getOrigin)()}${urlString}` : urlString;
        // Checks if `fullUrl` has a protocol(eg. http://, https://, etc), if not, add the `https://` protocol
        const protocolRegex = /^(.*?:\/\/)/;
        const urlWithProtocol = protocolRegex.test(fullUrl) ? fullUrl : `https://${fullUrl}`;
        // We use the URL constructor to validate the URL
        const url = new URL(urlWithProtocol);
        return url;
    } catch  {
        return undefined;
    }
}
module.exports["makeUrl"] = $3716a239e20d61f7$export$e98ca45c96b2aafe;

});

parcelRegister("9v4R2", function(module, exports) {
// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $6946f2676d93d3f0$export$bbc6c05835b799fc = [
    'atl-paas.net',
    'atlassian.com',
    'atlassian.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net'
];
module.exports["TRUSTED_ROOT_DOMAINS"] = $6946f2676d93d3f0$export$bbc6c05835b799fc;

});

parcelRegister("69400", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b91a44b41ae4f33$export$61945ff869c3ddb = /*#__PURE__*/ (0, $42omo.createContext)({
    frameCount: 0,
    setFrameCount: ()=>{}
});
const $6b91a44b41ae4f33$var$FrameCountProvider = ({ children: children })=>{
    const [frameCount, setFrameCount] = (0, $42omo.useState)(0);
    const value = {
        frameCount: frameCount,
        setFrameCount: setFrameCount
    };
    (0, $42omo.useEffect)(()=>{
        if (frameCount > 1) throw new Error('Max limit of one frame component per module.');
    }, [
        frameCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6b91a44b41ae4f33$export$61945ff869c3ddb.Provider, {
        value: value
    }, children);
};
var $6b91a44b41ae4f33$export$2e2bcd8739ae039 = $6b91a44b41ae4f33$var$FrameCountProvider;
module.exports["FrameCount"] = $6b91a44b41ae4f33$export$61945ff869c3ddb;
module.exports["default"] = $6b91a44b41ae4f33$export$2e2bcd8739ae039;

});

parcelRegister("eahkE", function(module, exports) {

var $ewF1l = parcelRequire("ewF1l");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $aoVih = parcelRequire("aoVih");


var $1Igmn = parcelRequire("1Igmn");


var $lCRfz = parcelRequire("lCRfz");

const $83b849164997a777$export$22d69806bfc9e8c1 = 'INVALID_INVOCATION_RUNTIME_ERROR';
const $83b849164997a777$var$buildMessage = (title, error)=>{
    if (error === $83b849164997a777$export$22d69806bfc9e8c1) return `Your app ${title} is no longer working as it uses a deprecated platform feature. Please check if an update for this app is available through Atlassian Administration, or ask the app developer to upgrade the app.\nIf the app is listed on the marketplace, contact the developer using the Support tab.`;
    return `${title} version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
};
const $83b849164997a777$var$ForgeDeprecationMessageInner = (props)=>{
    const { extension: extension, error: error } = props;
    const data = (0, $irOoi.useLazyLoadQuery)((0, $ewF1l.default), {
        id: extension?.id
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                }
            }
        }
    });
    const title = data.app?.name ? data.app?.name : extension.properties.title;
    const message = $83b849164997a777$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
const $83b849164997a777$var$ForgeDeprecationMessageFallback = (props)=>{
    const { extension: extension, error: error } = props;
    const title = extension.properties.title;
    const message = $83b849164997a777$var$buildMessage(title, error);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: "App update required",
        appearance: "error"
    }, message);
};
const $83b849164997a777$export$e812f4e5298c004d = (props)=>{
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($83b849164997a777$var$ForgeDeprecationMessageFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), {
        fallback: fallback,
        errorFallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($83b849164997a777$var$ForgeDeprecationMessageInner, props));
};
module.exports["SANDBOX_DEPRECATION_ERROR"] = $83b849164997a777$export$22d69806bfc9e8c1;
module.exports["ForgeDeprecationMessage"] = $83b849164997a777$export$e812f4e5298c004d;

});

parcelRegister("gvvHu", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $CMcde = parcelRequire("CMcde");

function $3044cb8be034d2df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $3044cb8be034d2df$var$AKSectionMessage = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hcdJZ")));

const $3044cb8be034d2df$var$SectionMessageAction = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fLmnB")));
const $3044cb8be034d2df$var$textWrapCss = {
    name: "1089mxj",
    styles: "white-space:pre-wrap"
};
var $3044cb8be034d2df$var$_ref = {
    name: "1axjbqe",
    styles: "width:100%;ul{padding-left:0;}"
};
const $3044cb8be034d2df$var$ErrorPanel = ({ error: error, dispatch: dispatch, isReloadPage: isReloadPage })=>{
    const { message: message, errorDetails: errorDetails, errorMessage: errorMessage } = error;
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const intl = (0, $aXWIB.useIntl)();
    const reinitializeApp = async ()=>{
        if (isReloadPage) window.location.reload();
        setIsLoading(true);
        try {
            if (dispatch) await dispatch({
                type: 'render',
                extensionData: {}
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $CMcde.Loader), null);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $3044cb8be034d2df$var$_ref
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$AKSectionMessage, {
        appearance: "error",
        title: message,
        actions: [
            {
                key: 'refresh',
                text: intl.formatMessage(isReloadPage ? $3044cb8be034d2df$var$messages.reloadPage : $3044cb8be034d2df$var$messages.refreshApp),
                onClick: reinitializeApp
            }
        ].map(({ text: text, key: key, onClick: onClick })=>/*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$SectionMessageAction, {
                key: key,
                onClick: onClick
            }, text))
    }, errorMessage && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gdv5Z.default), {
        xcss: $3044cb8be034d2df$var$textWrapCss
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
        as: "p"
    }, errorMessage)), errorDetails && /*#__PURE__*/ (0, $9K4OG.jsx)("pre", {
        css: $3044cb8be034d2df$var$textWrapCss
    }, errorDetails)));
};
var $3044cb8be034d2df$export$2e2bcd8739ae039 = $3044cb8be034d2df$var$ErrorPanel;
const $3044cb8be034d2df$export$1fe699079d0f690f = ({ forgeDoc: forgeDoc, dispatch: dispatch })=>{
    const { error: error } = forgeDoc.props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)($3044cb8be034d2df$var$ErrorPanel, {
        key: "error",
        error: error,
        dispatch: dispatch
    });
};
const $3044cb8be034d2df$var$messages = (0, $aXWIB.defineMessages)({
    refreshApp: {
        id: "confluence.error.panel.refresh.app",
        defaultMessage: "Refresh app"
    },
    reloadPage: {
        id: "confluence.error.panel.reload.page",
        defaultMessage: "Reload page"
    }
});
module.exports["default"] = $3044cb8be034d2df$export$2e2bcd8739ae039;

});

parcelRegister("amyZ5", function(module, exports) {

var $73oQr = parcelRequire("73oQr");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $aoVih = parcelRequire("aoVih");


var $aXWIB = parcelRequire("aXWIB");


var $1Igmn = parcelRequire("1Igmn");


var $lCRfz = parcelRequire("lCRfz");

/**
 * This message is displayed when a forge custom field is using a deprecated modal experience for rendering on the Jira issue view.
 * It is displayed in a modal dialog and is not dismissible.
 * It is one of the steps related to the deprecation of the modal experience which was decided here:
 * https://hello.atlassian.net/wiki/spaces/Ditto/pages/5092641172/DACI+-+Modal+experience+for+the+Forge+custom+fields+on+issue+view+clean-up?focusedCommentId=5111022370
 */ const $3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageInner = (props)=>{
    const { extension: extension } = props;
    const data = (0, $irOoi.useLazyLoadQuery)((0, $73oQr.default), {
        id: extension?.id || ''
    }, {
        networkCacheConfig: {
            metadata: {
                headers: {
                    'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                }
            }
        }
    });
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($3ed8ce0b7cea2643$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
        appName: data.app?.name
    }));
};
const $3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageFallback = (props)=>{
    const intl = (0, $aXWIB.useIntl)();
    const appName = props.extension?.properties.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: intl.formatMessage($3ed8ce0b7cea2643$var$messages.title),
        appearance: "error"
    }, intl.formatMessage($3ed8ce0b7cea2643$var$messages.message, {
        appName: appName
    }));
};
const $3ed8ce0b7cea2643$export$5b67d59ebd4f147c = (props)=>{
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lCRfz.RelaySuspensefulBoundary), {
        fallback: fallback,
        errorFallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3ed8ce0b7cea2643$var$ForgeModalDeprecationMessageInner, props));
};
const $3ed8ce0b7cea2643$var$messages = (0, $aXWIB.defineMessages)({
    title: {
        id: "forge.modal.deprecation.title",
        defaultMessage: "Update your app"
    },
    message: {
        id: "forge.modal.deprecation.message",
        defaultMessage: "Your app {appName} uses the deprecated modal editing experience for custom fields, which is being phased out. Please have your system admin update the app to use inline editing instead. If issues remain, contact the app developer."
    }
});
module.exports["ForgeModalDeprecationMessage"] = $3ed8ce0b7cea2643$export$5b67d59ebd4f147c;

});

parcelRegister("b7qxC", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $lzcvT = parcelRequire("lzcvT");

const $ea538cc77ceb57f0$export$d86e18ec9052db2c = (productEnvironment)=>{
    if ((0, $lzcvT.isFedRamp)()) {
        if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
        else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
    }
    if (productEnvironment === (0, $1c598.ProductEnvironment).DEVELOPMENT) return (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT;
    else if (productEnvironment === (0, $1c598.ProductEnvironment).STAGING) return (0, $1c598.ForgeCDNEnvironment).STAGING;
    else return (0, $1c598.ForgeCDNEnvironment).PRODUCTION;
};
module.exports["getCDNEnvironment"] = $ea538cc77ceb57f0$export$d86e18ec9052db2c;

});

parcelRegister("dRFAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hXuPC = parcelRequire("hXuPC");


$hXuPC.__exportStar((parcelRequire("9FlsF")), module.exports);

$hXuPC.__exportStar((parcelRequire("87m1m")), module.exports);

});

parcelRegister("eTuC8", function(module, exports) {

var $1JdaQ = parcelRequire("1JdaQ");


var $c5hPD = parcelRequire("c5hPD");


var $la0HD = parcelRequire("la0HD");

const $3b182436257331a8$export$cdae2f05238f63a2 = (appearance, features)=>{
    const memoisedFeatures = (0, $la0HD.useMemoisedFeatures)(features);
    const preset = (0, $1JdaQ.usePreset)((builder)=>(0, $c5hPD.createPreset)(builder, appearance, memoisedFeatures), [
        memoisedFeatures
    ]);
    return preset;
};
module.exports["usePresetByFeatures"] = $3b182436257331a8$export$cdae2f05238f63a2;

});

parcelRegister("bsX2q", function(module, exports) {

var $kVs3B = parcelRequire("kVs3B");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $diswb = parcelRequire("diswb");


var $grQpA = parcelRequire("grQpA");


var $5U2YR = parcelRequire("5U2YR");


var $39Ajm = parcelRequire("39Ajm");


var $inPa6 = parcelRequire("inPa6");


var $7TH2w = parcelRequire("7TH2w");


var $3Spjc = parcelRequire("3Spjc");


var $1Igmn = parcelRequire("1Igmn");

const $0f17c7f20af36c2d$export$73c0408abd298d1b = (client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale, ssr = false)=>{
    const variables = filter ? {
        contextIds: contextIds,
        locale: locale,
        filter: filter
    } : {
        contextIds: contextIds,
        locale: locale,
        type: extensionType
    };
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner, dataClassificationTagIds) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner, undefined, dataClassificationTagIds);
    // In SSR mode render and fetch is one-pass we can't do cache-and-network
    if (ssr && queryOptions?.fetchPolicy === 'cache-and-network') queryOptions.fetchPolicy = 'cache-first';
    return {
        variables: variables,
        ...queryOptions,
        query: query,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
            }
        }
    };
};
const $0f17c7f20af36c2d$export$1e6dc3c07340999 = ({ loading: loading, data: data })=>{
    if (!loading && data && data.extensionContexts && data.extensionContexts[0]) {
        if ('extensions' in data.extensionContexts[0]) // @ts-ignore
        return data.extensionContexts[0].extensions ?? null;
        else if ('extensionsByType' in data.extensionContexts[0]) return data.extensionContexts[0].extensionsByType ?? null;
    }
    return null;
};
const $0f17c7f20af36c2d$export$cab421e039d23b2 = ({ contextIds: contextIds, type: extensionType, filter: filter, client: client, queryOptions: queryOptions, expandAppOwner: expandAppOwner, dataClassificationTagIds: dataClassificationTagIds, locale: locale })=>{
    const requestOptions = $0f17c7f20af36c2d$export$73c0408abd298d1b(client, contextIds, queryOptions, expandAppOwner, filter, extensionType, dataClassificationTagIds, locale);
    const query = filter ? (0, $39Ajm.getExtensionListQuery)(expandAppOwner) : (0, $39Ajm.getExtensionListQueryOld)(expandAppOwner);
    const { error: error, loading: loading, data: data } = (0, $diswb.useQuery)(requestOptions.query || query, requestOptions);
    const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'useExtensionList'
                }
            }
        }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err = error.graphQLErrors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $0f17c7f20af36c2d$export$73b3e0afa63af44a = ({ contextIds: contextIds, type: extensionType, filter: extensionFilter, dataClassificationTagIds: dataClassificationTagIds, locale: locale, queryOptions: queryOptions })=>{
    const [extensions, setExtensions] = (0, $42omo.useState)(null);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { page: page } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const environment = (0, $irOoi.useRelayEnvironment)();
    // Context ids only ever contains a single id.
    // Extract out the id so that the useEffect dependency is a string instead of an array
    const contextId = contextIds[0];
    const shouldSkip = queryOptions?.skip;
    const stringifiedFilter = JSON.stringify(extensionFilter);
    const filter = (0, $42omo.useMemo)(()=>{
        return extensionFilter ?? [
            {
                type: 'EXTENSION_TYPE',
                value: [
                    extensionType
                ]
            }
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stringifiedFilter,
        extensionType
    ]);
    (0, $42omo.useEffect)(()=>{
        const contextIds = [
            contextId
        ];
        if (!shouldSkip) (0, $irOoi.fetchQuery)(environment, (0, $kVs3B.default), {
            contextIds: contextIds,
            locale: locale,
            filter: filter,
            dataClassificationTags: dataClassificationTagIds || []
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                    }
                }
            }
        }).subscribe({
            next: (data)=>{
                const extensions = $0f17c7f20af36c2d$export$1e6dc3c07340999({
                    data: data,
                    loading: false
                });
                if (extensions) createAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: 'succeeded',
                        actionSubject: 'forge.ui.webClient',
                        source: page,
                        tags: [
                            'forge'
                        ],
                        attributes: {
                            target: 'useExtensionList'
                        }
                    }
                }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
                setExtensions(extensions);
                setLoading(false);
            },
            error: (error)=>{
                setError(error);
                setLoading(false);
            }
        });
    }, [
        shouldSkip,
        contextId,
        filter,
        extensionType,
        locale,
        dataClassificationTagIds,
        environment,
        page,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $grQpA.isRelayNetworkError)(error)) {
            const err = error.source.errors.find((err)=>(0, $grQpA.isGQLUnderlyingServiceError)(err) || (0, $grQpA.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err ? (0, $grQpA.isGQLUnderlyingServiceError)(err) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
module.exports["createExtensionListQueryOptions"] = $0f17c7f20af36c2d$export$73c0408abd298d1b;
module.exports["getExtensionsFromGQLResult"] = $0f17c7f20af36c2d$export$1e6dc3c07340999;
module.exports["useExtensionListRelay"] = $0f17c7f20af36c2d$export$73b3e0afa63af44a;

});

parcelRegister("3qMxz", function(module, exports) {

var $luNHV = parcelRequire("luNHV");

const $b8ca2562eeb0d9e1$var$EMIT_READY_EVENT_NAME = 'EXTENSION_READY';
const $b8ca2562eeb0d9e1$var$UPDATE_BYLINE_ITEM_EVENT_NAME = 'FORGE_CONTENT_PROPERTY_UPDATED';
const $b8ca2562eeb0d9e1$export$7691e780388a0497 = (eventKey, eventName)=>{
    if (!eventName) return false;
    return eventKey === 'emit' && !(eventName === $b8ca2562eeb0d9e1$var$EMIT_READY_EVENT_NAME || eventName === $b8ca2562eeb0d9e1$var$UPDATE_BYLINE_ITEM_EVENT_NAME);
};
const $b8ca2562eeb0d9e1$export$b0842aa1e96f4de = (eventKey, dataToForward, postRobotSend, embeddedParentLocalId, extensionDetails)=>async ({ data: data })=>{
        // emitReadyEvent method calls the event method and also the actual emitReadyEvent method.
        // In use bridge we have 'emit' method and 'emitReadyEvent' method
        // This is referring to the former. For the latter, event key will be 'emitReadyEvent'
        if ($b8ca2562eeb0d9e1$export$7691e780388a0497(eventKey, data?.event)) {
            // Emit event as usual unless it is emitReadyEvent or updateBylineProperties event
            (0, $luNHV.emit)(data?.event, data?.payload, extensionDetails);
            return;
        }
        if (!postRobotSend || !embeddedParentLocalId) return;
        // This would need to be changed if we want to support multiple nesting levels
        const targetWindow = window.parent?.parent;
        if (!targetWindow || targetWindow === window) return;
        // Only forward to same hostname as FAUS for security (allow different ports for local dev)
        const targetDomain = `${window.location.protocol}//${window.location.hostname}`;
        // Check if data is an object or not.
        // E.g. updateMacroContent method's data is a type string.
        const originalPayload = typeof data === 'object' ? data : {
            data: data
        };
        const forwardedData = {
            eventKey: eventKey,
            ...dataToForward,
            ...originalPayload
        };
        try {
            const { data: data } = await postRobotSend(targetWindow, `messageFromEmbeddedFAUS_${embeddedParentLocalId}`, forwardedData, {
                domain: targetDomain
            });
            return data;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Failed to forward ${eventKey} to product:`, error);
        }
    };
module.exports["createMessageForwarder"] = $b8ca2562eeb0d9e1$export$b0842aa1e96f4de;

});

parcelRegister("aVZM7", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $1c598 = parcelRequire("1c598");


var $b7qxC = parcelRequire("b7qxC");

function $745598479b6c5b3c$export$faef963e38d4b894(environment) {
    const cdnEnv = (0, $b7qxC.getCDNEnvironment)(environment);
    // DEVELOPMENT has no dedicated CDN; fall back to STAGING assets.
    const urlEnv = cdnEnv === (0, $1c598.ForgeCDNEnvironment).DEVELOPMENT ? (0, $1c598.ForgeCDNEnvironment).STAGING : cdnEnv;
    const secondLevelDomain = (0, $lzcvT.isFedRamp)() ? 'atlassian-dev-us-gov-mod' : 'atlassian-dev';
    return `cdn.${urlEnv}.${secondLevelDomain}.net`;
}
module.exports["getForgeCDNBaseDomain"] = $745598479b6c5b3c$export$faef963e38d4b894;

});

parcelRegister("cqiXo", function(module, exports) {

var $2uzbP = parcelRequire("2uzbP");


var $6otn0 = parcelRequire("6otn0");


var $hTKp4 = parcelRequire("hTKp4");


var $dh538 = parcelRequire("dh538");

const $11028dbc0e45417b$export$423a62223c29d468 = (extension, extensionViewData)=>{
    const { egress: egress = [], installationConfig: installationConfig = [] } = extension;
    const getMacroParentHostDomain = ()=>{
        const doc = (0, $hTKp4.getDocument)();
        if (doc?.referrer && extension.type === 'xen:macro') {
            const referrerUrl = new URL(doc.referrer);
            const hostnameParts = referrerUrl.hostname.split('.');
            // Check if the second subdomain is 'cdn' to confirm it's a CDN URL
            const isCdnUrl = hostnameParts.length > 1 && hostnameParts[1] === 'cdn';
            if (isCdnUrl) return hostnameParts[0];
            const isLocalHost = referrerUrl.hostname === 'localhost';
            if (isLocalHost) return referrerUrl.host;
        }
    };
    const macroParentHostDomain = getMacroParentHostDomain();
    const shouldIncludeConnectMacroParentDomain = Boolean(extensionViewData?.connectMacroOrigin) && (0, $dh538.fg)('forge_nbm_set_frame_ancestors');
    return $11028dbc0e45417b$var$gzipAndB64Encode({
        egress: egress,
        installationConfig: installationConfig,
        hostname: window.location.hostname,
        ...macroParentHostDomain ? {
            macroParentHostDomain: macroParentHostDomain,
            macroParentHost: macroParentHostDomain
        } : {},
        ...shouldIncludeConnectMacroParentDomain ? {
            connectMacroParentDomain: extensionViewData?.connectMacroOrigin
        } : {}
    });
};
const $11028dbc0e45417b$var$gzipAndB64Encode = (json)=>{
    const jsonString = (0, (/*@__PURE__*/$parcel$interopDefault($2uzbP)))(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic
    try {
        const zippedData = (0, $6otn0.gzipSync)(new TextEncoder().encode(jsonString), {
            level: 9,
            mtime: 0
        });
        return btoa(String.fromCharCode(...zippedData));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err.message);
    }
    return '';
};
module.exports["getEncodedAppContext"] = $11028dbc0e45417b$export$423a62223c29d468;

});

parcelRegister("fgbwU", function(module, exports) {

var $3uVVG = parcelRequire("3uVVG");


var $jLYRk = parcelRequire("jLYRk");

const $40dbef35f15607cc$export$6baf9fc1d877ea76 = 'atlassian-token-service-key';
const $40dbef35f15607cc$export$5a2d35665f488c3c = async (startUrl, windowFeatures)=>{
    return (0, $3uVVG.auth)((0, $jLYRk.sanitizeUrl)(startUrl), windowFeatures);
};
const $40dbef35f15607cc$export$4211976e157c7ad8 = (startUrl)=>{
    const url = new URL(startUrl || '', window.location.href);
    const serviceKey = url.searchParams.get('serviceKey');
    return serviceKey !== $40dbef35f15607cc$export$6baf9fc1d877ea76;
};
module.exports["safeAuth"] = $40dbef35f15607cc$export$5a2d35665f488c3c;
module.exports["isExternalAuth"] = $40dbef35f15607cc$export$4211976e157c7ad8;

});

parcelRegister("kynWP", function(module, exports) {

var $65XYT = parcelRequire("65XYT");

const $c1947462b986f18c$var$disabledPerfCaptureConfig = {
    enabled: false,
    sampleRate: 0.0
};
const $c1947462b986f18c$export$3e4354104e72ffa1 = ({ module: module })=>{
    const isModuleEnabled = (0, $65XYT.enabledModulesForPerfCapture).indexOf(module) > -1;
    // Space to apply gates and experiments.
    return isModuleEnabled ? (0, $65XYT.defaultPerfCaptureConfig) : $c1947462b986f18c$var$disabledPerfCaptureConfig;
};
module.exports["getAppPerfCaptureConfig"] = $c1947462b986f18c$export$3e4354104e72ffa1;

});

parcelRegister("IiIMy", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $6oQb1 = parcelRequire("6oQb1");


var $42omo = parcelRequire("42omo");


var $5U2YR = parcelRequire("5U2YR");


var $dh538 = parcelRequire("dh538");

const $7f04a8099d8fa691$export$587370d4749ec188 = ({ config: config, samplingKey: samplingKey })=>{
    const { page: source } = (0, $5U2YR.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const enabled = (0, $42omo.useMemo)(()=>{
        if (!samplingKey) return false;
        if (!config.enabled || !(0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) return false;
        // Override: capture all events.
        const captureAllFlag = (0, $dh538.fg)('forge-ui-app-perf-capture-all-enabled');
        if (captureAllFlag) return true;
        // Capture a sample of events.
        const captureSampleFlag = (0, $dh538.fg)('forge-ui-app-perf-capture-sampling-enabled');
        if (captureSampleFlag && Math.random() <= config.sampleRate) return true;
        return false;
    }, [
        config,
        samplingKey
    ]);
    const capture = (0, $42omo.useCallback)((attributes)=>{
        if (!enabled) return;
        (0, $6oQb1.fireEvent)(createAnalyticsEvent, {
            action: 'performance.profiled',
            actionSubject: 'forge.ui.extension',
            attributes: attributes,
            source: source
        });
    }, [
        source,
        createAnalyticsEvent,
        enabled
    ]);
    return {
        enabled: enabled,
        capture: capture
    };
};
module.exports["useAppPerfCaptureStrategy"] = $7f04a8099d8fa691$export$587370d4749ec188;

});

parcelRegister("4No1R", function(module, exports) {
/**
 * @generated SignedSource<<1e705a2cc9edb86affeea1d0102a8f32>>
 * @relayHash 03405d83b15f59d0889abdb0c63674a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138
const $fa60f31b64adbc4c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBridge_tenantUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBridge_tenantUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "94a10998312c3467f8472075ae93ba6a72f87e0e5fc80ed56a84b36ab8800138",
            "metadata": {},
            "name": "useBridge_tenantUserQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fa60f31b64adbc4c$var$node.hash = "608300bf42cc1b2188141c51b357201e";
var $fa60f31b64adbc4c$export$2e2bcd8739ae039 = $fa60f31b64adbc4c$var$node;
module.exports["default"] = $fa60f31b64adbc4c$export$2e2bcd8739ae039;

});

parcelRegister("9zb43", function(module, exports) {

module.exports = (parcelRequire("1BqC1"));

});

parcelRegister("dWSaf", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $7KMPr = parcelRequire("7KMPr");


var $kxKUs = parcelRequire("kxKUs");


var $fSMLG = parcelRequire("fSMLG");


var $3Spjc = parcelRequire("3Spjc");


var $6oQb1 = parcelRequire("6oQb1");


var $dh538 = parcelRequire("dh538");


var $ly9ul = parcelRequire("ly9ul");

const $053a3977db87c15f$export$60b209a72f44cb2e = (bridgeMethod, payload, isSucceed)=>{
    if (bridgeMethod === 'submit' && isSucceed) {
        const payloadFields = Array.from(Object.entries(payload?.data ?? {})).filter(([, value])=>value).map(([key])=>key);
        return {
            payloadFields: payloadFields
        };
    }
    if (bridgeMethod === 'navigate') {
        const { target: target, url: url, type: type } = payload?.data ?? {};
        const navigationContext = {
            target: 'trusted',
            type: type
        };
        if (url && typeof url === 'string') try {
            if ([
                'https:',
                'http:'
            ].includes(new URL(url).protocol)) navigationContext.target = 'external';
        } catch  {}
        else if (target && typeof target === 'string') navigationContext.target = target;
        return navigationContext;
    }
    if ((0, $dh538.fg)('platform_forge_ui_open_rovo_bridge')) {
        if (bridgeMethod === 'openRovo' && isSucceed) {
            const { agentName: agentName, agentKey: agentKey, sourceAppId: sourceAppId } = payload?.data ?? {};
            const agentDetails = {
                agentName: agentName,
                agentKey: agentKey,
                sourceAppId: sourceAppId,
                isForgeAgent: false
            };
            if (agentName && agentKey) agentDetails.isForgeAgent = true;
            return agentDetails;
        }
    }
    return {};
};
const $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics = ({ feature: feature, createAnalyticsEvent: createAnalyticsEvent, page: page, bridgeMethod: bridgeMethod, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>async (payload)=>{
        try {
            tracing?.recordBridgeCall(`${bridgeMethod}() - start`);
            const result = await feature(payload);
            tracing?.recordBridgeCall(`${bridgeMethod}() - end`);
            if (bridgeMethod === 'on') createAnalyticsEvent({
                eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'subscribed',
                    actionSubject: 'bridgeEvent',
                    attributes: {
                        // TODO: remove the condition (and related test) once Developer UGC spec is ready
                        event: payload.data.event === 'JIRA_ISSUE_CHANGED' ? 'JIRA_ISSUE_CHANGED' : 'other'
                    },
                    source: page,
                    tags: [
                        'forge'
                    ]
                }
            }).fire((0, $3Spjc.FORGE_UI_ANALYTICS_CHANNEL));
            // this replaces the BRIDGE_REQUEST_RECEIVED metal client event
            (0, $6oQb1.trackBridgeSucceed)(createAnalyticsEvent, {
                source: page,
                method: bridgeMethod,
                forgeEnvironment: forgeEnvironment,
                additionalAttributes: $053a3977db87c15f$export$60b209a72f44cb2e(bridgeMethod, payload, true)
            });
            return result;
        } catch (err) {
            const error = err instanceof Error ? err : new Error(`Unknown Custom UI Bridge error: ${typeof err}`);
            if (!(error instanceof (0, $kxKUs.BridgeClientError))) {
                if (!(0, $fSMLG.blocklistedErrorMessagePatterns).some((pattern)=>pattern.test(error.message))) {
                    (0, $6oQb1.trackBridgeFailed)(createAnalyticsEvent, {
                        source: page,
                        errorName: error.name,
                        method: bridgeMethod,
                        forgeEnvironment: forgeEnvironment,
                        additionalAttributes: {
                            ...$053a3977db87c15f$export$60b209a72f44cb2e(bridgeMethod, payload, false),
                            reason: error.message,
                            isUnrecoverable: (0, $ly9ul.isUnrecoverableError)(error)
                        }
                    });
                    (0, $7KMPr.captureAndReportError)({
                        error: error,
                        environment: environment,
                        errorExtensionDetails: errorExtensionDetails,
                        page: page,
                        tracing: tracing
                    });
                }
            }
            throw err;
        }
    };
const $053a3977db87c15f$export$68a362b9cb2811d7 = ({ features: features, createAnalyticsEvent: createAnalyticsEvent, page: page, environment: environment, forgeEnvironment: forgeEnvironment, errorExtensionDetails: errorExtensionDetails, tracing: tracing })=>Object.entries(features).reduce((acc, [key, feature])=>({
            ...acc,
            [key]: $053a3977db87c15f$var$wrapFeatureWithMetricsAndAnalytics({
                feature: feature,
                createAnalyticsEvent: createAnalyticsEvent,
                page: page,
                bridgeMethod: key,
                environment: environment,
                forgeEnvironment: forgeEnvironment,
                errorExtensionDetails: errorExtensionDetails,
                tracing: tracing
            })
        }), {});
module.exports["prepareBridgeEventAttributes"] = $053a3977db87c15f$export$60b209a72f44cb2e;
module.exports["withMetricsAndAnalytics"] = $053a3977db87c15f$export$68a362b9cb2811d7;

});

parcelRegister("4c2yb", function(module, exports) {
function $3a24103e0164297d$export$32da5b5043dcd88c() {
    window.location.reload();
}
module.exports["reload"] = $3a24103e0164297d$export$32da5b5043dcd88c;

});

parcelRegister("b4nol", function(module, exports) {
var $32cb6d3cd1e17c5c$export$d0163c7b07301739 = /*#__PURE__*/ function(FeatureFlagEnv) {
    FeatureFlagEnv["development"] = "development";
    FeatureFlagEnv["staging"] = "staging";
    FeatureFlagEnv["production"] = "production";
    return FeatureFlagEnv;
}({});
var $32cb6d3cd1e17c5c$export$35879154c49e2b67 = /*#__PURE__*/ function(FeatureFlagEventTypes) {
    FeatureFlagEventTypes["INITIALIZATION"] = "initialization";
    FeatureFlagEventTypes["CHECKFLAG"] = "checkFlag";
    return FeatureFlagEventTypes;
}({});
module.exports["FeatureFlagEnv"] = $32cb6d3cd1e17c5c$export$d0163c7b07301739;
module.exports["FeatureFlagEventTypes"] = $32cb6d3cd1e17c5c$export$35879154c49e2b67;

});

parcelRegister("cMiG0", function(module, exports) {

var $faCvF = parcelRequire("faCvF");


var $6usda = parcelRequire("6usda");


var $6wbTo = parcelRequire("6wbTo");


var $j4W8T = parcelRequire("j4W8T");

const $bd08d1f86405f93a$var$extensionURLHelpers = {
    ...(0, $faCvF.confluenceExtensionURLHelpers),
    ...(0, $6wbTo.jiraExtensionURLHelpers)
};
const $bd08d1f86405f93a$var$navigationTargetHandlers = {
    ...(0, $6wbTo.jiraNavigationTargetHandlers),
    ...(0, $faCvF.confluenceNavigationTargetURLHelpers),
    userProfile: async ({ accountId: accountId })=>(0, $j4W8T.ensureURLPath)(`/people/${accountId}`),
    module: async ({ moduleKey: moduleKey, ...params }, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        if (!moduleKey) throw (0, $6usda.NavigationError).MissingProperty('moduleKey');
        const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
        if (!module || !module.appId || !module.environmentId) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
        const moduleUrlHelper = $bd08d1f86405f93a$var$extensionURLHelpers[module.type];
        if (!moduleUrlHelper) throw (0, $6usda.NavigationError).NotSupportedExtensionType(module.type);
        return await moduleUrlHelper(module, params);
    }
};
const $bd08d1f86405f93a$export$6aa8556afece32b2 = async (targetInfo, utils)=>{
    const { target: target, ...payload } = targetInfo;
    const handler = $bd08d1f86405f93a$var$navigationTargetHandlers[target];
    if (!handler) return null;
    try {
        const path = await handler(payload, utils);
        return path;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
        return null;
    }
};
module.exports["createNavigateTargetPath"] = $bd08d1f86405f93a$export$6aa8556afece32b2;

});

parcelRegister("1JDPF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $fYGGr = parcelRequire("fYGGr");


var $grQpA = parcelRequire("grQpA");


var $a4TK8 = parcelRequire("a4TK8");

const $a32dcdb2dcf56aee$var$useCustomCompareMemo = (factory, dependency, isEqual)=>{
    const dependencyRef = (0, $42omo.useRef)(dependency);
    const valueRef = (0, $42omo.useRef)(factory());
    if (!isEqual(dependency, dependencyRef.current)) {
        dependencyRef.current = dependency;
        valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>valueRef.current, [
        dependencyRef.current
    ]);
};
const $a32dcdb2dcf56aee$var$isSameDeps = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    const [relayEnvironmentA, appIdA, environmentIdA, contextIdsA] = a;
    const [relayEnvironmentB, appIdB, environmentIdB, contextIdsB] = b;
    return relayEnvironmentA === relayEnvironmentB && appIdA === appIdB && environmentIdA === environmentIdB && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(contextIdsA.sort(), contextIdsB.sort());
};
const $a32dcdb2dcf56aee$export$10dcd63d9a8843c4 = ({ appId: appId, environmentId: environmentId, contextIds: contextIds, cloudId: cloudId, includeHidden: includeHidden, moduleType: moduleType, bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall })=>{
    const relayEnvironment = (0, $irOoi.useRelayEnvironment)();
    return $a32dcdb2dcf56aee$var$useCustomCompareMemo(()=>{
        return async (params)=>{
            return await (0, $fYGGr.getForgeUIExtensionsRelayAsync)({
                contextIds: contextIds,
                extensionsFilter: [
                    {
                        type: (0, $grQpA.GQLExtensionContextsFilterType).AppIdEnvironmentId,
                        value: [
                            `${appId}:${environmentId}`
                        ]
                    }
                ],
                ...params,
                cloudId: cloudId,
                includeHidden: includeHidden,
                moduleType: moduleType,
                bypassNewForgeExtensionListCall: bypassNewForgeExtensionListCall,
                relayEnvironment: relayEnvironment
            });
        };
    }, [
        relayEnvironment,
        appId,
        environmentId,
        contextIds
    ], $a32dcdb2dcf56aee$var$isSameDeps);
};
module.exports["useGetAppForgeUIExtensions"] = $a32dcdb2dcf56aee$export$10dcd63d9a8843c4;

});

parcelRegister("974zo", function(module, exports) {

var $dIZZf = parcelRequire("dIZZf");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");

const $22833f81d2ea0d44$export$24d1d5a4c1bec897 = async ({ cloudId: cloudId, relayEnvironment: relayEnvironment })=>{
    if (relayEnvironment) {
        const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $dIZZf.default), {
            cloudId: cloudId
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        });
        return new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    resolve(data?.atlassianStudio_userSiteContext?.isRovoEnabled ?? false);
                },
                error: ()=>{
                    resolve(false);
                }
            });
        });
    }
    return false;
};
module.exports["getIsRovoEnabled"] = $22833f81d2ea0d44$export$24d1d5a4c1bec897;

});

parcelRegister("2gNWY", function(module, exports) {

var $9v4R2 = parcelRequire("9v4R2");

const $3722eb8dac50bf58$export$97f4c254b641e719 = (hostname)=>{
    return ![
        ...(0, $9v4R2.TRUSTED_ROOT_DOMAINS),
        'localhost',
        'jira-dev.com'
    ].some((trustedDomain)=>hostname.includes(trustedDomain));
};
module.exports["isCustomDomain"] = $3722eb8dac50bf58$export$97f4c254b641e719;

});

parcelRegister("buzAL", function(module, exports) {
/* usePermission.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @deprecated
 * This hook implements the v1 (stateful, React hook-based) permission bridge.
 *
 * New code should use the v2 stateless bridge methods instead:
 *   `platform/packages/forge/forge-ui/src/bridge/methods/permissions/index.tsx`
 *
 * The v2 methods (`egressGet`, `egressSet`, `egressDeleteDomain`,
 * `egressDeleteGroup`, `remoteGet`, `remoteSet`) are registered as
 * `__permission__*` bridge methods and are gated by
 * `fg('configurable-egress-mvp-frontend')`.
 *
 * This file is retained to support the legacy custom-UI iframe bridge path
 * (`usePermission` hook consumed via `useBridge`). Do not add new permission
 * logic here.
 */ 
var $42omo = parcelRequire("42omo");


var $kxKUs = parcelRequire("kxKUs");


var $fJCAk = parcelRequire("fJCAk");


var $dh538 = parcelRequire("dh538");


var $20GoR = parcelRequire("20GoR");


var $4LgCj = parcelRequire("4LgCj");


var $dhMrf = parcelRequire("dhMrf");


var $6oQb1 = parcelRequire("6oQb1");

const $5ea234701956fa1d$export$9d631cbf20f994be = [
    'egressSet',
    'egressGet',
    'egressDeleteDomain',
    'egressDeleteGroup',
    'remoteGet',
    'remoteSet'
];
const $5ea234701956fa1d$export$e6656e96c25a61f6 = '__permission__';
const $5ea234701956fa1d$var$RATE_LIMIT_MS = 5000;
const $5ea234701956fa1d$export$6adf362786c5a28e = (apiRef)=>({
        __permission__egressSet: async ({ data: data })=>{
            return apiRef.current.__permission__egressSet?.(data);
        },
        __permission__egressGet: async ({ data: data })=>{
            return apiRef.current.__permission__egressGet?.(data);
        },
        __permission__egressDeleteDomain: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteDomain?.(data);
        },
        __permission__egressDeleteGroup: async ({ data: data })=>{
            return apiRef.current.__permission__egressDeleteGroup?.(data);
        },
        __permission__remoteGet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteGet?.(data);
        },
        __permission__remoteSet: async ({ data: data })=>{
            return apiRef.current.__permission__remoteSet?.(data);
        }
    });
const $5ea234701956fa1d$export$dc21730956491a4c = (bridge)=>Object.fromEntries($5ea234701956fa1d$export$9d631cbf20f994be.map((method)=>[
            `${$5ea234701956fa1d$export$e6656e96c25a61f6}${method}`,
            (0, $4LgCj.createBridgeMethod)(bridge?.[`${$5ea234701956fa1d$export$e6656e96c25a61f6}${method}`])
        ]));
function $5ea234701956fa1d$export$d7376454a3cf5ab4({ appId: appId, installationId: installationId, contextIds: contextIds, extensionId: extensionId, renderThreeLOPrompt: renderThreeLOPrompt }) {
    const [modalState, setModalState] = (0, $42omo.useState)({
        state: 'closed'
    });
    const [isRateLimited, setIsRateLimited] = (0, $42omo.useState)(false);
    const { trackPermissionAction: trackPermissionAction } = (0, $6oQb1.useForgeUiAnalyticsEvent)();
    const permissionFetchClient = (0, $20GoR.usePermissionFetchClient)({
        appId: appId,
        installationId: installationId,
        contextIds: contextIds,
        extensionId: extensionId,
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const queryForgeApp = (0, $dhMrf.useForgeAppQuery)();
    const getAllCurrentEgress = async ()=>{
        const getEgress = await permissionFetchClient.egressGet({});
        return await getEgress.json();
    };
    const shouldDisplayModalForEgress = async (payload)=>{
        const allCurrentEgressResp = await getAllCurrentEgress();
        const currentDomainMap = (allCurrentEgressResp?.results ?? []).reduce((acc, result)=>{
            result.configured.forEach((d)=>acc[d.domain] = true);
            return acc;
        }, {});
        const domains = payload.egresses.reduce((acc, group)=>{
            const urls = group.configured.map((c)=>c.domain);
            acc.push(...urls);
            return acc;
        }, []);
        return domains.some((d)=>!currentDomainMap[d]);
    };
    const fetchAppData = async (id, contextIds)=>{
        try {
            return await queryForgeApp(id, contextIds);
        } catch (e) {
            if (e instanceof Error) {
                const error = new (0, $kxKUs.BridgeClientError)(e.message);
                error.stack = e.stack;
                throw error;
            }
            throw new (0, $kxKUs.BridgeClientError)(typeof e === 'string' ? e : String(e));
        }
    };
    const canOpenModal = ()=>{
        return modalState.state === 'closed' && !isRateLimited;
    };
    const noteModalOpened = ()=>{
        setIsRateLimited(true);
        setTimeout(()=>{
            setIsRateLimited(false);
        }, $5ea234701956fa1d$var$RATE_LIMIT_MS);
    };
    return {
        shouldDisplayModalForEgress: shouldDisplayModalForEgress,
        getModalJsx: ()=>(0, $dh538.fg)('configurable-egress-mvp-frontend') ? /*#__PURE__*/ $42omo.createElement((0, $fJCAk.AdminModal), {
                modalState: modalState
            }) : null,
        egressSet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressSet'
            });
            const app = await fetchAppData(appId, contextIds);
            const response = await permissionFetchClient.egressSet(payload, true);
            if (!response.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
            try {
                const shouldDisplay = await shouldDisplayModalForEgress(payload);
                if (shouldDisplay) {
                    if (!canOpenModal()) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
                    return new Promise((resolve, reject)=>{
                        noteModalOpened();
                        setModalState({
                            state: 'open',
                            onCancel: ()=>{
                                setModalState({
                                    state: 'closed'
                                });
                                reject('Setting egress was rejected by admin');
                            },
                            onConfirm: async ()=>{
                                try {
                                    const setEgressResp = await permissionFetchClient.egressSet(payload, false);
                                    const json = await setEgressResp.json();
                                    if (!setEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                                    setModalState({
                                        state: 'closed'
                                    });
                                    resolve(json);
                                } catch (err) {
                                    reject(err);
                                }
                            },
                            domainInfo: {
                                type: 'EGRESS',
                                payload: payload
                            },
                            appName: app.name,
                            termsOfUseLink: app.termsOfService,
                            privacyPolicyLink: app.privacyPolicy
                        });
                    });
                } else {
                    const setEgressResp = await permissionFetchClient.egressSet(payload, false);
                    const json = await setEgressResp.json();
                    if (!setEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                    return json;
                }
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not set egress due to ${err}`);
            }
        },
        egressGet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressGet'
            });
            try {
                const getEgressResp = await permissionFetchClient.egressGet(payload);
                const json = await getEgressResp.json();
                if (!getEgressResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not get egress due to: ${err}`);
            }
        },
        egressDeleteDomain: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressDeleteDomain'
            });
            try {
                const egressDeleteDomainResp = await permissionFetchClient.egressDeleteDomain(payload);
                const json = await egressDeleteDomainResp.json();
                if (!egressDeleteDomainResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress domain due to ${err}`);
            }
        },
        egressDeleteGroup: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'egressDeleteGroup'
            });
            try {
                const egressDeleteGroupResp = await permissionFetchClient.egressDeleteGroup(payload);
                const json = await egressDeleteGroupResp.json();
                if (!egressDeleteGroupResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not delete egress group due to ${err}`);
            }
        },
        remoteGet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'remoteGet'
            });
            try {
                const remoteGetResp = await permissionFetchClient.remoteGet(payload);
                const json = await remoteGetResp.json();
                if (!remoteGetResp.ok) throw new (0, $kxKUs.BridgeClientError)(JSON.stringify(json, null, 2));
                return json;
            } catch (err) {
                throw new (0, $kxKUs.BridgeClientError)(`Could not get remote due to: ${err}`);
            }
        },
        remoteSet: async (payload)=>{
            if (!(0, $dh538.fg)('configurable-egress-mvp-frontend')) return {};
            trackPermissionAction({
                appId: appId,
                installationId: installationId,
                action: 'remoteSet'
            });
            const app = await fetchAppData(appId, contextIds);
            const response = await permissionFetchClient.remoteSet(payload, true);
            if (!response.ok) throw new (0, $kxKUs.BridgeClientError)('Dry run failed');
            if (!canOpenModal()) throw new (0, $kxKUs.BridgeClientError)('Permission request rate limited. Please wait before making another request.');
            const node = (app.installationsByContexts?.edges ?? [])[0]?.node;
            const payloadKeys = new Set(payload.remotes.map((r)=>r.key));
            const manifestRemoteMap = (node?.appEnvironmentVersion?.extensions?.nodes ?? []).filter((e)=>e && e.extensionData.type === 'core:remote' && payloadKeys.has(e.extensionData.key)).reduce((acc, e)=>{
                if (e?.extensionData) acc[e.extensionData.key] = e.extensionData.configurable;
                return acc;
            }, {});
            return new Promise((resolve, reject)=>{
                noteModalOpened();
                setModalState({
                    state: 'open',
                    onCancel: ()=>{
                        setModalState({
                            state: 'closed'
                        });
                        reject(new (0, $kxKUs.BridgeClientError)('Setting remote was rejected by admin'));
                    },
                    onConfirm: async ()=>{
                        try {
                            const remoteSetResp = await permissionFetchClient.remoteSet(payload, false);
                            if (!remoteSetResp.ok) throw new (0, $kxKUs.BridgeClientError)(remoteSetResp.statusText);
                            setModalState({
                                state: 'closed'
                            });
                            resolve();
                        } catch (err) {
                            reject(new (0, $kxKUs.BridgeClientError)(`API call was rejected with the following error: ${err}`));
                        }
                    },
                    domainInfo: {
                        type: 'REMOTE',
                        payload: payload,
                        manifestRemoteMap: manifestRemoteMap
                    },
                    appName: app.name,
                    termsOfUseLink: app.termsOfService,
                    privacyPolicyLink: app.privacyPolicy
                });
            });
        }
    };
}
module.exports["permissionMethods"] = $5ea234701956fa1d$export$9d631cbf20f994be;
module.exports["PERMISSION_METHOD_PREFIX"] = $5ea234701956fa1d$export$e6656e96c25a61f6;
module.exports["getUseBridgePermissionFunctions"] = $5ea234701956fa1d$export$6adf362786c5a28e;
module.exports["getCreateBridgeApiPermissionFunctions"] = $5ea234701956fa1d$export$dc21730956491a4c;
module.exports["usePermission"] = $5ea234701956fa1d$export$d7376454a3cf5ab4;

});

parcelRegister("fyIiK", function(module, exports) {
const $2f7e23fa50cc881e$export$684c8d19f84f3f84 = (key, embeddedMacroLocalId, data)=>{
    if (key === 'getMacroContent' || key === 'updateMacroContent') return {
        ...typeof data === 'object' ? data : {},
        embeddedMacroLocalId: embeddedMacroLocalId
    };
    return data;
};
module.exports["transformDataForEmbeddedMacros"] = $2f7e23fa50cc881e$export$684c8d19f84f3f84;

});

parcelRegister("ewF1l", function(module, exports) {
/**
 * @generated SignedSource<<74521ce105b8364ed34465fb22f8abc8>>
 * @relayHash 1ddb7206934ab3dcd1cf0292ff839f9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee
const $695676b96a8592ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ForgeDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ForgeDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ddbf791d2d018cacdc833e0d1652f1d86228e3ac6814a7974f843771169ae3ee",
            "metadata": {},
            "name": "ForgeDeprecationMessage_appQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$695676b96a8592ec$var$node.hash = "06c66e4e27413d7a6996129034e23a82";
var $695676b96a8592ec$export$2e2bcd8739ae039 = $695676b96a8592ec$var$node;
module.exports["default"] = $695676b96a8592ec$export$2e2bcd8739ae039;

});

parcelRegister("lCRfz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dClXj = parcelRequire("dClXj");

const $43bea25c2aea9ada$export$4234d7cd582aba17 = ({ children: children, fallback: fallback = null, errorFallback: errorFallback = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dClXj.RelayErrorBoundary), {
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: fallback
    }, children));
module.exports["RelaySuspensefulBoundary"] = $43bea25c2aea9ada$export$4234d7cd582aba17;

});

parcelRegister("73oQr", function(module, exports) {
/**
 * @generated SignedSource<<70e06f2defb347cad8e45cc527c7b00f>>
 * @relayHash 0d86d9514ed0dc62ec55c47550347432
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855
const $1d95279d912e46c1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ForgeModalDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ForgeModalDeprecationMessage_appQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "10ddb346add2537047e9d08fed9494c213c3fbe41490cba82af8d9314e0e9855",
            "metadata": {},
            "name": "ForgeModalDeprecationMessage_appQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1d95279d912e46c1$var$node.hash = "6249f13b9dc8b658b8478b0412f6a152";
var $1d95279d912e46c1$export$2e2bcd8739ae039 = $1d95279d912e46c1$var$node;
module.exports["default"] = $1d95279d912e46c1$export$2e2bcd8739ae039;

});

parcelRegister("c5hPD", function(module, exports) {

var $gATpw = parcelRequire("gATpw");


var $1KHo7 = parcelRequire("1KHo7");


var $fi7Vj = parcelRequire("fi7Vj");


var $55skd = parcelRequire("55skd");


var $khxQ7 = parcelRequire("khxQ7");


var $7rj2U = parcelRequire("7rj2U");


var $gyXPd = parcelRequire("gyXPd");


var $kIhx9 = parcelRequire("kIhx9");


var $4KTOl = parcelRequire("4KTOl");


var $lgjGE = parcelRequire("lgjGE");


var $7sK9h = parcelRequire("7sK9h");


var $cVhn8 = parcelRequire("cVhn8");


var $5HHoF = parcelRequire("5HHoF");


var $36iDo = parcelRequire("36iDo");


var $e6sdP = parcelRequire("e6sdP");


var $i2zv0 = parcelRequire("i2zv0");


var $5mDFx = parcelRequire("5mDFx");


var $fMaLE = parcelRequire("fMaLE");

const $b040040bbf689f3f$var$shouldShow = (option)=>{
    // if option is not defined, return false
    if (option === undefined) return false;
    return option;
};
const $b040040bbf689f3f$export$b956d067c5bcf6b = (builder, appearance, features)=>{
    const defaultFeatures = {
        blockType: true,
        textFormatting: true,
        list: true,
        insertBlock: true,
        textColor: true,
        hyperLink: true,
        quickInsert: true,
        codeBlock: true
    };
    // if `features` is not defined, set all options to true
    // if `features` is provided, only options that are set to true by the developer will render. This is so any new plugin additions made by us will not be rendered by default as the developer has intentionally only set certain options to appear
    const enabledPlugins = features ?? defaultFeatures;
    return builder.add((0, $fi7Vj.default)).maybeAdd((0, $khxQ7.blockTypePlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.blockType)) // allows for different text tags(paragraphs, heading levels) and quote blocks to be added
    .add((0, $55skd.betterTypeHistoryPlugin)) // required for paste plugin
    .add([
        (0, $36iDo.pastePlugin),
        {}
    ]) // allows links to be converted to hyper link on paste
    .add((0, $fMaLE.typeAheadPlugin)).maybeAdd((0, $e6sdP.quickInsertPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.quickInsert)) // allows for `/` to insert nodes from a menu
    .maybeAdd((0, $5mDFx.textFormattingPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.textFormatting)).maybeAdd((0, $i2zv0.textColorPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.textColor)).maybeAdd((0, $5HHoF.listPlugin), $b040040bbf689f3f$var$shouldShow(enabledPlugins?.list)) // required for `-` to insert lists
    .maybeAdd([
        (0, $1KHo7.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.list)).add((0, $kIhx9.copyButtonPlugin)) // required for floating toolbar plugins
    .add((0, $lgjGE.editorDisabledPlugin)) // required for floating toolbar and `disabled` prop
    .add((0, $4KTOl.decorationsPlugin)) // required for floating toolbar
    .add((0, $7sK9h.floatingToolbarPlugin)) // required for toolbar to appear under links
    .maybeAdd([
        (0, $gATpw.hyperlinkPlugin),
        {
            editorAppearance: appearance,
            lpLinkPicker: true
        }
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.hyperLink)).add((0, $gyXPd.compositionPlugin)) // required for codeblock
    .maybeAdd([
        (0, $7rj2U.default),
        {}
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.codeBlock)).maybeAdd([
        (0, $cVhn8.insertBlockPlugin),
        {
            appearance: appearance
        }
    ], $b040040bbf689f3f$var$shouldShow(enabledPlugins?.insertBlock));
};
module.exports["createPreset"] = $b040040bbf689f3f$export$b956d067c5bcf6b;

});

parcelRegister("la0HD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

const $8ae13ba37c42793b$var$featuresAreEqual = (_previousFeatures, _currentFeatures)=>{
    // If both are references point to the same object, return true
    if (_previousFeatures === _currentFeatures) return true;
    const previousFeatures = _previousFeatures || {};
    const currentFeatures = _currentFeatures || {};
    if (Object.keys(previousFeatures).length !== Object.keys(currentFeatures).length) return false;
    // if any properties has changed, return false
    for(const key in previousFeatures){
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousFeatures[key], currentFeatures[key])) return false;
    }
    return true;
};
const $8ae13ba37c42793b$export$67693d05a6051899 = (features)=>{
    const previousFeatures = (0, $42omo.useRef)();
    const shouldUpdate = !$8ae13ba37c42793b$var$featuresAreEqual(previousFeatures.current, features);
    if (shouldUpdate) previousFeatures.current = features;
    return previousFeatures.current;
};
module.exports["useMemoisedFeatures"] = $8ae13ba37c42793b$export$67693d05a6051899;

});

parcelRegister("kVs3B", function(module, exports) {
/**
 * @generated SignedSource<<a462e79dac2ed3b21e4e829dc3845c67>>
 * @relayHash 0335332109c787dc4b91ad6ee3894ceb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43e7393e2b1dd4daa4f22d1c50da6e90c43cb68701111912458e4f4d7d7f6af0
const $da23282f06eaa55d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dataClassificationTags"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "locale",
            "variableName": "locale"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "environmentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "environmentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "environmentKey"
    }, v13 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "AppInstallationLicense",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "active"
            },
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
            },
            {
                "kind": "ScalarField",
                "name": "trialEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
            },
            {
                "kind": "ScalarField",
                "name": "isEvaluation"
            },
            {
                "kind": "ScalarField",
                "name": "billingPeriod"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
            },
            {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
            },
            {
                "kind": "ScalarField",
                "name": "capabilitySet"
            },
            {
                "kind": "ScalarField",
                "name": "modes"
            }
        ]
    }, v16 = {
        "concreteType": "UserAccess",
        "kind": "LinkedField",
        "name": "userAccess",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "enabled"
            },
            {
                "kind": "ScalarField",
                "name": "hasAccess"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "appVersion"
    }, v18 = {
        "kind": "ScalarField",
        "name": "installationId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "migrationKey"
    }, v20 = {
        "concreteType": "EcosystemAppInstallationConfigExtension",
        "kind": "LinkedField",
        "name": "installationConfig",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v21 = {
        "concreteType": "AppNetworkEgressPermissionExtension",
        "kind": "LinkedField",
        "name": "egress",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "addresses"
            },
            {
                "kind": "ScalarField",
                "name": "category"
            },
            {
                "kind": "ScalarField",
                "name": "inScopeEUD"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "scopes"
    }, v23 = {
        "kind": "ScalarField",
        "name": "consentUrl"
    }, v24 = {
        "concreteType": "UserConsentExtension",
        "kind": "LinkedField",
        "name": "currentUserConsent",
        "plural": false,
        "selections": [
            {
                "concreteType": "UserConsentExtensionUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "aaid"
                    }
                ]
            },
            {
                "concreteType": "UserConsentExtensionAppEnvironmentVersion",
                "kind": "LinkedField",
                "name": "appEnvironmentVersion",
                "plural": false,
                "selections": [
                    v5 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "consentedAt"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "requiresUserConsent"
    }, v26 = {
        "args": [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "dataClassificationTags",
                        "variableName": "dataClassificationTags"
                    }
                ],
                "kind": "ObjectValue",
                "name": "input"
            }
        ],
        "concreteType": "DataClassificationPolicyDecision",
        "kind": "LinkedField",
        "name": "dataClassificationPolicyDecision",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useExtensionList_forge_ui_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useExtensionList_forge_ui_Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "ExtensionContext",
                    "kind": "LinkedField",
                    "name": "extensionContexts",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "Extension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "appOwner",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v9 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "43e7393e2b1dd4daa4f22d1c50da6e90c43cb68701111912458e4f4d7d7f6af0",
            "metadata": {},
            "name": "useExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$da23282f06eaa55d$var$node.hash = "f4550c57b587a03d152e887674cfab78";
var $da23282f06eaa55d$export$2e2bcd8739ae039 = $da23282f06eaa55d$var$node;
module.exports["default"] = $da23282f06eaa55d$export$2e2bcd8739ae039;

});

parcelRegister("65XYT", function(module, exports) {
const $bb678f18ba43cf1b$var$DEFAULT_EVENT_SAMPLE_RATE = 0.1;
const $bb678f18ba43cf1b$var$DEFAULT_PROFILE_EVENT_VERSION = '2.0';
const $bb678f18ba43cf1b$export$b516b893fff0f452 = {
    enabled: true,
    sampleRate: $bb678f18ba43cf1b$var$DEFAULT_EVENT_SAMPLE_RATE,
    version: $bb678f18ba43cf1b$var$DEFAULT_PROFILE_EVENT_VERSION
};
const $bb678f18ba43cf1b$export$b8357089f6c151ea = [
    // Jira modules
    'jira:adminPage',
    'jira:customField',
    'jira:customFieldType',
    'jira:dashboardGadget',
    'jira:globalPage',
    'jira:issueAction',
    'jira:issueActivity',
    'jira:issueContext',
    'jira:issuePanel',
    'jira:projectPage',
    'jira:projectSettingsPage',
    'jira:uiModifications',
    // Confluence modules
    'confluence:contentAction',
    'confluence:contentBylineItem',
    'confluence:globalPage',
    'confluence:globalSettings',
    'confluence:spacePage',
    'xen:macro'
];
module.exports["defaultPerfCaptureConfig"] = $bb678f18ba43cf1b$export$b516b893fff0f452;
module.exports["enabledModulesForPerfCapture"] = $bb678f18ba43cf1b$export$b8357089f6c151ea;

});

parcelRegister("fSMLG", function(module, exports) {
const $796443ed50933d56$export$5458688a52e32026 = [
    // Error in user code
    /^There was an error invoking the function/,
    // User code returned non-JSON value, so XIS threw an InvalidInvocationPayloadError.
    /^Invalid response body, data must be JSON or undefined$/,
    // Networking errors
    /^Failed to fetch$/,
    /^Network error: Failed to fetch$/,
    /^Network error: Network failure: TypeError: Failed to fetch$/,
    /^NetworkError when attempting to fetch resource.$/,
    /^Network error: Received status 504$/,
    /^GraphQL error: The underlying service call timed out$/,
    // Unauthenticated requests made from public confluence content
    /^GraphQL error: Auth category: UNAUTHENTICATED is not allowed in service xen_invocation_service$/
];
module.exports["blocklistedErrorMessagePatterns"] = $796443ed50933d56$export$5458688a52e32026;

});

parcelRegister("faCvF", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $dh538 = parcelRequire("dh538");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $04ed449cb34fa9a4$var$makeConfluenceURLPath = (0, $j4W8T.createMakeProductURLPath)('/wiki');
const $04ed449cb34fa9a4$var$isCustomContentType = (contentType)=>contentType.startsWith('forge:');
const $04ed449cb34fa9a4$export$68f051c1b56c060f = {
    [(0, $1c598.ConfluenceExtension).FULL_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        if (!(0, $dh538.fg)('forge-ui-full-page-router-navigate')) return null;
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix) return null;
        return `/forge-apps/a/${appId}/e/${environmentId}/r/${routePrefix}`;
    },
    [(0, $1c598.ConfluenceExtension).GLOBAL_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId })=>{
        const { route: route } = properties;
        if (appId && environmentId && route) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).GLOBAL_SETTINGS]: ({ id: id })=>$04ed449cb34fa9a4$var$makeConfluenceURLPath('/admin/forge', {
            id: id
        }),
    [(0, $1c598.ConfluenceExtension).SPACE_PAGE]: ({ properties: properties, environmentId: environmentId, appId: appId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/apps/${appId}/${environmentId}/${route}`);
        return null;
    },
    [(0, $1c598.ConfluenceExtension).SPACE_SETTINGS]: ({ properties: properties, appId: appId, environmentId: environmentId }, { spaceKey: spaceKey })=>{
        const { route: route } = properties;
        if (!spaceKey) throw (0, $6usda.NavigationError).MissingProperty('spaceKey');
        if (route && environmentId && appId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}/settings/apps/${appId}/${environmentId}/${route}`);
        return null;
    }
};
const $04ed449cb34fa9a4$export$f91bdc214ca5389d = {
    contentView: async ({ contentId: contentId, version: version })=>{
        if (!contentId) throw (0, $6usda.NavigationError).MissingProperty('contentId');
        let resp = null;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { id: id, type: type, _links: { webui: webui } } = await resp.json();
        // if version is provided, we should use it, however, it only works for none-custom content type
        if (version && version >= 0) {
            if ($04ed449cb34fa9a4$var$isCustomContentType(type)) throw new Error('Version is not supported for custom content type');
            return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/pages/viewpage.action', {
                pageId: id,
                pageVersion: `${version}`
            });
        } else if (webui) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(webui);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    contentEdit: async ({ contentId: contentId })=>{
        let resp;
        try {
            resp = await fetch(`/wiki/rest/api/content/${contentId}`);
        } catch (e) {
            throw (0, $6usda.NavigationError).FailedToFetchContentInfo(contentId);
        }
        const { _links: { edituiv2: edituiv2 } } = await resp.json();
        // content with custom content type doesn't have edit link
        if (edituiv2) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(edituiv2);
        throw (0, $6usda.NavigationError).LinkForContentNotFound(contentId);
    },
    spaceView: async ({ spaceKey: spaceKey })=>{
        return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${(0, $6usda.ensurePropertyExists)('spaceKey', spaceKey)}`);
    },
    contentList: async (params, { getAppForgeUIExtensions: getAppForgeUIExtensions })=>{
        const { contentType: contentType } = params;
        if (!contentType) throw (0, $6usda.NavigationError).MissingProperty('contentType');
        if (contentType === 'customContent' && params.moduleKey) {
            const { moduleKey: moduleKey } = params;
            const module = await (0, $6usda.getModuleByKey)(getAppForgeUIExtensions, moduleKey);
            if (!module) throw (0, $6usda.NavigationError).ModuleNotFound(moduleKey);
            const { appId: appId, environmentId: environmentId } = module;
            if (appId && environmentId) return $04ed449cb34fa9a4$var$makeConfluenceURLPath('/search', {
                type: `forge:${appId}:${environmentId}:${moduleKey}`
            });
        } else if (contentType === 'page' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/pages`);
        else if (contentType === 'blogpost' && params.spaceKey) return $04ed449cb34fa9a4$var$makeConfluenceURLPath(`/spaces/${params.spaceKey}/blogs`);
        throw (0, $6usda.NavigationError).InvalidValueForProperty('contentType', contentType);
    }
};
module.exports["confluenceExtensionURLHelpers"] = $04ed449cb34fa9a4$export$68f051c1b56c060f;
module.exports["confluenceNavigationTargetURLHelpers"] = $04ed449cb34fa9a4$export$f91bdc214ca5389d;

});

parcelRegister("6usda", function(module, exports) {
const $9406182ad5621a53$export$c1f2bec49c0b084d = async (getAppForgeUIExtensions, moduleKey)=>{
    const { extensions: extensions } = await getAppForgeUIExtensions({
        expandAppOwner: false
    });
    const module = extensions?.find(({ key: key })=>key === moduleKey);
    return module?.type ? module : null;
};
const $9406182ad5621a53$export$c53ed1333d39ada3 = {
    ModuleNotFound: (moduleKey)=>{
        return new Error(`Navigation failed: Module with moduleKey ${moduleKey} was not found`);
    },
    MissingProperty: (property)=>{
        return new Error(`Navigation failed: ${property} not provided`);
    },
    FailedToFetchContentInfo: (contentId)=>{
        return new Error(`Navigation failed: Failed to fetch content information with id ${contentId}. Please check if the ID provided is correct`);
    },
    NotSupportedExtensionType: (moduleType)=>{
        return new Error(`Navigation failed: Module type ${moduleType} is not supported`);
    },
    InvalidValueForProperty: (property, value)=>{
        return new Error(`Navigation failed: ${value} is not a valid value for ${property}`);
    },
    LinkForContentNotFound: (contentId)=>{
        return new Error(`Navigation failed: Link for content with id ${contentId} was not found`);
    }
};
const $9406182ad5621a53$export$ae701e18d3b38cae = (propertyName, propertyValue)=>{
    if (propertyValue === undefined || propertyValue === null) throw $9406182ad5621a53$export$c53ed1333d39ada3.MissingProperty(propertyName);
    return propertyValue;
};
module.exports["getModuleByKey"] = $9406182ad5621a53$export$c1f2bec49c0b084d;
module.exports["NavigationError"] = $9406182ad5621a53$export$c53ed1333d39ada3;
module.exports["ensurePropertyExists"] = $9406182ad5621a53$export$ae701e18d3b38cae;

});

parcelRegister("6wbTo", function(module, exports) {

var $1c598 = parcelRequire("1c598");


var $dh538 = parcelRequire("dh538");


var $j4W8T = parcelRequire("j4W8T");


var $6usda = parcelRequire("6usda");

const $d3b8e1134d73790d$var$makeJiraURLPath = (0, $j4W8T.createMakeProductURLPath)('/jira');
const $d3b8e1134d73790d$var$PROJECT_TYPE_SEGMENT_MAP = {
    software: 'software',
    business: 'core',
    service_desk: 'servicedesk'
};
const $d3b8e1134d73790d$var$projectTypeSegmentCache = new Map();
const $d3b8e1134d73790d$export$8901d41959b1b84d = ()=>$d3b8e1134d73790d$var$projectTypeSegmentCache.clear();
const $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment = async (projectKey)=>{
    const cached = $d3b8e1134d73790d$var$projectTypeSegmentCache.get(projectKey);
    if (cached) return cached;
    try {
        const resp = await fetch(`/rest/api/3/project/${projectKey}`);
        const { projectTypeKey: projectTypeKey } = await resp.json();
        const segment = $d3b8e1134d73790d$var$PROJECT_TYPE_SEGMENT_MAP[projectTypeKey];
        if (segment) {
            $d3b8e1134d73790d$var$projectTypeSegmentCache.set(projectKey, segment);
            return segment;
        }
        // eslint-disable-next-line no-console
        console.warn(`Navigation: Unknown project type key "${projectTypeKey}" for "${projectKey}"`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Navigation: Failed to resolve project type for "${projectKey}"`, e);
    }
    // default to software segment if we fail to resolve the project type, this ensure backwards compatibility with the existing apps
    return 'software';
};
const $d3b8e1134d73790d$export$47842863b73e9046 = {
    [(0, $1c598.JiraExtension).FULL_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        if (!(0, $dh538.fg)('forge-ui-full-page-router-navigate')) return null;
        const { routePrefix: routePrefix } = properties;
        if (!routePrefix) return null;
        return `/forge-apps/a/${appId}/e/${environmentId}/r/${routePrefix}`;
    },
    [(0, $1c598.JiraExtension).ADMIN_PAGE]: ({ appId: appId, environmentId: environmentId, properties: properties })=>{
        const { useAsGetStarted: useAsGetStarted, useAsConfig: useAsConfig } = properties;
        if (useAsGetStarted) return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/get-started/${appId}/${environmentId}`);
        if (useAsConfig) return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/configure/${appId}/${environmentId}`);
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).GLOBAL_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PERSONAL_SETTINGS_PAGE]: ({ appId: appId, environmentId: environmentId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/settings/personal/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_SETTINGS_PAGE]: async ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        const validatedKey = (0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        if ((0, $dh538.fg)('forge-ui-get-url-supprt-jira-project-type-lookup')) {
            const segment = await $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment(validatedKey);
            return $d3b8e1134d73790d$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/settings/apps/${appId}/${environmentId}`);
        }
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${validatedKey}/settings/apps/${appId}/${environmentId}`);
    },
    [(0, $1c598.JiraExtension).PROJECT_PAGE]: async ({ appId: appId, environmentId: environmentId }, { projectKey: projectKey })=>{
        const validatedKey = (0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        if ((0, $dh538.fg)('forge-ui-get-url-supprt-jira-project-type-lookup')) {
            const segment = await $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment(validatedKey);
            return $d3b8e1134d73790d$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/apps/${appId}/${environmentId}`);
        }
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${validatedKey}/apps/${appId}/${environmentId}`);
    }
};
const $d3b8e1134d73790d$export$ca7043166c283e6d = {
    dashboard: async ({ dashboardId: dashboardId })=>{
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/dashboards/${(0, $6usda.ensurePropertyExists)('dashboardId', dashboardId)}`);
    },
    issue: async ({ issueKey: issueKey })=>{
        return `/browse/${(0, $6usda.ensurePropertyExists)('issueKey', issueKey)}`;
    },
    // equivalent to Connects projectAdminSummary target
    projectSettingsDetails: async ({ projectKey: projectKey })=>{
        const validatedKey = (0, $6usda.ensurePropertyExists)('projectKey', projectKey).toUpperCase();
        if ((0, $dh538.fg)('forge-ui-get-url-supprt-jira-project-type-lookup')) {
            const segment = await $d3b8e1134d73790d$var$resolveJiraProjectTypeSegment(validatedKey);
            return $d3b8e1134d73790d$var$makeJiraURLPath(`/${segment}/projects/${validatedKey}/settings/details`);
        }
        return $d3b8e1134d73790d$var$makeJiraURLPath(`/software/projects/${validatedKey}/settings/details`);
    }
};
module.exports["jiraExtensionURLHelpers"] = $d3b8e1134d73790d$export$47842863b73e9046;
module.exports["jiraNavigationTargetHandlers"] = $d3b8e1134d73790d$export$ca7043166c283e6d;

});

parcelRegister("j4W8T", function(module, exports) {
// Ensures that the path structured correctly and adds provided parameters to the path
const $ae891dc783a5dbcf$export$26e2379e0018d084 = (path, parameters)=>{
    let encodedPath = (path ?? '').split('/').map(encodeURIComponent).join('/');
    if (parameters && Object.keys(parameters).length > 0) encodedPath += '?' + new URLSearchParams(parameters).toString();
    return encodedPath;
};
const $ae891dc783a5dbcf$export$ab31bc7dd6e328ce = (productPathPrefix)=>(path, parameters)=>{
        return $ae891dc783a5dbcf$export$26e2379e0018d084(path ? productPathPrefix + path : productPathPrefix, parameters);
    };
module.exports["ensureURLPath"] = $ae891dc783a5dbcf$export$26e2379e0018d084;
module.exports["createMakeProductURLPath"] = $ae891dc783a5dbcf$export$ab31bc7dd6e328ce;

});

parcelRegister("dIZZf", function(module, exports) {
/**
 * @generated SignedSource<<ce81b90f1c46f89b0f8e4e64248c9d95>>
 * @relayHash a8d997cf9f56d7a9bc9c3a4673a4ab05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2
const $a84e2492be2891c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRovoEnabled"
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getIsRovoEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getIsRovoEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "392e69b59b157550f874185ece3f2558dca2cfd138ebbca83e163ba479f415b2",
            "metadata": {},
            "name": "getIsRovoEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a84e2492be2891c8$var$node.hash = "4e6658c9c4fce21189d6b3b9b3b4e535";
var $a84e2492be2891c8$export$2e2bcd8739ae039 = $a84e2492be2891c8$var$node;
module.exports["default"] = $a84e2492be2891c8$export$2e2bcd8739ae039;

});

parcelRegister("fJCAk", function(module, exports) {
/* AdminConsentModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @deprecated
 * This is the v1 admin consent modal, driven by the `usePermission` hook.
 *
 * The v2 equivalent is:
 *   `platform/packages/forge/forge-ui/src/bridge/methods/permissions/AdminConsentModal.tsx`
 *
 * The `styles` and `messages` exports from this file are
 * intentionally re-used by the v2 modal to keep the UI consistent while avoiding
 * duplication. Do not remove those exports.
 *
 * Do not add new UI logic here — add it to the v2 modal instead.
 */ 
var $42omo = parcelRequire("42omo");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $ccHMk = parcelRequire("ccHMk");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $aXWIB = parcelRequire("aXWIB");

const $f58f5052b341dbb2$export$9dd6ff9ea0189349 = {
    titleContainer: "_otyrxy5q",
    modalFooterContainer: "_15a5nqa1 _uwhke4h9 _1i531l7x",
    disclaimerContainer: "_19pkxy5q _otyrxy5q",
    rowContainer: "_ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _1il9nqa1 _1doce4h9 _1o3i1l7x"
};
const $f58f5052b341dbb2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    declineButtonLabel: {
        id: "forge-ui.adminConsentModal.decline.button.label",
        defaultMessage: "Decline"
    },
    approveButtonLabel: {
        id: "forge-ui.adminConsentModal.approve.button.label",
        defaultMessage: "Approve"
    },
    noticeForMoreDetails: {
        id: "forge-ui.adminConsentModal.notice.for-more-details",
        defaultMessage: "For more details, refer to {appName}'s"
    },
    noticeAnd: {
        id: "forge-ui.adminConsentModal.notice.and",
        defaultMessage: "and"
    },
    termsOfUseLink: {
        id: "forge-ui.adminConsentModal.terms-of-use.link",
        defaultMessage: "terms of use"
    },
    privacyPolicyLink: {
        id: "forge-ui.adminConsentModal.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    modalTransitionTitle: {
        id: "forge-ui.adminConsentModal.modal-transition.title",
        defaultMessage: "Data storage, sharing, receiving and processing"
    },
    modalTransitionText: {
        id: "forge-ui.adminConsentModal.modal-transition.text",
        defaultMessage: "{appName} is requesting to share with and receive data from the following domains:"
    }
});
const $f58f5052b341dbb2$export$24cbef36aabf5e56 = ({ modalState: modalState })=>{
    const intl = (0, $aXWIB.useIntl)();
    if (modalState.state === 'closed') return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null);
    const ModalFooter = ()=>{
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.modalFooterContainer
        }, /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            space: "space.075"
        }, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: modalState.onCancel
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.declineButtonLabel)), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            onClick: modalState.onConfirm,
            appearance: "primary"
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.approveButtonLabel)))));
    };
    const renderDomains = ()=>{
        const getHumanReadableName = (operation)=>{
            switch(operation){
                case 'FETCH_BACKEND_SIDE':
                    return 'Fetch backend side';
                case 'FETCH_CLIENT_SIDE':
                    return 'Fetch client side';
                case 'FONTS':
                    return 'Fonts';
                case 'FRAMES':
                    return 'Frames';
                case 'IMAGES':
                    return 'Images';
                case 'MEDIA':
                    return 'Media';
                case 'NAVIGATION':
                    return 'Navigation';
                case 'SCRIPTS':
                    return 'Scripts';
                case 'STYLES':
                    return 'Styles';
                default:
                    return 'Egress';
            }
        };
        const domainInfo = modalState.domainInfo;
        if (Object.keys(domainInfo).length === 0) return null;
        if (domainInfo.type === 'REMOTE') return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.remotes.map((r)=>{
            const manifestRemoteInfo = domainInfo.manifestRemoteMap[r.key];
            return /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: r.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "small"
            }, manifestRemoteInfo ? manifestRemoteInfo.description : 'Remote'), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.rowContainer,
                spread: "space-between",
                grow: "fill"
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, r.configured.endpoint === null ? 'This remote is being reset to the default value' : r.configured.endpoint), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, manifestRemoteInfo ? manifestRemoteInfo.name : null)));
        }));
        if (domainInfo.type === 'EGRESS') return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.150"
        }, domainInfo.payload.egresses.map((e)=>/*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
                key: e.key,
                space: "space.150"
            }, /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
                size: "xsmall"
            }, e.description), e.configured.map((c)=>{
                return c.type.map((t)=>{
                    return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                        xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.rowContainer,
                        spread: "space-between",
                        grow: "fill"
                    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, c.domain), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, getHumanReadableName(t)));
                });
            }))));
    };
    const Notice = ()=>{
        const { appName: appName, termsOfUseLink: termsOfUseLink, privacyPolicyLink: privacyPolicyLink } = modalState;
        if (termsOfUseLink && privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.termsOfUseLink)), ' ', intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeAnd), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.privacyPolicyLink)));
        else if (termsOfUseLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: termsOfUseLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.termsOfUseLink)));
        else if (privacyPolicyLink) return /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.noticeForMoreDetails, {
            appName: appName ?? 'the app'
        }), ' ', /*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
            href: privacyPolicyLink
        }, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.privacyPolicyLink)));
    };
    return /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: ()=>{
            modalState.onCancel();
        },
        width: "large"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), null, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.titleContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.modalTransitionTitle)))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        space: "space.300"
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, intl.formatMessage($f58f5052b341dbb2$export$defe85febe8b728c.modalTransitionText, {
        appName: modalState.appName ?? 'The app'
    })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), null, renderDomains(), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $f58f5052b341dbb2$export$9dd6ff9ea0189349.disclaimerContainer
    }, /*#__PURE__*/ $42omo.createElement(Notice, null))))), /*#__PURE__*/ $42omo.createElement(ModalFooter, null)));
};
module.exports["styles"] = $f58f5052b341dbb2$export$9dd6ff9ea0189349;
module.exports["messages"] = $f58f5052b341dbb2$export$defe85febe8b728c;
module.exports["AdminModal"] = $f58f5052b341dbb2$export$24cbef36aabf5e56;

});

parcelRegister("20GoR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $9XihO = parcelRequire("9XihO");


var $7MEO5 = parcelRequire("7MEO5");


var $hpRDw = parcelRequire("hpRDw");

const $703d3a3574eac153$var$EGRESS_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/egress'
    });
const $703d3a3574eac153$var$EGRESS_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/egress?dryRun=${dryRun}`
    });
const $703d3a3574eac153$var$EGRESS_DELETE_GROUP = (installationId)=>({
        method: 'DELETE',
        route: `/forge/installation/v1/${installationId}/dynamic/egress`
    });
const $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN = (installationId)=>({
        method: 'PATCH',
        route: `/forge/installation/v1/${installationId}/dynamic/egress/delete-domain`
    });
const $703d3a3574eac153$var$REMOTE_GET = ()=>({
        method: 'GET',
        route: '/forge/installation/v1/dynamic/remote'
    });
const $703d3a3574eac153$var$REMOTE_SET = (installationId, dryRun = false)=>({
        method: 'PUT',
        route: `/forge/installation/v1/${installationId}/dynamic/remote?dryRun=${dryRun}`
    });
function $703d3a3574eac153$export$70250d945629938a({ appId: appId, installationId: installationId, extensionId: extensionId, accountType: accountType, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: contextIds = [] }) {
    function getBaseUrl() {
        const currentUrl = new URL(document.URL);
        return `${currentUrl.origin}/gateway/api`;
    }
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const fetchOAuthToken = (0, $hpRDw.useFetchAuthToken)({
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    const oauthFetch = async (restPath, init)=>{
        const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
        captureEvent?.({
            type: 'permission-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const atlassianAccount = !accountType || accountType === 'atlassian';
        if (!(0, $9XihO.isTokenValid)(authTokenRef.current) && atlassianAccount) authTokenRef.current = await fetchOAuthToken(extensionId, contextIds);
        const headers = new Headers(init.headers);
        headers.set('Authorization', `Bearer ${authTokenRef?.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
        const request = fetch(new URL(`${getBaseUrl()}${restPath}`), {
            ...init,
            body: init.body,
            headers: headers
        });
        if ((0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) request.then(()=>{
            const requestEndMark = (0, $1uzCd.getPerformanceMark)();
            captureEvent?.({
                type: 'permission-api-requested',
                duration: requestEndMark - requestAuthStartMark,
                authDuration: requestAuthEndMark - requestAuthStartMark,
                elapsed: requestEndMark
            });
        });
        return request;
    };
    const sessionFetch = async (restPath, init)=>{
        const request = fetch(`${getBaseUrl()}${restPath}`, {
            ...init,
            body: init.body
        });
        return request;
    };
    return {
        egressGet: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_GET();
            const init = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append('keys', k);
            });
            if (payload.pageSize) sp.append('pageSize', `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append('nextPageToken', payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init);
        },
        egressSet: async (payload, isDryRun)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_SET(installationId, isDryRun);
            const body = JSON.stringify(payload);
            const init = {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route, init);
        },
        egressDeleteDomain: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_DELETE_DOMAIN(installationId);
            const body = JSON.stringify(payload);
            const init = {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route, init);
        },
        egressDeleteGroup: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$EGRESS_DELETE_GROUP(installationId);
            const init = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.key) sp.append('key', payload.key);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return sessionFetch(routeToUse, init);
        },
        remoteGet: async (payload)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$REMOTE_GET();
            const init = {
                method: method
            };
            const sp = new URLSearchParams();
            if (payload.keys && payload.keys.length > 0) payload.keys.forEach((k)=>{
                sp.append('keys', k);
            });
            if (payload.pageSize) sp.append('pageSize', `${payload.pageSize}`);
            if (payload.nextPageToken) sp.append('nextPageToken', payload.nextPageToken);
            let routeToUse = route;
            if (sp.size > 0) routeToUse = `${route}?${sp.toString()}`;
            return oauthFetch(routeToUse, init);
        },
        remoteSet: async (payload, isDryRun)=>{
            const { route: route, method: method } = $703d3a3574eac153$var$REMOTE_SET(installationId, isDryRun);
            const body = JSON.stringify(payload);
            const init = {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body
            };
            return sessionFetch(route, init);
        }
    };
}
module.exports["usePermissionFetchClient"] = $703d3a3574eac153$export$70250d945629938a;

});

parcelRegister("4LgCj", function(module, exports) {

var $hvvoj = parcelRequire("hvvoj");


var $buzAL = parcelRequire("buzAL");

const $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6 = (bridge, args)=>{
    const { userConsentRequired: userConsentRequired } = args;
    return {
        refresh: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.refresh),
        submit: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.submit),
        open: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.open),
        close: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.close),
        onClose: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.onClose),
        openModal: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.openModal, {
            requiresUserConsent: userConsentRequired
        }),
        showFlag: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.showFlag),
        closeFlag: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.closeFlag),
        reconcile: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.reconcile),
        emitReadyEvent: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.emitReadyEvent),
        onError: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.onError),
        createHistory: ()=>(0, $hvvoj.createHistory)({
                history: bridge?.history,
                extensionBasePath: bridge?.extensionBasePath
            }),
        changeWindowTitle: $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8(bridge?.changeWindowTitle),
        ...(0, $buzAL.getCreateBridgeApiPermissionFunctions)(bridge)
    };
};
const $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8 = (method, ...args)=>{
    return async (payload)=>{
        if (method) return method(payload, ...args) ?? true;
        return false;
    };
};
module.exports["createBridgeApi"] = $53fbfe482eb8d8a0$export$41b5b6d6fbe1e6b6;
module.exports["createBridgeMethod"] = $53fbfe482eb8d8a0$export$98f3bf6f3e07f1f8;

});

parcelRegister("dhMrf", function(module, exports) {

var $6mbqJ = parcelRequire("6mbqJ");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $7MEO5 = parcelRequire("7MEO5");


var $kaOT1 = parcelRequire("kaOT1");


var $1Igmn = parcelRequire("1Igmn");

class $c2921b3ec001e75a$export$67e3479a9f34cffa extends Error {
}
function $c2921b3ec001e75a$export$cea4d5b903e9aab5() {
    const tracing = (0, $kaOT1.useTracingContext)();
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const environment = relayContext?.environment;
    const fetchAppData = async (appId, contextIds)=>{
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        tracing?.recordGqlCall('APP_BY_ID_QUERY - start');
        // TODO move query fragment into AdminConsentModal.tsx
        return new Promise((resolve, reject)=>{
            if (environment) (0, $irOoi.fetchQuery)(environment, (0, $6mbqJ.default), {
                appAri: appAri,
                contextIds: contextIds
            }, {
                networkCacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                        }
                    }
                }
            }).subscribe({
                next: (data)=>{
                    resolve(data.app);
                },
                error: (error)=>{
                    const details = JSON.stringify(error);
                    reject(new $c2921b3ec001e75a$export$67e3479a9f34cffa(`Failed to fetch app data by its ID: ${appAri}, GraphQLError: ${details}`));
                },
                complete: ()=>{
                    tracing?.recordGqlCall('APP_BY_ID_QUERY - end');
                }
            });
        });
    };
    return fetchAppData;
}
module.exports["useForgeAppQuery"] = $c2921b3ec001e75a$export$cea4d5b903e9aab5;

});

parcelRegister("dClXj", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $77bb5e7ce6fe0664$export$efd8f108e163181c extends (0, $42omo.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
module.exports["RelayErrorBoundary"] = $77bb5e7ce6fe0664$export$efd8f108e163181c;

});

parcelRegister("9XihO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $JsJ4Y = parcelRequire("JsJ4Y");

var $b7qxC = parcelRequire("b7qxC");


var $dh538 = parcelRequire("dh538");


var $7MEO5 = parcelRequire("7MEO5");


var $1uzCd = parcelRequire("1uzCd");


var $iUjrf = parcelRequire("iUjrf");


var $hpRDw = parcelRequire("hpRDw");


var $cTsf6 = parcelRequire("cTsf6");


var $irOoi = parcelRequire("irOoi");


var $9c0Ac = parcelRequire("9c0Ac");

const $d04645d643f36821$var$validProducts = [
    'confluence',
    'jira',
    'bitbucket'
];
const $d04645d643f36821$var$apiGatewayUrlMap = {
    dev: 'api.stg.atlassian.com',
    stg: 'api.stg.atlassian.com',
    prod: 'api.atlassian.com'
};
const $d04645d643f36821$var$getApiGatewayUrl = (environment)=>{
    const apiBase = $d04645d643f36821$var$apiGatewayUrlMap[environment];
    const url = (0, $lzcvT.isFedRamp)() ? apiBase.replace('atlassian.com', 'atlassian-us-gov-mod.com') : apiBase;
    if (!url) throw new Error(`Invalid environment: ${environment}`);
    return url;
};
const $d04645d643f36821$var$getBaseUrlForIsolatedCloud = (product, cloudId)=>{
    if (product === 'bitbucket') throw new Error('product not supported in Isolated Cloud yet.');
    const apiBase = `api.${(0, $T9xHm.isolatedCloudDomain)()}`;
    return `https://${apiBase}/ex/${product}/${cloudId}`;
};
function $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId) {
    if (product === 'bitbucket') return environment === 'prod' ? 'https://api.bitbucket.org' : 'https://api.integration.bb-inf.net';
    const apiBase = $d04645d643f36821$var$getApiGatewayUrl(environment);
    return `https://${apiBase}/ex/${product}/${cloudId}`;
}
function $d04645d643f36821$var$getBaseUrl(environment, product, cloudId) {
    if ((0, $dh538.fg)('forge-ui-oasis-enabled')) return (0, $T9xHm.isIsolatedCloud)() ? $d04645d643f36821$var$getBaseUrlForIsolatedCloud(product, cloudId) : $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
    return $d04645d643f36821$var$getBaseUrlForCommercialAndFedRamp(environment, product, cloudId);
}
function $d04645d643f36821$var$createProductUrl(environment, product, restPath, cloudId) {
    const baseUrl = $d04645d643f36821$var$getBaseUrl(environment, product, cloudId);
    const fullUrl = // bitbucket requests could be made with absolute URLs
    // e.g. when following href links in API responses
    product === 'bitbucket' && restPath.startsWith(`${baseUrl}/`) ? restPath : `${baseUrl}${restPath}`;
    const productUrl = new URL(fullUrl).toString();
    if (!productUrl.startsWith(`${baseUrl}/`)) throw new Error('Invalid product URL');
    return productUrl;
}
function $d04645d643f36821$export$d1a8c8b605234fe8(token) {
    return !!(token && token.expiry > Date.now());
}
function $d04645d643f36821$var$isProduct(product) {
    return $d04645d643f36821$var$validProducts.includes(product);
}
function $d04645d643f36821$export$da8d8c42bfb20907(contentType) {
    return Boolean(contentType && !contentType.includes('application/json') && contentType.search(/text\//) === -1);
}
function $d04645d643f36821$var$parseFormData(formLike) {
    const form = new FormData();
    for (const [key, value] of Object.entries(formLike))if (key === 'file') {
        const fileName = formLike['__fileName'];
        const mimeType = formLike['__fileType'];
        // convert back from base64 to File (Blob)
        const blob = (0, $JsJ4Y.base64ToBlob)(value, mimeType);
        const file = new File([
            blob
        ], fileName, {
            type: mimeType
        });
        form.append('file', file);
    } else form.append(key, value);
    // remove request metadata properties
    form.delete('__fileName');
    form.delete('__fileType');
    return form;
}
const $d04645d643f36821$var$requestProduct = async (url, init)=>{
    const response = await fetch(url, init);
    const isAttachment = $d04645d643f36821$export$da8d8c42bfb20907(response.headers.get('content-type'));
    if (response.ok && response.body !== null && response.status !== 204 && isAttachment) {
        const b64Content = await (0, $JsJ4Y.blobToBase64)(await response.blob());
        return new Response(b64Content, {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
    return response;
};
function $d04645d643f36821$export$2f041121bdb61a5({ appId: appId, extensionId: extensionId, environment: environment, cloudId: cloudId, workspaceId: workspaceId, renderThreeLOPrompt: renderThreeLOPrompt, contextIds: contextIds = [], isAnonymousAccessSupportedByApp: isAnonymousAccessSupportedByApp = false }) {
    const { captureEvent: captureEvent } = (0, $iUjrf.usePerformanceAnalytics)();
    const userAccess = (0, $42omo.useContext)((0, $9c0Ac.UserAccessContext));
    const authTokenRef = (0, $42omo.useRef)(undefined);
    const isUserAnonymous = userAccess?.isUserAnonymous ?? false;
    const anonymousRequestsEnabled = (0, $42omo.useRef)(isUserAnonymous && isAnonymousAccessSupportedByApp);
    const relayContext = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    const relayEnvironment = relayContext?.environment;
    const fetchOAuthToken = (0, $hpRDw.useFetchAuthToken)({
        renderThreeLOPrompt: renderThreeLOPrompt
    });
    /**
	 * Workspace based products like Trello and Bitbucket will not pass in cloudId,
	 * they will pass in workspaceId instead.
	 */ if (!cloudId && !workspaceId) return async ()=>{
        throw new Error('Product APIs are not available in this module. Remove requestConfluence, requestJira or requestBitbucket from your code.');
    };
    const cdnEnvironment = (0, $b7qxC.getCDNEnvironment)(environment);
    return async (restPath, product, init, isMultipartFormData)=>{
        if (!$d04645d643f36821$var$isProduct(product)) throw new Error(`Invalid product: ${product}`);
        const requestAuthStartMark = (0, $1uzCd.getPerformanceMark)();
        captureEvent?.({
            type: 'product-api-request-initiated',
            elapsed: requestAuthStartMark
        });
        const prerequisites = [];
        const headers = new Headers(init.headers);
        if ((0, $dh538.fg)('forge-ui-enable-region-steering')) // We need to fetch the tenant region to know which region to steer the request to.
        prerequisites.push((0, $cTsf6.getTenantRegion)({
            product: product,
            cloudId: cloudId,
            relayEnvironment: relayEnvironment
        }).then((targetRegion)=>{
            if (!!targetRegion) headers.set('atl-edge-region-hint', targetRegion);
        })// Fallback to no steering.
        .catch(()=>null));
        const isAccessValid = anonymousRequestsEnabled.current || $d04645d643f36821$export$d1a8c8b605234fe8(authTokenRef.current);
        if (!isAccessValid) // Non-anonymous user -> fetch an OAuth token for API auth
        prerequisites.push(fetchOAuthToken(extensionId, contextIds).then((token)=>{
            // Token valid -> use in API calls
            authTokenRef.current = token;
        }).catch((e)=>{
            // Failure -> fallback to anon access if supported by app
            if (isAnonymousAccessSupportedByApp && (0, $dh538.fg)('forge-ui-allow-anon-rest-calls')) {
                anonymousRequestsEnabled.current = true;
                return;
            }
            // Expecting token -> Rethrow
            throw e;
        }));
        await Promise.all(prerequisites);
        if (!anonymousRequestsEnabled.current) headers.set('Authorization', `Bearer ${authTokenRef.current?.token}`);
        // this header is used to identify requests made by Forge, based on:
        // https://hello.atlassian.net/wiki/x/O5jUIwE?atlOrigin=eyJpIjoiM2NhNjU1MDUxOWJkNDcxNThiNzJjNWU1NzE5Y2FmZTMiLCJwIjoiYyJ9
        const appAri = (0, $7MEO5.createAppAri)({
            appId: appId
        }).toString();
        headers.set('x-ecosystem-user-agent', `forge ${appAri}`);
        const body = isMultipartFormData ? $d04645d643f36821$var$parseFormData(JSON.parse(init.body)) : init.body;
        if (isMultipartFormData) // let the fetch api correctly set the multipart/form-data content-type
        // https://github.com/github/fetch/issues/505#issuecomment-293064470
        headers.delete('content-type');
        const request = $d04645d643f36821$var$requestProduct($d04645d643f36821$var$createProductUrl(cdnEnvironment, product, restPath, cloudId), {
            // Defensive assumption: only token & anonymous auth is supported; prevent unintended
            // fallback to other auth mechanisms by omitting credentials (e.g. cookies).
            credentials: (0, $dh538.fg)('forge-ui-allow-anon-rest-calls') ? 'omit' : undefined,
            ...init,
            body: body,
            headers: headers
        });
        if ((0, $dh538.fg)('forge-ui-app-perf-tracking-enabled')) {
            const requestAuthEndMark = (0, $1uzCd.getPerformanceMark)();
            request.then(()=>{
                const requestEndMark = (0, $1uzCd.getPerformanceMark)();
                captureEvent?.({
                    type: 'product-api-requested',
                    duration: requestEndMark - requestAuthStartMark,
                    authDuration: requestAuthEndMark - requestAuthStartMark,
                    elapsed: requestEndMark
                });
            });
        }
        return request;
    };
}
module.exports["isTokenValid"] = $d04645d643f36821$export$d1a8c8b605234fe8;
module.exports["isBinaryContentType"] = $d04645d643f36821$export$da8d8c42bfb20907;
module.exports["useProductFetchClient"] = $d04645d643f36821$export$2f041121bdb61a5;

});

parcelRegister("hpRDw", function(module, exports) {

var $gmeYw = parcelRequire("gmeYw");


var $irOoi = parcelRequire("irOoi");


var $kaOT1 = parcelRequire("kaOT1");


var $1Igmn = parcelRequire("1Igmn");

const $6d9ae53960c6917a$export$5d72c9fa1086d504 = 1000;
const $6d9ae53960c6917a$export$b3d02211996f2c0a = ({ renderThreeLOPrompt: renderThreeLOPrompt })=>{
    const tracing = (0, $kaOT1.useTracingContext)();
    const [commitUserAuthTokenForExtensionMutation] = (0, $irOoi.useMutation)((0, $gmeYw.default));
    const fetchAuthToken = async (extensionId, contextIds)=>{
        tracing?.recordGqlCall('userAuthTokenForExtension - start');
        return new Promise((resolve, reject)=>{
            commitUserAuthTokenForExtensionMutation({
                variables: {
                    input: {
                        extensionId: extensionId,
                        contextIds: contextIds
                    }
                },
                // @ts-ignore
                cacheConfig: {
                    metadata: {
                        headers: {
                            'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)(contextIds.sort().join())
                        }
                    }
                },
                onError: (error)=>{
                    reject(new Error(`Network error: ${error.message}`));
                },
                onCompleted: (data)=>{
                    if (data?.userAuthTokenForExtension) {
                        const { success: success, authToken: authToken, errors: errors } = data.userAuthTokenForExtension;
                        tracing?.recordGqlCall('userAuthTokenForExtension - end');
                        if (!success && errors && errors[0].message?.includes('No Atlassian OAuth token found for this user and extension')) {
                            renderThreeLOPrompt(async ()=>{
                                const token = await fetchAuthToken(extensionId, contextIds);
                                resolve(token);
                            });
                            return;
                        }
                        if (success && authToken) {
                            const { token: token, ttl: ttl } = authToken;
                            resolve({
                                token: token,
                                expiry: Date.now() + ttl * $6d9ae53960c6917a$export$5d72c9fa1086d504
                            });
                            return;
                        }
                        reject(new Error('An unexpected error occurred when fetching an auth token'));
                        return;
                    }
                }
            });
        });
    };
    return fetchAuthToken;
};
module.exports["useFetchAuthToken"] = $6d9ae53960c6917a$export$b3d02211996f2c0a;

});

parcelRegister("hvvoj", function(module, exports) {

var $kxKUs = parcelRequire("kxKUs");

const $2a01424001f37a1e$export$21f63b78155c2049 = (extensionBasePath)=>{
    return {
        extensionRouteToFullPath: (extensionRoute)=>`${extensionBasePath}${extensionRoute ?? ''}`,
        fullPathToExtensionRoute: (fullLocation)=>{
            const extensionRoute = fullLocation.split(extensionBasePath).pop();
            return extensionRoute ? extensionRoute : '/';
        }
    };
};
const $2a01424001f37a1e$export$4178d7ac16e6cf7c = ({ history: history, extensionBasePath: extensionBasePath })=>{
    if (!history || !extensionBasePath) throw new (0, $kxKUs.BridgeClientError)('History API is not available within this module.');
    const { extensionRouteToFullPath: extensionRouteToFullPath, fullPathToExtensionRoute: fullPathToExtensionRoute } = $2a01424001f37a1e$export$21f63b78155c2049(extensionBasePath);
    const parseLocation = (location, parser)=>({
            ...location,
            pathname: parser(location.pathname)
        });
    const setNewHistoryLocation = (type, pathOrLocation, state)=>{
        const setHistory = type === 'push' ? history.push : history.replace;
        if (typeof pathOrLocation === 'string') return setHistory(extensionRouteToFullPath(pathOrLocation), state);
        return setHistory(parseLocation({
            state: state,
            ...pathOrLocation
        }, extensionRouteToFullPath));
    };
    return {
        ...history,
        location: parseLocation(history.location, fullPathToExtensionRoute),
        push (pathOrLocation, state) {
            setNewHistoryLocation('push', pathOrLocation, state);
        },
        replace (pathOrLocation, state) {
            setNewHistoryLocation('replace', pathOrLocation, state);
        },
        listen (listener) {
            const unlisten = history.listen((location, action)=>{
                listener(parseLocation(location, fullPathToExtensionRoute), action);
            });
            return unlisten;
        }
    };
};
module.exports["createHistory"] = $2a01424001f37a1e$export$4178d7ac16e6cf7c;

});

parcelRegister("6mbqJ", function(module, exports) {
/**
 * @generated SignedSource<<299c26970c3186f19ddb9b9bcd91907b>>
 * @relayHash f7bba14ed0ba3e90a97cbe6770906a31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad
const $b4ad3aab458be96b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "appAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "appAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "privacyPolicy"
    }, v4 = {
        "kind": "ScalarField",
        "name": "termsOfService"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "contextIds",
            "variableName": "contextIds"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "extensionData"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useForgeAppQuery_appByIdQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "app",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            {
                                "args": v5 /*: any*/ ,
                                "concreteType": "AppInstallationByIndexConnection",
                                "kind": "LinkedField",
                                "name": "installationsByContexts",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "AppInstallationByIndexEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "AppInstallation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AppEnvironmentVersion",
                                                        "kind": "LinkedField",
                                                        "name": "appEnvironmentVersion",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AppVersionExtensions",
                                                                "kind": "LinkedField",
                                                                "name": "extensions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AppVersionExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "nodes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v6 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "app"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useForgeAppQuery_appByIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "AppInstallationByIndexConnection",
                            "kind": "LinkedField",
                            "name": "installationsByContexts",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AppInstallationByIndexEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AppInstallation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AppEnvironmentVersion",
                                                    "kind": "LinkedField",
                                                    "name": "appEnvironmentVersion",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "AppVersionExtensions",
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "AppVersionExtension",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "3f678bd76c790e4ebfae99dd7eda54817e5a91318514b0cfd2d4a03ccfb0c7ad",
            "metadata": {},
            "name": "useForgeAppQuery_appByIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b4ad3aab458be96b$var$node.hash = "8343441a33776d30a7ee1f511ffa878d";
var $b4ad3aab458be96b$export$2e2bcd8739ae039 = $b4ad3aab458be96b$var$node;
module.exports["default"] = $b4ad3aab458be96b$export$2e2bcd8739ae039;

});

parcelRegister("JsJ4Y", function(module, exports) {
const $d09011ff2196b597$export$b3fb17ae4345ac8f = (b64string, mimeType)=>{
    const base64Data = b64string.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for(let i = 0; i < byteCharacters.length; i++)byteNumbers[i] = byteCharacters.charCodeAt(i);
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([
        byteArray
    ], {
        type: mimeType
    });
};
const $d09011ff2196b597$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
module.exports["base64ToBlob"] = $d09011ff2196b597$export$b3fb17ae4345ac8f;
module.exports["blobToBase64"] = $d09011ff2196b597$export$47a328b4cabd57cc;

});

parcelRegister("cTsf6", function(module, exports) {

var $eOpGZ = parcelRequire("eOpGZ");


var $49YLc = parcelRequire("49YLc");


var $irOoi = parcelRequire("irOoi");


var $1Igmn = parcelRequire("1Igmn");

let $edcbc2bd1a2659e9$var$tenantRegionResult;
const $edcbc2bd1a2659e9$export$e1b0b3d6e5c0e66c = ()=>{
    $edcbc2bd1a2659e9$var$tenantRegionResult = undefined;
};
const $edcbc2bd1a2659e9$var$getTenantRegionRelay = ({ product: product, cloudId: cloudId, relayEnvironment: relayEnvironment })=>{
    if (!!$edcbc2bd1a2659e9$var$tenantRegionResult) return $edcbc2bd1a2659e9$var$tenantRegionResult;
    if (!relayEnvironment || !cloudId) return Promise.resolve(null);
    try {
        const observable = (0, $irOoi.fetchQuery)(relayEnvironment, (0, $eOpGZ.default), {
            cloudIds: [
                cloudId
            ],
            product: product
        }, {
            networkCacheConfig: {
                metadata: {
                    headers: {
                        'atl-attribution': (0, $1Igmn.createAtlAttributionHeader)()
                    }
                }
            }
        });
        $edcbc2bd1a2659e9$var$tenantRegionResult = new Promise((resolve)=>{
            observable.subscribe({
                next: (data)=>{
                    resolve(data?.tenantContexts?.[0]?.activationIdByProduct?.targetRegion ?? null);
                },
                error: ()=>{
                    resolve(null);
                }
            });
        });
        return $edcbc2bd1a2659e9$var$tenantRegionResult;
    } catch  {
        return Promise.resolve(null);
    }
};
const $edcbc2bd1a2659e9$export$f15a25d73b1f3084 = (0, $49YLc.functionWithFG)('forge-ui-enable-region-steering', $edcbc2bd1a2659e9$var$getTenantRegionRelay, ()=>Promise.resolve(null));
module.exports["getTenantRegion"] = $edcbc2bd1a2659e9$export$f15a25d73b1f3084;

});

parcelRegister("9c0Ac", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bedQP = parcelRequire("bedQP");

var $49YLc = parcelRequire("49YLc");

const $a542b484036b0115$var$createUserAccessContext = ()=>/*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $a542b484036b0115$var$createNoopContext = ()=>/*#__PURE__*/ (0, $42omo.createContext)({
        accountId: undefined,
        isUserAnonymous: false
    });
const $a542b484036b0115$export$45572a5e2c7b827f = (0, $49YLc.functionWithFG)('forge-ui-allow-anon-rest-calls', $a542b484036b0115$var$createUserAccessContext, $a542b484036b0115$var$createNoopContext)();
const $a542b484036b0115$var$UserAccessProviderImpl = ({ accountId: accountId, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>{
        return {
            accountId: accountId,
            // Determine whether a user is anonymously accessing the Forge app UI.
            // Future: enhance to incorporate product account types, and Forge
            // decoupled licensing logic.
            get isUserAnonymous () {
                return !accountId;
            }
        };
    }, [
        accountId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a542b484036b0115$export$45572a5e2c7b827f.Provider, {
        value: value
    }, children);
};
const $a542b484036b0115$export$413b4e1df9bd6693 = (0, $bedQP.componentWithFG)('forge-ui-allow-anon-rest-calls', $a542b484036b0115$var$UserAccessProviderImpl, (0, $42omo.Fragment));
module.exports["UserAccessContext"] = $a542b484036b0115$export$45572a5e2c7b827f;
module.exports["UserAccessProvider"] = $a542b484036b0115$export$413b4e1df9bd6693;

});

parcelRegister("gmeYw", function(module, exports) {
/**
 * @generated SignedSource<<800beff416ecdd8211298cfa4a63f2bd>>
 * @relayHash 8044e66d6d14d3c8d608ad17b4c7a655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343
const $a58b42757ec4f68d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "UserAuthTokenForExtensionResponse",
            "kind": "LinkedField",
            "name": "userAuthTokenForExtension",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "AuthToken",
                    "kind": "LinkedField",
                    "name": "authToken",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "token"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ttl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "4bd98d71393d58feccd2a11d41423b399b61ad4c7d6d4a93b8d392ec2588d343",
            "metadata": {},
            "name": "useFetchAuthToken_forge_ui_userAuthTokenMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a58b42757ec4f68d$var$node.hash = "d3c16ce08d98682bc3fa0189ab747c05";
var $a58b42757ec4f68d$export$2e2bcd8739ae039 = $a58b42757ec4f68d$var$node;
module.exports["default"] = $a58b42757ec4f68d$export$2e2bcd8739ae039;

});

parcelRegister("eOpGZ", function(module, exports) {
/**
 * @generated SignedSource<<fb2cb2cc73ac9e2a77877448e7e3d69a>>
 * @relayHash e47a8d762ffff04a617bbcb521f2ffa5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3
const $f0a21fde804fef06$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudIds",
                    "variableName": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "product",
                            "variableName": "product"
                        }
                    ],
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIdByProduct",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "targetRegion"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getTenantRegionQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getTenantRegionQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "dfe29aeb7d5310c6db8859a9de6a2e7e88aba2fbf6339df8df5a30ef3f21bad3",
            "metadata": {},
            "name": "getTenantRegionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f0a21fde804fef06$var$node.hash = "6dc84af73dba89409a0c35ebb8003355";
var $f0a21fde804fef06$export$2e2bcd8739ae039 = $f0a21fde804fef06$var$node;
module.exports["default"] = $f0a21fde804fef06$export$2e2bcd8739ae039;

});


$parcel$global.rlb("7otKk")
//# sourceMappingURL=FullPageEditorComponent.abca0452.js.map
